// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/**
 * * `delivery_appointment` - Delivery appointment requirement
 * * `inside_delivery` - Inside delivery Required
 * * `lift_gate` - Lift gate required
 */
export enum AccessRequirementsEnum {
    DeliveryAppointment = "delivery_appointment",
    InsideDelivery = "inside_delivery",
    LiftGate = "lift_gate",
}

/**
 * Serializer for account details with country-specific validation.
 * Supports DUNS field and AccountEmail management.
 *
 * UK buyers require: company_name, vat_number, company_registration_number,
 *                   registered_address, contact_name, contact_phone_number,
 *                   contact_email_address
 *
 * US buyers require: company_name, vat_number (as EIN), registered_address,
 *                   contact_name, contact_phone_number, contact_email_address
 */
export interface AccountDetail {
    id: number;
    /**
     * Company name
     * @maxLength 255
     */
    company_name: string;
    /**
     * VAT number
     * @maxLength 100
     */
    vat_number: string;
    duns?: string | null;
    /**
     * Company Registration Number (UK only)
     * @maxLength 100
     */
    company_registration_number?: string;
    /** Registered company address */
    registered_address: string;
    /** @maxLength 255 */
    contact_name: string;
    /** @maxLength 50 */
    contact_phone_number: string;
    /**
     * Contact email address (DEPRECATED: Use account_emails relationship instead)
     * @format email
     * @maxLength 255
     */
    contact_email_address?: string;
    /** Tax exemption certificate (US only) */
    tax_exemption_certificate?: boolean;
    account_emails: AccountEmail[];
    /** @format date-time */
    created_at: string;
    /** @format date-time */
    modified_at: string;
}

/** Serializer for AccountEmail model. */
export interface AccountEmail {
    /**
     * Unique identifier for account email lookup
     * @format uuid
     */
    uuid: string;
    /**
     * Label for this contact (e.g. 'Accounts Payable')
     * @maxLength 255
     */
    label: string;
    /**
     * Contact email address
     * @format email
     * @maxLength 255
     */
    email_address: string;
    /** @format date-time */
    created_at: string;
    /** @format date-time */
    modified_at: string;
}

/**
 * * `checking` - Checking
 * * `savings` - Savings
 */
export enum AccountTypeEnum {
    Checking = "checking",
    Savings = "savings",
}

/**
 * * `Mark samples as dispatched` - Mark Samples Dispatched
 * * `Reject samples request` - Reject Samples Request
 * * `Buyer marks samples as delivered` - Buyer Marks Samples Delivered
 * * `Order is marked as dispatched or Buyer marks order as delivered` - Order Marked As Dispatched Or Buyer Marks Order Delivered
 * * `Order has been delivered` - Order Delivered
 * * `Purchase Order is Accepted or Declined` - Purchase Order Accepted Or Declined
 * * `Clear Time to Order Action` - Clear Time To Order Action
 * * `Payment has been received` - Payment Received
 * * `Signed Agreement Uploaded` - Signed Agreement Uploaded
 * * `Purchase Order is placed` - Purchase Order Placed
 * * `Update quote or reject negotiation` - Update Quote Or Reject Negotiation
 * * `One or more ingredients are created` - Ingredients Created
 * * `One of more products are created` - Products Created
 * * `Samples are marked as received` - Samples Marked As Received
 * * `Marked as delivered` - Marked As Delivered
 * * `Quote for request or decline request` - Quote For Request Or Decline
 * * `Product list is uploaded` - Product List Uploaded
 * * `Respond to Request` - Respond To Request
 * * `Respond to negotiations` - Respond To Negotiations
 * * `Contract is created` - Contract Created
 * * `Buyer has created a request` - Buyer Created Request
 * * `Order or decline quote` - Order Or Decline Quote
 * * `Open contract details page` - Open Contract Details Page
 * * `Accept contract renewal` - Accept Contract Renewal
 * * `Decline contract renewal` - Decline Contract Renewal
 * * `Negotiate contract renewal` - Negotiate Contract Renewal
 * * `Place first request` - Place First Request
 * * `Feedback has been given for a sample` - Feedback Given For Sample
 * * `5 or more ingredients are created` - Upload Ingredient List
 * * `2 or more products are created` - Upload Product List
 */
export enum ActionClearTriggerEnum {
    MarkSamplesAsDispatched = "Mark samples as dispatched",
    RejectSamplesRequest = "Reject samples request",
    BuyerMarksSamplesAsDelivered = "Buyer marks samples as delivered",
    OrderIsMarkedAsDispatchedOrBuyerMarksOrderAsDelivered = "Order is marked as dispatched or Buyer marks order as delivered",
    OrderHasBeenDelivered = "Order has been delivered",
    PurchaseOrderIsAcceptedOrDeclined = "Purchase Order is Accepted or Declined",
    ClearTimeToOrderAction = "Clear Time to Order Action",
    PaymentHasBeenReceived = "Payment has been received",
    SignedAgreementUploaded = "Signed Agreement Uploaded",
    PurchaseOrderIsPlaced = "Purchase Order is placed",
    UpdateQuoteOrRejectNegotiation = "Update quote or reject negotiation",
    OneOrMoreIngredientsAreCreated = "One or more ingredients are created",
    OneOfMoreProductsAreCreated = "One of more products are created",
    SamplesAreMarkedAsReceived = "Samples are marked as received",
    MarkedAsDelivered = "Marked as delivered",
    QuoteForRequestOrDeclineRequest = "Quote for request or decline request",
    ProductListIsUploaded = "Product list is uploaded",
    RespondToRequest = "Respond to Request",
    RespondToNegotiations = "Respond to negotiations",
    ContractIsCreated = "Contract is created",
    BuyerHasCreatedARequest = "Buyer has created a request",
    OrderOrDeclineQuote = "Order or decline quote",
    OpenContractDetailsPage = "Open contract details page",
    AcceptContractRenewal = "Accept contract renewal",
    DeclineContractRenewal = "Decline contract renewal",
    NegotiateContractRenewal = "Negotiate contract renewal",
    PlaceFirstRequest = "Place first request",
    FeedbackHasBeenGivenForASample = "Feedback has been given for a sample",
    Value5OrMoreIngredientsAreCreated = "5 or more ingredients are created",
    Value2OrMoreProductsAreCreated = "2 or more products are created",
}

/**
 * * `ACCEPT_FINAL` - Accept as Final
 * * `NEEDS_REVIEW` - Needs Manual Review
 * * `RERUN` - Rerun
 * * `ESCALATE` - Escalate to Human
 * * `DISCARD` - Discard
 */
export enum ActionPreferenceEnum {
    ACCEPT_FINAL = "ACCEPT_FINAL",
    NEEDS_REVIEW = "NEEDS_REVIEW",
    RERUN = "RERUN",
    ESCALATE = "ESCALATE",
    DISCARD = "DISCARD",
}

/**
 * * `order` - Order
 * * `request` - Request
 * * `contracts` - Contracts
 * * `onboarding` - Onboarding
 * * `samples` - Samples
 * * `quotes` - Quotes
 */
export enum ActionTypeEnum {
    Order = "order",
    Request = "request",
    Contracts = "contracts",
    Onboarding = "onboarding",
    Samples = "samples",
    Quotes = "quotes",
}

/**
 * * `producer` - Producer
 * * `distributor` - Distributor
 * * `importer_exporter` - Importer / Exporter
 * * `wholesaler` - Wholesaler
 * * `food_manufacturer` - Manufacturer of Finished Food Products
 * * `beverage_manufacturer` - Manufacturer of Finished Beverage Products
 * * `raw_mat_manufacturer` - Manufacturer of raw materials
 * * `other` - Other
 */
export enum ActivityTypeEnum {
    Producer = "producer",
    Distributor = "distributor",
    ImporterExporter = "importer_exporter",
    Wholesaler = "wholesaler",
    FoodManufacturer = "food_manufacturer",
    BeverageManufacturer = "beverage_manufacturer",
    RawMatManufacturer = "raw_mat_manufacturer",
    Other = "other",
}

export interface Address {
    /** @maxLength 100 */
    building?: string | null;
    /** @maxLength 255 */
    street_1?: string | null;
    /** @maxLength 255 */
    street_2?: string | null;
    /** @maxLength 100 */
    town?: string | null;
    /** @maxLength 100 */
    region?: string | null;
    /** @maxLength 100 */
    postcode?: string | null;
    country?: Country | BlankEnum | NullEnum | null;
    /** @maxLength 100 */
    place_id?: string | null;
    /**
     * @format decimal
     * @pattern ^-?\d{0,4}(?:\.\d{0,15})?$
     */
    latitude?: string | null;
    /**
     * @format decimal
     * @pattern ^-?\d{0,4}(?:\.\d{0,15})?$
     */
    longitude?: string | null;
    company_id: number;
}

/**
 * * `+376` - +376
 * * `+971` - +971
 * * `+93` - +93
 * * `+1268` - +1268
 * * `+1264` - +1264
 * * `+355` - +355
 * * `+374` - +374
 * * `+244` - +244
 * * `+672` - +672
 * * `+54` - +54
 * * `+1684` - +1684
 * * `+43` - +43
 * * `+61` - +61
 * * `+297` - +297
 * * `+994` - +994
 * * `+387` - +387
 * * `+1246` - +1246
 * * `+880` - +880
 * * `+32` - +32
 * * `+226` - +226
 * * `+359` - +359
 * * `+973` - +973
 * * `+257` - +257
 * * `+229` - +229
 * * `+590` - +590
 * * `+1441` - +1441
 * * `+673` - +673
 * * `+591` - +591
 * * `+55` - +55
 * * `+1242` - +1242
 * * `+975` - +975
 * * `+267` - +267
 * * `+375` - +375
 * * `+501` - +501
 * * `+1` - +1
 * * `+243` - +243
 * * `+236` - +236
 * * `+242` - +242
 * * `+41` - +41
 * * `+225` - +225
 * * `+682` - +682
 * * `+56` - +56
 * * `+237` - +237
 * * `+86` - +86
 * * `+57` - +57
 * * `+506` - +506
 * * `+53` - +53
 * * `+238` - +238
 * * `+357` - +357
 * * `+420` - +420
 * * `+49` - +49
 * * `+253` - +253
 * * `+45` - +45
 * * `+1767` - +1767
 * * `+1809` - +1809
 * * `+213` - +213
 * * `+593` - +593
 * * `+372` - +372
 * * `+20` - +20
 * * `+212` - +212
 * * `+291` - +291
 * * `+34` - +34
 * * `+251` - +251
 * * `+358` - +358
 * * `+679` - +679
 * * `+500` - +500
 * * `+691` - +691
 * * `+298` - +298
 * * `+33` - +33
 * * `+241` - +241
 * * `+44` - +44
 * * `+1473` - +1473
 * * `+995` - +995
 * * `+594` - +594
 * * `+441481` - +441481
 * * `+233` - +233
 * * `+350` - +350
 * * `+299` - +299
 * * `+220` - +220
 * * `+224` - +224
 * * `+240` - +240
 * * `+30` - +30
 * * `+502` - +502
 * * `+1671` - +1671
 * * `+245` - +245
 * * `+595` - +595
 * * `+852` - +852
 * * `+504` - +504
 * * `+385` - +385
 * * `+509` - +509
 * * `+36` - +36
 * * `+62` - +62
 * * `+353` - +353
 * * `+972` - +972
 * * `+441624` - +441624
 * * `+91` - +91
 * * `+246` - +246
 * * `+964` - +964
 * * `+98` - +98
 * * `+354` - +354
 * * `+39` - +39
 * * `+441534` - +441534
 * * `+1876` - +1876
 * * `+962` - +962
 * * `+81` - +81
 * * `+254` - +254
 * * `+996` - +996
 * * `+855` - +855
 * * `+686` - +686
 * * `+269` - +269
 * * `+1869` - +1869
 * * `+850` - +850
 * * `+82` - +82
 * * `+965` - +965
 * * `+345` - +345
 * * `+7` - +7
 * * `+856` - +856
 * * `+961` - +961
 * * `+1758` - +1758
 * * `+423` - +423
 * * `+94` - +94
 * * `+231` - +231
 * * `+266` - +266
 * * `+370` - +370
 * * `+352` - +352
 * * `+371` - +371
 * * `+218` - +218
 * * `+377` - +377
 * * `+373` - +373
 * * `+382` - +382
 * * `+261` - +261
 * * `+692` - +692
 * * `+389` - +389
 * * `+223` - +223
 * * `+95` - +95
 * * `+976` - +976
 * * `+853` - +853
 * * `+1670` - +1670
 * * `+596` - +596
 * * `+222` - +222
 * * `+1664` - +1664
 * * `+356` - +356
 * * `+230` - +230
 * * `+960` - +960
 * * `+265` - +265
 * * `+52` - +52
 * * `+60` - +60
 * * `+258` - +258
 * * `+264` - +264
 * * `+687` - +687
 * * `+227` - +227
 * * `+234` - +234
 * * `+505` - +505
 * * `+31` - +31
 * * `+47` - +47
 * * `+977` - +977
 * * `+674` - +674
 * * `+683` - +683
 * * `+64` - +64
 * * `+968` - +968
 * * `+507` - +507
 * * `+51` - +51
 * * `+689` - +689
 * * `+675` - +675
 * * `+63` - +63
 * * `+92` - +92
 * * `+48` - +48
 * * `+508` - +508
 * * `+1787` - +1787
 * * `+970` - +970
 * * `+351` - +351
 * * `+680` - +680
 * * `+974` - +974
 * * `+262` - +262
 * * `+40` - +40
 * * `+381` - +381
 * * `+250` - +250
 * * `+966` - +966
 * * `+677` - +677
 * * `+248` - +248
 * * `+249` - +249
 * * `+46` - +46
 * * `+65` - +65
 * * `+290` - +290
 * * `+386` - +386
 * * `+421` - +421
 * * `+232` - +232
 * * `+378` - +378
 * * `+221` - +221
 * * `+252` - +252
 * * `+597` - +597
 * * `+239` - +239
 * * `+503` - +503
 * * `+963` - +963
 * * `+268` - +268
 * * `+1649` - +1649
 * * `+235` - +235
 * * `+228` - +228
 * * `+66` - +66
 * * `+992` - +992
 * * `+690` - +690
 * * `+670` - +670
 * * `+993` - +993
 * * `+216` - +216
 * * `+676` - +676
 * * `+90` - +90
 * * `+1868` - +1868
 * * `+688` - +688
 * * `+886` - +886
 * * `+255` - +255
 * * `+380` - +380
 * * `+256` - +256
 * * `+598` - +598
 * * `+998` - +998
 * * `+379` - +379
 * * `+1784` - +1784
 * * `+58` - +58
 * * `+1284` - +1284
 * * `+1340` - +1340
 * * `+84` - +84
 * * `+678` - +678
 * * `+681` - +681
 * * `+685` - +685
 * * `+967` - +967
 * * `+27` - +27
 * * `+260` - +260
 * * `+263` - +263
 */
export enum AddressContactPhoneCountryCodeEnum {
    Value376 = "+376",
    Value971 = "+971",
    Value93 = "+93",
    Value1268 = "+1268",
    Value1264 = "+1264",
    Value355 = "+355",
    Value374 = "+374",
    Value244 = "+244",
    Value672 = "+672",
    Value54 = "+54",
    Value1684 = "+1684",
    Value43 = "+43",
    Value61 = "+61",
    Value297 = "+297",
    Value994 = "+994",
    Value387 = "+387",
    Value1246 = "+1246",
    Value880 = "+880",
    Value32 = "+32",
    Value226 = "+226",
    Value359 = "+359",
    Value973 = "+973",
    Value257 = "+257",
    Value229 = "+229",
    Value590 = "+590",
    Value1441 = "+1441",
    Value673 = "+673",
    Value591 = "+591",
    Value55 = "+55",
    Value1242 = "+1242",
    Value975 = "+975",
    Value267 = "+267",
    Value375 = "+375",
    Value501 = "+501",
    Value1 = "+1",
    Value243 = "+243",
    Value236 = "+236",
    Value242 = "+242",
    Value41 = "+41",
    Value225 = "+225",
    Value682 = "+682",
    Value56 = "+56",
    Value237 = "+237",
    Value86 = "+86",
    Value57 = "+57",
    Value506 = "+506",
    Value53 = "+53",
    Value238 = "+238",
    Value357 = "+357",
    Value420 = "+420",
    Value49 = "+49",
    Value253 = "+253",
    Value45 = "+45",
    Value1767 = "+1767",
    Value1809 = "+1809",
    Value213 = "+213",
    Value593 = "+593",
    Value372 = "+372",
    Value20 = "+20",
    Value212 = "+212",
    Value291 = "+291",
    Value34 = "+34",
    Value251 = "+251",
    Value358 = "+358",
    Value679 = "+679",
    Value500 = "+500",
    Value691 = "+691",
    Value298 = "+298",
    Value33 = "+33",
    Value241 = "+241",
    Value44 = "+44",
    Value1473 = "+1473",
    Value995 = "+995",
    Value594 = "+594",
    Value441481 = "+441481",
    Value233 = "+233",
    Value350 = "+350",
    Value299 = "+299",
    Value220 = "+220",
    Value224 = "+224",
    Value240 = "+240",
    Value30 = "+30",
    Value502 = "+502",
    Value1671 = "+1671",
    Value245 = "+245",
    Value595 = "+595",
    Value852 = "+852",
    Value504 = "+504",
    Value385 = "+385",
    Value509 = "+509",
    Value36 = "+36",
    Value62 = "+62",
    Value353 = "+353",
    Value972 = "+972",
    Value441624 = "+441624",
    Value91 = "+91",
    Value246 = "+246",
    Value964 = "+964",
    Value98 = "+98",
    Value354 = "+354",
    Value39 = "+39",
    Value441534 = "+441534",
    Value1876 = "+1876",
    Value962 = "+962",
    Value81 = "+81",
    Value254 = "+254",
    Value996 = "+996",
    Value855 = "+855",
    Value686 = "+686",
    Value269 = "+269",
    Value1869 = "+1869",
    Value850 = "+850",
    Value82 = "+82",
    Value965 = "+965",
    Value345 = "+345",
    Value7 = "+7",
    Value856 = "+856",
    Value961 = "+961",
    Value1758 = "+1758",
    Value423 = "+423",
    Value94 = "+94",
    Value231 = "+231",
    Value266 = "+266",
    Value370 = "+370",
    Value352 = "+352",
    Value371 = "+371",
    Value218 = "+218",
    Value377 = "+377",
    Value373 = "+373",
    Value382 = "+382",
    Value261 = "+261",
    Value692 = "+692",
    Value389 = "+389",
    Value223 = "+223",
    Value95 = "+95",
    Value976 = "+976",
    Value853 = "+853",
    Value1670 = "+1670",
    Value596 = "+596",
    Value222 = "+222",
    Value1664 = "+1664",
    Value356 = "+356",
    Value230 = "+230",
    Value960 = "+960",
    Value265 = "+265",
    Value52 = "+52",
    Value60 = "+60",
    Value258 = "+258",
    Value264 = "+264",
    Value687 = "+687",
    Value227 = "+227",
    Value234 = "+234",
    Value505 = "+505",
    Value31 = "+31",
    Value47 = "+47",
    Value977 = "+977",
    Value674 = "+674",
    Value683 = "+683",
    Value64 = "+64",
    Value968 = "+968",
    Value507 = "+507",
    Value51 = "+51",
    Value689 = "+689",
    Value675 = "+675",
    Value63 = "+63",
    Value92 = "+92",
    Value48 = "+48",
    Value508 = "+508",
    Value1787 = "+1787",
    Value970 = "+970",
    Value351 = "+351",
    Value680 = "+680",
    Value974 = "+974",
    Value262 = "+262",
    Value40 = "+40",
    Value381 = "+381",
    Value250 = "+250",
    Value966 = "+966",
    Value677 = "+677",
    Value248 = "+248",
    Value249 = "+249",
    Value46 = "+46",
    Value65 = "+65",
    Value290 = "+290",
    Value386 = "+386",
    Value421 = "+421",
    Value232 = "+232",
    Value378 = "+378",
    Value221 = "+221",
    Value252 = "+252",
    Value597 = "+597",
    Value239 = "+239",
    Value503 = "+503",
    Value963 = "+963",
    Value268 = "+268",
    Value1649 = "+1649",
    Value235 = "+235",
    Value228 = "+228",
    Value66 = "+66",
    Value992 = "+992",
    Value690 = "+690",
    Value670 = "+670",
    Value993 = "+993",
    Value216 = "+216",
    Value676 = "+676",
    Value90 = "+90",
    Value1868 = "+1868",
    Value688 = "+688",
    Value886 = "+886",
    Value255 = "+255",
    Value380 = "+380",
    Value256 = "+256",
    Value598 = "+598",
    Value998 = "+998",
    Value379 = "+379",
    Value1784 = "+1784",
    Value58 = "+58",
    Value1284 = "+1284",
    Value1340 = "+1340",
    Value84 = "+84",
    Value678 = "+678",
    Value681 = "+681",
    Value685 = "+685",
    Value967 = "+967",
    Value27 = "+27",
    Value260 = "+260",
    Value263 = "+263",
}

/**
 * * `billing_address` - Billing address
 * * `delivery_address` - Delivery address
 * * `dispatch_address` - Dispatch address
 * * `company_address` - Company address
 */
export enum AddressTypeEnum {
    BillingAddress = "billing_address",
    DeliveryAddress = "delivery_address",
    DispatchAddress = "dispatch_address",
    CompanyAddress = "company_address",
}

export interface AdminAppOrderDetails {
    /** @format uuid */
    uuid: string;
    order_number: string;
    /** @format date-time */
    created_at: string;
    /** @format date-time */
    modified_at: string;
    ordered_by: ShortUser;
    company_ordered_by: CompanyNameAndId;
    company_ordered_from: CompanyNameAndId;
    /**
     * * `initializing` - Initializing
     * * `confirmed` - Confirmed
     * * `canceled` - Cancelled
     * * `pending_merchant_of_record_approval` - Pending Merchant of Record Approval
     * * `order_received` - Order Received
     * * `order_sent_to_supplier` - Order Sent To Supplier
     * * `order_confirming_price` - Order Confirming Price
     * * `forecasted` - Forecasted
     */
    lifecycle_state?: LifecycleStateEnum;
    /**
     * * `initializing` - Initializing
     * * `not_started` - Not Started
     * * `due` - Due
     * * `overdue` - Overdue
     * * `awaiting_reconciliation` - Awaiting Reconciliation
     * * `paid` - Paid
     * * `refunded` - Refunded
     * * `partially_refunded` - Partially Refunded
     */
    pay_in_state?: PayInStateEnum;
    /**
     * * `initializing` - Initializing
     * * `not_started` - Not Started
     * * `due` - Due
     * * `overdue` - Overdue
     * * `paid` - Paid
     * * `refunded` - Refunded
     * * `partially_refunded` - Partially Refunded
     */
    payout_state?: PayoutStateEnum;
    /**
     * * `initializing` - Initializing
     * * `not_started` - Not Started
     * * `pending_dispatch` - Pending Dispatch
     * * `in_transit` - In Transit
     * * `delivered` - Delivered
     * * `freight_ownership_pending` - Freight Ownership Pending
     * * `gathering_quotes` - Gathering Quotes
     * * `dispatch_scheduled` - Dispatch Scheduled
     * * `awaiting_collection_details` - Awaiting Collection Details
     * * `ready_for_pickup` - Ready for Pickup
     * * `picked_up` - Picked Up
     * * `preparing_freight` - Preparing Freight
     * * `freight_scheduled` - Freight Scheduled
     * * `gathering_freight_quotes` - Gathering Freight Quotes
     * * `quotes_confirmed` - Quotes Confirmed
     */
    delivery_state?: DeliveryStateEnum;
    /**
     * * `pay_before_dispatch` - Pay Before Dispatch
     * * `pay_after_dispatch` - Pay After Dispatch
     * * `pay_on_28th_second_month_after_dispatch` - Pay on 28th second month after dispatch
     * * `pay_end_of_month_of_dispatch_date` - Pay End of Month of Dispatch Date
     */
    payment_terms?: AppOrderPaymentTermsEnum;
    /**
     * * `EUR` - EUR
     * * `GBP` - GBP
     * * `USD` - USD
     */
    buyer_currency?: AvailableCurrenciesEnum;
    /**
     * * `EUR` - EUR
     * * `GBP` - GBP
     * * `USD` - USD
     */
    supplier_currency?: AvailableCurrenciesEnum;
    /**
     * @format int64
     * @min 0
     * @max 9223372036854776000
     */
    shipping_price_in_supplier_currency: number;
    /**
     * @format int64
     * @min 0
     * @max 9223372036854776000
     */
    import_fee_price_in_buyer_currency?: number | null;
    /**
     * @format int64
     * @min 0
     * @max 9223372036854776000
     */
    export_fee_price_in_supplier_currency?: number | null;
    line_items: AdminOrderLineItem[];
    stripe_invoice_id: string | null;
    shipping_price_for_buyer: number;
    total_order_price_for_buyer: number;
    total_order_vat: number;
    delivery_address: DeliveryAddressResponse | null;
    delivery_tracking?: DeliveryTracking;
    payment_due_date: string;
    /**
     * Invoice due date from Two, set when order.reconciliation.invoiced.v1 webhook is received
     * @format date
     */
    two_invoice_due_date?: string | null;
    /**
     * @min 0
     * @max 2147483647
     */
    buyer_payment_period?: number;
    supplier_payout_due_date: string;
    supplier_payout_due_date_calculated: string;
    /** @format date */
    supplier_payout_due_date_override?: string | null;
    /**
     * @min 0
     * @max 2147483647
     */
    supplier_payment_period?: number;
    /**
     * * `payout_before_dispatch` - Payout Before Dispatch
     * * `payout_after_dispatch` - Payout After Dispatch
     */
    supplier_payout_terms?: SupplierPayoutTermsEnum;
    /** @format double */
    buyer_shipping_tax_rate: number;
    /** @format double */
    supplier_shipping_tax_rate: number;
    buyer_total_shipping_tax_amount_in_buyer_currency: number;
    supplier_total_shipping_tax_amount_in_supplier_currency: number;
    supplier_total_shipping_price_in_supplier_currency: number;
    /** @format date */
    delivery_date: string;
    user_uuid_from_company_ordered_by: string;
    user_uuid_from_company_ordered_from: string;
}

export interface AdminAppOrderDocument {
    /** @format uuid */
    uuid: string;
    /** @format uri */
    document: string;
    /**
     * * `uploaded_by_admin` - Uploaded by admin
     * * `uploaded_by_supplier` - Uploaded by supplier
     * * `uploaded_by_merchant_of_record` - Uploaded by merchant of record
     * * `uploaded_by_buyer` - Uploaded by buyer
     */
    category?: AppOrderDocumentCategory;
    file_name: string;
    /** @format date-time */
    created_at: string;
    /**
     * * `supplier_invoice` - Supplier Invoice
     * * `delivery_note` - Delivery Note
     * * `organic` - Organic
     * * `halal` - Halal
     * * `trading_schedule` - Trading Schedule
     * * `kosher` - Kosher
     * * `certificate_of_conformity` - Certificate of Conformity
     * * `packing_list` - Packing List
     * * `technical_data_sheet` - Technical Data Sheet
     * * `certificate_of_insurance` - Certificate of Insurance
     * * `customs_declaration_summary` - Customs Declaration Summary
     * * `bill_of_lading` - Bill of Lading
     * * `proof_of_payment` - Proof of Payment
     */
    type?: AppOrderDocumentType;
}

export interface AdminAppOrderEvent {
    id: number;
    /** @format date-time */
    created_at: string;
    /** @format uuid */
    uuid: string;
    order: number;
    text?: string | null;
    /**
     * * `mark_order_as_paid_out` - Mark order as paid out
     * * `mark_as_paid` - Mark as paid
     * * `approved_by_merchant_of_record` - Approved by merchant of record
     * * `rejected_by_merchant_of_record` - Rejected by merchant of record
     * * `edited_by_merchant_of_record` - Edited by merchant of record
     * * `comment` - Comment
     */
    event_type?: AppOrderEventTypeEnum;
    user: User;
}

export interface AdminAppOrderEventCreate {
    text?: string | null;
}

export interface AdminAppOrderList {
    /** @format uuid */
    uuid: string;
    order_number: string;
    /** @format date-time */
    created_at: string;
    /** @format date-time */
    modified_at: string;
    ordered_by: ShortUser;
    company_ordered_by: CompanyNameAndId;
    company_ordered_from: CompanyNameAndId;
    /**
     * * `initializing` - Initializing
     * * `not_started` - Not Started
     * * `due` - Due
     * * `overdue` - Overdue
     * * `awaiting_reconciliation` - Awaiting Reconciliation
     * * `paid` - Paid
     * * `refunded` - Refunded
     * * `partially_refunded` - Partially Refunded
     */
    pay_in_state?: PayInStateEnum;
    /**
     * * `initializing` - Initializing
     * * `not_started` - Not Started
     * * `due` - Due
     * * `overdue` - Overdue
     * * `paid` - Paid
     * * `refunded` - Refunded
     * * `partially_refunded` - Partially Refunded
     */
    payout_state?: PayoutStateEnum;
    /**
     * * `initializing` - Initializing
     * * `not_started` - Not Started
     * * `pending_dispatch` - Pending Dispatch
     * * `in_transit` - In Transit
     * * `delivered` - Delivered
     * * `freight_ownership_pending` - Freight Ownership Pending
     * * `gathering_quotes` - Gathering Quotes
     * * `dispatch_scheduled` - Dispatch Scheduled
     * * `awaiting_collection_details` - Awaiting Collection Details
     * * `ready_for_pickup` - Ready for Pickup
     * * `picked_up` - Picked Up
     * * `preparing_freight` - Preparing Freight
     * * `freight_scheduled` - Freight Scheduled
     * * `gathering_freight_quotes` - Gathering Freight Quotes
     * * `quotes_confirmed` - Quotes Confirmed
     */
    delivery_state?: DeliveryStateEnum;
    /**
     * * `pay_before_dispatch` - Pay Before Dispatch
     * * `pay_after_dispatch` - Pay After Dispatch
     * * `pay_on_28th_second_month_after_dispatch` - Pay on 28th second month after dispatch
     * * `pay_end_of_month_of_dispatch_date` - Pay End of Month of Dispatch Date
     */
    payment_terms?: AppOrderPaymentTermsEnum;
    /**
     * * `EUR` - EUR
     * * `GBP` - GBP
     * * `USD` - USD
     */
    buyer_currency?: AvailableCurrenciesEnum;
    /**
     * * `EUR` - EUR
     * * `GBP` - GBP
     * * `USD` - USD
     */
    supplier_currency?: AvailableCurrenciesEnum;
    /**
     * @format int64
     * @min 0
     * @max 9223372036854776000
     */
    shipping_price_in_supplier_currency: number;
    /**
     * @format int64
     * @min 0
     * @max 9223372036854776000
     */
    import_fee_price_in_buyer_currency?: number | null;
    /**
     * @format int64
     * @min 0
     * @max 9223372036854776000
     */
    export_fee_price_in_supplier_currency?: number | null;
    total_line_items: number;
}

export interface AdminAppOrderPrice {
    /**
     * * `EUR` - EUR
     * * `GBP` - GBP
     * * `USD` - USD
     */
    buyer_currency?: AvailableCurrenciesEnum;
    shipping_price_in_buyer_currency: number;
    /**
     * @format int64
     * @min 0
     * @max 9223372036854776000
     */
    import_fee_price_in_buyer_currency?: number | null;
    export_fee_price_in_buyer_currency: number;
    line_items: AdminOrderLineItemPrices[];
}

export interface AdminAppOrderUpdate {
    /**
     * @format int64
     * @min 0
     * @max 9223372036854776000
     */
    shipping_price_in_supplier_currency: number;
    /**
     * @format int64
     * @min 0
     * @max 9223372036854776000
     */
    import_fee_price_in_buyer_currency?: number | null;
    /**
     * @format int64
     * @min 0
     * @max 9223372036854776000
     */
    export_fee_price_in_supplier_currency?: number | null;
    line_items?: AdminLineItemUpdate[];
}

export interface AdminBuyerSummary {
    product_types_description?: string | null;
    revenue?: RevenueEnum | BlankEnum | NullEnum | null;
}

export interface AdminCheckReferralCode {
    referral_code: string;
}

export interface AdminCompany {
    id: number;
    /** @format uuid */
    uuid: string;
    /** @maxLength 255 */
    website?: string | null;
    /** @maxLength 255 */
    name: string;
    /** @format uri */
    logo?: string | null;
    /** @maxLength 100 */
    industry?: string | null;
    kyb_status: string;
    /** @maxLength 50 */
    phone_number?: string | null;
    country: string;
    state: string;
    /**
     * * `brand` - Brand
     * * `supplier` - Supplier
     * * `merchant_of_record` - Merchant of Record
     */
    company_type?: CompanyTypeEnum;
    /** @default ["e","h","o","r","t"] */
    product_type?: ProductTypeEnum[];
    /** @default ["e","h","o","r","t"] */
    activity_type?: ActivityTypeEnum[];
    /** @maxLength 255 */
    registration_number?: string | null;
    /** @maxLength 255 */
    registration_name?: string | null;
    mongo_id: string | null;
    referral_code: string;
    phone_country_code?: PhoneCountryCodeEnum | BlankEnum | NullEnum | null;
    company_addresses?: CompanyAddress[];
    currency: string;
    /**
     * rapyd payout method
     * @maxLength 45
     */
    payout_method_type?: string | null;
    bank_account_country?: Country | BlankEnum | NullEnum | null;
    /**
     * DUNS number for creditworthiness checks and payouts
     * @maxLength 50
     */
    duns?: string | null;
    /** @format date-time */
    created: string;
    last_login: LastLogin;
    /** @default ["e","h","o","r","t"] */
    product_category?: ProductCategoryEnum[];
    annual_turnover?: AnnualTurnoverEnum | BlankEnum | NullEnum | null;
    num_of_employees?: NumOfEmployeesEnum | BlankEnum | NullEnum | null;
    num_of_skus?: NumOfSkusEnum | BlankEnum | NullEnum | null;
    sku_ordering_enabled?: boolean;
    mov?: MovEnum | BlankEnum | NullEnum | null;
    is_active: string;
}

export interface AdminCompanyDocument {
    /** @format uuid */
    uuid: string;
    company: number;
    /** @format uri */
    document: string;
    description?: string | null;
    /**
     * * `ingredients_list` - Ingredients List
     * * `other` - Other
     */
    document_category?: CompanyDocumentCategory;
}

export interface AdminCompanyRetrieve {
    id: number;
    /** @format uuid */
    uuid: string;
    /** @maxLength 255 */
    website?: string | null;
    /** @maxLength 255 */
    name: string;
    /** @format uri */
    logo?: string | null;
    /** @maxLength 100 */
    industry?: string | null;
    kyb_status: string;
    /** @maxLength 50 */
    phone_number?: string | null;
    country: string;
    state: string;
    /**
     * * `brand` - Brand
     * * `supplier` - Supplier
     * * `merchant_of_record` - Merchant of Record
     */
    company_type?: CompanyTypeEnum;
    /** @default ["e","h","o","r","t"] */
    product_type?: ProductTypeEnum[];
    activity_type: string;
    /** @maxLength 255 */
    registration_number?: string | null;
    registration_name: string;
    /** @maxLength 50 */
    mongo_id?: string | null;
    /** @maxLength 10 */
    referral_code?: string;
    phone_country_code?: PhoneCountryCodeEnum | BlankEnum | NullEnum | null;
    company_addresses?: CompanyAddress[];
    currency: string;
    /**
     * rapyd payout method
     * @maxLength 45
     */
    payout_method_type?: string | null;
    bank_account_country?: Country | BlankEnum | NullEnum | null;
    /**
     * DUNS number for creditworthiness checks and payouts
     * @maxLength 50
     */
    duns?: string | null;
    /** @format date-time */
    created: string;
    last_login: LastLogin;
    /** @default ["e","h","o","r","t"] */
    product_category?: ProductCategoryEnum[];
    annual_turnover?: AnnualTurnoverEnum | BlankEnum | NullEnum | null;
    num_of_employees?: NumOfEmployeesEnum | BlankEnum | NullEnum | null;
    num_of_skus?: NumOfSkusEnum | BlankEnum | NullEnum | null;
    sku_ordering_enabled?: boolean;
    mov?: MovEnum | BlankEnum | NullEnum | null;
    is_active: string;
    created_by: User;
    description: string;
    company_documents: any[];
    referred_by: Company;
    /** @format date */
    kyb_verified_date: string | null;
    /** @format date */
    kyb_approved_date: string | null;
    /** @format date */
    kriya_kyb_approved_date: string | null;
    kriya_decision_status: string;
    /** @format double */
    kriya_total_limit: number;
    /** @format double */
    kriya_available_limit: number;
}

export interface AdminIngredientResponse {
    /** @format uuid */
    uuid: string;
    /** @maxLength 255 */
    name: string;
    /** @format uuid */
    company_uuid: string;
    associated_inquiries: string[];
    associated_contracts: string[];
    current_supplier?: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
     */
    current_unit_price: string;
    /**
     * * `EUR` - EUR
     * * `USD` - USD
     * * `GBP` - GBP
     * * `CAD` - CAD
     */
    currency?: Currencies;
    description: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
     */
    quantity: string;
    /**
     * * `fl oz` - Fluid Ounces
     * * `g` - Grams
     * * `mg` - milligrams
     * * `gals` - Gallons
     * * `kg` - Kilograms
     * * `L` - Liters
     * * `tons` - Metric Tons
     * * `oz` - Ounces
     * * `lbs` - Pounds
     * * `pcs` - Pieces
     * * `pt` - Pints
     * * `ml` - Milliliter
     * * `boxes` - Boxes
     * * `pallets` - Pallets
     * * `tsp` - Teaspoons
     * * `tbsp` - Tablespoons
     * * `units` - Units
     * * `cases` - Cases
     * * `trays` - Trays
     */
    unit_of_measurement?: UnitOfMeasurementEnum;
    diet_requirements?: DietRequirementsEnum | BlankEnum | NullEnum | null;
    frequency?: FrequencyEnum | BlankEnum | NullEnum | null;
    existing_suppliers: string;
}

export interface AdminLineItemUpdate {
    /** @format uuid */
    uuid: string;
    /**
     * @format int64
     * @min 0
     * @max 9223372036854776000
     */
    delivery_surcharge_price_in_supplier_currency?: number | null;
}

export interface AdminMessagesResponse {
    /** @format uuid */
    uuid: string;
    /** @format uuid */
    sender_company_uuid: string;
    /** @format uuid */
    recipient_company_uuid: string;
    /** @format date-time */
    created: string;
    text?: string | null;
    /** @format uuid */
    content_object_uuid: string;
    content_object_type: string;
}

export interface AdminOrderLineItem {
    /** @format uuid */
    uuid: string;
    /** @format date-time */
    created_at: string;
    /** @format date-time */
    modified_at: string;
    /** @maxLength 255 */
    product_name: string;
    /**
     * @format uri
     * @maxLength 2048
     */
    logo_url?: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,9}(?:\.\d{0,3})?$
     */
    quantity: string;
    /**
     * * `fl oz` - Fluid Ounces
     * * `g` - Grams
     * * `mg` - milligrams
     * * `gals` - Gallons
     * * `kg` - Kilograms
     * * `L` - Liters
     * * `tons` - Metric Tons
     * * `oz` - Ounces
     * * `lbs` - Pounds
     * * `pcs` - Pieces
     * * `pt` - Pints
     * * `ml` - Milliliter
     * * `boxes` - Boxes
     * * `pallets` - Pallets
     * * `tsp` - Teaspoons
     * * `tbsp` - Tablespoons
     * * `units` - Units
     * * `cases` - Cases
     * * `trays` - Trays
     */
    unit_of_measurement?: UnitOfMeasurementEnum;
    /** @format float */
    buyer_tax_rate: number;
    /**
     * @format int64
     * @min 0
     * @max 9223372036854776000
     */
    delivery_surcharge_price_in_supplier_currency?: number | null;
    buyer_unit_price_in_buyer_currency: number;
    buyer_total_price_in_buyer_currency: number;
    buyer_total_tax_amount_in_buyer_currency: number;
    supplier_unit_price_in_supplier_currency: number;
    supplier_total_price_in_supplier_currency: number;
    supplier_total_tax_amount_in_supplier_currency: number;
    /** @format float */
    supplier_tax_rate: number;
    /** @format float */
    buyer_commission_percentage: number;
}

export interface AdminOrderLineItemPrices {
    /** @format uuid */
    uuid: string;
    /** @format date-time */
    created_at: string;
    /** @format date-time */
    modified_at: string;
    /** @maxLength 255 */
    product_name: string;
    /**
     * @format uri
     * @maxLength 2048
     */
    logo_url?: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,9}(?:\.\d{0,3})?$
     */
    quantity: string;
    /**
     * * `fl oz` - Fluid Ounces
     * * `g` - Grams
     * * `mg` - milligrams
     * * `gals` - Gallons
     * * `kg` - Kilograms
     * * `L` - Liters
     * * `tons` - Metric Tons
     * * `oz` - Ounces
     * * `lbs` - Pounds
     * * `pcs` - Pieces
     * * `pt` - Pints
     * * `ml` - Milliliter
     * * `boxes` - Boxes
     * * `pallets` - Pallets
     * * `tsp` - Teaspoons
     * * `tbsp` - Tablespoons
     * * `units` - Units
     * * `cases` - Cases
     * * `trays` - Trays
     */
    unit_of_measurement?: UnitOfMeasurementEnum;
    /**
     * @format decimal
     * @pattern ^-?\d{0,1}(?:\.\d{0,4})?$
     */
    buyer_tax_rate?: string | null;
    /**
     * @format int64
     * @min 0
     * @max 9223372036854776000
     */
    delivery_surcharge_price_in_supplier_currency?: number | null;
    delivery_surcharge_price_in_buyer_currency: number;
    buyer_unit_price_in_buyer_currency: number;
    buyer_total_price_in_buyer_currency: number;
}

export interface AdminProductCatalogueList {
    /** @format uuid */
    uuid: string;
    /**
     * * `pending` - Pending
     * * `being_processed` - Is being processed
     * * `processed` - Processed
     * * `failed` - Failed
     */
    status?: UploadedProductsCatalogueStatus;
    /** @format uri */
    catalogue?: string | null;
    /** @format date-time */
    created: string;
}

export interface AdminSendUploadedListEmailNotification {
    /**
     * * `ingredients_list` - Ingredients List
     * * `other` - Other
     */
    category: CompanyDocumentCategory;
}

export interface AgentActivity {
    /** @format uuid */
    uuid: string;
    /**
     * * `task_created` - Task created
     * * `subtask_done` - Subtask done
     * * `plan_uploaded` - Plan uploaded
     * * `run_succeeded` - Run succeeded
     * * `run_failed` - Run failed
     * * `dispatch_retrying` - Dispatch retrying
     * * `dispatch_failed` - Dispatch failed
     */
    kind: AgentActivityKindEnum;
    /**
     * Short user-facing summary authored by the agent.
     * @maxLength 255
     */
    message: string;
    /** Optional structured data for richer FE rendering. */
    payload?: any;
    task: TaskRef;
    /** @pattern ^[-a-zA-Z0-9_]+$ */
    agent_slug: string;
    agent_name: string;
    is_read: boolean;
    /** @format date-time */
    created: string;
}

/**
 * * `task_created` - Task created
 * * `subtask_done` - Subtask done
 * * `plan_uploaded` - Plan uploaded
 * * `run_succeeded` - Run succeeded
 * * `run_failed` - Run failed
 * * `dispatch_retrying` - Dispatch retrying
 * * `dispatch_failed` - Dispatch failed
 */
export enum AgentActivityKindEnum {
    TaskCreated = "task_created",
    SubtaskDone = "subtask_done",
    PlanUploaded = "plan_uploaded",
    RunSucceeded = "run_succeeded",
    RunFailed = "run_failed",
    DispatchRetrying = "dispatch_retrying",
    DispatchFailed = "dispatch_failed",
}

/** Response shape for the bulk mark-seen endpoint. */
export interface AgentActivityMarkSeenResponse {
    /** Number of activities newly marked as read by this user. */
    marked: number;
}

/**
 * Common error envelope for the agents session endpoints — returns
 * ``{"detail": "..."}`` on every non-2xx response.
 */
export interface AgentDetailError {
    detail: string;
}

/** Used for reading feedbacks. */
export interface AgentFeedback {
    /** @format uuid */
    uuid: string;
    /** @format uuid */
    workflow_uuid: string;
    workflow_type: string;
    /**
     * * `GOOD` - Good
     * * `BAD` - Bad
     */
    feedback_rating: FeedbackRatingEnum;
    issue_type?: IssueTypeEnum[] | null;
    confidence_level?: ConfidenceLevelEnum | BlankEnum | NullEnum | null;
    /**
     * * `ACCEPT_FINAL` - Accept as Final
     * * `NEEDS_REVIEW` - Needs Manual Review
     * * `RERUN` - Rerun
     * * `ESCALATE` - Escalate to Human
     * * `DISCARD` - Discard
     */
    action_preference: ActionPreferenceEnum;
    /** @maxLength 200 */
    comment?: string;
    /** @format email */
    created_by_email: string;
    metadata?: any;
    /** @format date-time */
    created: string;
    /** @format date-time */
    modified: string;
}

/** Accepts a workflow by UUID for creation convenience. */
export interface AgentFeedbackCreate {
    /** @format uuid */
    uuid: string;
    /** @format uuid */
    workflow_uuid: string;
    /**
     * * `GOOD` - Good
     * * `BAD` - Bad
     */
    feedback_rating: FeedbackRatingEnum;
    issue_type?: IssueTypeEnum[] | null;
    confidence_level?: ConfidenceLevelEnum | BlankEnum | NullEnum | null;
    /**
     * * `ACCEPT_FINAL` - Accept as Final
     * * `NEEDS_REVIEW` - Needs Manual Review
     * * `RERUN` - Rerun
     * * `ESCALATE` - Escalate to Human
     * * `DISCARD` - Discard
     */
    action_preference: ActionPreferenceEnum;
    /** @maxLength 200 */
    comment?: string;
    metadata?: any;
}

export interface AgentInstallationAdminRow {
    agent: AgentRef;
    installation: InstallationRef | null;
}

/** The shape the FE consumes — enough to address the agent and render its name. */
export interface AgentInstallationMe {
    /** @format uuid */
    uuid: string;
    status: string;
    agent: AgentRef;
    shadow_user: ShadowUserRef;
}

/**
 * * `active` - Active
 * * `paused` - Paused
 * * `revoked` - Revoked
 */
export enum AgentInstallationStatusEnum {
    Active = "active",
    Paused = "paused",
    Revoked = "revoked",
}

/**
 * Read shape for the active AgentCore session pointer.
 *
 * Surfaces ``session_id`` plus ``last_used_at`` so the FE can decide
 * whether a hydrated value is stale enough to warrant a fresh chat. We
 * intentionally do not expose the row's primary key — callers always
 * address "the session for the current ``(user, company, agent_name)``"
 * via the ``/me/`` endpoint, so a UUID lookup field would be dead weight.
 */
export interface AgentSession {
    /** Opaque AgentCore session id. Conversation pointer, not a secret — AgentCore enforces auth via the runtime JWT. Min length 33 chars (AgentCore SDK requirement); we mint as 'opply-{uuid4().hex}'. */
    session_id: string;
    /** AgentCore runtime name (e.g. 'buyer-assistant'). */
    agent_name: string;
    /**
     * Bumped on every invocation; lets us garbage-collect stale rows later.
     * @format date-time
     */
    last_used_at: string;
}

/**
 * One persisted conversation message in the chat transcript.
 *
 * Mirrors Strands' ``MessageData`` shape (``{role, content}``) for the
 * roles + content blocks we persist between turns: user + assistant
 * messages, each carrying an array of native Bedrock content blocks
 * (``{text}`` / ``{toolUse}`` / ``{toolResult}``). The agent's per-turn
 * handler restores its ``Agent.messages`` from the snapshot, projects
 * each message through ``projectMessages`` /
 * ``projectContentBlocks``, and emits the projection as a single
 * ``messagesSnapshotEvent`` frame; Django picks that frame out and
 * serialises it through this class.
 *
 * The FE walks ``content`` looking for ``toolUse`` + matching
 * ``toolResult`` block pairs and renders one widget per pair via the
 * agent-widgets registry; the live SSE path consumes the same block
 * shape from Strands, so cold-load and live-stream rendering can't
 * drift.
 */
export interface AgentSessionMessage {
    /**
     * * `user` - user
     * * `assistant` - assistant
     */
    role: AgentSessionMessageRoleEnum;
    content:
        | (
              | {
                    text: string;
                }
              | {
                    toolUse: {
                        name: string;
                        toolUseId: string;
                        input?: any;
                    };
                }
              | {
                    toolResult: {
                        toolUseId: string;
                        status: "success" | "error";
                        content: (
                            | {
                                  text: string;
                              }
                            | {
                                  json: any;
                              }
                        )[];
                    };
                }
          )[]
        | null;
}

/**
 * * `user` - user
 * * `assistant` - assistant
 */
export enum AgentSessionMessageRoleEnum {
    User = "user",
    Assistant = "assistant",
}

/**
 * Envelope returned by ``GET /sessions/me/events/`` carrying the
 * user's chat transcript projected from the agent's snapshot.
 */
export interface AgentSessionMessages {
    messages: AgentSessionMessage[];
}

/** Stable client message surfaced on upstream identity-broker failures. */
export interface AgentTokenErrorResponse {
    error: string;
}

/**
 * JSON body the agent runtime POSTs to ``agent-token``.
 *
 * The runtime passes the active turn's ``company_uuid`` so the lookup
 * targets the right tenant for multi-company users; absent means fall
 * back to ``user.get_company()`` (the single-company case Opply assumes
 * today).
 */
export interface AgentTokenRequest {
    /** @format uuid */
    company_uuid?: string;
}

/**
 * Token-resolution outcome surfaced to the agent runtime.
 *
 * ``status``:
 * - ``ok`` — connection found and the vault returned a usable token.
 *   ``access_token`` and ``expires_in`` are populated.
 * - ``not_connected`` — no active connection exists for this
 *   user/company. Token fields are absent.
 * - ``needs_reconnect`` — there is an active row but the vault has no
 *   usable token (revoked, expired, or never stored). Token fields are
 *   absent.
 */
export interface AgentTokenResponse {
    /**
     * * `ok` - ok
     * * `not_connected` - not_connected
     * * `needs_reconnect` - needs_reconnect
     */
    status: AgentTokenResponseStatusEnum;
    access_token?: string;
    expires_in?: number;
}

/**
 * * `ok` - ok
 * * `not_connected` - not_connected
 * * `needs_reconnect` - needs_reconnect
 */
export enum AgentTokenResponseStatusEnum {
    Ok = "ok",
    NotConnected = "not_connected",
    NeedsReconnect = "needs_reconnect",
}

export interface AgreementLineItemDocument {
    /** @format uuid */
    uuid: string;
    /** @format uri */
    document: string;
    /**
     * * `spec_sheet` - Spec Sheet
     * * `signed_agreement` - Signed Agreement
     */
    category: AgreementLineItemDocumentCategoryEnum;
}

/**
 * * `spec_sheet` - Spec Sheet
 * * `signed_agreement` - Signed Agreement
 */
export enum AgreementLineItemDocumentCategoryEnum {
    SpecSheet = "spec_sheet",
    SignedAgreement = "signed_agreement",
}

export interface AgreementLineItemDocumentUpload {
    file_name: string;
    /**
     * * `spec_sheet` - Spec Sheet
     * * `signed_agreement` - Signed Agreement
     */
    category: AgreementLineItemDocumentCategoryEnum;
}

export interface AgreementOrderCreate {
    /** @format uuid */
    delivery_address_uuid?: string | null;
    /** @format date */
    delivery_date: string;
    line_items: AgreementOrderLineItem[];
    buyer_purchase_order_reference?: string | null;
}

export interface AgreementOrderLineItem {
    /** @format uuid */
    agreement_line_item_uuid: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,10}(?:\.\d{0,2})?$
     */
    quantity: string;
}

export interface AgreementOrderResponse {
    /** @format uuid */
    order_uuid: string;
}

/** Serializer for agreement summary metrics. */
export interface AgreementSummary {
    /** @format double */
    percent_fulfilled: number;
    orders_completed: number;
    orders_estimated: number;
}

/** Serializer for Alerts model - isolated feature */
export interface Alerts {
    /** @format uuid */
    uuid: string;
    /**
     * Creator agent type
     *
     * * `payment_agent` - Payment Agent
     * * `debt_agent` - Debt Agent
     * * `onboarding_agent` - Onboarding Agent
     * * `demand_forecaster` - Demand Forecaster
     * * `supplier_optimizer` - Supplier Optimizer
     */
    creator: CreatorEnum;
    /** Messages/Description */
    content: string;
    /**
     * Alert type classification
     *
     * * `critical` - Critical
     * * `baseline` - Baseline
     * * `stress_scenario` - Stress Scenario
     * * `optimistic_scenario` - Optimistic Scenario
     */
    type: TrendsAlertTypeEnum;
    /**
     * Title text
     * @maxLength 255
     */
    title: string;
    /** @format date-time */
    created_at: string;
    /** @format date-time */
    modified_at: string;
}

export interface AllAndFeaturedQuotesForInquiry {
    /** @format uuid */
    uuid: string;
    /** @maxLength 255 */
    product_name: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,9}(?:\.\d{0,10})?$
     */
    unit_price?: string;
    /**
     * * `EUR` - EUR
     * * `GBP` - GBP
     * * `USD` - USD
     * * `CAD` - CAD
     */
    currency: SupportedCurrencies;
    /**
     * * `non_recurring` - Non Recurring
     * * `recurring` - Recurring
     * * `purchase_request_quote` - Purchase Request Quote
     */
    category?: QuoteCategory;
    /**
     * @format decimal
     * @pattern ^-?\d{0,10}(?:\.\d{0,2})?$
     */
    quantity: string;
    /**
     * * `fl oz` - Fluid Ounces
     * * `g` - Grams
     * * `mg` - milligrams
     * * `gals` - Gallons
     * * `kg` - Kilograms
     * * `L` - Liters
     * * `tons` - Metric Tons
     * * `oz` - Ounces
     * * `lbs` - Pounds
     * * `pcs` - Pieces
     * * `pt` - Pints
     * * `ml` - Milliliter
     * * `boxes` - Boxes
     * * `pallets` - Pallets
     * * `tsp` - Teaspoons
     * * `tbsp` - Tablespoons
     * * `units` - Units
     * * `cases` - Cases
     * * `trays` - Trays
     */
    unit_of_measurement?: UnitOfMeasurementEnum;
    /**
     * The maximum time a supplier agrees to deliver the product within (days)
     * @min 0
     * @max 2147483647
     */
    lead_time: number;
    /** @format date */
    expiry_date?: string | null;
    /**
     * * `available` - available
     * * `ordered` - ordered
     * * `expired` - expired
     * * `declined` - declined
     * * `pending_payment` - pending_payment
     * * `proceeded` - proceeded
     * * `contract_created` - Contract Created
     * * `contract_proceeded` - contract_proceeded
     * * `contract_confirmed` - contract_confirmed
     */
    status?: QuoteState;
    /**
     * * `available` - Available
     * * `requested` - Requested
     * * `sent` - Sent
     * * `received` - Received
     * * `accepted` - Accepted
     * * `rejected` - Rejected
     * * `declined` - Declined
     */
    samples_status?: SamplesStatusEnum;
    samples_delivery_address?: number | null;
    samples_feedback?: SamplesFeedbackEnum[] | null;
    samples_feedback_comment?: string;
    unread_messages_count: number;
    has_specs: boolean;
    unit_price_no_vat_with_shipping: string;
    price_percentage_lower: string;
    packaging: string;
    expires_in: string;
    total_forecast_volume: string;
}

/**
 * * `CNH` - CNH
 * * `NIC` - NIC
 * * `BOV` - BOV
 * * `GIP` - GIP
 * * `ZAL` - ZAL
 * * `ILR` - ILR
 * * `LRD` - LRD
 * * `YUD` - YUD
 * * `BRR` - BRR
 * * `SUR` - SUR
 * * `NLG` - NLG
 * * `CLP` - CLP
 * * `EEK` - EEK
 * * `XPT` - XPT
 * * `MZE` - MZE
 * * `IQD` - IQD
 * * `XBA` - XBA
 * * `TWD` - TWD
 * * `VEF` - VEF
 * * `DOP` - DOP
 * * `UGX` - UGX
 * * `LUF` - LUF
 * * `FJD` - FJD
 * * `BOP` - BOP
 * * `BAM` - BAM
 * * `VND` - VND
 * * `BEL` - BEL
 * * `EGP` - EGP
 * * `MVP` - MVP
 * * `YUR` - YUR
 * * `BND` - BND
 * * `SSP` - SSP
 * * `UYU` - UYU
 * * `KRW` - KRW
 * * `BOB` - BOB
 * * `TJR` - TJR
 * * `USN` - USN
 * * `GQE` - GQE
 * * `ZRZ` - ZRZ
 * * `GBP` - GBP
 * * `VEB` - VEB
 * * `MGF` - MGF
 * * `LSL` - LSL
 * * `BOL` - BOL
 * * `JPY` - JPY
 * * `SDD` - SDD
 * * `BEF` - BEF
 * * `YUM` - YUM
 * * `GNS` - GNS
 * * `ROL` - ROL
 * * `BIF` - BIF
 * * `DKK` - DKK
 * * `MAF` - MAF
 * * `RSD` - RSD
 * * `OMR` - OMR
 * * `NAD` - NAD
 * * `TMM` - TMM
 * * `BEC` - BEC
 * * `ECS` - ECS
 * * `BRE` - BRE
 * * `KZT` - KZT
 * * `SOS` - SOS
 * * `ZWR` - ZWR
 * * `VUV` - VUV
 * * `VED` - VED
 * * `IEP` - IEP
 * * `ESA` - ESA
 * * `KGS` - KGS
 * * `RON` - RON
 * * `RUR` - RUR
 * * `SLL` - SLL
 * * `XFO` - XFO
 * * `KMF` - KMF
 * * `SDP` - SDP
 * * `BGN` - BGN
 * * `ZWD` - ZWD
 * * `MXN` - MXN
 * * `HNL` - HNL
 * * `AON` - AON
 * * `ZMW` - ZMW
 * * `LTL` - LTL
 * * `LUC` - LUC
 * * `VNN` - VNN
 * * `CLF` - CLF
 * * `BAD` - BAD
 * * `PLZ` - PLZ
 * * `ZWL` - ZWL
 * * `AZM` - AZM
 * * `IRR` - IRR
 * * `ISK` - ISK
 * * `CLE` - CLE
 * * `CRC` - CRC
 * * `JMD` - JMD
 * * `RUB` - RUB
 * * `JOD` - JOD
 * * `ETB` - ETB
 * * `UAK` - UAK
 * * `CDF` - CDF
 * * `CHF` - CHF
 * * `ESB` - ESB
 * * `KRO` - KRO
 * * `MZN` - MZN
 * * `BMD` - BMD
 * * `XRE` - XRE
 * * `BWP` - BWP
 * * `NZD` - NZD
 * * `CSD` - CSD
 * * `BUK` - BUK
 * * `ERN` - ERN
 * * `MWK` - MWK
 * * `XDR` - XDR
 * * `GWE` - GWE
 * * `LYD` - LYD
 * * `DDM` - DDM
 * * `XFU` - XFU
 * * `KWD` - KWD
 * * `TTD` - TTD
 * * `PGK` - PGK
 * * `XAG` - XAG
 * * `AZN` - AZN
 * * `NGN` - NGN
 * * `ANG` - ANG
 * * `BGM` - BGM
 * * `MVR` - MVR
 * * `TPE` - TPE
 * * `TZS` - TZS
 * * `CUP` - CUP
 * * `SEK` - SEK
 * * `AED` - AED
 * * `XEU` - XEU
 * * `BYB` - BYB
 * * `MNT` - MNT
 * * `SGD` - SGD
 * * `LAK` - LAK
 * * `ZWG` - ZWG
 * * `SDG` - SDG
 * * `SCR` - SCR
 * * `XAU` - XAU
 * * `THB` - THB
 * * `ARL` - ARL
 * * `XBC` - XBC
 * * `COP` - COP
 * * `MAD` - MAD
 * * `FIM` - FIM
 * * `NPR` - NPR
 * * `GWP` - GWP
 * * `XBB` - XBB
 * * `MTL` - MTL
 * * `EUR` - EUR
 * * `ZRN` - ZRN
 * * `CHW` - CHW
 * * `TRL` - TRL
 * * `GHS` - GHS
 * * `SKK` - SKK
 * * `PYG` - PYG
 * * `XOF` - XOF
 * * `BZD` - BZD
 * * `IDR` - IDR
 * * `STN` - STN
 * * `UYI` - UYI
 * * `XUA` - XUA
 * * `KPW` - KPW
 * * `USD` - USD
 * * `UYP` - UYP
 * * `XPD` - XPD
 * * `BAN` - BAN
 * * `GYD` - GYD
 * * `UGS` - UGS
 * * `CSK` - CSK
 * * `HUF` - HUF
 * * `AFA` - AFA
 * * `SRG` - SRG
 * * `CNX` - CNX
 * * `ALK` - ALK
 * * `GTQ` - GTQ
 * * `MGA` - MGA
 * * `KYD` - KYD
 * * `INR` - INR
 * * `XAF` - XAF
 * * `USS` - USS
 * * `ALL` - ALL
 * * `LKR` - LKR
 * * `XSU` - XSU
 * * `AOA` - AOA
 * * `SAR` - SAR
 * * `PKR` - PKR
 * * `XBD` - XBD
 * * `KES` - KES
 * * `SZL` - SZL
 * * `SVC` - SVC
 * * `MMK` - MMK
 * * `QAR` - QAR
 * * `TRY` - TRY
 * * `PES` - PES
 * * `BGL` - BGL
 * * `PLN` - PLN
 * * `CZK` - CZK
 * * `TND` - TND
 * * `GRD` - GRD
 * * `BYN` - BYN
 * * `MCF` - MCF
 * * `WST` - WST
 * * `VES` - VES
 * * `BTN` - BTN
 * * `PHP` - PHP
 * * `ILP` - ILP
 * * `MLF` - MLF
 * * `HRD` - HRD
 * * `MDC` - MDC
 * * `PAB` - PAB
 * * `SIT` - SIT
 * * `COU` - COU
 * * `MXV` - MXV
 * * `AWG` - AWG
 * * `SYP` - SYP
 * * `DEM` - DEM
 * * `ZMK` - ZMK
 * * `MKN` - MKN
 * * `XPF` - XPF
 * * `AMD` - AMD
 * * `CYP` - CYP
 * * `PEN` - PEN
 * * `TOP` - TOP
 * * `GEK` - GEK
 * * `FRF` - FRF
 * * `MTP` - MTP
 * * `SBD` - SBD
 * * `LVL` - LVL
 * * `MRU` - MRU
 * * `XTS` - XTS
 * * `RHD` - RHD
 * * `MKD` - MKD
 * * `MRO` - MRO
 * * `RWF` - RWF
 * * `AOR` - AOR
 * * `AOK` - AOK
 * * `ILS` - ILS
 * * `BBD` - BBD
 * * `ARP` - ARP
 * * `CVE` - CVE
 * * `LUL` - LUL
 * * `NIO` - NIO
 * * `STD` - STD
 * * `CHE` - CHE
 * * `GMD` - GMD
 * * `FKP` - FKP
 * * `MZM` - MZM
 * * `PEI` - PEI
 * * `ESP` - ESP
 * * `CAD` - CAD
 * * `MUR` - MUR
 * * `NOK` - NOK
 * * `UZS` - UZS
 * * `CUC` - CUC
 * * `MYR` - MYR
 * * `GHC` - GHC
 * * `ISJ` - ISJ
 * * `YDD` - YDD
 * * `BRC` - BRC
 * * `CNY` - CNY
 * * `PTE` - PTE
 * * `DZD` - DZD
 * * `LBP` - LBP
 * * `MOP` - MOP
 * * `DJF` - DJF
 * * `SRD` - SRD
 * * `AUD` - AUD
 * * `YUN` - YUN
 * * `BRN` - BRN
 * * `TMT` - TMT
 * * `XCG` - XCG
 * * `GNF` - GNF
 * * `UAH` - UAH
 * * `ARA` - ARA
 * * `MXP` - MXP
 * * `BRL` - BRL
 * * `AFN` - AFN
 * * `HKD` - HKD
 * * `BHD` - BHD
 * * `YER` - YER
 * * `ARM` - ARM
 * * `ARS` - ARS
 * * `SHP` - SHP
 * * `ITL` - ITL
 * * `KHR` - KHR
 * * `LVR` - LVR
 * * `SLE` - SLE
 * * `XXX` - XXX
 * * `BYR` - BYR
 * * `BRB` - BRB
 * * `ADP` - ADP
 * * `HRK` - HRK
 * * `BDT` - BDT
 * * `BSD` - BSD
 * * `ATS` - ATS
 * * `KRH` - KRH
 * * `ZAR` - ZAR
 * * `ECV` - ECV
 * * `HTG` - HTG
 * * `LTT` - LTT
 * * `MDL` - MDL
 * * `UYW` - UYW
 * * `TJS` - TJS
 * * `BGO` - BGO
 * * `GEL` - GEL
 * * `BRZ` - BRZ
 * * `XCD` - XCD
 */
export enum AllCurrencies {
    CNH = "CNH",
    NIC = "NIC",
    BOV = "BOV",
    GIP = "GIP",
    ZAL = "ZAL",
    ILR = "ILR",
    LRD = "LRD",
    YUD = "YUD",
    BRR = "BRR",
    SUR = "SUR",
    NLG = "NLG",
    CLP = "CLP",
    EEK = "EEK",
    XPT = "XPT",
    MZE = "MZE",
    IQD = "IQD",
    XBA = "XBA",
    TWD = "TWD",
    VEF = "VEF",
    DOP = "DOP",
    UGX = "UGX",
    LUF = "LUF",
    FJD = "FJD",
    BOP = "BOP",
    BAM = "BAM",
    VND = "VND",
    BEL = "BEL",
    EGP = "EGP",
    MVP = "MVP",
    YUR = "YUR",
    BND = "BND",
    SSP = "SSP",
    UYU = "UYU",
    KRW = "KRW",
    BOB = "BOB",
    TJR = "TJR",
    USN = "USN",
    GQE = "GQE",
    ZRZ = "ZRZ",
    GBP = "GBP",
    VEB = "VEB",
    MGF = "MGF",
    LSL = "LSL",
    BOL = "BOL",
    JPY = "JPY",
    SDD = "SDD",
    BEF = "BEF",
    YUM = "YUM",
    GNS = "GNS",
    ROL = "ROL",
    BIF = "BIF",
    DKK = "DKK",
    MAF = "MAF",
    RSD = "RSD",
    OMR = "OMR",
    NAD = "NAD",
    TMM = "TMM",
    BEC = "BEC",
    ECS = "ECS",
    BRE = "BRE",
    KZT = "KZT",
    SOS = "SOS",
    ZWR = "ZWR",
    VUV = "VUV",
    VED = "VED",
    IEP = "IEP",
    ESA = "ESA",
    KGS = "KGS",
    RON = "RON",
    RUR = "RUR",
    SLL = "SLL",
    XFO = "XFO",
    KMF = "KMF",
    SDP = "SDP",
    BGN = "BGN",
    ZWD = "ZWD",
    MXN = "MXN",
    HNL = "HNL",
    AON = "AON",
    ZMW = "ZMW",
    LTL = "LTL",
    LUC = "LUC",
    VNN = "VNN",
    CLF = "CLF",
    BAD = "BAD",
    PLZ = "PLZ",
    ZWL = "ZWL",
    AZM = "AZM",
    IRR = "IRR",
    ISK = "ISK",
    CLE = "CLE",
    CRC = "CRC",
    JMD = "JMD",
    RUB = "RUB",
    JOD = "JOD",
    ETB = "ETB",
    UAK = "UAK",
    CDF = "CDF",
    CHF = "CHF",
    ESB = "ESB",
    KRO = "KRO",
    MZN = "MZN",
    BMD = "BMD",
    XRE = "XRE",
    BWP = "BWP",
    NZD = "NZD",
    CSD = "CSD",
    BUK = "BUK",
    ERN = "ERN",
    MWK = "MWK",
    XDR = "XDR",
    GWE = "GWE",
    LYD = "LYD",
    DDM = "DDM",
    XFU = "XFU",
    KWD = "KWD",
    TTD = "TTD",
    PGK = "PGK",
    XAG = "XAG",
    AZN = "AZN",
    NGN = "NGN",
    ANG = "ANG",
    BGM = "BGM",
    MVR = "MVR",
    TPE = "TPE",
    TZS = "TZS",
    CUP = "CUP",
    SEK = "SEK",
    AED = "AED",
    XEU = "XEU",
    BYB = "BYB",
    MNT = "MNT",
    SGD = "SGD",
    LAK = "LAK",
    ZWG = "ZWG",
    SDG = "SDG",
    SCR = "SCR",
    XAU = "XAU",
    THB = "THB",
    ARL = "ARL",
    XBC = "XBC",
    COP = "COP",
    MAD = "MAD",
    FIM = "FIM",
    NPR = "NPR",
    GWP = "GWP",
    XBB = "XBB",
    MTL = "MTL",
    EUR = "EUR",
    ZRN = "ZRN",
    CHW = "CHW",
    TRL = "TRL",
    GHS = "GHS",
    SKK = "SKK",
    PYG = "PYG",
    XOF = "XOF",
    BZD = "BZD",
    IDR = "IDR",
    STN = "STN",
    UYI = "UYI",
    XUA = "XUA",
    KPW = "KPW",
    USD = "USD",
    UYP = "UYP",
    XPD = "XPD",
    BAN = "BAN",
    GYD = "GYD",
    UGS = "UGS",
    CSK = "CSK",
    HUF = "HUF",
    AFA = "AFA",
    SRG = "SRG",
    CNX = "CNX",
    ALK = "ALK",
    GTQ = "GTQ",
    MGA = "MGA",
    KYD = "KYD",
    INR = "INR",
    XAF = "XAF",
    USS = "USS",
    ALL = "ALL",
    LKR = "LKR",
    XSU = "XSU",
    AOA = "AOA",
    SAR = "SAR",
    PKR = "PKR",
    XBD = "XBD",
    KES = "KES",
    SZL = "SZL",
    SVC = "SVC",
    MMK = "MMK",
    QAR = "QAR",
    TRY = "TRY",
    PES = "PES",
    BGL = "BGL",
    PLN = "PLN",
    CZK = "CZK",
    TND = "TND",
    GRD = "GRD",
    BYN = "BYN",
    MCF = "MCF",
    WST = "WST",
    VES = "VES",
    BTN = "BTN",
    PHP = "PHP",
    ILP = "ILP",
    MLF = "MLF",
    HRD = "HRD",
    MDC = "MDC",
    PAB = "PAB",
    SIT = "SIT",
    COU = "COU",
    MXV = "MXV",
    AWG = "AWG",
    SYP = "SYP",
    DEM = "DEM",
    ZMK = "ZMK",
    MKN = "MKN",
    XPF = "XPF",
    AMD = "AMD",
    CYP = "CYP",
    PEN = "PEN",
    TOP = "TOP",
    GEK = "GEK",
    FRF = "FRF",
    MTP = "MTP",
    SBD = "SBD",
    LVL = "LVL",
    MRU = "MRU",
    XTS = "XTS",
    RHD = "RHD",
    MKD = "MKD",
    MRO = "MRO",
    RWF = "RWF",
    AOR = "AOR",
    AOK = "AOK",
    ILS = "ILS",
    BBD = "BBD",
    ARP = "ARP",
    CVE = "CVE",
    LUL = "LUL",
    NIO = "NIO",
    STD = "STD",
    CHE = "CHE",
    GMD = "GMD",
    FKP = "FKP",
    MZM = "MZM",
    PEI = "PEI",
    ESP = "ESP",
    CAD = "CAD",
    MUR = "MUR",
    NOK = "NOK",
    UZS = "UZS",
    CUC = "CUC",
    MYR = "MYR",
    GHC = "GHC",
    ISJ = "ISJ",
    YDD = "YDD",
    BRC = "BRC",
    CNY = "CNY",
    PTE = "PTE",
    DZD = "DZD",
    LBP = "LBP",
    MOP = "MOP",
    DJF = "DJF",
    SRD = "SRD",
    AUD = "AUD",
    YUN = "YUN",
    BRN = "BRN",
    TMT = "TMT",
    XCG = "XCG",
    GNF = "GNF",
    UAH = "UAH",
    ARA = "ARA",
    MXP = "MXP",
    BRL = "BRL",
    AFN = "AFN",
    HKD = "HKD",
    BHD = "BHD",
    YER = "YER",
    ARM = "ARM",
    ARS = "ARS",
    SHP = "SHP",
    ITL = "ITL",
    KHR = "KHR",
    LVR = "LVR",
    SLE = "SLE",
    XXX = "XXX",
    BYR = "BYR",
    BRB = "BRB",
    ADP = "ADP",
    HRK = "HRK",
    BDT = "BDT",
    BSD = "BSD",
    ATS = "ATS",
    KRH = "KRH",
    ZAR = "ZAR",
    ECV = "ECV",
    HTG = "HTG",
    LTT = "LTT",
    MDL = "MDL",
    UYW = "UYW",
    TJS = "TJS",
    BGO = "BGO",
    GEL = "GEL",
    BRZ = "BRZ",
    XCD = "XCD",
}

export interface AllEmailNotifications {
    all_emails: boolean;
}

/**
 * * `celery` - Celery
 * * `cereals_containing_gluten` - Cereals Containing Gluten
 * * `crustaceans` - Crustaceans
 * * `eggs` - Eggs
 * * `fish` - Fish
 * * `lupin` - Lupin
 * * `milk` - Milk
 * * `molluscs` - Molluscs
 * * `mustard` - Mustard
 * * `nuts` - Nuts
 * * `peanuts` - Peanuts
 * * `sesame_seeds` - Sesame Seeds
 * * `soya` - Soya
 * * `sulphur_dioxide` - Sulphur Dioxide
 */
export enum AllergenRequirementsEnum {
    Celery = "celery",
    CerealsContainingGluten = "cereals_containing_gluten",
    Crustaceans = "crustaceans",
    Eggs = "eggs",
    Fish = "fish",
    Lupin = "lupin",
    Milk = "milk",
    Molluscs = "molluscs",
    Mustard = "mustard",
    Nuts = "nuts",
    Peanuts = "peanuts",
    SesameSeeds = "sesame_seeds",
    Soya = "soya",
    SulphurDioxide = "sulphur_dioxide",
}

/** Serializer for connecting a buyer company to an Allianz company record. */
export interface AllianzConnect {
    /** The Allianz company ID to associate with this buyer. */
    allianz_company_id: string;
    /**
     * When true, skips the Allianz API validation and saves the company ID directly. Intended for local/staging environments where the Allianz API is unavailable.
     * @default false
     */
    skip_validation?: boolean;
}

/** Credit limit data for Allianz/recourse credit. */
export interface AllianzCreditLimit {
    /**
     * Credit limit availability status
     *
     * * `available` - Available
     * * `not_connected` - Not Connected
     * * `not_configured` - Not Configured
     * * `api_error` - API Error
     */
    status: CreditLimitStatusEnum;
    /** Allianz approved cover amount (cents) */
    approved_limit: number | null;
    /** Effective available recourse credit after allocations (cents) */
    effective_available: number | null;
}

/** Breakdown of allocated credit by order state. */
export interface AllocatedCreditBreakdown {
    /** Total value of pending MoR approval orders in cents */
    pending: number;
    /** Total value of confirmed orders in cents */
    confirmed: number;
    /** Total value of on-hold orders in cents */
    on_hold: number;
    /** Total value of orders in other active states in cents */
    other: number;
}

/**
 * * `0 USD - 5m USD` - 0 USD - 5m USD
 * * `6m USD - 20m USD` - 6m USD - 20m USD
 * * `21m USD - 100m USD` - 21m USD - 100m USD
 * * `100m+ USD` - 100m+ USD
 */
export enum AnnualTurnoverEnum {
    Value0USD5MUSD = "0 USD - 5m USD",
    Value6MUSD20MUSD = "6m USD - 20m USD",
    Value21MUSD100MUSD = "21m USD - 100m USD",
    Value100MUSD = "100m+ USD",
}

/**
 * * `uploaded_by_admin` - Uploaded by admin
 * * `uploaded_by_supplier` - Uploaded by supplier
 * * `uploaded_by_merchant_of_record` - Uploaded by merchant of record
 * * `uploaded_by_buyer` - Uploaded by buyer
 */
export enum AppOrderDocumentCategory {
    UploadedByAdmin = "uploaded_by_admin",
    UploadedBySupplier = "uploaded_by_supplier",
    UploadedByMerchantOfRecord = "uploaded_by_merchant_of_record",
    UploadedByBuyer = "uploaded_by_buyer",
}

/**
 * * `supplier_invoice` - Supplier Invoice
 * * `delivery_note` - Delivery Note
 * * `organic` - Organic
 * * `halal` - Halal
 * * `trading_schedule` - Trading Schedule
 * * `kosher` - Kosher
 * * `certificate_of_conformity` - Certificate of Conformity
 * * `packing_list` - Packing List
 * * `technical_data_sheet` - Technical Data Sheet
 * * `certificate_of_insurance` - Certificate of Insurance
 * * `customs_declaration_summary` - Customs Declaration Summary
 * * `bill_of_lading` - Bill of Lading
 * * `proof_of_payment` - Proof of Payment
 */
export enum AppOrderDocumentType {
    SupplierInvoice = "supplier_invoice",
    DeliveryNote = "delivery_note",
    Organic = "organic",
    Halal = "halal",
    TradingSchedule = "trading_schedule",
    Kosher = "kosher",
    CertificateOfConformity = "certificate_of_conformity",
    PackingList = "packing_list",
    TechnicalDataSheet = "technical_data_sheet",
    CertificateOfInsurance = "certificate_of_insurance",
    CustomsDeclarationSummary = "customs_declaration_summary",
    BillOfLading = "bill_of_lading",
    ProofOfPayment = "proof_of_payment",
}

/**
 * * `mark_order_as_paid_out` - Mark order as paid out
 * * `mark_as_paid` - Mark as paid
 * * `approved_by_merchant_of_record` - Approved by merchant of record
 * * `rejected_by_merchant_of_record` - Rejected by merchant of record
 * * `edited_by_merchant_of_record` - Edited by merchant of record
 * * `comment` - Comment
 */
export enum AppOrderEventTypeEnum {
    MarkOrderAsPaidOut = "mark_order_as_paid_out",
    MarkAsPaid = "mark_as_paid",
    ApprovedByMerchantOfRecord = "approved_by_merchant_of_record",
    RejectedByMerchantOfRecord = "rejected_by_merchant_of_record",
    EditedByMerchantOfRecord = "edited_by_merchant_of_record",
    Comment = "comment",
}

/**
 * * `pay_before_dispatch` - Pay Before Dispatch
 * * `pay_after_dispatch` - Pay After Dispatch
 * * `pay_on_28th_second_month_after_dispatch` - Pay on 28th second month after dispatch
 * * `pay_end_of_month_of_dispatch_date` - Pay End of Month of Dispatch Date
 */
export enum AppOrderPaymentTermsEnum {
    PayBeforeDispatch = "pay_before_dispatch",
    PayAfterDispatch = "pay_after_dispatch",
    PayOn28thSecondMonthAfterDispatch = "pay_on_28th_second_month_after_dispatch",
    PayEndOfMonthOfDispatchDate = "pay_end_of_month_of_dispatch_date",
}

export interface AssignThread {
    /** @maxLength 100 */
    external_id: string;
}

/**
 * * `authorization-code` - Authorization code
 * * `urn:ietf:params:oauth:grant-type:device_code` - Device Code
 * * `implicit` - Implicit
 * * `password` - Resource owner password-based
 * * `client-credentials` - Client credentials
 * * `openid-hybrid` - OpenID connect hybrid
 */
export enum AuthorizationGrantTypeEnum {
    AuthorizationCode = "authorization-code",
    UrnIetfParamsOauthGrantTypeDeviceCode = "urn:ietf:params:oauth:grant-type:device_code",
    Implicit = "implicit",
    Password = "password",
    ClientCredentials = "client-credentials",
    OpenidHybrid = "openid-hybrid",
}

/**
 * * `EUR` - EUR
 * * `GBP` - GBP
 * * `USD` - USD
 */
export enum AvailableCurrenciesEnum {
    EUR = "EUR",
    GBP = "GBP",
    USD = "USD",
}

/**
 * * `stripe` - Stripe
 * * `two` - Two
 * * `direct` - Direct
 */
export enum AvailablePaymentProvidersEnum {
    Stripe = "stripe",
    Two = "two",
    Direct = "direct",
}

export interface AvailableSitesResponse {
    /** Merged list of site names and dispatch address names (deduplicated, sorted) */
    available_sites: string[];
    sites: SupplierSite[];
}

export interface BankAccount {
    beneficiary_name: string;
    address: string;
    sort_code?: string | null;
    account_no?: string | null;
    bic?: string | null;
    iban?: string | null;
    aba_routing_number?: string | null;
    account_type?: string | null;
}

/** Serializer for a single bank detail entry (label/value pair). */
export interface BankDetail {
    label: string;
    value: string;
}

export interface BankTransfer {
    merchant_reference_id: string;
    reference_number: string;
    bank_account?: BankAccount | null;
}

/**
 * * `US` - Us
 * * `GB` - Gb
 * * `CA` - Ca
 * * `AT` - At
 * * `BE` - Be
 * * `CY` - Cy
 * * `DE` - De
 * * `EE` - Ee
 * * `ES` - Es
 * * `FI` - Fi
 * * `FR` - Fr
 * * `GR` - Gr
 * * `IE` - Ie
 * * `IT` - It
 * * `LT` - Lt
 * * `LU` - Lu
 * * `LV` - Lv
 * * `MT` - Mt
 * * `NL` - Nl
 * * `PT` - Pt
 * * `SI` - Si
 * * `SK` - Sk
 * * `BG` - Bg
 * * `CZ` - Cz
 * * `DK` - Dk
 * * `HR` - Hr
 * * `HU` - Hu
 * * `PL` - Pl
 * * `RO` - Ro
 * * `SE` - Se
 * * `EU` - Eu
 */
export enum BankingCountryTypeEnum {
    US = "US",
    GB = "GB",
    CA = "CA",
    AT = "AT",
    BE = "BE",
    CY = "CY",
    DE = "DE",
    EE = "EE",
    ES = "ES",
    FI = "FI",
    FR = "FR",
    GR = "GR",
    IE = "IE",
    IT = "IT",
    LT = "LT",
    LU = "LU",
    LV = "LV",
    MT = "MT",
    NL = "NL",
    PT = "PT",
    SI = "SI",
    SK = "SK",
    BG = "BG",
    CZ = "CZ",
    DK = "DK",
    HR = "HR",
    HU = "HU",
    PL = "PL",
    RO = "RO",
    SE = "SE",
    EU = "EU",
}

export interface BasketDiscountSwagger {
    quote_uuids: string[];
}

export interface BasketPrices {
    /**
     * @format decimal
     * @pattern ^-?\d{0,13}(?:\.\d{0,2})?$
     */
    sum_to_pay: string;
    /**
     * * `CNH` - CNH
     * * `NIC` - NIC
     * * `BOV` - BOV
     * * `GIP` - GIP
     * * `ZAL` - ZAL
     * * `ILR` - ILR
     * * `LRD` - LRD
     * * `YUD` - YUD
     * * `BRR` - BRR
     * * `SUR` - SUR
     * * `NLG` - NLG
     * * `CLP` - CLP
     * * `EEK` - EEK
     * * `XPT` - XPT
     * * `MZE` - MZE
     * * `IQD` - IQD
     * * `XBA` - XBA
     * * `TWD` - TWD
     * * `VEF` - VEF
     * * `DOP` - DOP
     * * `UGX` - UGX
     * * `LUF` - LUF
     * * `FJD` - FJD
     * * `BOP` - BOP
     * * `BAM` - BAM
     * * `VND` - VND
     * * `BEL` - BEL
     * * `EGP` - EGP
     * * `MVP` - MVP
     * * `YUR` - YUR
     * * `BND` - BND
     * * `SSP` - SSP
     * * `UYU` - UYU
     * * `KRW` - KRW
     * * `BOB` - BOB
     * * `TJR` - TJR
     * * `USN` - USN
     * * `GQE` - GQE
     * * `ZRZ` - ZRZ
     * * `GBP` - GBP
     * * `VEB` - VEB
     * * `MGF` - MGF
     * * `LSL` - LSL
     * * `BOL` - BOL
     * * `JPY` - JPY
     * * `SDD` - SDD
     * * `BEF` - BEF
     * * `YUM` - YUM
     * * `GNS` - GNS
     * * `ROL` - ROL
     * * `BIF` - BIF
     * * `DKK` - DKK
     * * `MAF` - MAF
     * * `RSD` - RSD
     * * `OMR` - OMR
     * * `NAD` - NAD
     * * `TMM` - TMM
     * * `BEC` - BEC
     * * `ECS` - ECS
     * * `BRE` - BRE
     * * `KZT` - KZT
     * * `SOS` - SOS
     * * `ZWR` - ZWR
     * * `VUV` - VUV
     * * `VED` - VED
     * * `IEP` - IEP
     * * `ESA` - ESA
     * * `KGS` - KGS
     * * `RON` - RON
     * * `RUR` - RUR
     * * `SLL` - SLL
     * * `XFO` - XFO
     * * `KMF` - KMF
     * * `SDP` - SDP
     * * `BGN` - BGN
     * * `ZWD` - ZWD
     * * `MXN` - MXN
     * * `HNL` - HNL
     * * `AON` - AON
     * * `ZMW` - ZMW
     * * `LTL` - LTL
     * * `LUC` - LUC
     * * `VNN` - VNN
     * * `CLF` - CLF
     * * `BAD` - BAD
     * * `PLZ` - PLZ
     * * `ZWL` - ZWL
     * * `AZM` - AZM
     * * `IRR` - IRR
     * * `ISK` - ISK
     * * `CLE` - CLE
     * * `CRC` - CRC
     * * `JMD` - JMD
     * * `RUB` - RUB
     * * `JOD` - JOD
     * * `ETB` - ETB
     * * `UAK` - UAK
     * * `CDF` - CDF
     * * `CHF` - CHF
     * * `ESB` - ESB
     * * `KRO` - KRO
     * * `MZN` - MZN
     * * `BMD` - BMD
     * * `XRE` - XRE
     * * `BWP` - BWP
     * * `NZD` - NZD
     * * `CSD` - CSD
     * * `BUK` - BUK
     * * `ERN` - ERN
     * * `MWK` - MWK
     * * `XDR` - XDR
     * * `GWE` - GWE
     * * `LYD` - LYD
     * * `DDM` - DDM
     * * `XFU` - XFU
     * * `KWD` - KWD
     * * `TTD` - TTD
     * * `PGK` - PGK
     * * `XAG` - XAG
     * * `AZN` - AZN
     * * `NGN` - NGN
     * * `ANG` - ANG
     * * `BGM` - BGM
     * * `MVR` - MVR
     * * `TPE` - TPE
     * * `TZS` - TZS
     * * `CUP` - CUP
     * * `SEK` - SEK
     * * `AED` - AED
     * * `XEU` - XEU
     * * `BYB` - BYB
     * * `MNT` - MNT
     * * `SGD` - SGD
     * * `LAK` - LAK
     * * `ZWG` - ZWG
     * * `SDG` - SDG
     * * `SCR` - SCR
     * * `XAU` - XAU
     * * `THB` - THB
     * * `ARL` - ARL
     * * `XBC` - XBC
     * * `COP` - COP
     * * `MAD` - MAD
     * * `FIM` - FIM
     * * `NPR` - NPR
     * * `GWP` - GWP
     * * `XBB` - XBB
     * * `MTL` - MTL
     * * `EUR` - EUR
     * * `ZRN` - ZRN
     * * `CHW` - CHW
     * * `TRL` - TRL
     * * `GHS` - GHS
     * * `SKK` - SKK
     * * `PYG` - PYG
     * * `XOF` - XOF
     * * `BZD` - BZD
     * * `IDR` - IDR
     * * `STN` - STN
     * * `UYI` - UYI
     * * `XUA` - XUA
     * * `KPW` - KPW
     * * `USD` - USD
     * * `UYP` - UYP
     * * `XPD` - XPD
     * * `BAN` - BAN
     * * `GYD` - GYD
     * * `UGS` - UGS
     * * `CSK` - CSK
     * * `HUF` - HUF
     * * `AFA` - AFA
     * * `SRG` - SRG
     * * `CNX` - CNX
     * * `ALK` - ALK
     * * `GTQ` - GTQ
     * * `MGA` - MGA
     * * `KYD` - KYD
     * * `INR` - INR
     * * `XAF` - XAF
     * * `USS` - USS
     * * `ALL` - ALL
     * * `LKR` - LKR
     * * `XSU` - XSU
     * * `AOA` - AOA
     * * `SAR` - SAR
     * * `PKR` - PKR
     * * `XBD` - XBD
     * * `KES` - KES
     * * `SZL` - SZL
     * * `SVC` - SVC
     * * `MMK` - MMK
     * * `QAR` - QAR
     * * `TRY` - TRY
     * * `PES` - PES
     * * `BGL` - BGL
     * * `PLN` - PLN
     * * `CZK` - CZK
     * * `TND` - TND
     * * `GRD` - GRD
     * * `BYN` - BYN
     * * `MCF` - MCF
     * * `WST` - WST
     * * `VES` - VES
     * * `BTN` - BTN
     * * `PHP` - PHP
     * * `ILP` - ILP
     * * `MLF` - MLF
     * * `HRD` - HRD
     * * `MDC` - MDC
     * * `PAB` - PAB
     * * `SIT` - SIT
     * * `COU` - COU
     * * `MXV` - MXV
     * * `AWG` - AWG
     * * `SYP` - SYP
     * * `DEM` - DEM
     * * `ZMK` - ZMK
     * * `MKN` - MKN
     * * `XPF` - XPF
     * * `AMD` - AMD
     * * `CYP` - CYP
     * * `PEN` - PEN
     * * `TOP` - TOP
     * * `GEK` - GEK
     * * `FRF` - FRF
     * * `MTP` - MTP
     * * `SBD` - SBD
     * * `LVL` - LVL
     * * `MRU` - MRU
     * * `XTS` - XTS
     * * `RHD` - RHD
     * * `MKD` - MKD
     * * `MRO` - MRO
     * * `RWF` - RWF
     * * `AOR` - AOR
     * * `AOK` - AOK
     * * `ILS` - ILS
     * * `BBD` - BBD
     * * `ARP` - ARP
     * * `CVE` - CVE
     * * `LUL` - LUL
     * * `NIO` - NIO
     * * `STD` - STD
     * * `CHE` - CHE
     * * `GMD` - GMD
     * * `FKP` - FKP
     * * `MZM` - MZM
     * * `PEI` - PEI
     * * `ESP` - ESP
     * * `CAD` - CAD
     * * `MUR` - MUR
     * * `NOK` - NOK
     * * `UZS` - UZS
     * * `CUC` - CUC
     * * `MYR` - MYR
     * * `GHC` - GHC
     * * `ISJ` - ISJ
     * * `YDD` - YDD
     * * `BRC` - BRC
     * * `CNY` - CNY
     * * `PTE` - PTE
     * * `DZD` - DZD
     * * `LBP` - LBP
     * * `MOP` - MOP
     * * `DJF` - DJF
     * * `SRD` - SRD
     * * `AUD` - AUD
     * * `YUN` - YUN
     * * `BRN` - BRN
     * * `TMT` - TMT
     * * `XCG` - XCG
     * * `GNF` - GNF
     * * `UAH` - UAH
     * * `ARA` - ARA
     * * `MXP` - MXP
     * * `BRL` - BRL
     * * `AFN` - AFN
     * * `HKD` - HKD
     * * `BHD` - BHD
     * * `YER` - YER
     * * `ARM` - ARM
     * * `ARS` - ARS
     * * `SHP` - SHP
     * * `ITL` - ITL
     * * `KHR` - KHR
     * * `LVR` - LVR
     * * `SLE` - SLE
     * * `XXX` - XXX
     * * `BYR` - BYR
     * * `BRB` - BRB
     * * `ADP` - ADP
     * * `HRK` - HRK
     * * `BDT` - BDT
     * * `BSD` - BSD
     * * `ATS` - ATS
     * * `KRH` - KRH
     * * `ZAR` - ZAR
     * * `ECV` - ECV
     * * `HTG` - HTG
     * * `LTT` - LTT
     * * `MDL` - MDL
     * * `UYW` - UYW
     * * `TJS` - TJS
     * * `BGO` - BGO
     * * `GEL` - GEL
     * * `BRZ` - BRZ
     * * `XCD` - XCD
     */
    currency: AllCurrencies;
    /**
     * @format decimal
     * @pattern ^-?\d{0,13}(?:\.\d{0,2})?$
     */
    sum_to_pay_no_discount: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,13}(?:\.\d{0,2})?$
     */
    discount_amount: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,13}(?:\.\d{0,2})?$
     */
    total_shipping_cost: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,13}(?:\.\d{0,2})?$
     */
    total_price: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,13}(?:\.\d{0,2})?$
     */
    total_price_no_vat: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,13}(?:\.\d{0,2})?$
     */
    total_shipping_cost_no_vat: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,13}(?:\.\d{0,2})?$
     */
    total_vat: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,13}(?:\.\d{0,2})?$
     */
    total_cost: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,13}(?:\.\d{0,2})?$
     */
    total_additional_fees: string;
}

export interface BasketResponse {
    /** @format uuid */
    supplier_uuid: string;
    basket_prices: BasketPrices;
}

export enum BlankEnum {
    Value = "",
}

/**
 * Per-sector "above threshold?" observation submitted by the FE.
 *
 * The FE knows each sector's unlock threshold (per
 * ``BRAIN_SECTOR_UNLOCK`` in ``mocks/brain.ts``); the BE doesn't
 * care about the count itself, only the boolean "is the sector
 * above its threshold right now?". This keeps the API agnostic
 * to FE-side threshold tuning — we can move targets without a BE
 * deploy.
 *
 * Unknown sector keys are ignored at the view level so newer FE
 * builds that emit additional keys don't 400 against an older API.
 */
export interface BrainObserveProgressRequest {
    /** Map of brain sector key → whether the user is currently above the sector's unlock threshold. Keys outside the ``BrainSectorKey`` enum are silently ignored. */
    sectors: Record<string, boolean>;
}

/**
 * Sectors whose unlock-celebration modal should be shown now.
 *
 * Returned in the order the server processed them; the FE queues
 * them and surfaces one at a time. A sector appears here exactly
 * once across all observations — the BE flips the row's
 * ``resolved`` flag in the same transaction.
 */
export interface BrainObserveProgressResponse {
    /** Brain sector keys whose unlock threshold was just observed to cross from below to above. Empty when nothing new fired. */
    celebrate: CelebrateEnum[];
}

export interface BrandBuyerItemCreate {
    /** @maxLength 255 */
    item_name: string;
    /** @maxLength 255 */
    sku?: string | null;
    item_description?: string | null;
    /**
     * @format uri
     * @maxLength 2048
     */
    logo_url?: string;
    /** @format uuid */
    category_uuid?: string | null;
    /**
     * What kind of material this row represents (ingredient, packaging, ...).
     *
     * * `ingredient` - Ingredient
     * * `packaging` - Packaging
     */
    kind?: CatalogItemKindEnum;
    /**
     * Natural unit the material is measured in.
     *
     * * `fl oz` - Fluid Ounces
     * * `g` - Grams
     * * `mg` - milligrams
     * * `gals` - Gallons
     * * `kg` - Kilograms
     * * `L` - Liters
     * * `tons` - Metric Tons
     * * `oz` - Ounces
     * * `lbs` - Pounds
     * * `pcs` - Pieces
     * * `pt` - Pints
     * * `ml` - Milliliter
     * * `boxes` - Boxes
     * * `pallets` - Pallets
     * * `tsp` - Teaspoons
     * * `tbsp` - Tablespoons
     * * `units` - Units
     * * `cases` - Cases
     * * `trays` - Trays
     */
    unit_of_measurement?: UnitOfMeasurementEnum;
    allergen_requirements?: AllergenRequirementsEnum[];
    /** A signed allergen declaration is required to source this material. */
    require_allergen_declaration?: boolean;
    diet_requirements?: DietRequirementsEnum[];
    /** A dietary certificate is required to validate the diet requirements. */
    require_dietary_certificate?: boolean;
}

export interface BrandBuyerItemDetail {
    /** @format uuid */
    uuid: string;
    /** @maxLength 255 */
    item_name: string;
    /** @maxLength 255 */
    sku?: string | null;
    item_description?: string | null;
    /**
     * @format uri
     * @maxLength 2048
     */
    logo_url?: string;
    /** @format uuid */
    category_uuid?: string | null;
    /**
     * What kind of material this row represents (ingredient, packaging, ...).
     *
     * * `ingredient` - Ingredient
     * * `packaging` - Packaging
     */
    kind?: CatalogItemKindEnum;
    /**
     * Natural unit the material is measured in.
     *
     * * `fl oz` - Fluid Ounces
     * * `g` - Grams
     * * `mg` - milligrams
     * * `gals` - Gallons
     * * `kg` - Kilograms
     * * `L` - Liters
     * * `tons` - Metric Tons
     * * `oz` - Ounces
     * * `lbs` - Pounds
     * * `pcs` - Pieces
     * * `pt` - Pints
     * * `ml` - Milliliter
     * * `boxes` - Boxes
     * * `pallets` - Pallets
     * * `tsp` - Teaspoons
     * * `tbsp` - Tablespoons
     * * `units` - Units
     * * `cases` - Cases
     * * `trays` - Trays
     */
    unit_of_measurement?: UnitOfMeasurementEnum;
    allergen_requirements?: AllergenRequirementsEnum[];
    /** A signed allergen declaration is required to source this material. */
    require_allergen_declaration?: boolean;
    diet_requirements?: DietRequirementsEnum[];
    /** A dietary certificate is required to validate the diet requirements. */
    require_dietary_certificate?: boolean;
    is_active?: boolean;
    documents: BuyerItemDocument[];
    /** @format date-time */
    created_at: string;
    /** @format date-time */
    modified_at: string;
}

export interface BrandBuyerItemList {
    /** @format uuid */
    uuid: string;
    item_name: string;
    sku: string | null;
    item_description: string | null;
    /** @format uri */
    logo_url: string;
    /** @format uuid */
    category_uuid: string | null;
    /**
     * What kind of material this row represents (ingredient, packaging, ...).
     *
     * * `ingredient` - Ingredient
     * * `packaging` - Packaging
     */
    kind: CatalogItemKindEnum;
    /**
     * Natural unit the material is measured in.
     *
     * * `fl oz` - Fluid Ounces
     * * `g` - Grams
     * * `mg` - milligrams
     * * `gals` - Gallons
     * * `kg` - Kilograms
     * * `L` - Liters
     * * `tons` - Metric Tons
     * * `oz` - Ounces
     * * `lbs` - Pounds
     * * `pcs` - Pieces
     * * `pt` - Pints
     * * `ml` - Milliliter
     * * `boxes` - Boxes
     * * `pallets` - Pallets
     * * `tsp` - Teaspoons
     * * `tbsp` - Tablespoons
     * * `units` - Units
     * * `cases` - Cases
     * * `trays` - Trays
     */
    unit_of_measurement: UnitOfMeasurementEnum;
    /**
     * Allergens that must be absent or formally declared for this material.
     *
     * * `celery` - Celery
     * * `cereals_containing_gluten` - Cereals Containing Gluten
     * * `crustaceans` - Crustaceans
     * * `eggs` - Eggs
     * * `fish` - Fish
     * * `lupin` - Lupin
     * * `milk` - Milk
     * * `molluscs` - Molluscs
     * * `mustard` - Mustard
     * * `nuts` - Nuts
     * * `peanuts` - Peanuts
     * * `sesame_seeds` - Sesame Seeds
     * * `soya` - Soya
     * * `sulphur_dioxide` - Sulphur Dioxide
     */
    allergen_requirements: AllergenRequirementsEnum | NullEnum | null;
    /** A signed allergen declaration is required to source this material. */
    require_allergen_declaration: boolean;
    /**
     * Dietary regimes the material must comply with.
     *
     * * `kosher` - Kosher
     * * `halal` - Halal
     * * `organic` - Organic
     * * `vegan` - Vegan
     * * `vegetarian` - Vegetarian
     */
    diet_requirements: DietRequirementsEnum | NullEnum | null;
    /** A dietary certificate is required to validate the diet requirements. */
    require_dietary_certificate: boolean;
    is_active: boolean;
    document_count: number;
    /** @format date-time */
    created_at: string;
}

export interface BrandCreate {
    company_name: string;
    /** @format uri */
    website?: string | null;
    first_name: string;
    last_name: string;
    /** @format email */
    email: string;
    /** @maxLength 10 */
    referred_by?: string;
    phone_country_code?: PhoneCountryCodeEnum | BlankEnum | NullEnum | null;
    registration_number?: string | null;
    phone_number?: string | null;
    company_address: CompanyAddress;
    /** @default true */
    send_welcome_email?: boolean;
    /** @default false */
    send_contract_ready_email?: boolean;
    company_type: ProductTypeEnum[];
}

export interface BrandDashboardCount {
    /** @min 0 */
    orders_in_progress: number;
}

export interface BrandInvoice {
    number: string;
    billed_to: string;
    /** @format date-time */
    billed_on: string;
    due_to: string;
    payment_due_date: string | null;
    payment_status: string;
    /** @format date-time */
    paid_date: string | null;
    payment_details: PaymentDetailsInvoice | null;
    /**
     * * `CNH` - CNH
     * * `NIC` - NIC
     * * `BOV` - BOV
     * * `GIP` - GIP
     * * `ZAL` - ZAL
     * * `ILR` - ILR
     * * `LRD` - LRD
     * * `YUD` - YUD
     * * `BRR` - BRR
     * * `SUR` - SUR
     * * `NLG` - NLG
     * * `CLP` - CLP
     * * `EEK` - EEK
     * * `XPT` - XPT
     * * `MZE` - MZE
     * * `IQD` - IQD
     * * `XBA` - XBA
     * * `TWD` - TWD
     * * `VEF` - VEF
     * * `DOP` - DOP
     * * `UGX` - UGX
     * * `LUF` - LUF
     * * `FJD` - FJD
     * * `BOP` - BOP
     * * `BAM` - BAM
     * * `VND` - VND
     * * `BEL` - BEL
     * * `EGP` - EGP
     * * `MVP` - MVP
     * * `YUR` - YUR
     * * `BND` - BND
     * * `SSP` - SSP
     * * `UYU` - UYU
     * * `KRW` - KRW
     * * `BOB` - BOB
     * * `TJR` - TJR
     * * `USN` - USN
     * * `GQE` - GQE
     * * `ZRZ` - ZRZ
     * * `GBP` - GBP
     * * `VEB` - VEB
     * * `MGF` - MGF
     * * `LSL` - LSL
     * * `BOL` - BOL
     * * `JPY` - JPY
     * * `SDD` - SDD
     * * `BEF` - BEF
     * * `YUM` - YUM
     * * `GNS` - GNS
     * * `ROL` - ROL
     * * `BIF` - BIF
     * * `DKK` - DKK
     * * `MAF` - MAF
     * * `RSD` - RSD
     * * `OMR` - OMR
     * * `NAD` - NAD
     * * `TMM` - TMM
     * * `BEC` - BEC
     * * `ECS` - ECS
     * * `BRE` - BRE
     * * `KZT` - KZT
     * * `SOS` - SOS
     * * `ZWR` - ZWR
     * * `VUV` - VUV
     * * `VED` - VED
     * * `IEP` - IEP
     * * `ESA` - ESA
     * * `KGS` - KGS
     * * `RON` - RON
     * * `RUR` - RUR
     * * `SLL` - SLL
     * * `XFO` - XFO
     * * `KMF` - KMF
     * * `SDP` - SDP
     * * `BGN` - BGN
     * * `ZWD` - ZWD
     * * `MXN` - MXN
     * * `HNL` - HNL
     * * `AON` - AON
     * * `ZMW` - ZMW
     * * `LTL` - LTL
     * * `LUC` - LUC
     * * `VNN` - VNN
     * * `CLF` - CLF
     * * `BAD` - BAD
     * * `PLZ` - PLZ
     * * `ZWL` - ZWL
     * * `AZM` - AZM
     * * `IRR` - IRR
     * * `ISK` - ISK
     * * `CLE` - CLE
     * * `CRC` - CRC
     * * `JMD` - JMD
     * * `RUB` - RUB
     * * `JOD` - JOD
     * * `ETB` - ETB
     * * `UAK` - UAK
     * * `CDF` - CDF
     * * `CHF` - CHF
     * * `ESB` - ESB
     * * `KRO` - KRO
     * * `MZN` - MZN
     * * `BMD` - BMD
     * * `XRE` - XRE
     * * `BWP` - BWP
     * * `NZD` - NZD
     * * `CSD` - CSD
     * * `BUK` - BUK
     * * `ERN` - ERN
     * * `MWK` - MWK
     * * `XDR` - XDR
     * * `GWE` - GWE
     * * `LYD` - LYD
     * * `DDM` - DDM
     * * `XFU` - XFU
     * * `KWD` - KWD
     * * `TTD` - TTD
     * * `PGK` - PGK
     * * `XAG` - XAG
     * * `AZN` - AZN
     * * `NGN` - NGN
     * * `ANG` - ANG
     * * `BGM` - BGM
     * * `MVR` - MVR
     * * `TPE` - TPE
     * * `TZS` - TZS
     * * `CUP` - CUP
     * * `SEK` - SEK
     * * `AED` - AED
     * * `XEU` - XEU
     * * `BYB` - BYB
     * * `MNT` - MNT
     * * `SGD` - SGD
     * * `LAK` - LAK
     * * `ZWG` - ZWG
     * * `SDG` - SDG
     * * `SCR` - SCR
     * * `XAU` - XAU
     * * `THB` - THB
     * * `ARL` - ARL
     * * `XBC` - XBC
     * * `COP` - COP
     * * `MAD` - MAD
     * * `FIM` - FIM
     * * `NPR` - NPR
     * * `GWP` - GWP
     * * `XBB` - XBB
     * * `MTL` - MTL
     * * `EUR` - EUR
     * * `ZRN` - ZRN
     * * `CHW` - CHW
     * * `TRL` - TRL
     * * `GHS` - GHS
     * * `SKK` - SKK
     * * `PYG` - PYG
     * * `XOF` - XOF
     * * `BZD` - BZD
     * * `IDR` - IDR
     * * `STN` - STN
     * * `UYI` - UYI
     * * `XUA` - XUA
     * * `KPW` - KPW
     * * `USD` - USD
     * * `UYP` - UYP
     * * `XPD` - XPD
     * * `BAN` - BAN
     * * `GYD` - GYD
     * * `UGS` - UGS
     * * `CSK` - CSK
     * * `HUF` - HUF
     * * `AFA` - AFA
     * * `SRG` - SRG
     * * `CNX` - CNX
     * * `ALK` - ALK
     * * `GTQ` - GTQ
     * * `MGA` - MGA
     * * `KYD` - KYD
     * * `INR` - INR
     * * `XAF` - XAF
     * * `USS` - USS
     * * `ALL` - ALL
     * * `LKR` - LKR
     * * `XSU` - XSU
     * * `AOA` - AOA
     * * `SAR` - SAR
     * * `PKR` - PKR
     * * `XBD` - XBD
     * * `KES` - KES
     * * `SZL` - SZL
     * * `SVC` - SVC
     * * `MMK` - MMK
     * * `QAR` - QAR
     * * `TRY` - TRY
     * * `PES` - PES
     * * `BGL` - BGL
     * * `PLN` - PLN
     * * `CZK` - CZK
     * * `TND` - TND
     * * `GRD` - GRD
     * * `BYN` - BYN
     * * `MCF` - MCF
     * * `WST` - WST
     * * `VES` - VES
     * * `BTN` - BTN
     * * `PHP` - PHP
     * * `ILP` - ILP
     * * `MLF` - MLF
     * * `HRD` - HRD
     * * `MDC` - MDC
     * * `PAB` - PAB
     * * `SIT` - SIT
     * * `COU` - COU
     * * `MXV` - MXV
     * * `AWG` - AWG
     * * `SYP` - SYP
     * * `DEM` - DEM
     * * `ZMK` - ZMK
     * * `MKN` - MKN
     * * `XPF` - XPF
     * * `AMD` - AMD
     * * `CYP` - CYP
     * * `PEN` - PEN
     * * `TOP` - TOP
     * * `GEK` - GEK
     * * `FRF` - FRF
     * * `MTP` - MTP
     * * `SBD` - SBD
     * * `LVL` - LVL
     * * `MRU` - MRU
     * * `XTS` - XTS
     * * `RHD` - RHD
     * * `MKD` - MKD
     * * `MRO` - MRO
     * * `RWF` - RWF
     * * `AOR` - AOR
     * * `AOK` - AOK
     * * `ILS` - ILS
     * * `BBD` - BBD
     * * `ARP` - ARP
     * * `CVE` - CVE
     * * `LUL` - LUL
     * * `NIO` - NIO
     * * `STD` - STD
     * * `CHE` - CHE
     * * `GMD` - GMD
     * * `FKP` - FKP
     * * `MZM` - MZM
     * * `PEI` - PEI
     * * `ESP` - ESP
     * * `CAD` - CAD
     * * `MUR` - MUR
     * * `NOK` - NOK
     * * `UZS` - UZS
     * * `CUC` - CUC
     * * `MYR` - MYR
     * * `GHC` - GHC
     * * `ISJ` - ISJ
     * * `YDD` - YDD
     * * `BRC` - BRC
     * * `CNY` - CNY
     * * `PTE` - PTE
     * * `DZD` - DZD
     * * `LBP` - LBP
     * * `MOP` - MOP
     * * `DJF` - DJF
     * * `SRD` - SRD
     * * `AUD` - AUD
     * * `YUN` - YUN
     * * `BRN` - BRN
     * * `TMT` - TMT
     * * `XCG` - XCG
     * * `GNF` - GNF
     * * `UAH` - UAH
     * * `ARA` - ARA
     * * `MXP` - MXP
     * * `BRL` - BRL
     * * `AFN` - AFN
     * * `HKD` - HKD
     * * `BHD` - BHD
     * * `YER` - YER
     * * `ARM` - ARM
     * * `ARS` - ARS
     * * `SHP` - SHP
     * * `ITL` - ITL
     * * `KHR` - KHR
     * * `LVR` - LVR
     * * `SLE` - SLE
     * * `XXX` - XXX
     * * `BYR` - BYR
     * * `BRB` - BRB
     * * `ADP` - ADP
     * * `HRK` - HRK
     * * `BDT` - BDT
     * * `BSD` - BSD
     * * `ATS` - ATS
     * * `KRH` - KRH
     * * `ZAR` - ZAR
     * * `ECV` - ECV
     * * `HTG` - HTG
     * * `LTT` - LTT
     * * `MDL` - MDL
     * * `UYW` - UYW
     * * `TJS` - TJS
     * * `BGO` - BGO
     * * `GEL` - GEL
     * * `BRZ` - BRZ
     * * `XCD` - XCD
     */
    currency: AllCurrencies;
    products: ProductDetails[];
    fees?: Fees[] | null;
    /**
     * @format decimal
     * @pattern ^-?\d{0,13}(?:\.\d{0,2})?$
     */
    fees_sum: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,13}(?:\.\d{0,2})?$
     */
    products_price: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,13}(?:\.\d{0,2})?$
     */
    shipping_price: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,13}(?:\.\d{0,2})?$
     */
    total_price: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,13}(?:\.\d{0,2})?$
     */
    vat_sum: string;
}

export interface BrandOnboarding {
    /** @maxLength 255 */
    first_name: string;
    /** @maxLength 255 */
    last_name: string;
    /**
     * @format email
     * @maxLength 255
     */
    email: string;
    /** @maxLength 255 */
    password: string;
    /** @maxLength 255 */
    company_name: string;
    /** @maxLength 100 */
    state?: string;
    /** @maxLength 255 */
    website?: string;
    company_address: CompanyAddress;
    referred_by?: string;
    phone_country_code?: PhoneCountryCodeEnum | BlankEnum | NullEnum | null;
    registration_number?: string | null;
    phone_number?: string | null;
    /** @maxLength 50 */
    duns?: string | null;
    /** @default ["e","h","o","r","t"] */
    product_type?: ProductTypeEnum[];
}

export interface BrandQuoteUpdate {
    /**
     * * `available` - Available
     * * `requested` - Requested
     * * `sent` - Sent
     * * `received` - Received
     * * `accepted` - Accepted
     * * `rejected` - Rejected
     * * `declined` - Declined
     */
    samples_status?: SamplesStatusEnum;
    /** @format uuid */
    samples_delivery_address?: string;
    samples_feedback?: SamplesFeedbackEnum[] | null;
    samples_feedback_comment?: string;
    /** @format date */
    samples_received_date?: string | null;
    /** @format date */
    samples_accepted_date?: string | null;
    /** @format date */
    samples_rejected_date?: string | null;
    /** @format date */
    samples_declined_date?: string | null;
    /** @format date */
    samples_requested_date?: string | null;
    /**
     * * `in_advance` - In Advance
     * * `on_dispatch` - On Dispatch
     * * `7_days_after_dispatch` - Days After Dispatch 7
     * * `14_days_after_dispatch` - Days After Dispatch 14
     * * `30_days_after_dispatch` - Days After Dispatch 30
     * * `60_days_after_dispatch` - Days After Dispatch 60
     */
    requested_payment_terms?: PaymentTermsEnum;
    extension_accepted?: boolean | null;
    payment_terms_updated_by_supplier?: boolean;
}

export interface BrandUser {
    /** @format uuid */
    uuid: string;
    first_name: string;
    last_name: string;
}

export interface BrandVatInvoiceData {
    /** @min 1 */
    invoice_id: number;
    brand_name: string;
    address_line_1: string | null;
    address_line_2: string | null;
    city: string | null;
    country: string | null;
    postal_code: string | null;
    payment_date: string;
    /** @format uuid */
    order_number: string;
    currency: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,10}(?:\.\d{0,2})?$
     */
    total_price_commission: string;
    commission_payin_vat_rate_pct: string | null;
    /**
     * @format decimal
     * @pattern ^-?\d{0,10}(?:\.\d{0,2})?$
     */
    total_price_commission_vat: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,10}(?:\.\d{0,2})?$
     */
    total_price_commission_with_vat: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,10}(?:\.\d{0,2})?$
     */
    fx_rate: string | null;
    /**
     * @format decimal
     * @pattern ^-?\d{0,10}(?:\.\d{0,2})?$
     */
    total_price_fx_fee: string;
    our_address: OurAddress;
}

/**
 * Buyer Business Profile section. Writes a flat shape that the agent's
 * Step-3 Verify panel posts. Mutates `Company` plus a paired
 * `CompanyAddress(address_type=COMPANY)` and (when `use_as_billing` is
 * true) mirrors to `CompanyAddress(address_type=BILLING)`.
 */
export interface BusinessProfile {
    /** @maxLength 255 */
    name: string;
    /** @maxLength 255 */
    registration_name?: string | null;
    /** @maxLength 255 */
    registration_number?: string | null;
    /**
     * Legal entity type captured on the buyer Business Profile section. Required for buyers; left blank for suppliers and merchants of record.
     *
     * * `ltd` - Limited Company (Ltd)
     * * `llp` - Limited Liability Partnership (LLP)
     * * `plc` - Public Limited Company (PLC)
     * * `sole_trader` - Sole Trader
     * * `partnership` - Partnership
     * * `other` - Other
     */
    legal_entity_type: LegalEntityTypeEnum;
    /** @maxLength 255 */
    website?: string | null;
    /** @maxLength 50 */
    vat_number?: string | null;
    /** @maxLength 2 */
    vat_country_code?: string | null;
    phone_country_code?: PhoneCountryCodeEnum | BlankEnum | NullEnum | null;
    /** @maxLength 50 */
    phone_number?: string | null;
    /**
     * @format email
     * @maxLength 254
     */
    buyer_accounts_email_address?: string | null;
    /**
     * @format email
     * @maxLength 254
     */
    buyer_delivery_email_address?: string | null;
    /**
     * The buyer's primary `CompanyAddress(address_type=COMPANY)`. The address
     * country is set server-side from `Company.registration_country_code`, so
     * it is read-only on the wire.
     */
    address?: BusinessProfileAddress;
    /** @default true */
    use_as_billing?: boolean;
    billing_matches_company: string;
    email: string;
    country: string;
}

/**
 * The buyer's primary `CompanyAddress(address_type=COMPANY)`. The address
 * country is set server-side from `Company.registration_country_code`, so
 * it is read-only on the wire.
 */
export interface BusinessProfileAddress {
    /** @format uuid */
    uuid: string;
    /** @maxLength 255 */
    street_1: string;
    /** @maxLength 255 */
    street_2?: string | null;
    /** @maxLength 100 */
    town: string;
    /** @maxLength 100 */
    region?: string | null;
    /** @maxLength 100 */
    postcode: string;
    country: Country | NullEnum | null;
}

export interface BuyerAgreementDetails {
    /** @format uuid */
    uuid: string;
    agreement_number: string;
    /**
     * * `pay_before_dispatch` - Pay Before Dispatch
     * * `pay_after_dispatch` - Pay After Dispatch
     * * `pay_on_28th_second_month_after_dispatch` - Pay on 28th second month after dispatch
     * * `pay_end_of_month_of_dispatch_date` - Pay End of Month of Dispatch Date
     */
    payment_terms?: AppOrderPaymentTermsEnum;
    buyer_currency: string;
    line_items: BuyerAgreementLineItem[];
    shipping_price_for_buyer_in_cents: number;
    buyer_total_shipping_tax_amount_in_buyer_currency_in_cents: number;
    delivery_address: DeliveryAddressResponse | null;
    /** @format double */
    buyer_shipping_tax_rate: number;
    /**
     * @min 0
     * @max 2147483647
     */
    estimated_number_of_orders: number;
    /**
     * @min 0
     * @max 2147483647
     */
    minimum_lead_time_for_first_order_in_days: number;
    /**
     * @min 0
     * @max 2147483647
     */
    minimum_lead_time_for_following_orders_in_days: number;
    /**
     * @min 0
     * @max 2147483647
     */
    days_until_payment_due?: number;
    /** Checks if there is at least one AppOrder associated with this Agreement. */
    has_at_least_one_order: boolean;
    /** @format uuid */
    channel_uuid: string;
    legacy_contract_uuid: string;
    summary: AgreementSummary;
    /** @format date */
    contract_start_date: string;
    /** @format date */
    contract_end_date: string;
    supplier_company_name: string;
    supplier_company_uuid: string;
}

export interface BuyerAgreementLineItem {
    /** @format uuid */
    uuid: string;
    /** @format date-time */
    created_at: string;
    /** @maxLength 255 */
    product_name: string;
    /**
     * * `fl oz` - Fluid Ounces
     * * `g` - Grams
     * * `mg` - milligrams
     * * `gals` - Gallons
     * * `kg` - Kilograms
     * * `L` - Liters
     * * `tons` - Metric Tons
     * * `oz` - Ounces
     * * `lbs` - Pounds
     * * `pcs` - Pieces
     * * `pt` - Pints
     * * `ml` - Milliliter
     * * `boxes` - Boxes
     * * `pallets` - Pallets
     * * `tsp` - Teaspoons
     * * `tbsp` - Tablespoons
     * * `units` - Units
     * * `cases` - Cases
     * * `trays` - Trays
     */
    unit_of_measurement?: UnitOfMeasurementEnum;
    /** @format float */
    buyer_tax_rate: number;
    buyer_unit_price_in_buyer_currency: number;
    buyer_total_price_in_buyer_currency_in_cents: number;
    buyer_total_tax_amount_in_buyer_currency_in_cents: number;
    /**
     * @format decimal
     * @pattern ^-?\d{0,10}(?:\.\d{0,2})?$
     */
    minimum_order_quantity: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,10}(?:\.\d{0,2})?$
     */
    total_quantity_agreed: string;
    /** @maxLength 255 */
    sku?: string | null;
    /** @maxLength 255 */
    product_description?: string | null;
    /** @maxLength 255 */
    packaging_format?: string | null;
    quantity_ordered: number;
    /** @format float */
    quantity: number;
    spec_sheet_document: AgreementLineItemDocument;
    signed_agreement_document: AgreementLineItemDocument;
}

export interface BuyerAgreementList {
    /** @format uuid */
    uuid: string;
    /** @format date-time */
    created_at: string;
    /** @format date */
    contract_end_date: string;
    /** @format date */
    contract_start_date: string;
    line_items: BuyerAgreementLineItem[];
    agreement_number: string;
    /**
     * * `EUR` - EUR
     * * `GBP` - GBP
     * * `USD` - USD
     */
    buyer_currency?: AvailableCurrenciesEnum;
    legacy_contract_uuid: string;
    /** @format date */
    legacy_contract_end_date: string;
    legacy_product_name: string;
    legacy_contract_length: number;
    summary: AgreementSummary;
    supplier_company_name: string;
    supplier_company_uuid: string;
    /**
     * * `pay_before_dispatch` - Pay Before Dispatch
     * * `pay_after_dispatch` - Pay After Dispatch
     * * `pay_on_28th_second_month_after_dispatch` - Pay on 28th second month after dispatch
     * * `pay_end_of_month_of_dispatch_date` - Pay End of Month of Dispatch Date
     */
    payment_terms?: AppOrderPaymentTermsEnum;
    lead_time_days: number;
}

/** Response serializer for the buyer allocated credit endpoint. */
export interface BuyerAllocatedCreditResponse {
    /** The buyer's currency code (e.g., 'GBP', 'EUR') */
    buyer_currency: string;
    /** Allocated credit for Two payment provider */
    two: ProviderAllocatedCredit;
    /** Allocated credit for Stripe payment provider */
    stripe: ProviderAllocatedCredit;
    /** Allocated credit for Two organic orders (credit risk held by Two) */
    two_organic: ProviderAllocatedCreditWithForecast;
    /** Allocated credit for Two recourse orders (credit risk held by Allianz) */
    two_recourse: ProviderAllocatedCreditWithForecast;
    /** Allocated credit for Stripe (same as stripe, with forecasted) */
    stripe_allocated: ProviderAllocatedCreditWithForecast;
    /** Total allocated credit for orders with no credit risk owner (cents, visibility only) */
    empty_credit_risk_owner_total: number;
    /** Credit limits from Two/Allianz APIs with effective available credit and status. */
    credit_limits: CreditLimits;
}

/** Buyer surface — uses the nested serializer that hides `supplier_document_url`. */
export interface BuyerAppOrderDetails {
    /** @format uuid */
    uuid: string;
    /** @format date-time */
    created_at: string;
    /** @format date-time */
    modified_at: string;
    ordered_by: number;
    /**
     * * `initializing` - Initializing
     * * `not_started` - Not Started
     * * `due` - Due
     * * `overdue` - Overdue
     * * `awaiting_reconciliation` - Awaiting Reconciliation
     * * `paid` - Paid
     * * `refunded` - Refunded
     * * `partially_refunded` - Partially Refunded
     */
    pay_in_state?: PayInStateEnum;
    /**
     * * `initializing` - Initializing
     * * `confirmed` - Confirmed
     * * `canceled` - Cancelled
     * * `pending_merchant_of_record_approval` - Pending Merchant of Record Approval
     * * `order_received` - Order Received
     * * `order_sent_to_supplier` - Order Sent To Supplier
     * * `order_confirming_price` - Order Confirming Price
     * * `forecasted` - Forecasted
     */
    lifecycle_state?: LifecycleStateEnum;
    /**
     * * `initializing` - Initializing
     * * `not_started` - Not Started
     * * `pending_dispatch` - Pending Dispatch
     * * `in_transit` - In Transit
     * * `delivered` - Delivered
     * * `freight_ownership_pending` - Freight Ownership Pending
     * * `gathering_quotes` - Gathering Quotes
     * * `dispatch_scheduled` - Dispatch Scheduled
     * * `awaiting_collection_details` - Awaiting Collection Details
     * * `ready_for_pickup` - Ready for Pickup
     * * `picked_up` - Picked Up
     * * `preparing_freight` - Preparing Freight
     * * `freight_scheduled` - Freight Scheduled
     * * `gathering_freight_quotes` - Gathering Freight Quotes
     * * `quotes_confirmed` - Quotes Confirmed
     */
    delivery_state?: DeliveryStateEnum;
    /**
     * * `pay_before_dispatch` - Pay Before Dispatch
     * * `pay_after_dispatch` - Pay After Dispatch
     * * `pay_on_28th_second_month_after_dispatch` - Pay on 28th second month after dispatch
     * * `pay_end_of_month_of_dispatch_date` - Pay End of Month of Dispatch Date
     */
    payment_terms?: AppOrderPaymentTermsEnum;
    order_number: string;
    company_ordered_by: CompanyNameAndId;
    company_ordered_from: CompanyNameAndId;
    /**
     * Check if the supplier has a registered CompanyReferral with the buyer,
     * meaning the buyer can access the supplier through the my-suppliers endpoint.
     */
    is_supplier_accessible: boolean;
    buyer_currency: string;
    shipping_price_in_supplier_currency: number;
    import_fee_price_in_buyer_currency: number | null;
    export_fee_price_in_supplier_currency: number | null;
    /**
     * US-only. Flat sales-tax amount as it appears on the supplier invoice, in supplier currency cents. This value is the tax itself — it is added to the order's with-tax totals and excluded from the without-tax totals (no further tax is applied to it). Buyer-side amount is derived via the order's supplier_to_buyer_currency_conversion_rate.
     * @format int64
     * @min 0
     * @max 9223372036854776000
     */
    sales_tax_in_supplier_currency_in_cents?: number | null;
    line_items: BuyerOrderLineItem[];
    /** @format date */
    dispatched_at: string | null;
    /** @format date */
    estimated_delivery_date: string | null;
    tracking_code: string | null;
    shipping_provider: string | null;
    shipping_price_for_buyer: number;
    buyer_total_shipping_tax_amount_in_buyer_currency: number;
    /** US-only flat sales tax in buyer-currency cents. 0 when unset. */
    buyer_total_sales_tax_amount_in_buyer_currency: number;
    total_order_price_for_buyer: number;
    total_order_vat: number;
    delivery_address: DeliveryAddressResponse | null;
    payment_due_date: string;
    /**
     * Invoice due date from Two, set when order.reconciliation.invoiced.v1 webhook is received
     * @format date
     */
    two_invoice_due_date?: string | null;
    /** @format double */
    buyer_shipping_tax_rate: number;
    /** @format uuid */
    channel_uuid: string;
    /**
     * @min 0
     * @max 2147483647
     */
    buyer_payment_period?: number;
    /** @format date */
    delivery_date: string;
    legacy_order_uuid: string;
    legacy_order_payment_status: string;
    documents: BuyerAppOrderDocument[];
    is_spot_order: string;
    buyer_purchase_order_reference: string | null;
    payment_provider: string | null;
    /**
     * * `buyer` - Buyer
     * * `supplier` - Supplier
     * * `unknown` - Unknown
     * * `to_be_confirmed` - To Be Confirmed
     * * `merchant_of_record` - Merchant of Record
     */
    shipping_responsibility?: ShippingResponsibilityEnum;
    supplier_site: SupplierSite;
    is_direct_order: boolean;
    supplier_payout_details: SupplierPayoutDetails | null;
    is_on_hold: boolean;
    hold_details: {
        /** @format date-time */
        held_at?: string;
        hold_public_notes?: string;
    } | null;
    /** @format date */
    forecast_date: string;
    total_pay_in_refunded_amount: number;
    two_order_has_invoice: boolean;
    direct_order_has_invoice: boolean;
    bank_details: BankDetail[];
    originating_adjustments: BuyerNestedOrderAdjustment[];
    applied_adjustments: BuyerNestedOrderAdjustment[];
}

export interface BuyerAppOrderDocument {
    /** @format uuid */
    uuid: string;
    /** @format uri */
    document: string;
    file_name: string;
    /** @format date-time */
    created_at: string;
    type: AppOrderDocumentType;
}

export interface BuyerAppOrderList {
    /** @format uuid */
    uuid: string;
    /** @format date-time */
    created_at: string;
    /** @format date-time */
    modified_at: string;
    ordered_by: number;
    /**
     * * `initializing` - Initializing
     * * `confirmed` - Confirmed
     * * `canceled` - Cancelled
     * * `pending_merchant_of_record_approval` - Pending Merchant of Record Approval
     * * `order_received` - Order Received
     * * `order_sent_to_supplier` - Order Sent To Supplier
     * * `order_confirming_price` - Order Confirming Price
     * * `forecasted` - Forecasted
     */
    lifecycle_state?: LifecycleStateEnum;
    /**
     * * `initializing` - Initializing
     * * `not_started` - Not Started
     * * `due` - Due
     * * `overdue` - Overdue
     * * `awaiting_reconciliation` - Awaiting Reconciliation
     * * `paid` - Paid
     * * `refunded` - Refunded
     * * `partially_refunded` - Partially Refunded
     */
    pay_in_state?: PayInStateEnum;
    /**
     * * `initializing` - Initializing
     * * `not_started` - Not Started
     * * `pending_dispatch` - Pending Dispatch
     * * `in_transit` - In Transit
     * * `delivered` - Delivered
     * * `freight_ownership_pending` - Freight Ownership Pending
     * * `gathering_quotes` - Gathering Quotes
     * * `dispatch_scheduled` - Dispatch Scheduled
     * * `awaiting_collection_details` - Awaiting Collection Details
     * * `ready_for_pickup` - Ready for Pickup
     * * `picked_up` - Picked Up
     * * `preparing_freight` - Preparing Freight
     * * `freight_scheduled` - Freight Scheduled
     * * `gathering_freight_quotes` - Gathering Freight Quotes
     * * `quotes_confirmed` - Quotes Confirmed
     */
    delivery_state?: DeliveryStateEnum;
    /**
     * * `pay_before_dispatch` - Pay Before Dispatch
     * * `pay_after_dispatch` - Pay After Dispatch
     * * `pay_on_28th_second_month_after_dispatch` - Pay on 28th second month after dispatch
     * * `pay_end_of_month_of_dispatch_date` - Pay End of Month of Dispatch Date
     */
    payment_terms?: AppOrderPaymentTermsEnum;
    order_number: string;
    company_ordered_by: CompanyNameAndId;
    company_ordered_from: CompanyNameAndId;
    buyer_currency: string;
    line_items: BuyerOrderLineItem[];
    total_order_price_for_buyer: number;
    legacy_delivery_status: LegacyDeliveryStatusEnum;
    legacy_payment_status: LegacyPaymentStatusEnum;
    legacy_lifecycle_status: LegacyLifecycleStatusEnum;
    legacy_total_order_price: number;
    legacy_ingredients: {
        product_name: string;
    }[];
    legacy_order_uuid: string;
    buyer_purchase_order_reference: string | null;
    /** @format date */
    estimated_delivery_date: string | null;
    /** @format date */
    delivery_date: string;
    post_code: string;
    address_name: string;
    supplier_site?: number | null;
    is_on_hold: boolean;
    is_payment_needed: boolean;
    /**
     * * `stripe` - Stripe
     * * `two` - Two
     * * `direct` - Direct
     */
    payment_provider?: PaymentProviderEnum;
    /** @format date */
    payment_due_date: string;
    /**
     * * `buyer` - Buyer
     * * `supplier` - Supplier
     * * `unknown` - Unknown
     * * `to_be_confirmed` - To Be Confirmed
     * * `merchant_of_record` - Merchant of Record
     */
    shipping_responsibility?: ShippingResponsibilityEnum;
    total_pay_in_refunded_amount: number;
}

/** Serializer for supplier with uuid, name, and lead time (drives the order-request calendar block). */
export interface BuyerAppOrderListSuppliers {
    /** @format uuid */
    uuid: string;
    /** @maxLength 255 */
    name: string;
    /**
     * Default number of calendar days this supplier needs between order and delivery. Factored into the earliest selectable delivery date on orders.
     * @min 0
     * @max 365
     */
    supplier_lead_time_days?: number | null;
}

export interface BuyerAvailablePaymentSections {
    available_payment_providers: AvailablePaymentProvidersEnum[];
    has_service_fees: boolean;
}

export interface BuyerBalance {
    /** @maxLength 3 */
    currency: string;
    /** Balance in cents */
    balance: number;
    /** @format date */
    next_due_date: string | null;
    /** Next payment amount in cents */
    next_payment_amount: number;
}

export interface BuyerClientNotifiedAsPaid {
    file_name?: string | null;
}

/**
 * Wraps the active OMC with a `state` discriminator so the FE can render
 * an empty card when the buyer has no current contract.
 */
export interface BuyerCurrentOrderManagementContract {
    /**
     * * `active` - Active
     * * `empty` - Empty
     */
    state: BuyerCurrentOrderManagementContractStateEnum;
    data: BuyerOrderManagementContractActiveData | null;
}

/**
 * * `active` - Active
 * * `empty` - Empty
 */
export enum BuyerCurrentOrderManagementContractStateEnum {
    Active = "active",
    Empty = "empty",
}

/**
 * Serializer for BuyerDocument — buyer certification and compliance documents.
 *
 * Handles CRUD with computed status fields, mirroring OpplyDocumentSerializer.
 */
export interface BuyerDocument {
    /** @format uuid */
    uuid: string;
    type: DocumentType;
    /** @format uuid */
    type_uuid?: string;
    /** @format uuid */
    renewing_uuid?: string | null;
    /**
     * The uploaded document file
     * @format uri
     */
    file: string;
    /**
     * Display name for the document
     * @maxLength 255
     */
    name: string;
    /**
     * Start date of document validity
     * @format date
     */
    start_date?: string | null;
    /**
     * End/expiry date of document validity
     * @format date
     */
    end_date?: string | null;
    /** ISO country codes this document applies to. Empty = all countries. */
    countries?: Country[];
    /**
     * Optional notes about this document
     * @maxLength 2048
     */
    notes?: string | null;
    status: DocumentLifecycleStatusEnum;
    /** Return whether the document is archived (expired or renewed). */
    is_archived: boolean;
    /** @format uuid */
    superseded_by_uuid: string | null;
    /** @format date-time */
    created: string;
    /** @format date-time */
    modified: string;
}

/** Read serializer returned for list/create responses. */
export interface BuyerFinancialDocument {
    /** @format uuid */
    uuid: string;
    /**
     * Category of financial document — drives how the credit team triages the upload.
     *
     * * `management_accounts` - Management Accounts
     * * `audited_accounts` - Audited Accounts
     * * `balance_sheet` - Balance Sheet
     * * `profit_and_loss` - Profit and Loss
     * * `cashflow_forecast` - Cashflow Forecast
     * * `sales_tax_exemption` - Sales Tax Exemption
     * * `other` - Other
     */
    type: BuyerFinancialDocumentTypeEnum;
    /** Filename as supplied by the user at upload time (preserved for display). */
    original_filename: string;
    /** Size of the uploaded file in bytes; capped at the application-level upload limit. */
    file_size_bytes: number;
    file_url: string | null;
    uploaded_by_name: string | null;
    /** @format date-time */
    created_at: string;
    /** Display name (sales-tax exemptions only; blank for other financial docs). */
    name: string;
    /**
     * Start date of document validity (sales-tax exemptions only).
     * @format date
     */
    start_date: string | null;
    /**
     * End/expiry date of document validity (sales-tax exemptions only).
     * @format date
     */
    end_date: string | null;
    /** Permit / exemption / certificate number as printed (sales-tax exemptions only). */
    certificate_number: string;
    /** State/region the document applies in, as printed (e.g. 'Michigan'). For US documents the structured counterpart is us_state_jurisdiction. */
    jurisdiction: string;
    /** Body that issued the document (e.g. 'Michigan Department of Treasury'). */
    issuing_authority: string;
    /** Entity the document is issued to as printed — normally the buyer company. */
    holder_name: string;
}

/**
 * * `management_accounts` - Management Accounts
 * * `audited_accounts` - Audited Accounts
 * * `balance_sheet` - Balance Sheet
 * * `profit_and_loss` - Profit and Loss
 * * `cashflow_forecast` - Cashflow Forecast
 * * `sales_tax_exemption` - Sales Tax Exemption
 * * `other` - Other
 */
export enum BuyerFinancialDocumentTypeEnum {
    ManagementAccounts = "management_accounts",
    AuditedAccounts = "audited_accounts",
    BalanceSheet = "balance_sheet",
    ProfitAndLoss = "profit_and_loss",
    CashflowForecast = "cashflow_forecast",
    SalesTaxExemption = "sales_tax_exemption",
    Other = "other",
}

/** Write serializer for multipart uploads. */
export interface BuyerFinancialDocumentUpload {
    /** @format binary */
    file: File;
    /** @default "management_accounts" */
    type?: BuyerFinancialDocumentTypeEnum;
}

export interface BuyerGroupedStatementDetail {
    /** @format uuid */
    uuid: string;
    /** Human-readable statement identifier (e.g. 2026-MAY-TWO-000042) */
    statement_id: string;
    merchant_of_record_company_name: string;
    payment_provider: PaymentProviderEnum;
    status: GroupedStatementStatusEnum;
    /**
     * Date by which payment is expected. Grouping key.
     * @format date
     */
    due_date: string;
    currency: AvailableCurrenciesEnum;
    /** Subtotal in cents (before tax). Sum of member orders' subtotals. */
    subtotal: number;
    /** Tax amount in cents. Sum of member orders' tax. */
    tax: number;
    /** Total in cents (subtotal + tax). Sum of member orders' totals. */
    total: number;
    /** Outstanding amount in cents. total - sum(OrderPayment.amount_cents) across member orders. Recomputed on allocation events. No default — services creating a statement must set this explicitly (typically equal to `total` before any payments arrive). */
    total_outstanding: number;
    order_count: number;
    /** @format date-time */
    paid_at: string | null;
    /** Payment reference copied from the provider's report. Used in reconciliation. */
    external_payment_id: string | null;
    orders: BuyerGroupedStatementOrder[];
    bank_details: BankDetail[];
}

export interface BuyerGroupedStatementList {
    /** @format uuid */
    uuid: string;
    /** Human-readable statement identifier (e.g. 2026-MAY-TWO-000042) */
    statement_id: string;
    merchant_of_record_company_name: string;
    payment_provider: PaymentProviderEnum;
    status: GroupedStatementStatusEnum;
    /**
     * Date by which payment is expected. Grouping key.
     * @format date
     */
    due_date: string;
    currency: AvailableCurrenciesEnum;
    /** Subtotal in cents (before tax). Sum of member orders' subtotals. */
    subtotal: number;
    /** Tax amount in cents. Sum of member orders' tax. */
    tax: number;
    /** Total in cents (subtotal + tax). Sum of member orders' totals. */
    total: number;
    /** Outstanding amount in cents. total - sum(OrderPayment.amount_cents) across member orders. Recomputed on allocation events. No default — services creating a statement must set this explicitly (typically equal to `total` before any payments arrive). */
    total_outstanding: number;
    order_count: number;
    /** @format date-time */
    paid_at: string | null;
    /** Payment reference copied from the provider's report. Used in reconciliation. */
    external_payment_id: string | null;
}

/** Order summary nested inside a buyer's grouped statement detail response. */
export interface BuyerGroupedStatementOrder {
    /** @format uuid */
    uuid: string;
    order_number: string;
    lifecycle_state: LifecycleStateEnum;
    pay_in_state: PayInStateEnum;
    payment_provider: PaymentProviderEnum;
    /** @format date */
    dispatched_at: string | null;
    subtotal_cents: number;
    tax_cents: number;
    total_cents: number;
    total_outstanding: number;
    two_order_has_invoice: boolean;
}

export interface BuyerItemCreate {
    /** @maxLength 255 */
    item_name: string;
    /** @maxLength 255 */
    sku?: string | null;
    item_description?: string | null;
    /**
     * @format uri
     * @maxLength 2048
     */
    logo_url?: string;
    /** @format uuid */
    buyer_company_uuid: string;
    /** @format uuid */
    category_uuid?: string | null;
    /**
     * What kind of material this row represents (ingredient, packaging, ...).
     *
     * * `ingredient` - Ingredient
     * * `packaging` - Packaging
     */
    kind?: CatalogItemKindEnum;
    /**
     * Natural unit the material is measured in.
     *
     * * `fl oz` - Fluid Ounces
     * * `g` - Grams
     * * `mg` - milligrams
     * * `gals` - Gallons
     * * `kg` - Kilograms
     * * `L` - Liters
     * * `tons` - Metric Tons
     * * `oz` - Ounces
     * * `lbs` - Pounds
     * * `pcs` - Pieces
     * * `pt` - Pints
     * * `ml` - Milliliter
     * * `boxes` - Boxes
     * * `pallets` - Pallets
     * * `tsp` - Teaspoons
     * * `tbsp` - Tablespoons
     * * `units` - Units
     * * `cases` - Cases
     * * `trays` - Trays
     */
    unit_of_measurement?: UnitOfMeasurementEnum;
    allergen_requirements?: AllergenRequirementsEnum[];
    /** A signed allergen declaration is required to source this material. */
    require_allergen_declaration?: boolean;
    diet_requirements?: DietRequirementsEnum[];
    /** A dietary certificate is required to validate the diet requirements. */
    require_dietary_certificate?: boolean;
}

export interface BuyerItemDetail {
    /** @format uuid */
    uuid: string;
    /** @maxLength 255 */
    item_name: string;
    /** @maxLength 255 */
    sku?: string | null;
    item_description?: string | null;
    /**
     * @format uri
     * @maxLength 2048
     */
    logo_url?: string;
    /** @format uuid */
    buyer_company_uuid: string;
    buyer_company_name: string;
    /** @format uuid */
    category_uuid?: string | null;
    /**
     * What kind of material this row represents (ingredient, packaging, ...).
     *
     * * `ingredient` - Ingredient
     * * `packaging` - Packaging
     */
    kind?: CatalogItemKindEnum;
    /**
     * Natural unit the material is measured in.
     *
     * * `fl oz` - Fluid Ounces
     * * `g` - Grams
     * * `mg` - milligrams
     * * `gals` - Gallons
     * * `kg` - Kilograms
     * * `L` - Liters
     * * `tons` - Metric Tons
     * * `oz` - Ounces
     * * `lbs` - Pounds
     * * `pcs` - Pieces
     * * `pt` - Pints
     * * `ml` - Milliliter
     * * `boxes` - Boxes
     * * `pallets` - Pallets
     * * `tsp` - Teaspoons
     * * `tbsp` - Tablespoons
     * * `units` - Units
     * * `cases` - Cases
     * * `trays` - Trays
     */
    unit_of_measurement?: UnitOfMeasurementEnum;
    allergen_requirements?: AllergenRequirementsEnum[];
    /** A signed allergen declaration is required to source this material. */
    require_allergen_declaration?: boolean;
    diet_requirements?: DietRequirementsEnum[];
    /** A dietary certificate is required to validate the diet requirements. */
    require_dietary_certificate?: boolean;
    is_active?: boolean;
    documents: BuyerItemDocument[];
    /** @format date-time */
    created_at: string;
    /** @format date-time */
    modified_at: string;
}

export interface BuyerItemDocument {
    /** @format uuid */
    uuid: string;
    /** @format uri */
    document: string;
    file_name: string;
    category: CatalogItemDocumentCategoryEnum;
    /**
     * Start date of document validity
     * @format date
     */
    start_date: string | null;
    /**
     * End/expiry date of document validity
     * @format date
     */
    end_date: string | null;
    is_active: boolean;
    status: string;
    is_archived: boolean;
    /** @format date-time */
    created_at: string;
}

export interface BuyerItemDocumentUpload {
    file_name: string;
    /**
     * * `spec_sheet` - Spec Sheet
     * * `certificate_of_analysis` - Certificate of Analysis
     * * `british_retail_consortium` - British Retail Consortium
     * * `international_organisation_for_standardisation` - International Organisation for Standardisation
     * * `foundation_food_safety_system_certification` - Foundation Food Safety System Certification
     * * `international_featured_standards` - International Featured Standards
     * * `safe_quality_food` - Safe Quality Food
     */
    category: CatalogItemDocumentCategoryEnum;
    /** @format date */
    start_date?: string | null;
    /** @format date */
    end_date?: string | null;
}

export interface BuyerItemList {
    /** @format uuid */
    uuid: string;
    item_name: string;
    sku: string | null;
    item_description: string | null;
    /** @format uri */
    logo_url: string;
    /** @format uuid */
    buyer_company_uuid: string;
    buyer_company_name: string;
    /** @format uuid */
    merchant_of_record_company_uuid: string;
    /** @format uuid */
    category_uuid: string | null;
    /**
     * What kind of material this row represents (ingredient, packaging, ...).
     *
     * * `ingredient` - Ingredient
     * * `packaging` - Packaging
     */
    kind: CatalogItemKindEnum;
    /**
     * Natural unit the material is measured in.
     *
     * * `fl oz` - Fluid Ounces
     * * `g` - Grams
     * * `mg` - milligrams
     * * `gals` - Gallons
     * * `kg` - Kilograms
     * * `L` - Liters
     * * `tons` - Metric Tons
     * * `oz` - Ounces
     * * `lbs` - Pounds
     * * `pcs` - Pieces
     * * `pt` - Pints
     * * `ml` - Milliliter
     * * `boxes` - Boxes
     * * `pallets` - Pallets
     * * `tsp` - Teaspoons
     * * `tbsp` - Tablespoons
     * * `units` - Units
     * * `cases` - Cases
     * * `trays` - Trays
     */
    unit_of_measurement: UnitOfMeasurementEnum;
    /**
     * Allergens that must be absent or formally declared for this material.
     *
     * * `celery` - Celery
     * * `cereals_containing_gluten` - Cereals Containing Gluten
     * * `crustaceans` - Crustaceans
     * * `eggs` - Eggs
     * * `fish` - Fish
     * * `lupin` - Lupin
     * * `milk` - Milk
     * * `molluscs` - Molluscs
     * * `mustard` - Mustard
     * * `nuts` - Nuts
     * * `peanuts` - Peanuts
     * * `sesame_seeds` - Sesame Seeds
     * * `soya` - Soya
     * * `sulphur_dioxide` - Sulphur Dioxide
     */
    allergen_requirements: AllergenRequirementsEnum | NullEnum | null;
    /** A signed allergen declaration is required to source this material. */
    require_allergen_declaration: boolean;
    /**
     * Dietary regimes the material must comply with.
     *
     * * `kosher` - Kosher
     * * `halal` - Halal
     * * `organic` - Organic
     * * `vegan` - Vegan
     * * `vegetarian` - Vegetarian
     */
    diet_requirements: DietRequirementsEnum | NullEnum | null;
    /** A dietary certificate is required to validate the diet requirements. */
    require_dietary_certificate: boolean;
    is_active: boolean;
    document_count: number;
    /** @format date-time */
    created_at: string;
}

/** Serializer for marking an order as picked up by the buyer. */
export interface BuyerMarkAsPickedUp {
    tracking_code?: string | null;
    shipping_provider?: string | null;
    /** @format date */
    estimated_delivery_date: string;
    /** @format date */
    dispatched_at: string;
}

/**
 * Polymorphic row inside the merged Merchant-of-Record listing.
 *
 * Each row is either a Stripe order (``type='order'``) or a service-fee
 * statement (``type='service_fee_invoice'``). Both share the core
 * columns the merged buyer-app table renders (uuid / order_number /
 * supplier_name / subtotal / tax / total / currency / pay_in_state /
 * payment_due_date); statements additionally carry their nested
 * ``orders`` array so the row can expand to show its breakdown.
 */
export interface BuyerMerchantOfRecordItem {
    /**
     * * `order` - Order
     * * `service_fee_invoice` - Service fee invoice
     */
    type: BuyerPaymentRowKindEnum;
    /** @format uuid */
    uuid: string;
    order_number: string;
    supplier_name: string | null;
    merchant_of_record_company_name: string;
    subtotal: string;
    tax: string;
    total: string;
    currency: string;
    pay_in_state: string;
    payment_terms: string | null;
    payment_due_date: string | null;
    orders?: BuyerServiceFeeOrder[] | null;
}

/**
 * Combined Merchant-of-Record payments listing — Stripe (MoR) orders **and**
 * service-fee statements in a single sorted, paginated list. Each item is
 * a polymorphic row tagged with `type`. Backs the
 * /payments/merchant-of-record/ endpoint. Legacy /payments/ and
 * /payments/service-fees/ remain so older consumers keep working.
 */
export interface BuyerMerchantOfRecordPaymentsListing {
    items: BuyerMerchantOfRecordItem[];
    items_count: number;
    bank_details: BankDetail[];
    /** Serializer for the available filter options. */
    filters: PaymentFilters;
}

/**
 * Slim adjustment payload for the buyer-facing inline arrays on order-detail.
 *
 * Used by `BuyerAppOrderDetailsSerializer` to expose `originating_adjustments`
 * and `applied_adjustments` without an extra round trip. The supplier-uploaded
 * document is deliberately not included here — exposing it would leak an
 * internal artefact. MoR users see the same arrays via
 * `MerchantOfRecordNestedOrderAdjustmentSerializer`, which adds
 * `supplier_document_url`.
 *
 * Cross-order links are exposed via `originating_order_uuid` / `_number` and
 * `applied_to_order_uuid` / `_number` so the FE can render "Order #5734-…"
 * references without resolving the FKs separately.
 */
export interface BuyerNestedOrderAdjustment {
    /** @format uuid */
    uuid: string;
    /**
     * CREDIT_NOTE reduces the buyer's amount due; DEBIT_NOTE adds an additional charge to the buyer
     *
     * * `credit_note` - Credit Note
     * * `debit_note` - Debit Note
     */
    type: OrderAdjustmentTypeEnum;
    status: OrderAdjustmentStatusEnum;
    /** Pre-tax adjustment amount in cents */
    base_amount: number;
    /** Tax amount in cents */
    tax_amount: number;
    /** Total in cents (base_amount + tax_amount); always positive — type indicates direction */
    total_amount: number;
    currency: AvailableCurrenciesEnum;
    /** MoR-entered reason for the adjustment (internal/audit). Required for source=MANUAL; null for WEBHOOK / BACKFILL rows. */
    reason: string | null;
    /** @format uuid */
    originating_order_uuid: string;
    originating_order_number: string;
    /** @format uuid */
    applied_to_order_uuid: string;
    applied_to_order_number: string;
    /** Provider invoice ID at apply time (snapshotted) */
    applied_to_invoice_id: string | null;
    /** Cached PDF URL from the provider; refresh via API as needed */
    provider_document_pdf_url: string | null;
    /** @format date-time */
    pending_application_at: string | null;
    /** @format date-time */
    applied_at: string | null;
    /** @format date-time */
    created_at: string;
}

/**
 * * `us` - United States
 * * `uk` - United Kingdom
 */
export enum BuyerOnboardingCountry {
    Us = "us",
    Uk = "uk",
}

/**
 * Serializer for BuyerOnboardingDeliveryAddress model.
 * Includes all BaseAddress fields plus delivery-specific fields.
 */
export interface BuyerOnboardingDeliveryAddress {
    /** @format uuid */
    uuid: string;
    /** @maxLength 255 */
    name: string;
    /**
     * * `billing_address` - Billing address
     * * `delivery_address` - Delivery address
     * * `dispatch_address` - Dispatch address
     * * `company_address` - Company address
     */
    address_type?: AddressTypeEnum;
    /** @maxLength 255 */
    contact_full_name?: string | null;
    /** @maxLength 50 */
    contact_phone?: string | null;
    /** @maxLength 100 */
    building?: string | null;
    /** @maxLength 255 */
    street_1?: string | null;
    /** @maxLength 255 */
    street_2?: string | null;
    /** @maxLength 100 */
    town?: string | null;
    /** @maxLength 100 */
    region?: string | null;
    /** @maxLength 100 */
    postcode?: string | null;
    country?: Country | BlankEnum | NullEnum | null;
    /** @maxLength 100 */
    place_id?: string | null;
    /**
     * @format decimal
     * @pattern ^-?\d{0,4}(?:\.\d{0,15})?$
     */
    latitude?: string | null;
    /**
     * @format decimal
     * @pattern ^-?\d{0,4}(?:\.\d{0,15})?$
     */
    longitude?: string | null;
    /** @maxLength 50 */
    vat_number?: string | null;
    vat_country_code?: Country | BlankEnum | NullEnum | null;
    vat_exempt?: boolean;
    phone_country_code?: PhoneCountryCodeEnum | BlankEnum | NullEnum | null;
    delivery_instructions?: string | null;
    collection_instructions?: string | null;
    /**
     * * `EU` - Eu
     * * `GB` - Gb
     * * `Other` - Other
     */
    country_type?: CountryTypeEnum;
    /** @maxLength 20 */
    eori_number?: string;
    /** @maxLength 20 */
    ein_number?: string;
    /**
     * Type of delivery location
     *
     * * `warehouse` - Warehouse
     * * `factory` - Factory
     * * `distribution_center` - Distribution Center
     * * `retail_location` - Retail Location
     * * `other` - Other
     */
    delivery_location_type?: DeliveryLocationTypeEnum | BlankEnum;
    delivery_location_type_display: string;
    /**
     * Specify delivery location type when 'Other' is selected
     * @maxLength 255
     */
    delivery_location_type_other?: string;
    /**
     * Warehouse receiving hours
     * @maxLength 255
     */
    warehouse_receiving_hours?: string;
    /** @format date-time */
    created: string;
    /** @format date-time */
    modified: string;
}

/**
 * Detailed serializer for buyer onboarding.
 * Includes all related information.
 *
 * For self-onboarded buyers (`buyer_onboarding.company` is set), the
 * name / email fields are derived from the canonical `Company` /
 * `User`, and `has_account_details` / `has_delivery_details` consider
 * Company columns alongside the legacy AccountDetail/DeliveryDetails
 * tables.
 */
export interface BuyerOnboardingDetail {
    /**
     * Unique identifier for sharing the onboarding form
     * @format uuid
     */
    uuid: string;
    name: string;
    email: string;
    /**
     * * `us` - United States
     * * `uk` - United Kingdom
     */
    country: BuyerOnboardingCountry;
    company_uuid: string;
    company_name: string;
    /** Internal notes */
    notes?: string;
    /**
     * When the buyer submitted the form
     * @format date-time
     */
    submitted_at: string | null;
    is_submitted: string;
    total_steps: string;
    completed_steps: string;
    has_account_details: string;
    has_delivery_details: string;
    suppliers_count: string;
    suppliers_pending_review_count: string;
    suppliers_completed: string;
    /**
     * When the supplier section was marked as complete
     * @format date-time
     */
    suppliers_completed_at: string | null;
    /** @format date-time */
    created_at: string;
    /** @format date-time */
    modified_at: string;
}

/** Serializer for BuyerOnboardingDocument model. */
export interface BuyerOnboardingDocument {
    /**
     * Unique identifier for document lookup
     * @format uuid
     */
    uuid: string;
    /**
     * Uploaded document
     * @format uri
     */
    document: string;
    document_url: string;
    /** Optional description of the document */
    description?: string | null;
    /** @format date-time */
    created_at: string;
    /** @format date-time */
    modified_at: string;
}

/**
 * Response serializer for the legacy `generate-link` endpoint.
 * Includes the UUID-based shareable onboarding URL.
 */
export interface BuyerOnboardingLinkResponse {
    /** @format uuid */
    uuid: string;
    name: string;
    /** @format email */
    email: string;
    country: BuyerOnboardingCountry;
    link: string;
    /** @format date-time */
    created_at: string;
}

/**
 * Serializer for listing buyer onboardings.
 * Includes summary information about steps and submission status.
 *
 * For self-onboarded buyers (`buyer_onboarding.company` is set), the
 * name / email / company_uuid / company_name fields are derived from the
 * canonical `Company` + `created_by` `User` rather than the mirror fields
 * on BuyerOnboarding, which are only seeded at creation time.
 */
export interface BuyerOnboardingList {
    /**
     * Unique identifier for sharing the onboarding form
     * @format uuid
     */
    uuid: string;
    name: string;
    email: string;
    /**
     * * `us` - United States
     * * `uk` - United Kingdom
     */
    country: BuyerOnboardingCountry;
    company_uuid: string;
    company_name: string;
    /** Internal notes */
    notes?: string;
    /**
     * When the buyer submitted the form
     * @format date-time
     */
    submitted_at?: string | null;
    is_submitted: string;
    total_steps: string;
    completed_steps: string;
    /** @format date-time */
    created_at: string;
    /** @format date-time */
    modified_at: string;
}

/** Serializer for buyer onboarding step with template information. */
export interface BuyerOnboardingStep {
    id: number;
    /** The template this step is based on */
    template_step: number;
    template_phase: string;
    template_phase_display: string;
    process_description: string;
    template_step_order: number;
    /** Buyer-specific notes for this step */
    notes?: string;
    /** Whether this step is completed */
    is_completed?: boolean;
    /**
     * When this step was completed
     * @format date-time
     */
    completed_at: string | null;
    /** Who completed this step */
    completed_by: number | null;
    /** @format email */
    completed_by_email: string;
    /**
     * Custom order for this buyer (overrides template step order)
     * @min 0
     * @max 2147483647
     */
    custom_step_order?: number | null;
    /** Whether this step is visible for this buyer */
    is_step_visible?: boolean;
    /** @format date-time */
    created_at: string;
    /** @format date-time */
    modified_at: string;
}

/** Serializer for reading order activities for buyer users. */
export interface BuyerOrderActivity {
    /** @format uuid */
    uuid: string;
    /** @format date-time */
    created_at: string;
    user: ShortUser;
    message: string | null;
    category: OrderActivityCategory;
    documents: OrderActivityDocument[];
}

/**
 * Serializer for reading order activities with order information for buyer users.
 * Used for the list_all_order_activities endpoint.
 */
export interface BuyerOrderActivityWithOrder {
    /** @format uuid */
    uuid: string;
    /** @format date-time */
    created_at: string;
    user: ShortUser;
    message: string | null;
    category: OrderActivityCategory;
    /** @format uuid */
    order_uuid: string;
    order_number: string;
    documents: OrderActivityDocument[];
}

/**
 * Buyer-facing detail serializer.
 *
 * Fields are listed explicitly (allowlist) rather than excluding `supplier_document_url`
 * from the parent's list, so any future field added to the MoR detail serializer
 * has to be deliberately opted in for buyer exposure rather than silently leaking.
 *
 * Notable difference vs MoR detail: `supplier_document_url` is omitted — the
 * supplier-uploaded credit/debit note PDF is internal-facing. Buyers see the
 * provider-generated artefact via `provider_document_pdf_url`.
 */
export interface BuyerOrderAdjustmentDetail {
    /** @format uuid */
    uuid: string;
    /**
     * CREDIT_NOTE reduces the buyer's amount due; DEBIT_NOTE adds an additional charge to the buyer
     *
     * * `credit_note` - Credit Note
     * * `debit_note` - Debit Note
     */
    type: OrderAdjustmentTypeEnum;
    status: OrderAdjustmentStatusEnum;
    /** Pre-tax adjustment amount in cents */
    base_amount: number;
    /** Tax amount in cents */
    tax_amount: number;
    /** Total in cents (base_amount + tax_amount); always positive — type indicates direction */
    total_amount: number;
    currency: AvailableCurrenciesEnum;
    /**
     * Derived from originating_order at create time
     *
     * * `stripe` - Stripe
     * * `two` - Two
     * * `direct` - Direct
     */
    payment_provider: PaymentProviderEnum;
    /** MoR-entered reason for the adjustment (internal/audit). Required for source=MANUAL; null for WEBHOOK / BACKFILL rows. */
    reason: string | null;
    /** @format uuid */
    originating_order_uuid: string;
    originating_order_number: string;
    /** @format uuid */
    applied_to_order_uuid: string;
    applied_to_order_number: string;
    /** Provider invoice ID at apply time (snapshotted) */
    applied_to_invoice_id: string | null;
    /** @format uuid */
    supplier_company_uuid: string;
    /** @format uuid */
    buyer_company_uuid: string;
    /** @format uuid */
    merchant_of_record_company_uuid: string;
    /** Provider artefact ID created on apply. For CREDIT_NOTE: Stripe credit note id or Two credit note ref. For DEBIT_NOTE: Stripe new invoice id or Two new invoice ref. */
    provider_document_id: string | null;
    /** Cached PDF URL from the provider; refresh via API as needed */
    provider_document_pdf_url: string | null;
    /** @format date-time */
    pending_application_at: string | null;
    /** @format date-time */
    applied_at: string | null;
    /** @format date-time */
    voided_at: string | null;
    /** @format date-time */
    created_at: string;
    /** @format date-time */
    modified_at: string;
}

export interface BuyerOrderLineItem {
    /** @format uuid */
    uuid: string;
    /** @format date-time */
    created_at: string;
    /** @format date-time */
    modified_at: string;
    /** @maxLength 255 */
    product_name: string;
    /**
     * @format uri
     * @maxLength 2048
     */
    logo_url?: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,10}(?:\.\d{0,2})?$
     */
    quantity: string;
    /**
     * * `fl oz` - Fluid Ounces
     * * `g` - Grams
     * * `mg` - milligrams
     * * `gals` - Gallons
     * * `kg` - Kilograms
     * * `L` - Liters
     * * `tons` - Metric Tons
     * * `oz` - Ounces
     * * `lbs` - Pounds
     * * `pcs` - Pieces
     * * `pt` - Pints
     * * `ml` - Milliliter
     * * `boxes` - Boxes
     * * `pallets` - Pallets
     * * `tsp` - Teaspoons
     * * `tbsp` - Tablespoons
     * * `units` - Units
     * * `cases` - Cases
     * * `trays` - Trays
     */
    unit_of_measurement?: UnitOfMeasurementEnum;
    /** @format float */
    buyer_tax_rate: number;
    /**
     * @format int64
     * @min 0
     * @max 9223372036854776000
     */
    delivery_surcharge_price_in_supplier_currency?: number | null;
    buyer_unit_price_in_buyer_currency: number;
    buyer_total_price_in_buyer_currency: number;
    buyer_total_tax_amount_in_buyer_currency: number;
    /** @maxLength 255 */
    packaging_info?: string | null;
    product_description?: string | null;
    documents: OrderLineItemDocument[];
}

/**
 * Active Order Management Contract data shaped for the contracts page card.
 *
 * All money is emitted as integer cents. The FE mapper divides by 100 to
 * render major units for display.
 *
 * `OrderManagementContract.total_contract_value` is stored in **micro-units**
 * on the model (1 GBP = 1,000,000) — the same convention as every per-unit
 * price in `BuyerPriceCalculatorService`. We convert it to cents in
 * `get_total_in_cents` so the API contract is uniformly cents and the FE
 * can apply its single `/100` major-unit conversion without knowing about
 * micro-units. Utilised already comes out of the price calculator as cents.
 *
 * The card surfaces two parallel notions of elapsed time:
 *
 * * `months_elapsed` / `months_total` — drive the friendly
 *   "X of N months" label only. Whole calendar months since `start_date`.
 * * `days_elapsed` / `contract_duration_days` — drive the "X% vs pace"
 *   indicator. Day-granularity, aligned with the same calculation
 *   Metabase uses for internal reporting so account managers and buyers
 *   see the same number. Start day counts as day 1 (inclusive math),
 *   clamped to `[0, contract_duration_days]`.
 */
export interface BuyerOrderManagementContractActiveData {
    /**
     * Convert the model's micro-unit storage to cents for the API contract.
     *
     * `total_contract_value` is stored in micro-units (1 GBP = 1,000,000).
     * Dividing by 10,000 yields cents, matching `utilised_in_cents` and the
     * rest of the monetary surface.
     */
    total_in_cents: number;
    utilised_in_cents: number;
    months_elapsed: number;
    months_total: number;
    days_elapsed: number;
    contract_duration_days: number;
    signed: string;
    renews: string;
    avg_monthly_in_cents: number;
    currency: string;
}

/**
 * Operational view of outstanding payments for the buyer finance page.
 *
 * All monetary values are in cents.
 */
export interface BuyerOutstandingPaymentsSummary {
    currency: string;
    overdue: PaymentBucket;
    /** Due in the next 7 days, not yet overdue */
    due_soon: PaymentBucket;
    total_outstanding: PaymentBucket;
    /** Oldest overdue payment that the buyer can act on (Two excluded). `null` when there's nothing payable to surface. */
    first_payable_overdue: BuyerPayableOverdueRef | null;
}

/**
 * Lean reference to the oldest non-Two overdue payment.
 *
 * Returned alongside the summary so the buyer-app overdue banner can
 * surface a one-click Pay Now CTA — the frontend deep-links to
 * ``/nodes/payments?pay=<uuid>&kind=...&provider=...`` and the existing
 * payments-page deep-link logic opens the drawer over the matching row.
 */
export interface BuyerPayableOverdueRef {
    uuid: string;
    /**
     * * `order` - Order
     * * `service_fee_invoice` - Service fee invoice
     */
    type: BuyerPaymentRowKindEnum;
    /** 'stripe' | 'direct' | null. Two is excluded server-side. */
    payment_provider: string | null;
    reference_number: string;
    provider_name: string | null;
    total_cents: number;
    currency: string;
}

export interface BuyerPaymentAnalytics {
    outstanding_payments: OutstandingPayment[];
    bank_details: ProviderBankDetails;
}

/** Serializer for an individual order in the payments listing. */
export interface BuyerPaymentOrder {
    /** @format uuid */
    uuid: string;
    order_number: string;
    supplier_name: string;
    subtotal: string;
    tax: string;
    total: string;
    currency: string;
    pay_in_state: string;
    lifecycle_state: string;
    payment_terms: string;
    payment_due_date: string;
}

/**
 * * `order` - Order
 * * `service_fee_invoice` - Service fee invoice
 */
export enum BuyerPaymentRowKindEnum {
    Order = "order",
    ServiceFeeInvoice = "service_fee_invoice",
}

export interface BuyerRepeatSpotOrderLineItem {
    /** @format uuid */
    line_item_uuid: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,10}(?:\.\d{0,2})?$
     */
    quantity: string;
}

/** Serializer for repeat spot order request information */
export interface BuyerRepeatSpotOrderRequest {
    /** @format uuid */
    delivery_address_uuid: string;
    /** @format date */
    delivery_date: string;
    line_item_quantities?: BuyerRepeatSpotOrderLineItem[];
    raise_zendesk_ticket_for_additional_line_items_requested?: boolean;
}

/** Serializer for repeat spot order response information */
export interface BuyerRepeatSpotOrderResponse {
    /** @format uuid */
    uuid: string;
}

/** Serializer for a service fee invoice in the payments listing (flat, not grouped by month). */
export interface BuyerServiceFeeInvoice {
    /** @format uuid */
    uuid: string;
    order_number: string;
    supplier_name: string;
    merchant_of_record_company_name: string;
    subtotal: string;
    tax: string;
    total: string;
    currency: string;
    pay_in_state: string;
    payment_due_date: string;
    orders: BuyerServiceFeeOrder[];
}

/** Serializer for an individual order nested within a service fee statement entry. */
export interface BuyerServiceFeeOrder {
    /** @format uuid */
    uuid: string;
    order_number: string;
    supplier_name: string;
    service_fee_subtotal: string;
    service_fee_tax: string;
    service_fee_total: string;
    currency: string;
}

/** Serializer for the service fees listing response (separate from orders). */
export interface BuyerServiceFeesListing {
    service_fees: BuyerServiceFeeInvoice[];
    service_fees_count: number;
    bank_details: BankDetail[];
}

/** Serializer for creating and reading spot buy requests */
export interface BuyerSpotBuyRequest {
    /** @format uuid */
    uuid: string;
    description?: string;
    /** @format date-time */
    created_at: string;
    /** @format date-time */
    modified_at: string;
    documents?: SpotBuyAttachment[];
    /** @format uuid */
    supplier_uuid?: string | null;
    line_items?: SpotBuyLineItem[];
    skus?: SpotBuySku[];
    /** @format uuid */
    delivery_address_uuid?: string | null;
    /**
     * Requested delivery date
     * @format date
     */
    delivery_date?: string | null;
}

/** Read-only serializer for listing spot buy requests. */
export interface BuyerSpotBuyRequestList {
    /** @format uuid */
    uuid: string;
    /** Unique request number in format REQ-XXXX-XXXX-XXXX */
    request_number: string;
    /**
     * Current status of the spot buy request
     *
     * * `pending` - Pending
     * * `completed` - Completed
     * * `cancelled` - Cancelled
     */
    status: SpotBuyRequestStatusEnum;
    description: string;
    /** @format date-time */
    created_at: string;
    supplier: BuyerAppOrderListSuppliers;
    /**
     * Requested delivery date
     * @format date
     */
    delivery_date: string | null;
    line_items: SpotBuyLineItem[];
    skus: SpotBuySku[];
    has_po_upload: boolean;
}

/** Serializer for the Stripe payments order listing response. */
export interface BuyerStripePaymentListing {
    orders: BuyerPaymentOrder[];
    orders_count: number;
    /** Serializer for the available filter options. */
    filters: PaymentFilters;
}

/** Serializer for buyer summary information */
export interface BuyerSummary {
    /** @format uuid */
    uuid: string;
    name: string;
}

export interface BuyerSummaryRequest {
    /** @format uuid */
    uuid: string;
}

export interface BuyerSummaryResponse {
    product_type: ProductTypeEnum[];
    product_types_description?: string | null;
    revenue?: RevenueEnum | BlankEnum | NullEnum | null;
    location: DeliveryAddressForSupplier;
}

/**
 * Serializer for suppliers associated with a buyer.
 * Includes payment terms if a BuyerSupplierPaymentTerms record exists for this pair.
 */
export interface BuyerSupplier {
    /** @format uuid */
    uuid: string;
    /** @maxLength 255 */
    name: string;
    status: string;
    supplier_type?: SupplierTypeEnum | BlankEnum | NullEnum | null;
    /**
     * Default number of calendar days this supplier needs between order and delivery. Factored into the earliest selectable delivery date on orders.
     * @min 0
     * @max 365
     */
    supplier_lead_time_days?: number | null;
    payment_terms: string;
    days_until_payment_due: string;
}

export interface BuyerSupplierPaymentTerms {
    /** @format uuid */
    uuid: string;
    /** @format uuid */
    buyer_uuid: string;
    /** @format uuid */
    supplier_uuid: string;
    /**
     * * `pay_before_dispatch` - Pay Before Dispatch
     * * `pay_after_dispatch` - Pay After Dispatch
     * * `pay_on_28th_second_month_after_dispatch` - Pay on 28th second month after dispatch
     * * `pay_end_of_month_of_dispatch_date` - Pay End of Month of Dispatch Date
     */
    payment_terms: AppOrderPaymentTermsEnum;
    /**
     * Number of days after dispatch until payment is due from the buyer
     * @min 0
     * @max 2147483647
     */
    days_until_payment_due?: number;
    /** @format date-time */
    created: string;
    /** @format date-time */
    modified: string;
}

export interface BuyerSupplierPaymentTermsCreate {
    /** @format uuid */
    uuid: string;
    /** @format uuid */
    buyer_uuid: string;
    /** @format uuid */
    supplier_uuid: string;
    /**
     * * `pay_before_dispatch` - Pay Before Dispatch
     * * `pay_after_dispatch` - Pay After Dispatch
     * * `pay_on_28th_second_month_after_dispatch` - Pay on 28th second month after dispatch
     * * `pay_end_of_month_of_dispatch_date` - Pay End of Month of Dispatch Date
     */
    payment_terms: AppOrderPaymentTermsEnum;
    /**
     * Number of days after dispatch until payment is due from the buyer
     * @min 0
     * @max 2147483647
     */
    days_until_payment_due?: number;
    /** @format date-time */
    created: string;
    /** @format date-time */
    modified: string;
}

/**
 * Serializer for buyer's Two credit summary.
 *
 * Monetary values are in cents in the buyer's currency. total_credit and
 * available_for_new_orders are null whenever status is not AVAILABLE —
 * i.e. the buyer is not configured for Two, credit is revoked, or the
 * upstream API is erroring.
 */
export interface BuyerTwoCreditInformation {
    /**
     * Summary status: 'available' (credit usable), 'not_configured' (no Two integration), 'revoked' (Two denied organic credit and recourse cannot compensate), or 'api_error' (transient upstream failure — retry may succeed)
     *
     * * `available` - Available
     * * `not_configured` - Not Configured
     * * `revoked` - Revoked
     * * `api_error` - API Error
     */
    status: BuyerTwoCreditStatusEnum;
    /** Currency code (e.g., 'GBP', 'EUR', 'USD') */
    currency: string | null;
    /** Total Two credit limit (organic + recourse) in cents, or null when status != available */
    total_credit: number | null;
    /** Credit available for new orders in cents: total_credit minus allocated orders, with the recourse portion capped by the Allianz ceiling. Null when status != available. */
    available_for_new_orders: number | null;
    /** Number of financial documents (P&L, balance sheet, management accounts) the buyer has on file. */
    financial_document_count: number;
}

/**
 * * `available` - Available
 * * `not_configured` - Not Configured
 * * `revoked` - Revoked
 * * `api_error` - API Error
 */
export enum BuyerTwoCreditStatusEnum {
    Available = "available",
    NotConfigured = "not_configured",
    Revoked = "revoked",
    ApiError = "api_error",
}

export interface CannyTokenResponse {
    token: string;
}

/**
 * * `document_valid` - Valid
 * * `document_expired` - Expired
 * * `document_expiring_soon` - Expiring Soon
 * * `document_renewed` - Renewed
 */
export enum CatalogDocumentStatusEnum {
    DocumentValid = "document_valid",
    DocumentExpired = "document_expired",
    DocumentExpiringSoon = "document_expiring_soon",
    DocumentRenewed = "document_renewed",
}

/**
 * * `spec_sheet` - Spec Sheet
 * * `certificate_of_analysis` - Certificate of Analysis
 * * `british_retail_consortium` - British Retail Consortium
 * * `international_organisation_for_standardisation` - International Organisation for Standardisation
 * * `foundation_food_safety_system_certification` - Foundation Food Safety System Certification
 * * `international_featured_standards` - International Featured Standards
 * * `safe_quality_food` - Safe Quality Food
 */
export enum CatalogItemDocumentCategoryEnum {
    SpecSheet = "spec_sheet",
    CertificateOfAnalysis = "certificate_of_analysis",
    BritishRetailConsortium = "british_retail_consortium",
    InternationalOrganisationForStandardisation = "international_organisation_for_standardisation",
    FoundationFoodSafetySystemCertification = "foundation_food_safety_system_certification",
    InternationalFeaturedStandards = "international_featured_standards",
    SafeQualityFood = "safe_quality_food",
}

/**
 * * `ingredient` - Ingredient
 * * `packaging` - Packaging
 */
export enum CatalogItemKindEnum {
    Ingredient = "ingredient",
    Packaging = "packaging",
}

/**
 * * `suppliers` - Suppliers
 * * `ingredients` - Ingredients
 * * `operations` - Operations
 * * `commercials` - Commercials
 * * `compliance` - Compliance
 * * `financial` - Financial
 * * `market` - Market
 */
export enum CelebrateEnum {
    Suppliers = "suppliers",
    Ingredients = "ingredients",
    Operations = "operations",
    Commercials = "commercials",
    Compliance = "compliance",
    Financial = "financial",
    Market = "market",
}

/** Serializer for changing payment terms on a confirmed/forecasted order. */
export interface ChangePaymentTerms {
    /**
     * * `pay_before_dispatch` - Pay Before Dispatch
     * * `pay_after_dispatch` - Pay After Dispatch
     * * `pay_on_28th_second_month_after_dispatch` - Pay on 28th second month after dispatch
     * * `pay_end_of_month_of_dispatch_date` - Pay End of Month of Dispatch Date
     */
    payment_terms?: AppOrderPaymentTermsEnum;
    /**
     * * `payout_before_dispatch` - Payout Before Dispatch
     * * `payout_after_dispatch` - Payout After Dispatch
     */
    supplier_payout_terms?: SupplierPayoutTermsEnum;
    /** @min 0 */
    buyer_payment_period?: number;
    /** @min 0 */
    supplier_payment_period?: number;
}

export interface Channel {
    /** @format uuid */
    uuid: string;
    /** @format date-time */
    new_messages_check?: string;
    companies: ChannelCompany[];
    latest_message: Message;
    related_object_type: string;
    /** @format uuid */
    related_object_uuid: string;
    object_history: ChannelObjectHistory[];
    buyer_name: string;
    supplier_name: string;
}

export interface ChannelCompany {
    /** @format uuid */
    uuid: string;
}

/**
 * * `email` - Email
 * * `in_app` - In App
 */
export enum ChannelEnum {
    Email = "email",
    InApp = "in_app",
}

export interface ChannelExpanded {
    /** @format uuid */
    uuid: string;
    buyer_name: string;
    supplier_name: string;
}

export interface ChannelForMessage {
    /** @format uuid */
    uuid: string;
    /** @format date-time */
    new_messages_check?: string;
    companies: ChannelForMessageCompany[];
    related_object_type: string;
    /** @format uuid */
    related_object_uuid: string;
    name: string;
    logo_url: string;
}

export interface ChannelForMessageCompany {
    /** @format uuid */
    uuid: string;
}

export interface ChannelObjectHistory {
    object_type: string;
    object_uuid: string;
    /** @format date-time */
    created: string;
    action?: ChannelObjectHistoryActionEnum | BlankEnum | NullEnum | null;
    data?: any;
}

/**
 * * `request_created` - Request Created
 * * `quote_created` - Quote Created
 * * `contract_created` - Contract Created
 * * `order_created` - Order Created
 * * `purchase_request_created` - Purchase Request Created
 * * `purchase_request_quote_created` - Purchase Request Quote Created
 * * `purchase_request_order_created` - Purchase Request Order Created
 */
export enum ChannelObjectHistoryActionEnum {
    RequestCreated = "request_created",
    QuoteCreated = "quote_created",
    ContractCreated = "contract_created",
    OrderCreated = "order_created",
    PurchaseRequestCreated = "purchase_request_created",
    PurchaseRequestQuoteCreated = "purchase_request_quote_created",
    PurchaseRequestOrderCreated = "purchase_request_order_created",
}

export interface ChannelUUID {
    /** @format uuid */
    uuid: string;
}

/**
 * * `confidential` - Confidential
 * * `public` - Public
 */
export enum ClientTypeEnum {
    Confidential = "confidential",
    Public = "public",
}

export interface CompaniesHouseSearchResponse {
    results: CompaniesHouseSearchResult[];
}

export interface CompaniesHouseSearchResult {
    registration_name: string;
    registration_number: string;
}

export interface Company {
    id: number;
    /** @format uuid */
    uuid: string;
    /** @maxLength 255 */
    website?: string | null;
    /** @maxLength 255 */
    name: string;
    /** @format uri */
    logo?: string | null;
    /** @maxLength 100 */
    industry?: string | null;
    kyb_status: string;
    /** @maxLength 50 */
    phone_number?: string | null;
    country: string;
    state: string;
    /**
     * * `brand` - Brand
     * * `supplier` - Supplier
     * * `merchant_of_record` - Merchant of Record
     */
    company_type?: CompanyTypeEnum;
    /** @default ["e","h","o","r","t"] */
    product_type?: ProductTypeEnum[];
    /** @default ["e","h","o","r","t"] */
    activity_type?: ActivityTypeEnum[];
    /** @maxLength 255 */
    registration_number?: string | null;
    /** @maxLength 255 */
    registration_name?: string | null;
    mongo_id: string | null;
    referral_code: string;
    phone_country_code?: PhoneCountryCodeEnum | BlankEnum | NullEnum | null;
    company_addresses?: CompanyAddress[];
    currency: string;
    /**
     * rapyd payout method
     * @maxLength 45
     */
    payout_method_type?: string | null;
    bank_account_country?: Country | BlankEnum | NullEnum | null;
    /**
     * DUNS number for creditworthiness checks and payouts
     * @maxLength 50
     */
    duns?: string | null;
}

export interface CompanyAddress {
    id: number;
    /** @format date-time */
    created: string;
    /** @format date-time */
    modified: string;
    /** @format uuid */
    uuid: string;
    /** @maxLength 255 */
    name: string;
    /**
     * * `billing_address` - Billing address
     * * `delivery_address` - Delivery address
     * * `dispatch_address` - Dispatch address
     * * `company_address` - Company address
     */
    address_type?: AddressTypeEnum;
    /** @maxLength 255 */
    contact_full_name?: string | null;
    /** @maxLength 50 */
    contact_phone?: string | null;
    /** @maxLength 100 */
    building?: string | null;
    /** @maxLength 255 */
    street_1?: string | null;
    /** @maxLength 255 */
    street_2?: string | null;
    /** @maxLength 100 */
    town?: string | null;
    /** @maxLength 100 */
    region?: string | null;
    /** @maxLength 100 */
    postcode?: string | null;
    country?: Country | BlankEnum | NullEnum | null;
    /** @maxLength 100 */
    place_id?: string | null;
    /**
     * @format decimal
     * @pattern ^-?\d{0,4}(?:\.\d{0,15})?$
     */
    latitude?: string | null;
    /**
     * @format decimal
     * @pattern ^-?\d{0,4}(?:\.\d{0,15})?$
     */
    longitude?: string | null;
    /** @maxLength 50 */
    vat_number?: string | null;
    vat_country_code?: Country | BlankEnum | NullEnum | null;
    vat_exempt?: boolean;
    phone_country_code?: PhoneCountryCodeEnum | BlankEnum | NullEnum | null;
    delivery_instructions?: string | null;
    collection_instructions?: string | null;
    /**
     * * `EU` - Eu
     * * `GB` - Gb
     * * `Other` - Other
     */
    country_type?: CountryTypeEnum;
    /** @maxLength 20 */
    eori_number?: string;
    /** @maxLength 20 */
    ein_number?: string;
    notes?: string;
    /**
     * Type of delivery location (warehouse, factory, distribution_center, retail_location, other).
     * @maxLength 50
     */
    delivery_location_type?: string;
    /**
     * Free-text description when delivery_location_type == 'other'.
     * @maxLength 255
     */
    delivery_location_type_other?: string;
    /**
     * Free-text receiving hours (e.g. 'Mon-Fri 9am-5pm').
     * @maxLength 255
     */
    warehouse_receiving_hours?: string;
}

export interface CompanyAddressAdminCreate {
    id: number;
    /**
     * company uuid
     * @format uuid
     */
    company: string;
    /** @format date-time */
    created: string;
    /** @format date-time */
    modified: string;
    /** @format uuid */
    uuid: string;
    /** @maxLength 255 */
    name: string;
    /** @default "billing_address" */
    address_type?: AddressTypeEnum;
    /** @maxLength 255 */
    contact_full_name?: string | null;
    /** @maxLength 50 */
    contact_phone?: string | null;
    /** @maxLength 100 */
    building?: string | null;
    /** @maxLength 255 */
    street_1?: string | null;
    /** @maxLength 255 */
    street_2?: string | null;
    /** @maxLength 100 */
    town?: string | null;
    /** @maxLength 100 */
    region?: string | null;
    /** @maxLength 100 */
    postcode?: string | null;
    country?: Country | BlankEnum | NullEnum | null;
    /** @maxLength 100 */
    place_id?: string | null;
    /**
     * @format decimal
     * @pattern ^-?\d{0,4}(?:\.\d{0,15})?$
     */
    latitude?: string | null;
    /**
     * @format decimal
     * @pattern ^-?\d{0,4}(?:\.\d{0,15})?$
     */
    longitude?: string | null;
    /** @maxLength 50 */
    vat_number?: string | null;
    vat_country_code?: Country | BlankEnum | NullEnum | null;
    vat_exempt?: boolean;
    phone_country_code?: PhoneCountryCodeEnum | BlankEnum | NullEnum | null;
    delivery_instructions?: string | null;
    collection_instructions?: string | null;
    /**
     * * `EU` - Eu
     * * `GB` - Gb
     * * `Other` - Other
     */
    country_type?: CountryTypeEnum;
    /** @maxLength 20 */
    eori_number?: string;
    /** @maxLength 20 */
    ein_number?: string;
    notes?: string;
    /**
     * Type of delivery location (warehouse, factory, distribution_center, retail_location, other).
     * @maxLength 50
     */
    delivery_location_type?: string;
    /**
     * Free-text description when delivery_location_type == 'other'.
     * @maxLength 255
     */
    delivery_location_type_other?: string;
    /**
     * Free-text receiving hours (e.g. 'Mon-Fri 9am-5pm').
     * @maxLength 255
     */
    warehouse_receiving_hours?: string;
}

export interface CompanyDocument {
    /** @format uuid */
    uuid: string;
    /** @format uri */
    document: string;
    description?: string | null;
    /**
     * * `ingredients_list` - Ingredients List
     * * `other` - Other
     */
    document_category?: CompanyDocumentCategory;
}

/**
 * * `ingredients_list` - Ingredients List
 * * `other` - Other
 */
export enum CompanyDocumentCategory {
    IngredientsList = "ingredients_list",
    Other = "other",
}

export interface CompanyInfo {
    id: number;
    /** @format uuid */
    uuid: string;
    /** @maxLength 255 */
    website?: string | null;
    /** @maxLength 255 */
    name: string;
    /** @format uri */
    logo?: string | null;
    /** @maxLength 100 */
    industry?: string | null;
    kyb_status: string;
    /** @maxLength 50 */
    phone_number?: string | null;
    country: string;
    state: string;
    /**
     * * `brand` - Brand
     * * `supplier` - Supplier
     * * `merchant_of_record` - Merchant of Record
     */
    company_type?: CompanyTypeEnum;
    /** @default ["e","h","o","r","t"] */
    product_type?: ProductTypeEnum[];
    /** @default ["e","h","o","r","t"] */
    activity_type?: ActivityTypeEnum[];
    /** @maxLength 255 */
    registration_number?: string | null;
    /** @maxLength 255 */
    registration_name?: string | null;
    mongo_id: string | null;
    referral_code: string;
    phone_country_code?: PhoneCountryCodeEnum | BlankEnum | NullEnum | null;
    company_addresses: string;
    currency: string;
    /**
     * rapyd payout method
     * @maxLength 45
     */
    payout_method_type?: string | null;
    bank_account_country?: Country | BlankEnum | NullEnum | null;
    /**
     * DUNS number for creditworthiness checks and payouts
     * @maxLength 50
     */
    duns?: string | null;
    questionnaire_submitted?: boolean | null;
    zendesk_chat_widget_key: string | null;
    zendesk_chat_token: string;
    /** @format email */
    buyer_accounts_email_address: string | null;
    /** @format email */
    buyer_delivery_email_address: string | null;
    /**
     * Two-letter ISO country code for Two integration
     *
     * * `AF` - Afghanistan
     * * `AX` - Åland Islands
     * * `AL` - Albania
     * * `DZ` - Algeria
     * * `AS` - American Samoa
     * * `AD` - Andorra
     * * `AO` - Angola
     * * `AI` - Anguilla
     * * `AQ` - Antarctica
     * * `AG` - Antigua and Barbuda
     * * `AR` - Argentina
     * * `AM` - Armenia
     * * `AW` - Aruba
     * * `AU` - Australia
     * * `AT` - Austria
     * * `AZ` - Azerbaijan
     * * `BS` - Bahamas
     * * `BH` - Bahrain
     * * `BD` - Bangladesh
     * * `BB` - Barbados
     * * `BY` - Belarus
     * * `BE` - Belgium
     * * `BZ` - Belize
     * * `BJ` - Benin
     * * `BM` - Bermuda
     * * `BT` - Bhutan
     * * `BO` - Bolivia
     * * `BQ` - Bonaire, Sint Eustatius and Saba
     * * `BA` - Bosnia and Herzegovina
     * * `BW` - Botswana
     * * `BV` - Bouvet Island
     * * `BR` - Brazil
     * * `IO` - British Indian Ocean Territory
     * * `BN` - Brunei
     * * `BG` - Bulgaria
     * * `BF` - Burkina Faso
     * * `BI` - Burundi
     * * `CV` - Cabo Verde
     * * `KH` - Cambodia
     * * `CM` - Cameroon
     * * `CA` - Canada
     * * `KY` - Cayman Islands
     * * `CF` - Central African Republic
     * * `TD` - Chad
     * * `CL` - Chile
     * * `CN` - China
     * * `CX` - Christmas Island
     * * `CC` - Cocos (Keeling) Islands
     * * `CO` - Colombia
     * * `KM` - Comoros
     * * `CG` - Congo
     * * `CD` - Congo (the Democratic Republic of the)
     * * `CK` - Cook Islands
     * * `CR` - Costa Rica
     * * `CI` - Côte d'Ivoire
     * * `HR` - Croatia
     * * `CU` - Cuba
     * * `CW` - Curaçao
     * * `CY` - Cyprus
     * * `CZ` - Czechia
     * * `DK` - Denmark
     * * `DJ` - Djibouti
     * * `DM` - Dominica
     * * `DO` - Dominican Republic
     * * `EC` - Ecuador
     * * `EG` - Egypt
     * * `SV` - El Salvador
     * * `GQ` - Equatorial Guinea
     * * `ER` - Eritrea
     * * `EE` - Estonia
     * * `SZ` - Eswatini
     * * `ET` - Ethiopia
     * * `FK` - Falkland Islands (Malvinas)
     * * `FO` - Faroe Islands
     * * `FJ` - Fiji
     * * `FI` - Finland
     * * `FR` - France
     * * `GF` - French Guiana
     * * `PF` - French Polynesia
     * * `TF` - French Southern Territories
     * * `GA` - Gabon
     * * `GM` - Gambia
     * * `GE` - Georgia
     * * `DE` - Germany
     * * `GH` - Ghana
     * * `GI` - Gibraltar
     * * `GR` - Greece
     * * `GL` - Greenland
     * * `GD` - Grenada
     * * `GP` - Guadeloupe
     * * `GU` - Guam
     * * `GT` - Guatemala
     * * `GG` - Guernsey
     * * `GN` - Guinea
     * * `GW` - Guinea-Bissau
     * * `GY` - Guyana
     * * `HT` - Haiti
     * * `HM` - Heard Island and McDonald Islands
     * * `VA` - Holy See
     * * `HN` - Honduras
     * * `HK` - Hong Kong
     * * `HU` - Hungary
     * * `IS` - Iceland
     * * `IN` - India
     * * `ID` - Indonesia
     * * `IR` - Iran
     * * `IQ` - Iraq
     * * `IE` - Ireland
     * * `IM` - Isle of Man
     * * `IL` - Israel
     * * `IT` - Italy
     * * `JM` - Jamaica
     * * `JP` - Japan
     * * `JE` - Jersey
     * * `JO` - Jordan
     * * `KZ` - Kazakhstan
     * * `KE` - Kenya
     * * `KI` - Kiribati
     * * `KW` - Kuwait
     * * `KG` - Kyrgyzstan
     * * `LA` - Laos
     * * `LV` - Latvia
     * * `LB` - Lebanon
     * * `LS` - Lesotho
     * * `LR` - Liberia
     * * `LY` - Libya
     * * `LI` - Liechtenstein
     * * `LT` - Lithuania
     * * `LU` - Luxembourg
     * * `MO` - Macao
     * * `MG` - Madagascar
     * * `MW` - Malawi
     * * `MY` - Malaysia
     * * `MV` - Maldives
     * * `ML` - Mali
     * * `MT` - Malta
     * * `MH` - Marshall Islands
     * * `MQ` - Martinique
     * * `MR` - Mauritania
     * * `MU` - Mauritius
     * * `YT` - Mayotte
     * * `MX` - Mexico
     * * `FM` - Micronesia
     * * `MD` - Moldova
     * * `MC` - Monaco
     * * `MN` - Mongolia
     * * `ME` - Montenegro
     * * `MS` - Montserrat
     * * `MA` - Morocco
     * * `MZ` - Mozambique
     * * `MM` - Myanmar
     * * `NA` - Namibia
     * * `NR` - Nauru
     * * `NP` - Nepal
     * * `NL` - Netherlands
     * * `NC` - New Caledonia
     * * `NZ` - New Zealand
     * * `NI` - Nicaragua
     * * `NE` - Niger
     * * `NG` - Nigeria
     * * `NU` - Niue
     * * `NF` - Norfolk Island
     * * `KP` - North Korea
     * * `MK` - North Macedonia
     * * `XI` - Northern Ireland
     * * `MP` - Northern Mariana Islands
     * * `NO` - Norway
     * * `OM` - Oman
     * * `PK` - Pakistan
     * * `PW` - Palau
     * * `PS` - Palestine, State of
     * * `PA` - Panama
     * * `PG` - Papua New Guinea
     * * `PY` - Paraguay
     * * `PE` - Peru
     * * `PH` - Philippines
     * * `PN` - Pitcairn
     * * `PL` - Poland
     * * `PT` - Portugal
     * * `PR` - Puerto Rico
     * * `QA` - Qatar
     * * `RE` - Réunion
     * * `RO` - Romania
     * * `RU` - Russia
     * * `RW` - Rwanda
     * * `BL` - Saint Barthélemy
     * * `SH` - Saint Helena, Ascension and Tristan da Cunha
     * * `KN` - Saint Kitts and Nevis
     * * `LC` - Saint Lucia
     * * `MF` - Saint Martin (French part)
     * * `PM` - Saint Pierre and Miquelon
     * * `VC` - Saint Vincent and the Grenadines
     * * `WS` - Samoa
     * * `SM` - San Marino
     * * `ST` - Sao Tome and Principe
     * * `SA` - Saudi Arabia
     * * `SN` - Senegal
     * * `RS` - Serbia
     * * `SC` - Seychelles
     * * `SL` - Sierra Leone
     * * `SG` - Singapore
     * * `SX` - Sint Maarten (Dutch part)
     * * `SK` - Slovakia
     * * `SI` - Slovenia
     * * `SB` - Solomon Islands
     * * `SO` - Somalia
     * * `ZA` - South Africa
     * * `GS` - South Georgia and the South Sandwich Islands
     * * `KR` - South Korea
     * * `SS` - South Sudan
     * * `ES` - Spain
     * * `LK` - Sri Lanka
     * * `SD` - Sudan
     * * `SR` - Suriname
     * * `SJ` - Svalbard and Jan Mayen
     * * `SE` - Sweden
     * * `CH` - Switzerland
     * * `SY` - Syria
     * * `TW` - Taiwan
     * * `TJ` - Tajikistan
     * * `TZ` - Tanzania
     * * `TH` - Thailand
     * * `TL` - Timor-Leste
     * * `TG` - Togo
     * * `TK` - Tokelau
     * * `TO` - Tonga
     * * `TT` - Trinidad and Tobago
     * * `TN` - Tunisia
     * * `TR` - Türkiye
     * * `TM` - Turkmenistan
     * * `TC` - Turks and Caicos Islands
     * * `TV` - Tuvalu
     * * `UG` - Uganda
     * * `UA` - Ukraine
     * * `AE` - United Arab Emirates
     * * `GB` - United Kingdom
     * * `UM` - United States Minor Outlying Islands
     * * `US` - United States of America
     * * `UY` - Uruguay
     * * `UZ` - Uzbekistan
     * * `VU` - Vanuatu
     * * `VE` - Venezuela
     * * `VN` - Vietnam
     * * `VG` - Virgin Islands (British)
     * * `VI` - Virgin Islands (U.S.)
     * * `WF` - Wallis and Futuna
     * * `EH` - Western Sahara
     * * `YE` - Yemen
     * * `ZM` - Zambia
     * * `ZW` - Zimbabwe
     */
    registration_country_code?: Country | BlankEnum | NullEnum | null;
    /** Indicates if company is integrated with Two payment provider */
    is_connected_to_two?: boolean;
    /** Indicates if company is integrated with Allianz credit insurance */
    is_connected_to_allianz?: boolean;
    sku_ordering_enabled?: boolean;
    merchant_of_record_name: string;
    /**
     * Default number of calendar days this supplier needs between order and delivery. Factored into the earliest selectable delivery date on orders.
     * @min 0
     * @max 365
     */
    supplier_lead_time_days?: number | null;
    marketplace_tc_status: MarketplaceTcStatusEnum;
    /** Returns URL of current T&C version. */
    marketplace_tc_url: string | null;
    /**
     * Buyer onboarding lifecycle. Default 'active' so existing rows and non-buyer Companies are unaffected. New buyers signed up via the brand onboarding flow are created with 'in_progress' and flip to 'active' once they finish onboarding.
     *
     * * `in_progress` - In progress
     * * `active` - Active
     */
    onboarding_state: CompanyOnboardingStateEnum;
}

export interface CompanyInquiryAdmin {
    /** @maxLength 255 */
    name: string;
    /** @format date-time */
    created: string;
    suppliers_found: string;
    number_of_quotes: string;
    /**
     * * `awaiting_quotes` - Awaiting Quotes
     * * `quotes_available` - Quotes Available
     * * `ordered` - Ordered
     * * `expired` - Expired
     * * `proceeded` - Proceeded
     * * `contract_confirmed` - Contract Confirmed
     * * `supplier_decline_to_quote` - Supplier Decline To Quote
     * * `cancelled` - Cancelled
     */
    state?: InquiryState;
}

export interface CompanyInvite {
    id: number;
    contact_first_name: string;
    contact_last_name: string;
    company_name: string;
    /** @format email */
    contact_email: string;
    /**
     * * `brand` - Brand
     * * `supplier` - Supplier
     * * `merchant_of_record` - Merchant of Record
     */
    referred_company_type: CompanyTypeEnum;
    signup_link: string;
}

export interface CompanyMembersList {
    /** @format uuid */
    uuid: string | null;
    /** @maxLength 30 */
    first_name: string;
    /** @maxLength 30 */
    last_name: string;
    /** @format email */
    email: string;
    /**
     * * `pending` - Pending
     * * `accepted` - Accepted
     * * `owner` - Owner
     */
    status: CompanyMembersListStatusEnum;
    /** @default false */
    is_admin?: boolean;
}

/**
 * * `pending` - Pending
 * * `accepted` - Accepted
 * * `owner` - Owner
 */
export enum CompanyMembersListStatusEnum {
    Pending = "pending",
    Accepted = "accepted",
    Owner = "owner",
}

export interface CompanyNameAndId {
    id: number;
    /** @format uuid */
    uuid: string;
    /** @maxLength 255 */
    name: string;
}

export interface CompanyNotificationOverride {
    /** * `order_created` - order_created */
    kind: NotificationKindCodeEnum;
    enabled?: boolean;
}

/**
 * * `in_progress` - In progress
 * * `active` - Active
 */
export enum CompanyOnboardingStateEnum {
    InProgress = "in_progress",
    Active = "active",
}

/**
 * * `admin` - Admin
 * * `member` - Member
 * * `staff` - Staff
 */
export enum CompanyRoleEnum {
    Admin = "admin",
    Member = "member",
    Staff = "staff",
}

/**
 * * `brand` - Brand
 * * `supplier` - Supplier
 * * `merchant_of_record` - Merchant of Record
 */
export enum CompanyTypeEnum {
    Brand = "brand",
    Supplier = "supplier",
    MerchantOfRecord = "merchant_of_record",
}

export interface CompanyUserAdmin {
    /** @format uuid */
    uuid: string;
    /** @maxLength 150 */
    first_name?: string;
    /** @maxLength 150 */
    last_name?: string;
    /**
     * @format email
     * @maxLength 254
     */
    email: string;
    /** @maxLength 255 */
    job_title?: string | null;
    last_login: string;
}

/**
 * * `CONFIDENT` - Confident
 * * `UNSURE` - Unsure
 * * `NOT_CONFIDENT` - Not Confident
 */
export enum ConfidenceLevelEnum {
    CONFIDENT = "CONFIDENT",
    UNSURE = "UNSURE",
    NOT_CONFIDENT = "NOT_CONFIDENT",
}

/** Serializer for confirming shipping responsibility when transitioning from gathering_quotes state. */
export interface ConfirmShippingResponsibility {
    /**
     * The confirmed shipping responsibility (supplier, buyer, or merchant_of_record)
     *
     * * `supplier` - Supplier
     * * `buyer` - Buyer
     * * `merchant_of_record` - Merchant of Record
     */
    shipping_responsibility: ConfirmShippingResponsibilityShippingResponsibilityEnum;
}

/**
 * * `supplier` - Supplier
 * * `buyer` - Buyer
 * * `merchant_of_record` - Merchant of Record
 */
export enum ConfirmShippingResponsibilityShippingResponsibilityEnum {
    Supplier = "supplier",
    Buyer = "buyer",
    MerchantOfRecord = "merchant_of_record",
}

/** Read-only view of a connector definition merged with its connection state. */
export interface Connector {
    provider: string;
    display_name: string;
    description: string;
    icon_key: string;
    /**
     * * `per_user` - Per user
     * * `per_tenant` - Per tenant
     */
    kind: ConnectorKindEnum;
    /**
     * * `none` - None (per-user connector)
     * * `shared_token` - Shared admin token
     * * `admin_consent` - Provider admin-consent
     */
    tenant_mode: ConnectorTenantModeEnum;
    required_scopes: string[];
    feature_flag: string;
    status: ConnectorConnectionStatusEnum | NullEnum | null;
    /** @format date-time */
    connected_at: string | null;
    /** @format date-time */
    last_verified_at: string | null;
    connected_by_name: string | null;
    is_connected_by_admin: boolean;
    /** True when the requesting user can connect/disconnect this connector. */
    can_user_act: boolean;
}

/**
 * * `pending` - Pending OAuth completion
 * * `connected` - Connected
 * * `needs_reconnect` - Needs reconnect
 * * `revoked` - Revoked
 * * `error` - Error
 */
export enum ConnectorConnectionStatusEnum {
    Pending = "pending",
    Connected = "connected",
    NeedsReconnect = "needs_reconnect",
    Revoked = "revoked",
    Error = "error",
}

/**
 * * `per_user` - Per user
 * * `per_tenant` - Per tenant
 */
export enum ConnectorKindEnum {
    PerUser = "per_user",
    PerTenant = "per_tenant",
}

/**
 * * `none` - None (per-user connector)
 * * `shared_token` - Shared admin token
 * * `admin_consent` - Provider admin-consent
 */
export enum ConnectorTenantModeEnum {
    None = "none",
    SharedToken = "shared_token",
    AdminConsent = "admin_consent",
}

/**
 * Coarse, closed-union result of the pre-flight token probe.
 *
 * Deliberately NOT the full ``ConnectorConnectionStatus`` set — the FE only
 * needs to know whether the connection is usable, needs a reconnect, or is
 * absent. Non-probed states (``pending`` / ``revoked`` / ``error``) are
 * collapsed into one of these three before they leave the endpoint.
 */
export interface ConnectorVerifyResponse {
    /**
     * * `connected` - connected
     * * `needs_reconnect` - needs_reconnect
     * * `not_connected` - not_connected
     */
    status: ConnectorVerifyResponseStatusEnum;
}

/**
 * * `connected` - connected
 * * `needs_reconnect` - needs_reconnect
 * * `not_connected` - not_connected
 */
export enum ConnectorVerifyResponseStatusEnum {
    Connected = "connected",
    NeedsReconnect = "needs_reconnect",
    NotConnected = "not_connected",
}

/**
 * * `celery` - Celery
 * * `cereals_containing_gluten` - Cereals Containing Gluten
 * * `crustaceans` - Crustaceans
 * * `eggs` - Eggs
 * * `fish` - Fish
 * * `lupin` - Lupin
 * * `milk` - Milk
 * * `molluscs` - Molluscs
 * * `mustard` - Mustard
 * * `nuts` - Nuts
 * * `peanuts` - Peanuts
 * * `sesame_seeds` - Sesame Seeds
 * * `soya` - Soya
 * * `sulphur_dioxide` - Sulphur Dioxide
 */
export enum ContainedAllergensEnum {
    Celery = "celery",
    CerealsContainingGluten = "cereals_containing_gluten",
    Crustaceans = "crustaceans",
    Eggs = "eggs",
    Fish = "fish",
    Lupin = "lupin",
    Milk = "milk",
    Molluscs = "molluscs",
    Mustard = "mustard",
    Nuts = "nuts",
    Peanuts = "peanuts",
    SesameSeeds = "sesame_seeds",
    Soya = "soya",
    SulphurDioxide = "sulphur_dioxide",
}

export interface ContractInterest {
    /** @format uuid */
    uuid: string;
    /**
     * @format email
     * @maxLength 254
     */
    email: string;
    /** @maxLength 255 */
    product_name: string;
    /**
     * @min -2147483648
     * @max 2147483647
     */
    number_of_deliveries_per_year: number;
    /** @format double */
    volume_per_delivery: number;
    /** @format double */
    unit_price?: number | null;
    is_one_off_purchase?: boolean;
    /** @maxLength 255 */
    company_name: string;
    /** @maxLength 50 */
    company_number: string;
    company_address: string;
}

export interface ContractRenewNegotiation {
    /** @format uuid */
    uuid: string;
    /** @format uuid */
    company_uuid?: string;
    /**
     * Duration of the contract in months.
     * @min -2147483648
     * @max 2147483647
     */
    contract_length?: number | null;
    /**
     * @min 0
     * @max 2147483647
     */
    quantity_per_order: number;
    /**
     * @format decimal
     * @pattern ^-?\d{0,17}(?:\.\d{0,2})?$
     */
    total_forecast_volume?: string;
    /** @format date */
    first_order_delivery_date?: string | null;
    /**
     * @format decimal
     * @pattern ^-?\d{0,9}(?:\.\d{0,10})?$
     */
    unit_price?: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
     */
    price_per_order?: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
     */
    shipping_cost_per_order?: string | null;
    /**
     * * `created` - Created
     * * `accepted` - Accepted
     * * `declined` - Declined
     * * `completed` - Completed
     */
    status?: QuoteNegotiationStatus;
    /** @format date */
    declined_date?: string | null;
    /** @format date */
    accepted_date?: string | null;
    /** @format date */
    confirmed_date?: string | null;
    /** @format uuid */
    new_contract_uuid?: string | null;
    /** @format date-time */
    created: string;
    /** @format date-time */
    modified: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
     */
    payout_per_unit_no_shipping?: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
     */
    sum_payout_no_shipping?: string;
}

export interface ContractRenewNegotiationDecline {
    decline_reason?: string | null;
}

/** Used for reading jobs (and nested under workflows). */
export interface CortexJob {
    /** @format uuid */
    uuid: string;
    /** @format uuid */
    workflow_uuid: string;
    workflow_type: string;
    agent_name: string;
    description: string;
    /**
     * @min 0
     * @max 2147483647
     */
    job_index?: number;
    /**
     * * `PENDING` - Pending
     * * `EXECUTING` - Executing
     * * `COMPLETED` - Completed
     * * `AWAITING_HUMAN` - Awaiting Human
     */
    status: CortexJobStatusEnum;
    /** @format date-time */
    status_last_updated?: string | null;
    /** @format date-time */
    created: string;
    /** @format date-time */
    modified: string;
}

/** Accepts a workflow by UUID for creation convenience. */
export interface CortexJobCreate {
    /** @format uuid */
    uuid: string;
    /** @format uuid */
    workflow_uuid: string;
    agent_name: string;
    description: string;
    /**
     * * `PENDING` - Pending
     * * `EXECUTING` - Executing
     * * `COMPLETED` - Completed
     * * `AWAITING_HUMAN` - Awaiting Human
     */
    status: CortexJobStatusEnum;
    /**
     * @min 0
     * @max 2147483647
     */
    job_index?: number;
}

/**
 * * `PENDING` - Pending
 * * `EXECUTING` - Executing
 * * `COMPLETED` - Completed
 * * `AWAITING_HUMAN` - Awaiting Human
 */
export enum CortexJobStatusEnum {
    PENDING = "PENDING",
    EXECUTING = "EXECUTING",
    COMPLETED = "COMPLETED",
    AWAITING_HUMAN = "AWAITING_HUMAN",
}

/** Partial updates: agent_name, description, status. */
export interface CortexJobUpdate {
    agent_name?: string;
    description?: string;
    /**
     * * `PENDING` - Pending
     * * `EXECUTING` - Executing
     * * `COMPLETED` - Completed
     * * `AWAITING_HUMAN` - Awaiting Human
     */
    status?: CortexJobStatusEnum;
    /**
     * @min 0
     * @max 2147483647
     */
    job_index?: number;
}

export interface CortexWorkflowCreate {
    /** @format uuid */
    uuid: string;
    input: string;
    /**
     * * `FINANCE` - Finance
     * * `PREDICTIONS` - Predictions
     * * `COMPLIANCE` - Compliance
     * * `LOGISTICS` - Logistics
     * * `ORDERS` - Orders
     */
    type: CortexWorkflowTypeEnum;
    /** @maxLength 100 */
    zendesk_ticket_id?: string | null;
}

/**
 * * `FINANCE` - Finance
 * * `PREDICTIONS` - Predictions
 * * `COMPLIANCE` - Compliance
 * * `LOGISTICS` - Logistics
 * * `ORDERS` - Orders
 */
export enum CortexWorkflowTypeEnum {
    FINANCE = "FINANCE",
    PREDICTIONS = "PREDICTIONS",
    COMPLIANCE = "COMPLIANCE",
    LOGISTICS = "LOGISTICS",
    ORDERS = "ORDERS",
}

/** List all workflows with their associated jobs. */
export interface CortexWorkflowWithJobs {
    /** @format uuid */
    uuid: string;
    input: string;
    /**
     * * `FINANCE` - Finance
     * * `PREDICTIONS` - Predictions
     * * `COMPLIANCE` - Compliance
     * * `LOGISTICS` - Logistics
     * * `ORDERS` - Orders
     */
    type: CortexWorkflowTypeEnum;
    /** @maxLength 100 */
    zendesk_ticket_id?: string | null;
    /** @format date-time */
    created: string;
    /** @format date-time */
    modified: string;
    jobs: CortexJob[];
    workFlowAlreadyHasFeedback: string;
}

/**
 * * `AF` - Afghanistan
 * * `AX` - Åland Islands
 * * `AL` - Albania
 * * `DZ` - Algeria
 * * `AS` - American Samoa
 * * `AD` - Andorra
 * * `AO` - Angola
 * * `AI` - Anguilla
 * * `AQ` - Antarctica
 * * `AG` - Antigua and Barbuda
 * * `AR` - Argentina
 * * `AM` - Armenia
 * * `AW` - Aruba
 * * `AU` - Australia
 * * `AT` - Austria
 * * `AZ` - Azerbaijan
 * * `BS` - Bahamas
 * * `BH` - Bahrain
 * * `BD` - Bangladesh
 * * `BB` - Barbados
 * * `BY` - Belarus
 * * `BE` - Belgium
 * * `BZ` - Belize
 * * `BJ` - Benin
 * * `BM` - Bermuda
 * * `BT` - Bhutan
 * * `BO` - Bolivia
 * * `BQ` - Bonaire, Sint Eustatius and Saba
 * * `BA` - Bosnia and Herzegovina
 * * `BW` - Botswana
 * * `BV` - Bouvet Island
 * * `BR` - Brazil
 * * `IO` - British Indian Ocean Territory
 * * `BN` - Brunei
 * * `BG` - Bulgaria
 * * `BF` - Burkina Faso
 * * `BI` - Burundi
 * * `CV` - Cabo Verde
 * * `KH` - Cambodia
 * * `CM` - Cameroon
 * * `CA` - Canada
 * * `KY` - Cayman Islands
 * * `CF` - Central African Republic
 * * `TD` - Chad
 * * `CL` - Chile
 * * `CN` - China
 * * `CX` - Christmas Island
 * * `CC` - Cocos (Keeling) Islands
 * * `CO` - Colombia
 * * `KM` - Comoros
 * * `CG` - Congo
 * * `CD` - Congo (the Democratic Republic of the)
 * * `CK` - Cook Islands
 * * `CR` - Costa Rica
 * * `CI` - Côte d'Ivoire
 * * `HR` - Croatia
 * * `CU` - Cuba
 * * `CW` - Curaçao
 * * `CY` - Cyprus
 * * `CZ` - Czechia
 * * `DK` - Denmark
 * * `DJ` - Djibouti
 * * `DM` - Dominica
 * * `DO` - Dominican Republic
 * * `EC` - Ecuador
 * * `EG` - Egypt
 * * `SV` - El Salvador
 * * `GQ` - Equatorial Guinea
 * * `ER` - Eritrea
 * * `EE` - Estonia
 * * `SZ` - Eswatini
 * * `ET` - Ethiopia
 * * `FK` - Falkland Islands (Malvinas)
 * * `FO` - Faroe Islands
 * * `FJ` - Fiji
 * * `FI` - Finland
 * * `FR` - France
 * * `GF` - French Guiana
 * * `PF` - French Polynesia
 * * `TF` - French Southern Territories
 * * `GA` - Gabon
 * * `GM` - Gambia
 * * `GE` - Georgia
 * * `DE` - Germany
 * * `GH` - Ghana
 * * `GI` - Gibraltar
 * * `GR` - Greece
 * * `GL` - Greenland
 * * `GD` - Grenada
 * * `GP` - Guadeloupe
 * * `GU` - Guam
 * * `GT` - Guatemala
 * * `GG` - Guernsey
 * * `GN` - Guinea
 * * `GW` - Guinea-Bissau
 * * `GY` - Guyana
 * * `HT` - Haiti
 * * `HM` - Heard Island and McDonald Islands
 * * `VA` - Holy See
 * * `HN` - Honduras
 * * `HK` - Hong Kong
 * * `HU` - Hungary
 * * `IS` - Iceland
 * * `IN` - India
 * * `ID` - Indonesia
 * * `IR` - Iran
 * * `IQ` - Iraq
 * * `IE` - Ireland
 * * `IM` - Isle of Man
 * * `IL` - Israel
 * * `IT` - Italy
 * * `JM` - Jamaica
 * * `JP` - Japan
 * * `JE` - Jersey
 * * `JO` - Jordan
 * * `KZ` - Kazakhstan
 * * `KE` - Kenya
 * * `KI` - Kiribati
 * * `KW` - Kuwait
 * * `KG` - Kyrgyzstan
 * * `LA` - Laos
 * * `LV` - Latvia
 * * `LB` - Lebanon
 * * `LS` - Lesotho
 * * `LR` - Liberia
 * * `LY` - Libya
 * * `LI` - Liechtenstein
 * * `LT` - Lithuania
 * * `LU` - Luxembourg
 * * `MO` - Macao
 * * `MG` - Madagascar
 * * `MW` - Malawi
 * * `MY` - Malaysia
 * * `MV` - Maldives
 * * `ML` - Mali
 * * `MT` - Malta
 * * `MH` - Marshall Islands
 * * `MQ` - Martinique
 * * `MR` - Mauritania
 * * `MU` - Mauritius
 * * `YT` - Mayotte
 * * `MX` - Mexico
 * * `FM` - Micronesia
 * * `MD` - Moldova
 * * `MC` - Monaco
 * * `MN` - Mongolia
 * * `ME` - Montenegro
 * * `MS` - Montserrat
 * * `MA` - Morocco
 * * `MZ` - Mozambique
 * * `MM` - Myanmar
 * * `NA` - Namibia
 * * `NR` - Nauru
 * * `NP` - Nepal
 * * `NL` - Netherlands
 * * `NC` - New Caledonia
 * * `NZ` - New Zealand
 * * `NI` - Nicaragua
 * * `NE` - Niger
 * * `NG` - Nigeria
 * * `NU` - Niue
 * * `NF` - Norfolk Island
 * * `KP` - North Korea
 * * `MK` - North Macedonia
 * * `XI` - Northern Ireland
 * * `MP` - Northern Mariana Islands
 * * `NO` - Norway
 * * `OM` - Oman
 * * `PK` - Pakistan
 * * `PW` - Palau
 * * `PS` - Palestine, State of
 * * `PA` - Panama
 * * `PG` - Papua New Guinea
 * * `PY` - Paraguay
 * * `PE` - Peru
 * * `PH` - Philippines
 * * `PN` - Pitcairn
 * * `PL` - Poland
 * * `PT` - Portugal
 * * `PR` - Puerto Rico
 * * `QA` - Qatar
 * * `RE` - Réunion
 * * `RO` - Romania
 * * `RU` - Russia
 * * `RW` - Rwanda
 * * `BL` - Saint Barthélemy
 * * `SH` - Saint Helena, Ascension and Tristan da Cunha
 * * `KN` - Saint Kitts and Nevis
 * * `LC` - Saint Lucia
 * * `MF` - Saint Martin (French part)
 * * `PM` - Saint Pierre and Miquelon
 * * `VC` - Saint Vincent and the Grenadines
 * * `WS` - Samoa
 * * `SM` - San Marino
 * * `ST` - Sao Tome and Principe
 * * `SA` - Saudi Arabia
 * * `SN` - Senegal
 * * `RS` - Serbia
 * * `SC` - Seychelles
 * * `SL` - Sierra Leone
 * * `SG` - Singapore
 * * `SX` - Sint Maarten (Dutch part)
 * * `SK` - Slovakia
 * * `SI` - Slovenia
 * * `SB` - Solomon Islands
 * * `SO` - Somalia
 * * `ZA` - South Africa
 * * `GS` - South Georgia and the South Sandwich Islands
 * * `KR` - South Korea
 * * `SS` - South Sudan
 * * `ES` - Spain
 * * `LK` - Sri Lanka
 * * `SD` - Sudan
 * * `SR` - Suriname
 * * `SJ` - Svalbard and Jan Mayen
 * * `SE` - Sweden
 * * `CH` - Switzerland
 * * `SY` - Syria
 * * `TW` - Taiwan
 * * `TJ` - Tajikistan
 * * `TZ` - Tanzania
 * * `TH` - Thailand
 * * `TL` - Timor-Leste
 * * `TG` - Togo
 * * `TK` - Tokelau
 * * `TO` - Tonga
 * * `TT` - Trinidad and Tobago
 * * `TN` - Tunisia
 * * `TR` - Türkiye
 * * `TM` - Turkmenistan
 * * `TC` - Turks and Caicos Islands
 * * `TV` - Tuvalu
 * * `UG` - Uganda
 * * `UA` - Ukraine
 * * `AE` - United Arab Emirates
 * * `GB` - United Kingdom
 * * `UM` - United States Minor Outlying Islands
 * * `US` - United States of America
 * * `UY` - Uruguay
 * * `UZ` - Uzbekistan
 * * `VU` - Vanuatu
 * * `VE` - Venezuela
 * * `VN` - Vietnam
 * * `VG` - Virgin Islands (British)
 * * `VI` - Virgin Islands (U.S.)
 * * `WF` - Wallis and Futuna
 * * `EH` - Western Sahara
 * * `YE` - Yemen
 * * `ZM` - Zambia
 * * `ZW` - Zimbabwe
 */
export enum Country {
    AF = "AF",
    AX = "AX",
    AL = "AL",
    DZ = "DZ",
    AS = "AS",
    AD = "AD",
    AO = "AO",
    AI = "AI",
    AQ = "AQ",
    AG = "AG",
    AR = "AR",
    AM = "AM",
    AW = "AW",
    AU = "AU",
    AT = "AT",
    AZ = "AZ",
    BS = "BS",
    BH = "BH",
    BD = "BD",
    BB = "BB",
    BY = "BY",
    BE = "BE",
    BZ = "BZ",
    BJ = "BJ",
    BM = "BM",
    BT = "BT",
    BO = "BO",
    BQ = "BQ",
    BA = "BA",
    BW = "BW",
    BV = "BV",
    BR = "BR",
    IO = "IO",
    BN = "BN",
    BG = "BG",
    BF = "BF",
    BI = "BI",
    CV = "CV",
    KH = "KH",
    CM = "CM",
    CA = "CA",
    KY = "KY",
    CF = "CF",
    TD = "TD",
    CL = "CL",
    CN = "CN",
    CX = "CX",
    CC = "CC",
    CO = "CO",
    KM = "KM",
    CG = "CG",
    CD = "CD",
    CK = "CK",
    CR = "CR",
    CI = "CI",
    HR = "HR",
    CU = "CU",
    CW = "CW",
    CY = "CY",
    CZ = "CZ",
    DK = "DK",
    DJ = "DJ",
    DM = "DM",
    DO = "DO",
    EC = "EC",
    EG = "EG",
    SV = "SV",
    GQ = "GQ",
    ER = "ER",
    EE = "EE",
    SZ = "SZ",
    ET = "ET",
    FK = "FK",
    FO = "FO",
    FJ = "FJ",
    FI = "FI",
    FR = "FR",
    GF = "GF",
    PF = "PF",
    TF = "TF",
    GA = "GA",
    GM = "GM",
    GE = "GE",
    DE = "DE",
    GH = "GH",
    GI = "GI",
    GR = "GR",
    GL = "GL",
    GD = "GD",
    GP = "GP",
    GU = "GU",
    GT = "GT",
    GG = "GG",
    GN = "GN",
    GW = "GW",
    GY = "GY",
    HT = "HT",
    HM = "HM",
    VA = "VA",
    HN = "HN",
    HK = "HK",
    HU = "HU",
    IS = "IS",
    IN = "IN",
    ID = "ID",
    IR = "IR",
    IQ = "IQ",
    IE = "IE",
    IM = "IM",
    IL = "IL",
    IT = "IT",
    JM = "JM",
    JP = "JP",
    JE = "JE",
    JO = "JO",
    KZ = "KZ",
    KE = "KE",
    KI = "KI",
    KW = "KW",
    KG = "KG",
    LA = "LA",
    LV = "LV",
    LB = "LB",
    LS = "LS",
    LR = "LR",
    LY = "LY",
    LI = "LI",
    LT = "LT",
    LU = "LU",
    MO = "MO",
    MG = "MG",
    MW = "MW",
    MY = "MY",
    MV = "MV",
    ML = "ML",
    MT = "MT",
    MH = "MH",
    MQ = "MQ",
    MR = "MR",
    MU = "MU",
    YT = "YT",
    MX = "MX",
    FM = "FM",
    MD = "MD",
    MC = "MC",
    MN = "MN",
    ME = "ME",
    MS = "MS",
    MA = "MA",
    MZ = "MZ",
    MM = "MM",
    NA = "NA",
    NR = "NR",
    NP = "NP",
    NL = "NL",
    NC = "NC",
    NZ = "NZ",
    NI = "NI",
    NE = "NE",
    NG = "NG",
    NU = "NU",
    NF = "NF",
    KP = "KP",
    MK = "MK",
    XI = "XI",
    MP = "MP",
    NO = "NO",
    OM = "OM",
    PK = "PK",
    PW = "PW",
    PS = "PS",
    PA = "PA",
    PG = "PG",
    PY = "PY",
    PE = "PE",
    PH = "PH",
    PN = "PN",
    PL = "PL",
    PT = "PT",
    PR = "PR",
    QA = "QA",
    RE = "RE",
    RO = "RO",
    RU = "RU",
    RW = "RW",
    BL = "BL",
    SH = "SH",
    KN = "KN",
    LC = "LC",
    MF = "MF",
    PM = "PM",
    VC = "VC",
    WS = "WS",
    SM = "SM",
    ST = "ST",
    SA = "SA",
    SN = "SN",
    RS = "RS",
    SC = "SC",
    SL = "SL",
    SG = "SG",
    SX = "SX",
    SK = "SK",
    SI = "SI",
    SB = "SB",
    SO = "SO",
    ZA = "ZA",
    GS = "GS",
    KR = "KR",
    SS = "SS",
    ES = "ES",
    LK = "LK",
    SD = "SD",
    SR = "SR",
    SJ = "SJ",
    SE = "SE",
    CH = "CH",
    SY = "SY",
    TW = "TW",
    TJ = "TJ",
    TZ = "TZ",
    TH = "TH",
    TL = "TL",
    TG = "TG",
    TK = "TK",
    TO = "TO",
    TT = "TT",
    TN = "TN",
    TR = "TR",
    TM = "TM",
    TC = "TC",
    TV = "TV",
    UG = "UG",
    UA = "UA",
    AE = "AE",
    GB = "GB",
    UM = "UM",
    US = "US",
    UY = "UY",
    UZ = "UZ",
    VU = "VU",
    VE = "VE",
    VN = "VN",
    VG = "VG",
    VI = "VI",
    WF = "WF",
    EH = "EH",
    YE = "YE",
    ZM = "ZM",
    ZW = "ZW",
}

/**
 * * `EU` - Eu
 * * `GB` - Gb
 * * `Other` - Other
 */
export enum CountryTypeEnum {
    EU = "EU",
    GB = "GB",
    Other = "Other",
}

export interface CreateCompanyAddress {
    id: number;
    /** @format uuid */
    company_uuid: string;
    /** @format date-time */
    created: string;
    /** @format date-time */
    modified: string;
    /** @format uuid */
    uuid: string;
    /** @maxLength 255 */
    name: string;
    /**
     * * `billing_address` - Billing address
     * * `delivery_address` - Delivery address
     * * `dispatch_address` - Dispatch address
     * * `company_address` - Company address
     */
    address_type?: AddressTypeEnum;
    /** @maxLength 255 */
    contact_full_name?: string | null;
    /** @maxLength 50 */
    contact_phone?: string | null;
    /** @maxLength 100 */
    building?: string | null;
    /** @maxLength 255 */
    street_1?: string | null;
    /** @maxLength 255 */
    street_2?: string | null;
    /** @maxLength 100 */
    town?: string | null;
    /** @maxLength 100 */
    region?: string | null;
    /** @maxLength 100 */
    postcode?: string | null;
    country?: Country | BlankEnum | NullEnum | null;
    /** @maxLength 100 */
    place_id?: string | null;
    /**
     * @format decimal
     * @pattern ^-?\d{0,4}(?:\.\d{0,15})?$
     */
    latitude?: string | null;
    /**
     * @format decimal
     * @pattern ^-?\d{0,4}(?:\.\d{0,15})?$
     */
    longitude?: string | null;
    /** @maxLength 50 */
    vat_number?: string | null;
    vat_country_code?: Country | BlankEnum | NullEnum | null;
    vat_exempt?: boolean;
    phone_country_code?: PhoneCountryCodeEnum | BlankEnum | NullEnum | null;
    delivery_instructions?: string | null;
    collection_instructions?: string | null;
    /**
     * * `EU` - Eu
     * * `GB` - Gb
     * * `Other` - Other
     */
    country_type?: CountryTypeEnum;
    /** @maxLength 20 */
    eori_number?: string;
    /** @maxLength 20 */
    ein_number?: string;
    notes?: string;
    /**
     * Type of delivery location (warehouse, factory, distribution_center, retail_location, other).
     * @maxLength 50
     */
    delivery_location_type?: string;
    /**
     * Free-text description when delivery_location_type == 'other'.
     * @maxLength 255
     */
    delivery_location_type_other?: string;
    /**
     * Free-text receiving hours (e.g. 'Mon-Fri 9am-5pm').
     * @maxLength 255
     */
    warehouse_receiving_hours?: string;
}

export interface CreateUser {
    id: number;
    /** @maxLength 128 */
    password: string;
    /** @maxLength 150 */
    first_name?: string;
    /** @maxLength 150 */
    last_name?: string;
    /**
     * @format email
     * @maxLength 254
     */
    email: string;
    /** @maxLength 128 */
    phone_number?: string | null;
    auth_token: string;
}

export interface CreatedBy {
    /** @format uuid */
    uuid: string;
    name: string;
}

/**
 * * `payment_agent` - Payment Agent
 * * `debt_agent` - Debt Agent
 * * `onboarding_agent` - Onboarding Agent
 * * `demand_forecaster` - Demand Forecaster
 * * `supplier_optimizer` - Supplier Optimizer
 */
export enum CreatorEnum {
    PaymentAgent = "payment_agent",
    DebtAgent = "debt_agent",
    OnboardingAgent = "onboarding_agent",
    DemandForecaster = "demand_forecaster",
    SupplierOptimizer = "supplier_optimizer",
}

/** All credit limits for the calculator response. */
export interface CreditCalculatorLimits {
    two_organic: TwoOrganicLimitCheck | null;
    two_recourse: LimitCheck | null;
    allianz: LimitCheck | null;
}

/** Request serializer for the credit calculator endpoint. */
export interface CreditCalculatorRequest {
    /**
     * UUID of an existing order to check credit for
     * @format uuid
     */
    order_uuid?: string;
    /**
     * Order amount in cents
     * @format int64
     * @min 0
     * @max 99999999999
     */
    amount_cents?: number;
    /**
     * Payment provider to use for credit risk evaluation (only with amount_cents)
     *
     * * `stripe` - Stripe
     * * `two` - Two
     * * `direct` - Direct
     */
    payment_provider?: PaymentProviderEnum;
}

/** Response serializer for the credit calculator endpoint. */
export interface CreditCalculatorResponse {
    /** False for DIRECT orders (no credit check needed) */
    credit_check_required: boolean;
    /** The amount checked against limits (cents) */
    amount_cents: number | null;
    /** Payment provider used for the check */
    payment_provider: string | null;
    /** The buyer's currency code (e.g., 'GBP', 'EUR') */
    buyer_currency: string | null;
    /** Credit limits by provider */
    limits: CreditCalculatorLimits;
    /**
     * Recommended credit risk owner
     *
     * * `two` - Two
     * * `allianz` - Allianz
     * * `opply` - Opply
     */
    recommended_credit_risk_owner: CreditRiskOwnerEnum | NullEnum | null;
    /** Total allocated credit for orders with no credit risk owner (cents, visibility only) */
    empty_credit_risk_owner_total: number;
    /** Whether any credit path can cover the amount (null if no amount) */
    has_sufficient_credit: boolean | null;
}

/**
 * * `available` - Available
 * * `not_connected` - Not Connected
 * * `not_configured` - Not Configured
 * * `api_error` - API Error
 */
export enum CreditLimitStatusEnum {
    Available = "available",
    NotConnected = "not_connected",
    NotConfigured = "not_configured",
    ApiError = "api_error",
}

/** Combined credit limits from Two and Allianz APIs. */
export interface CreditLimits {
    /** Credit limit data for Two organic (non-recourse) credit. */
    two_organic: TwoOrganicCreditLimit;
    /** Credit limit data for Two recourse credit. */
    two_recourse: TwoRecourseCreditLimit;
    /** Credit limit data for Allianz/recourse credit. */
    allianz: AllianzCreditLimit;
}

/**
 * * `two` - Two
 * * `allianz` - Allianz
 * * `opply` - Opply
 */
export enum CreditRiskOwnerEnum {
    Two = "two",
    Allianz = "allianz",
    Opply = "opply",
}

export interface CrmCompany {
    /** @format uuid */
    uuid: string;
    /** @maxLength 255 */
    domain: string;
    /**
     * Result of HTTP reachability check against the company domain.
     *
     * * `pending` - Pending
     * * `success` - Success
     * * `error` - Error
     * * `not_found` - Not Found
     */
    dns_check?: DnsCheckStatusEnum;
    data_entries: CrmCompanyData[];
    contact_count: number;
    enriched_fields: CrmCompanyEnrichedFields;
    hubspot_sync_status: HubSpotSyncStatusEnum | NullEnum | null;
    hubspot_deal_stage: HubSpotDealStageEnum | NullEnum | null;
    hubspot_has_lead: boolean | null;
    /** @format date-time */
    created: string;
    /** @format date-time */
    modified: string;
}

export interface CrmCompanyData {
    /** @format uuid */
    uuid: string;
    /**
     * Data provider origin (free text; commonly clay, cognism, lusha, apollo, generic)
     * @maxLength 50
     */
    source: string;
    /**
     * Company name
     * @maxLength 500
     */
    name?: string;
    /** List of LinkedIn URLs */
    linkedin_url?: any;
    /** @maxLength 2048 */
    website_url?: string;
    /** @maxLength 2048 */
    logo_url?: string;
    description?: string;
    short_description?: string;
    /** @maxLength 500 */
    primary_industry?: string;
    /** List of industry labels */
    industries?: any;
    /**
     * Headcount (point estimate)
     * @min -2147483648
     * @max 2147483647
     */
    employees?: number | null;
    /**
     * @min -2147483648
     * @max 2147483647
     */
    employees_min?: number | null;
    /**
     * @min -2147483648
     * @max 2147483647
     */
    employees_max?: number | null;
    /**
     * Annual revenue in USD (point estimate)
     * @format int64
     * @min -9223372036854776000
     * @max 9223372036854776000
     */
    revenue?: number | null;
    /**
     * @format int64
     * @min -9223372036854776000
     * @max 9223372036854776000
     */
    revenue_min?: number | null;
    /**
     * @format int64
     * @min -9223372036854776000
     * @max 9223372036854776000
     */
    revenue_max?: number | null;
    /**
     * @min -2147483648
     * @max 2147483647
     */
    year_founded?: number | null;
    /**
     * HQ city
     * @maxLength 255
     */
    city?: string;
    /**
     * HQ state
     * @maxLength 255
     */
    state?: string;
    /**
     * HQ country
     * @maxLength 255
     */
    country?: string;
    /**
     * HQ postal code
     * @maxLength 50
     */
    postal_code?: string;
    /** One raw address per source */
    address_raw?: string;
    /** List of office location objects */
    all_locations?: any;
    /** List of phone numbers */
    phone?: any;
    /** @maxLength 2048 */
    twitter_url?: string;
    /** @maxLength 2048 */
    facebook_url?: string;
    /** @maxLength 2048 */
    crunchbase_url?: string;
    /** List of keyword strings */
    keywords?: any;
    /** List of SIC code strings */
    sic_codes?: any;
    /** List of NAICS code strings */
    naics_codes?: any;
    /**
     * @min -2147483648
     * @max 2147483647
     */
    linkedin_followers?: number | null;
    /** @format date-time */
    created: string;
    /** @format date-time */
    modified: string;
}

export interface CrmCompanyEnrichedFields {
    /**
     * ICP score (0-100) calculated from icp_scoring enrichment process
     * @format double
     */
    score?: number | null;
    /** AI-generated company summary from icp_scoring enrichment process */
    ai_summary?: string | null;
    /** @format date-time */
    created: string;
    /** @format date-time */
    modified: string;
}

export interface CrmContact {
    /** @format uuid */
    uuid: string;
    /** @format uuid */
    company_uuid: string;
    /**
     * LinkedIn profile URL used as the unique identifier for the contact
     * @maxLength 500
     */
    linkedin_url: string;
    fields: CrmContactField[];
    /** @format date-time */
    created: string;
    /** @format date-time */
    modified: string;
}

export interface CrmContactField {
    field_type: CrmContactFieldTypeEnum;
    field_value: any;
    source: string;
}

/**
 * * `company_name` - Company Name
 * * `first_name` - First Name
 * * `last_name` - Last Name
 * * `full_name` - Full Name
 * * `job_title` - Job Title
 * * `location` - Location
 * * `linkedin_url` - LinkedIn URL
 * * `phone` - Phone
 * * `email` - Email
 * * `other` - Other
 */
export enum CrmContactFieldTypeEnum {
    CompanyName = "company_name",
    FirstName = "first_name",
    LastName = "last_name",
    FullName = "full_name",
    JobTitle = "job_title",
    Location = "location",
    LinkedinUrl = "linkedin_url",
    Phone = "phone",
    Email = "email",
    Other = "other",
}

export interface CrmCustomColumn {
    /** @format uuid */
    uuid: string;
    /** @maxLength 255 */
    name: string;
    /**
     * * `numeric` - Numeric
     * * `text` - Text
     * * `llm` - LLM
     * * `score` - Score
     */
    type: CrmCustomColumnTypeEnum;
    config?: any;
    /** @format uuid */
    created_by_uuid: string;
    is_owner: boolean;
    /** @format date-time */
    created: string;
    /** @format date-time */
    modified: string;
}

/**
 * * `numeric` - Numeric
 * * `text` - Text
 * * `llm` - LLM
 * * `score` - Score
 */
export enum CrmCustomColumnTypeEnum {
    Numeric = "numeric",
    Text = "text",
    Llm = "llm",
    Score = "score",
}

/** Detail representation for the CRM import run history endpoint. */
export interface CrmImportRunDetail {
    /** @format uuid */
    uuid: string;
    /**
     * Which kind of import this run represents.
     *
     * * `companies_bulk` - Companies Bulk Import
     * * `companies_file` - Companies File Import
     * * `contacts_csv` - Contacts CSV Import
     */
    run_type: CrmImportRunTypeEnum;
    /**
     * Data source label passed to the import (e.g. clay, cognism, apollo).
     * @maxLength 100
     */
    source?: string;
    /**
     * * `pending` - Pending
     * * `in_progress` - In Progress
     * * `success` - Success
     * * `failure` - Failure
     */
    status?: CrmImportRunStatusEnum;
    /**
     * @min 0
     * @max 2147483647
     */
    total_companies?: number;
    /**
     * @min 0
     * @max 2147483647
     */
    created_companies?: number;
    /**
     * @min 0
     * @max 2147483647
     */
    updated_companies?: number;
    /** @format uuid */
    triggered_by_uuid: string;
    /** @format date-time */
    created: string;
    /** @format date-time */
    completed_at?: string | null;
    error?: string;
    /** @format date-time */
    started_at?: string | null;
}

/** List representation for the CRM import run history endpoint. */
export interface CrmImportRunList {
    /** @format uuid */
    uuid: string;
    /**
     * Which kind of import this run represents.
     *
     * * `companies_bulk` - Companies Bulk Import
     * * `companies_file` - Companies File Import
     * * `contacts_csv` - Contacts CSV Import
     */
    run_type: CrmImportRunTypeEnum;
    /**
     * Data source label passed to the import (e.g. clay, cognism, apollo).
     * @maxLength 100
     */
    source?: string;
    /**
     * * `pending` - Pending
     * * `in_progress` - In Progress
     * * `success` - Success
     * * `failure` - Failure
     */
    status?: CrmImportRunStatusEnum;
    /**
     * @min 0
     * @max 2147483647
     */
    total_companies?: number;
    /**
     * @min 0
     * @max 2147483647
     */
    created_companies?: number;
    /**
     * @min 0
     * @max 2147483647
     */
    updated_companies?: number;
    /** @format uuid */
    triggered_by_uuid: string;
    /** @format date-time */
    created: string;
    /** @format date-time */
    completed_at?: string | null;
}

/**
 * * `pending` - Pending
 * * `in_progress` - In Progress
 * * `success` - Success
 * * `failure` - Failure
 */
export enum CrmImportRunStatusEnum {
    Pending = "pending",
    InProgress = "in_progress",
    Success = "success",
    Failure = "failure",
}

/**
 * * `companies_bulk` - Companies Bulk Import
 * * `companies_file` - Companies File Import
 * * `contacts_csv` - Contacts CSV Import
 */
export enum CrmImportRunTypeEnum {
    CompaniesBulk = "companies_bulk",
    CompaniesFile = "companies_file",
    ContactsCsv = "contacts_csv",
}

export interface CrmSavedView {
    /** @format uuid */
    uuid: string;
    /** @maxLength 255 */
    name: string;
    config?: any;
    columns: CrmCustomColumn[];
    column_uuids?: string[];
    /** @format uuid */
    created_by_uuid: string;
    is_owner: boolean;
    /** @format date-time */
    created: string;
    /** @format date-time */
    modified: string;
    /**
     * Timestamp of the most recent change to `config`. Used to determine whether the latest HubSpot sync is stale relative to the current view config.
     * @format date-time
     */
    config_last_changed_at: string | null;
    latest_hubspot_sync_run: string;
    hubspot_sync_is_stale: boolean;
}

/**
 * Serializer for per-company CRM settings (singleton).
 *
 * The `company` field is set server-side and is not exposed.
 */
export interface CrmSettings {
    /** @format uuid */
    uuid: string;
    /** When False, the automatic HubSpot View Sync that fires on saved view create/update is suppressed. Manual syncs via the hubspot-sync endpoint are unaffected. */
    sync_hubspot_on_view_save?: boolean;
    /** @format date-time */
    created: string;
    /** @format date-time */
    modified: string;
}

/**
 * * `EUR` - EUR
 * * `USD` - USD
 * * `GBP` - GBP
 * * `CAD` - CAD
 */
export enum Currencies {
    EUR = "EUR",
    USD = "USD",
    GBP = "GBP",
    CAD = "CAD",
}

/**
 * * `healthy` - Healthy
 * * `average` - Average
 * * `at_risk` - At Risk
 * * `new` - New
 * * `churned` - Churned
 * * `on_hold` - On Hold
 */
export enum CustomerHealthStatusEnum {
    Healthy = "healthy",
    Average = "average",
    AtRisk = "at_risk",
    New = "new",
    Churned = "churned",
    OnHold = "on_hold",
}

export enum CustomerHoldReasonEnum {
    OverduePayments = "overdue_payments",
    NewContractRequired = "new_contract_required",
    VerificationNeeded = "verification_needed",
    Other = "other",
}

/** Serializer for reading CustomerStatus records. */
export interface CustomerStatus {
    /** @format uuid */
    uuid: string;
    /**
     * Health status of the customer (healthy, average, at_risk, new, churned, on_hold)
     *
     * * `healthy` - Healthy
     * * `average` - Average
     * * `at_risk` - At Risk
     * * `new` - New
     * * `churned` - Churned
     * * `on_hold` - On Hold
     */
    status: CustomerHealthStatusEnum;
    /** Buyer-facing reason category (dropdown); empty unless status is on_hold. */
    on_hold_reason_category: CustomerHoldReasonEnum | "";
    /** Free-text reason, used only when category is OTHER; empty otherwise. */
    on_hold_public_reason: string;
    /** @format date-time */
    created: string;
    updated_by: UpdatedBy;
}

export interface CustomerStatusNotFoundResponse {
    detail: string;
}

/** Serializer for updating a customer's status. */
export interface CustomerStatusUpdate {
    /**
     * New health status for the customer
     *
     * * `healthy` - Healthy
     * * `average` - Average
     * * `at_risk` - At Risk
     * * `new` - New
     * * `churned` - Churned
     * * `on_hold` - On Hold
     */
    status: CustomerHealthStatusEnum;
    /** Buyer-facing reason category (dropdown). Only stored when status is ON_HOLD. */
    on_hold_reason_category?: CustomerHoldReasonEnum | "";
    /**
     * Free-text reason, only stored when status is ON_HOLD and the category is OTHER.
     * @maxLength 1000
     */
    on_hold_public_reason?: string;
}

export interface DashboardContractsList {
    /** @format uuid */
    uuid: string;
    /** @format uuid */
    inquiry_uuid: string;
    /** @maxLength 255 */
    product_name: string;
    /**
     * @format uri
     * @maxLength 2048
     */
    logo_url?: string;
    /**
     * * `available` - available
     * * `ordered` - ordered
     * * `expired` - expired
     * * `declined` - declined
     * * `pending_payment` - pending_payment
     * * `proceeded` - proceeded
     * * `contract_created` - Contract Created
     * * `contract_proceeded` - contract_proceeded
     * * `contract_confirmed` - contract_confirmed
     */
    status?: QuoteState;
    total_forecast_volume: string;
    ordered_volume: number;
    is_new: boolean;
    /**
     * * `fl oz` - Fluid Ounces
     * * `g` - Grams
     * * `mg` - milligrams
     * * `gals` - Gallons
     * * `kg` - Kilograms
     * * `L` - Liters
     * * `tons` - Metric Tons
     * * `oz` - Ounces
     * * `lbs` - Pounds
     * * `pcs` - Pieces
     * * `pt` - Pints
     * * `ml` - Milliliter
     * * `boxes` - Boxes
     * * `pallets` - Pallets
     * * `tsp` - Teaspoons
     * * `tbsp` - Tablespoons
     * * `units` - Units
     * * `cases` - Cases
     * * `trays` - Trays
     */
    unit_of_measurement?: UnitOfMeasurementEnum;
    is_pending: boolean;
    days_left: number;
    quantity_remaining: number;
    contract_status: string;
    is_filled: boolean;
    agreement_required?: boolean;
    has_pending_purchase_request: boolean;
    contract_progress_status: string;
}

export interface DashboardInquiries {
    /** @format uuid */
    uuid: string;
    /** @maxLength 255 */
    name: string;
    /**
     * @format uri
     * @maxLength 2048
     */
    logo_url?: string;
    /**
     * * `EUR` - EUR
     * * `USD` - USD
     * * `GBP` - GBP
     * * `CAD` - CAD
     */
    currency?: Currencies;
    /**
     * * `fl oz` - Fluid Ounces
     * * `g` - Grams
     * * `mg` - milligrams
     * * `gals` - Gallons
     * * `kg` - Kilograms
     * * `L` - Liters
     * * `tons` - Metric Tons
     * * `oz` - Ounces
     * * `lbs` - Pounds
     * * `pcs` - Pieces
     * * `pt` - Pints
     * * `ml` - Milliliter
     * * `boxes` - Boxes
     * * `pallets` - Pallets
     * * `tsp` - Teaspoons
     * * `tbsp` - Tablespoons
     * * `units` - Units
     * * `cases` - Cases
     * * `trays` - Trays
     */
    unit_of_measurement?: UnitOfMeasurementEnum;
    total_quotes_count: number;
    new_quotes_count: number;
    /** @format double */
    lowest_unit_price: number;
    savings_percentage: number;
    is_new: boolean;
    /** @format uuid */
    original_quote_uuid: string;
    ai_generated?: boolean;
}

export interface DashboardInquiriesForSupplier {
    /** @format uuid */
    uuid: string;
    /** @maxLength 255 */
    name: string;
    /**
     * @format uri
     * @maxLength 2048
     */
    logo_url?: string;
    /**
     * * `EUR` - EUR
     * * `USD` - USD
     * * `GBP` - GBP
     * * `CAD` - CAD
     */
    currency?: Currencies;
    /**
     * * `fl oz` - Fluid Ounces
     * * `g` - Grams
     * * `mg` - milligrams
     * * `gals` - Gallons
     * * `kg` - Kilograms
     * * `L` - Liters
     * * `tons` - Metric Tons
     * * `oz` - Ounces
     * * `lbs` - Pounds
     * * `pcs` - Pieces
     * * `pt` - Pints
     * * `ml` - Milliliter
     * * `boxes` - Boxes
     * * `pallets` - Pallets
     * * `tsp` - Teaspoons
     * * `tbsp` - Tablespoons
     * * `units` - Units
     * * `cases` - Cases
     * * `trays` - Trays
     */
    unit_of_measurement?: UnitOfMeasurementEnum;
    /**
     * * `non_recurring` - Non Recurring
     * * `recurring` - Recurring
     * * `purchase_request` - Purchase Request
     * * `ingredient` - Ingredient
     * * `ingredient_copy` - Ingredient Copy
     */
    category?: InquiryCategory;
    /**
     * @format decimal
     * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
     */
    quantity: string;
    total_forecast_quantity: string;
    /** @format date */
    first_order_delivery_date?: string | null;
    is_new: boolean;
    /** @format date */
    due_date: string;
    /** @format uuid */
    original_quote_uuid: string;
}

export interface DashboardOrders {
    /** @format uuid */
    uuid: string;
    order_number: string;
    /** @format date */
    quote_delivery_date: string;
    /**
     * * `pending_dispatch` - pending_dispatch
     * * `dispatched` - Dispatched
     * * `delivered` - Delivered
     */
    shipment_status?: ShipmentStatusEnum;
    is_new: boolean;
}

export interface Deals {
    id: number;
    /** @format uuid */
    uuid: string;
    /** @maxLength 100 */
    title: string;
    notes: Notes[];
}

export interface DeliveryAddressForSupplier {
    /** @maxLength 100 */
    town?: string | null;
    country?: Country | BlankEnum | NullEnum | null;
    /** @maxLength 100 */
    postcode?: string | null;
}

export interface DeliveryAddressResponse {
    /** @format uuid */
    uuid: string;
    /** @maxLength 255 */
    name?: string | null;
    /** @maxLength 100 */
    street_1?: string | null;
    /** @maxLength 100 */
    street_2?: string | null;
    /** @maxLength 100 */
    postcode?: string | null;
    /** @maxLength 100 */
    town?: string | null;
    /** @maxLength 100 */
    region?: string | null;
    country?: Country | BlankEnum | NullEnum | null;
    delivery_instructions?: string | null;
    contact_phone?: string | null;
    phone_country_code?: string | null;
    contact_full_name?: string | null;
}

/** Serializer for delivery details. */
export interface DeliveryDetails {
    id: number;
    /** Delivery address (DEPRECATED: Use buyer_onboarding_delivery_address instead) */
    delivery_address?: string;
    /**
     * * `warehouse` - Warehouse
     * * `factory` - Factory
     * * `distribution_center` - Distribution Center
     * * `retail_location` - Retail Location
     * * `other` - Other
     */
    delivery_location_type: DeliveryLocationTypeEnum;
    delivery_location_type_display: string;
    /**
     * Specify delivery location type when 'Other' is selected
     * @maxLength 255
     */
    delivery_location_type_other?: string;
    /** Delivery instructions */
    delivery_instructions?: string;
    /**
     * Delivery contact name (DEPRECATED: Use delivery_address relationship instead)
     * @maxLength 255
     */
    delivery_contact_name?: string;
    /**
     * Delivery contact phone number (DEPRECATED: Use delivery_address relationship instead)
     * @maxLength 50
     */
    delivery_contact_phone_number?: string;
    /**
     * Delivery contact email (DEPRECATED: Use delivery_emails relationship instead)
     * @format email
     * @maxLength 255
     */
    delivery_contact_email?: string;
    /**
     * Warehouse receiving hours
     * @maxLength 255
     */
    warehouse_receiving_hours?: string;
    /**
     * Storage capacity
     * @maxLength 255
     */
    storage_capacity?: string;
    /**
     * Access requirements
     *
     * * `delivery_appointment` - Delivery appointment requirement
     * * `inside_delivery` - Inside delivery Required
     * * `lift_gate` - Lift gate required
     */
    access_requirements?: AccessRequirementsEnum | BlankEnum;
    /** Is a sample required? */
    is_sample_required?: boolean;
    /** @format date-time */
    created_at: string;
    /** @format date-time */
    modified_at: string;
}

/** Serializer for DeliveryEmail model. */
export interface DeliveryEmail {
    /**
     * Unique identifier for delivery email lookup
     * @format uuid
     */
    uuid: string;
    /**
     * Label for this delivery contact (e.g. 'Goods In')
     * @maxLength 255
     */
    label: string;
    /**
     * Delivery contact email
     * @format email
     * @maxLength 255
     */
    email_address: string;
    /** @format date-time */
    created_at: string;
    /** @format date-time */
    modified_at: string;
}

/**
 * Serializer for handling create/update/delete operations on a list of delivery emails.
 * Accepts a list of delivery email objects and handles validation, creation, updates, and deletions.
 */
export interface DeliveryEmailList {
    /** List of delivery email objects with 'uuid' (optional), 'label', and 'email_address' */
    delivery_emails: Record<string, any>[];
}

/**
 * Buyer Delivery Locations section. A buyer can have 1..N of these,
 * each one a `CompanyAddress(address_type=DELIVERY)`. The required-field
 * set matches the doc's §4.5 list. Includes the rich legacy fields
 * (`warehouse_receiving_hours`, `delivery_location_type`, EORI, EIN)
 * so the new flow has parity with the old `BuyerOnboardingDeliveryAddress`
 * shape.
 */
export interface DeliveryLocation {
    /** @format uuid */
    uuid: string;
    /** @maxLength 255 */
    name: string;
    /** @maxLength 255 */
    contact_full_name: string;
    /** @maxLength 50 */
    contact_phone: string;
    phone_country_code?: PhoneCountryCodeEnum | BlankEnum | NullEnum | null;
    /** @maxLength 255 */
    street_1: string;
    /** @maxLength 255 */
    street_2?: string | null;
    /** @maxLength 100 */
    town: string;
    /** @maxLength 100 */
    region?: string | null;
    /** @maxLength 100 */
    postcode: string;
    country: Country | BlankEnum;
    delivery_instructions?: string | null;
    /** @maxLength 20 */
    eori_number?: string;
    /** @maxLength 20 */
    ein_number?: string;
    /**
     * Type of delivery location (warehouse, factory, distribution_center, retail_location, other).
     * @maxLength 50
     */
    delivery_location_type?: string;
    /**
     * Free-text description when delivery_location_type == 'other'.
     * @maxLength 255
     */
    delivery_location_type_other?: string;
    /**
     * Free-text receiving hours (e.g. 'Mon-Fri 9am-5pm').
     * @maxLength 255
     */
    warehouse_receiving_hours?: string;
}

/**
 * * `warehouse` - Warehouse
 * * `factory` - Factory
 * * `distribution_center` - Distribution Center
 * * `retail_location` - Retail Location
 * * `other` - Other
 */
export enum DeliveryLocationTypeEnum {
    Warehouse = "warehouse",
    Factory = "factory",
    DistributionCenter = "distribution_center",
    RetailLocation = "retail_location",
    Other = "other",
}

/**
 * * `initializing` - Initializing
 * * `not_started` - Not Started
 * * `pending_dispatch` - Pending Dispatch
 * * `in_transit` - In Transit
 * * `delivered` - Delivered
 * * `freight_ownership_pending` - Freight Ownership Pending
 * * `gathering_quotes` - Gathering Quotes
 * * `dispatch_scheduled` - Dispatch Scheduled
 * * `awaiting_collection_details` - Awaiting Collection Details
 * * `ready_for_pickup` - Ready for Pickup
 * * `picked_up` - Picked Up
 * * `preparing_freight` - Preparing Freight
 * * `freight_scheduled` - Freight Scheduled
 * * `gathering_freight_quotes` - Gathering Freight Quotes
 * * `quotes_confirmed` - Quotes Confirmed
 */
export enum DeliveryStateEnum {
    Initializing = "initializing",
    NotStarted = "not_started",
    PendingDispatch = "pending_dispatch",
    InTransit = "in_transit",
    Delivered = "delivered",
    FreightOwnershipPending = "freight_ownership_pending",
    GatheringQuotes = "gathering_quotes",
    DispatchScheduled = "dispatch_scheduled",
    AwaitingCollectionDetails = "awaiting_collection_details",
    ReadyForPickup = "ready_for_pickup",
    PickedUp = "picked_up",
    PreparingFreight = "preparing_freight",
    FreightScheduled = "freight_scheduled",
    GatheringFreightQuotes = "gathering_freight_quotes",
    QuotesConfirmed = "quotes_confirmed",
}

export interface DeliveryTracking {
    tracking_code: string;
    shipping_provider: string;
    /** @format date */
    estimated_delivery_date: string | null;
    /** @format date */
    dispatched_at: string | null;
}

/**
 * * `kosher` - Kosher
 * * `halal` - Halal
 * * `organic` - Organic
 * * `vegan` - Vegan
 * * `vegetarian` - Vegetarian
 */
export enum DietComplianceEnum {
    Kosher = "kosher",
    Halal = "halal",
    Organic = "organic",
    Vegan = "vegan",
    Vegetarian = "vegetarian",
}

/**
 * * `kosher` - Kosher
 * * `halal` - Halal
 * * `organic` - Organic
 * * `vegan` - Vegan
 * * `vegetarian` - Vegetarian
 */
export enum DietRequirementsEnum {
    Kosher = "kosher",
    Halal = "halal",
    Organic = "organic",
    Vegan = "vegan",
    Vegetarian = "vegetarian",
}

/** Response serializer for the disabled-months endpoint. */
export interface DisabledMonths {
    disabled_months: string[];
}

/**
 * * `pending` - Pending
 * * `success` - Success
 * * `error` - Error
 * * `not_found` - Not Found
 */
export enum DnsCheckStatusEnum {
    Pending = "pending",
    Success = "success",
    Error = "error",
    NotFound = "not_found",
}

/**
 * * `valid` - Valid
 * * `expired` - Expired
 * * `expiring_soon` - Expiring Soon
 * * `renewed` - Renewed
 */
export enum DocumentLifecycleStatusEnum {
    Valid = "valid",
    Expired = "expired",
    ExpiringSoon = "expiring_soon",
    Renewed = "renewed",
}

/** Shared serializer for the DocumentType taxonomy (buyer, supplier, Opply documents). */
export interface DocumentType {
    /** @format uuid */
    uuid: string;
    /** @maxLength 255 */
    name: string;
    description?: string;
}

/** Serializer for duplicate order response */
export interface DuplicateOrderResponse {
    /** @format uuid */
    uuid: string;
}

export interface DuplicateQuote {
    /** @format date */
    delivery_date: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,10}(?:\.\d{0,2})?$
     */
    quantity: string;
    delivery_address?: number | null;
}

export interface EmailInviteResponse {
    id: number;
    /** @format date-time */
    created: string;
    /** @format date-time */
    modified: string;
    /** @format uuid */
    uuid: string;
    /** @maxLength 30 */
    first_name: string;
    /** @maxLength 30 */
    last_name: string;
    /**
     * @format email
     * @maxLength 254
     */
    email: string;
    is_admin?: boolean;
    /**
     * * `pending` - Pending
     * * `accepted` - Accepted
     */
    status?: EmailInviteResponseStatusEnum;
    company: number;
}

/**
 * * `pending` - Pending
 * * `accepted` - Accepted
 */
export enum EmailInviteResponseStatusEnum {
    Pending = "pending",
    Accepted = "accepted",
}

export interface EmailNotifications {
    /** @format uuid */
    uuid: string;
    /** @maxLength 255 */
    title?: string | null;
    /**
     * * `b_s_new_message` - b_s_new_message
     * * `b_s_daily_message_summary` - b_s_daily_message_summary
     * * `b_payment_confirmation` - b_payment_confirmation
     * * `b_payment_due` - b_payment_due
     * * `b_payment_reminder` - b_payment_reminder
     * * `s_payout_complete` - s_payout_complete
     * * `b_purchase_request_accepted` - b_purchase_request_accepted
     * * `s_new_purchase_request` - s_new_purchase_request
     * * `b_dispatch_notification` - b_dispatch_notification
     * * `b_new_quote_received` - b_new_quote_received
     * * `s_quote_accepted` - s_quote_accepted
     * * `s_new_request` - s_new_request
     * * `b_order_confirmations` - b_order_confirmations
     * * `s_dispatch_reminders` - s_dispatch_reminders
     * * `s_samples_requested` - s_samples_requested
     * * `b_quote_available_to_order` - b_quote_available_to_order
     * * `b_purchase_request_declined` - b_purchase_request_declined
     * * `s_quote_negotiations_started` - s_quote_negotiations_started
     * * `b_quote_negotiation_responses` - b_quote_negotiation_responses
     * * `b_products_list_uploaded` - b_products_list_uploaded
     * * `b_ingredients_list_uploaded` - b_ingredients_list_uploaded
     * * `s_reminder_to_quote` - s_reminder_to_quote
     * * `b_quote_expiry_reminder` - b_quote_expiry_reminder
     * * `b_samples_dispatched` - b_samples_dispatched
     * * `s_supplier_remind_to_quote` - s_supplier_remind_to_quote
     * * `b_review_quotes` - b_review_quotes
     * * `s_samples_delivered` - s_samples_delivered
     * * `b_samples_feedback` - b_samples_feedback
     * * `s_reorder_request_created` - s_reorder_request_created
     * * `b_reorder_request_accepted` - b_reorder_request_accepted
     * * `b_reorder_request_declined` - b_reorder_request_declined
     * * `s_order_delivered` - s_order_delivered
     * * `s_purchase_order_cancelled` - s_purchase_order_cancelled
     * * `s_payout_confirmation` - s_payout_confirmation
     * * `b_contract_confirmed` - b_contract_confirmed
     * * `s_contract_confirmed` - s_contract_confirmed
     * * `s_create_contract` - s_create_contract
     * * `b_upload_signed_agreement` - b_upload_signed_agreement
     * * `s_purchase_order_edited` - s_purchase_order_edited
     * * `s_quote_declined` - s_quote_declined
     * * `s_requested_updated_quote` - s_requested_updated_quote
     * * `b_quote_updated` - b_quote_updated
     * * `b_order_updated` - b_order_updated
     * * `b_order_pending_payment` - b_order_pending_payment
     * * `b_order_dispatched` - b_order_dispatched
     * * `b_order_activity_message` - b_order_activity_message
     * * `b_s_daily_task_digest` - b_s_daily_task_digest
     * * `b_spot_buy_request_created` - b_spot_buy_request_created
     * * `b_order_created` - b_order_created
     * * `b_service_fee_invoice` - b_service_fee_invoice
     * * `b_grouped_statement_due_reminder` - b_grouped_statement_due_reminder
     * * `b_grouped_statement_due_today` - b_grouped_statement_due_today
     * * `b_grouped_statement_overdue` - b_grouped_statement_overdue
     */
    type: EmailNotificationsTypeEnum;
    /** @maxLength 255 */
    description?: string | null;
    is_activated_for_user: boolean;
}

/**
 * * `b_s_new_message` - b_s_new_message
 * * `b_s_daily_message_summary` - b_s_daily_message_summary
 * * `b_payment_confirmation` - b_payment_confirmation
 * * `b_payment_due` - b_payment_due
 * * `b_payment_reminder` - b_payment_reminder
 * * `s_payout_complete` - s_payout_complete
 * * `b_purchase_request_accepted` - b_purchase_request_accepted
 * * `s_new_purchase_request` - s_new_purchase_request
 * * `b_dispatch_notification` - b_dispatch_notification
 * * `b_new_quote_received` - b_new_quote_received
 * * `s_quote_accepted` - s_quote_accepted
 * * `s_new_request` - s_new_request
 * * `b_order_confirmations` - b_order_confirmations
 * * `s_dispatch_reminders` - s_dispatch_reminders
 * * `s_samples_requested` - s_samples_requested
 * * `b_quote_available_to_order` - b_quote_available_to_order
 * * `b_purchase_request_declined` - b_purchase_request_declined
 * * `s_quote_negotiations_started` - s_quote_negotiations_started
 * * `b_quote_negotiation_responses` - b_quote_negotiation_responses
 * * `b_products_list_uploaded` - b_products_list_uploaded
 * * `b_ingredients_list_uploaded` - b_ingredients_list_uploaded
 * * `s_reminder_to_quote` - s_reminder_to_quote
 * * `b_quote_expiry_reminder` - b_quote_expiry_reminder
 * * `b_samples_dispatched` - b_samples_dispatched
 * * `s_supplier_remind_to_quote` - s_supplier_remind_to_quote
 * * `b_review_quotes` - b_review_quotes
 * * `s_samples_delivered` - s_samples_delivered
 * * `b_samples_feedback` - b_samples_feedback
 * * `s_reorder_request_created` - s_reorder_request_created
 * * `b_reorder_request_accepted` - b_reorder_request_accepted
 * * `b_reorder_request_declined` - b_reorder_request_declined
 * * `s_order_delivered` - s_order_delivered
 * * `s_purchase_order_cancelled` - s_purchase_order_cancelled
 * * `s_payout_confirmation` - s_payout_confirmation
 * * `b_contract_confirmed` - b_contract_confirmed
 * * `s_contract_confirmed` - s_contract_confirmed
 * * `s_create_contract` - s_create_contract
 * * `b_upload_signed_agreement` - b_upload_signed_agreement
 * * `s_purchase_order_edited` - s_purchase_order_edited
 * * `s_quote_declined` - s_quote_declined
 * * `s_requested_updated_quote` - s_requested_updated_quote
 * * `b_quote_updated` - b_quote_updated
 * * `b_order_updated` - b_order_updated
 * * `b_order_pending_payment` - b_order_pending_payment
 * * `b_order_dispatched` - b_order_dispatched
 * * `b_order_activity_message` - b_order_activity_message
 * * `b_s_daily_task_digest` - b_s_daily_task_digest
 * * `b_spot_buy_request_created` - b_spot_buy_request_created
 * * `b_order_created` - b_order_created
 * * `b_service_fee_invoice` - b_service_fee_invoice
 * * `b_grouped_statement_due_reminder` - b_grouped_statement_due_reminder
 * * `b_grouped_statement_due_today` - b_grouped_statement_due_today
 * * `b_grouped_statement_overdue` - b_grouped_statement_overdue
 */
export enum EmailNotificationsTypeEnum {
    BSNewMessage = "b_s_new_message",
    BSDailyMessageSummary = "b_s_daily_message_summary",
    BPaymentConfirmation = "b_payment_confirmation",
    BPaymentDue = "b_payment_due",
    BPaymentReminder = "b_payment_reminder",
    SPayoutComplete = "s_payout_complete",
    BPurchaseRequestAccepted = "b_purchase_request_accepted",
    SNewPurchaseRequest = "s_new_purchase_request",
    BDispatchNotification = "b_dispatch_notification",
    BNewQuoteReceived = "b_new_quote_received",
    SQuoteAccepted = "s_quote_accepted",
    SNewRequest = "s_new_request",
    BOrderConfirmations = "b_order_confirmations",
    SDispatchReminders = "s_dispatch_reminders",
    SSamplesRequested = "s_samples_requested",
    BQuoteAvailableToOrder = "b_quote_available_to_order",
    BPurchaseRequestDeclined = "b_purchase_request_declined",
    SQuoteNegotiationsStarted = "s_quote_negotiations_started",
    BQuoteNegotiationResponses = "b_quote_negotiation_responses",
    BProductsListUploaded = "b_products_list_uploaded",
    BIngredientsListUploaded = "b_ingredients_list_uploaded",
    SReminderToQuote = "s_reminder_to_quote",
    BQuoteExpiryReminder = "b_quote_expiry_reminder",
    BSamplesDispatched = "b_samples_dispatched",
    SSupplierRemindToQuote = "s_supplier_remind_to_quote",
    BReviewQuotes = "b_review_quotes",
    SSamplesDelivered = "s_samples_delivered",
    BSamplesFeedback = "b_samples_feedback",
    SReorderRequestCreated = "s_reorder_request_created",
    BReorderRequestAccepted = "b_reorder_request_accepted",
    BReorderRequestDeclined = "b_reorder_request_declined",
    SOrderDelivered = "s_order_delivered",
    SPurchaseOrderCancelled = "s_purchase_order_cancelled",
    SPayoutConfirmation = "s_payout_confirmation",
    BContractConfirmed = "b_contract_confirmed",
    SContractConfirmed = "s_contract_confirmed",
    SCreateContract = "s_create_contract",
    BUploadSignedAgreement = "b_upload_signed_agreement",
    SPurchaseOrderEdited = "s_purchase_order_edited",
    SQuoteDeclined = "s_quote_declined",
    SRequestedUpdatedQuote = "s_requested_updated_quote",
    BQuoteUpdated = "b_quote_updated",
    BOrderUpdated = "b_order_updated",
    BOrderPendingPayment = "b_order_pending_payment",
    BOrderDispatched = "b_order_dispatched",
    BOrderActivityMessage = "b_order_activity_message",
    BSDailyTaskDigest = "b_s_daily_task_digest",
    BSpotBuyRequestCreated = "b_spot_buy_request_created",
    BOrderCreated = "b_order_created",
    BServiceFeeInvoice = "b_service_fee_invoice",
    BGroupedStatementDueReminder = "b_grouped_statement_due_reminder",
    BGroupedStatementDueToday = "b_grouped_statement_due_today",
    BGroupedStatementOverdue = "b_grouped_statement_overdue",
}

/** Input for triggering enrichment on a saved view. */
export interface EnrichViewRequest {
    /** @default "icp_scoring" */
    process_name?: EnrichmentProcessNameEnum;
    /**
     * Bypass the pre-score threshold check, forcing supplementary enrichment regardless of score.
     * @default false
     */
    force_full_enrichment?: boolean;
    /**
     * Bypass the S3 cache on every Lambda in the pipeline.
     * @default false
     */
    force_refresh?: boolean;
}

/**
 * * `icp_scoring` - ICP Scoring
 * * `company_employee_data` - Company Employee Data
 * * `contact_enrichment` - Contact Enrichment
 */
export enum EnrichmentProcessNameEnum {
    IcpScoring = "icp_scoring",
    CompanyEmployeeData = "company_employee_data",
    ContactEnrichment = "contact_enrichment",
}

/** Serializer for enrichment run status, including progress percentage. */
export interface EnrichmentRun {
    /** @format uuid */
    uuid: string;
    /**
     * Which enrichment process to run
     *
     * * `icp_scoring` - ICP Scoring
     * * `company_employee_data` - Company Employee Data
     * * `contact_enrichment` - Contact Enrichment
     */
    process_name: EnrichmentProcessNameEnum;
    /**
     * * `pending` - Pending
     * * `in_progress` - In Progress
     * * `success` - Success
     * * `failure` - Failure
     */
    status?: CrmImportRunStatusEnum;
    /**
     * @min 0
     * @max 2147483647
     */
    total_companies?: number;
    /**
     * @min 0
     * @max 2147483647
     */
    processed_companies?: number;
    /** @format double */
    progress_percent: number;
    error?: string;
    /** @format date-time */
    started_at?: string | null;
    /** @format date-time */
    completed_at?: string | null;
    /** @format date-time */
    created: string;
}

/** Response after triggering enrichment. */
export interface EnrichmentRunCreated {
    /** @format uuid */
    run_uuid: string;
}

/** Detail representation for the enrichment run history endpoint. */
export interface EnrichmentRunDetail {
    /** @format uuid */
    uuid: string;
    /** @format uuid */
    view_uuid: string;
    /**
     * Which enrichment process to run
     *
     * * `icp_scoring` - ICP Scoring
     * * `company_employee_data` - Company Employee Data
     * * `contact_enrichment` - Contact Enrichment
     */
    process_name: EnrichmentProcessNameEnum;
    /**
     * * `pending` - Pending
     * * `in_progress` - In Progress
     * * `success` - Success
     * * `failure` - Failure
     */
    status?: CrmImportRunStatusEnum;
    /**
     * @min 0
     * @max 2147483647
     */
    total_companies?: number;
    /**
     * @min 0
     * @max 2147483647
     */
    processed_companies?: number;
    /** @format double */
    progress_percent: number;
    /** @format uuid */
    triggered_by_uuid: string;
    /** @format date-time */
    created: string;
    /** @format date-time */
    completed_at?: string | null;
    error?: string;
    /** @format date-time */
    started_at?: string | null;
}

/** List representation for the enrichment run history endpoint. */
export interface EnrichmentRunList {
    /** @format uuid */
    uuid: string;
    /** @format uuid */
    view_uuid: string;
    /**
     * Which enrichment process to run
     *
     * * `icp_scoring` - ICP Scoring
     * * `company_employee_data` - Company Employee Data
     * * `contact_enrichment` - Contact Enrichment
     */
    process_name: EnrichmentProcessNameEnum;
    /**
     * * `pending` - Pending
     * * `in_progress` - In Progress
     * * `success` - Success
     * * `failure` - Failure
     */
    status?: CrmImportRunStatusEnum;
    /**
     * @min 0
     * @max 2147483647
     */
    total_companies?: number;
    /**
     * @min 0
     * @max 2147483647
     */
    processed_companies?: number;
    /** @format double */
    progress_percent: number;
    /** @format uuid */
    triggered_by_uuid: string;
    /** @format date-time */
    created: string;
    /** @format date-time */
    completed_at?: string | null;
}

export interface ExistingSuppliersList {
    id: number;
    /** @maxLength 255 */
    company_name: string;
    /**
     * @format email
     * @maxLength 254
     */
    contact_email: string;
    status: string;
    referred_company: string;
    company_type: string;
    product_category: string;
    product_type: string;
    website: string;
    supplier_type: string;
    supplier_lead_time_days: number | null;
    /** @default 0 */
    orders_count: number;
}

/**
 * * `due` - Due
 * * `overdue` - Overdue
 */
export enum ExpectedPayoutStateEnum {
    Due = "due",
    Overdue = "overdue",
}

export interface ExportAdmin {
    /** @format date */
    date_from?: string | null;
    /** @format date */
    date_to?: string | null;
    company_uuid?: string[] | null;
    file_format?: FileFormatEnum | BlankEnum;
}

/**
 * Read+write line-item proposal. ``source_invoice_uuid`` and
 * ``source_supplier_uuid`` are nullable for the empty-path case (no
 * document evidence).
 */
export interface ExtractedLineItem {
    /** @format uuid */
    uuid: string;
    /** @format uuid */
    source_invoice_uuid: string;
    /** @format uuid */
    source_supplier_uuid: string;
    /** @maxLength 255 */
    name: string;
    description?: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,11}(?:\.\d{0,3})?$
     */
    quantity?: string | null;
    /** @maxLength 32 */
    unit?: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,10}(?:\.\d{0,4})?$
     */
    unit_price?: string | null;
    /** @maxLength 8 */
    currency?: string;
    /**
     * * `INGREDIENT` - Ingredient
     * * `PACKAGING` - Packaging
     * * `LOGISTICS` - Logistics
     * * `SERVICES` - Services
     * * `OTHER` - Other
     */
    classification: LineItemClassificationEnum;
    /**
     * * `high` - High
     * * `medium` - Medium
     * * `low` - Low
     * * `manual` - Manual
     */
    confidence: ExtractionConfidenceEnum;
}

/** Nested read shape for ``OnboardingExtractionSerializer``. */
export interface ExtractedSupplierRead {
    /** @format uuid */
    uuid: string;
    /** @format uuid */
    source_invoice_uuid: string | null;
    supplier_name: string;
    vat_number: string;
    address: string;
    contact_name: string;
    /** @format email */
    contact_email: string;
    contact_phone: string;
    payment_terms: string;
    invoice_currency: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,12}(?:\.\d{0,2})?$
     */
    average_monthly_spend: string | null;
    lead_time_days: number | null;
    /** Free-text country label; ISO-3166 alpha-2 preferred. */
    supplier_country: string;
    confidence: ExtractionConfidenceEnum;
    /** Verbatim snippet from the source document (capped at 300 chars by the serializer). */
    evidence: string;
    /** List of {field, kind, reason} dicts for missing/unclear fields. */
    gaps: any;
    /** If the buyer's network already has this supplier, the matching Company.id. */
    matched_existing_supplier_id: number | null;
    line_items: ExtractedLineItem[];
}

/**
 * * `high` - High
 * * `medium` - Medium
 * * `low` - Low
 * * `manual` - Manual
 */
export enum ExtractionConfidenceEnum {
    High = "high",
    Medium = "medium",
    Low = "low",
    Manual = "manual",
}

export interface FeedItemRead {
    /** @format uuid */
    uuid: string;
    source: string;
    event_type: string;
    /** @format uuid */
    order_uuid: string | null;
    /** @format email */
    actor_email: string | null;
    actor_first_name: string | null;
    actor_last_name: string | null;
    summary: string;
    body_text: string;
    /** @format date-time */
    occurred_at: string;
    /** @format date-time */
    created: string;
    status: FeedItemStatusEnum;
}

/**
 * * `queued` - Queued
 * * `processing` - Processing
 * * `integrating` - Integrating
 * * `processed` - Processed
 */
export enum FeedItemStatusEnum {
    Queued = "queued",
    Processing = "processing",
    Integrating = "integrating",
    Processed = "processed",
}

/**
 * * `GOOD` - Good
 * * `BAD` - Bad
 */
export enum FeedbackRatingEnum {
    GOOD = "GOOD",
    BAD = "BAD",
}

export interface Fees {
    /**
     * @format decimal
     * @pattern ^-?\d{0,13}(?:\.\d{0,2})?$
     */
    amount: string;
    vat_rate?: string;
}

/**
 * * `csv` - csv
 * * `json` - json
 * * `xlsx` - xlsx
 */
export enum FileFormatEnum {
    Csv = "csv",
    Json = "json",
    Xlsx = "xlsx",
}

/** Metadata payload returned by ``GET /api/v1/files/<uuid>/``. */
export interface FileMetadata {
    /** Registered file-resource type slug (e.g. ``task-attachment``). */
    type: string;
    /**
     * UUID of the file row.
     * @format uuid
     */
    uuid: string;
    /** Sanitised filename suitable for ``Content-Disposition``. */
    filename: string;
    /** MIME type of the file bytes. */
    content_type: string;
    /**
     * Size of the file in bytes.
     * @min 0
     */
    size_bytes: number;
}

/**
 * Returned by ``GET /api/v1/files/<uuid>/url/`` — metadata + a
 * short-lived signed download URL.
 */
export interface FileSignedUrl {
    /** Registered file-resource type slug (e.g. ``task-attachment``). */
    type: string;
    /**
     * UUID of the file row.
     * @format uuid
     */
    uuid: string;
    /** Sanitised filename suitable for ``Content-Disposition``. */
    filename: string;
    /** MIME type of the file bytes. */
    content_type: string;
    /**
     * Size of the file in bytes.
     * @min 0
     */
    size_bytes: number;
    /**
     * Short-lived signed GCS/S3 download URL.
     * @format uri
     */
    download_url: string;
    /**
     * Seconds until ``download_url`` expires.
     * @min 0
     */
    expires_in_seconds: number;
}

/**
 * 413 response from ``GET /api/v1/files/<uuid>/content/`` when the file
 * exceeds the inline cap — points the caller at the ``/url/`` action.
 */
export interface FileTooLarge {
    /** Registered file-resource type slug (e.g. ``task-attachment``). */
    type: string;
    /**
     * UUID of the file row.
     * @format uuid
     */
    uuid: string;
    /** Sanitised filename suitable for ``Content-Disposition``. */
    filename: string;
    /** MIME type of the file bytes. */
    content_type: string;
    /**
     * Size of the file in bytes.
     * @min 0
     */
    size_bytes: number;
    detail: string;
    /** @min 0 */
    max_inline_bytes: number;
}

export interface FileUpload {
    /**
     * Name of the file being uploaded
     * @maxLength 1024
     */
    file_name: string;
    /**
     * Name of the model related to this file. eg. for chats it would be 'Message'
     * @maxLength 256
     */
    model_name: string;
    /**
     * Name of the field on the model where file is stored. eg. for chats it would be 'attachment'
     * @maxLength 256
     */
    field_name: string;
    /**
     * Content type of the file.
     * @maxLength 256
     */
    content_type: string;
    /**
     * File size.
     * @min 1
     */
    size: number;
}

export interface FileUploadResponse {
    /** @format uri */
    url: string;
    token: string;
    file_name: string;
}

/**
 * Serializer for creating the final supplier when onboarding is complete.
 * This creates a new User, the Company, and its associated CompanyAddress,
 * and automatically sets the onboarding supplier status to READY_TO_TRADE.
 */
export interface FinalSupplierCreate {
    /** @maxLength 150 */
    first_name: string;
    /** @maxLength 150 */
    last_name: string;
    /**
     * @format email
     * @maxLength 254
     */
    email: string;
    /** @maxLength 255 */
    name: string;
    /** @maxLength 255 */
    registration_number?: string;
    /** @maxLength 255 */
    website?: string;
    /** @maxLength 10 */
    phone_country_code?: string;
    /** @maxLength 50 */
    phone_number?: string;
    /** @maxLength 10 */
    vat_country_code?: string;
    /** @maxLength 50 */
    vat_number?: string;
    company_address?: CompanyAddress;
    /** Optional message to record with the final supplier creation activity */
    message?: string;
}

/** Serializer for Forecast model - isolated feature */
export interface Forecast {
    /** @format uuid */
    uuid: string;
    /**
     * Creator agent type
     *
     * * `payment_agent` - Payment Agent
     * * `debt_agent` - Debt Agent
     * * `onboarding_agent` - Onboarding Agent
     * * `demand_forecaster` - Demand Forecaster
     * * `supplier_optimizer` - Supplier Optimizer
     */
    creator: CreatorEnum;
    /** Messages/Description */
    content: string;
    /**
     * Alert type classification
     *
     * * `critical` - Critical
     * * `baseline` - Baseline
     * * `stress_scenario` - Stress Scenario
     * * `optimistic_scenario` - Optimistic Scenario
     */
    type: TrendsAlertTypeEnum;
    /**
     * Title text
     * @maxLength 255
     */
    title: string;
    /** @format date-time */
    created_at: string;
    /** @format date-time */
    modified_at: string;
}

/**
 * * `one_time_order` - One Time Order
 * * `weekly` - Weekly
 * * `Monthly` - Monthly
 * * `quarterly` - Quarterly
 * * `annually` - Annually
 * * `undecided` - Undecided
 */
export enum ForecastEnum {
    OneTimeOrder = "one_time_order",
    Weekly = "weekly",
    Monthly = "Monthly",
    Quarterly = "quarterly",
    Annually = "annually",
    Undecided = "undecided",
}

/**
 * * `weekly` - Weekly
 * * `monthly` - Monthly
 * * `quarterly` - Quarterly
 * * `annually` - Annually
 */
export enum FrequencyEnum {
    Weekly = "weekly",
    Monthly = "monthly",
    Quarterly = "quarterly",
    Annually = "annually",
}

/**
 * Legacy serializer: creates a `BuyerOnboarding` row and returns a
 * UUID-based shareable link the MoR can hand to the buyer. Used by the
 * pre-`isBuyerInvitationFlowEnabled` flow.
 *
 * Required fields:
 * - name: Buyer contact name
 * - email: Buyer contact email
 * - country: US or UK
 *
 * No User / Company / Employee provisioning happens here — that is the
 * new `invite` flow's job. Keep this lightweight so the legacy FE keeps
 * working when the feature flag is off.
 */
export interface GenerateBuyerLink {
    /**
     * Buyer contact name
     * @maxLength 255
     */
    name: string;
    /**
     * Buyer contact email
     * @format email
     * @maxLength 255
     */
    email: string;
    /**
     * * `us` - United States
     * * `uk` - United Kingdom
     */
    country: BuyerOnboardingCountry;
}

export interface GoodsReceiptPDFUrl {
    /** @format uri */
    pdf_url: string;
}

export interface GoogleHandshake {
    opply_jwt: string;
}

export interface GoogleStorageSignedUrl {
    /** @maxLength 976 */
    file_name: string;
    /**
     * @format int64
     * @min 1
     * @max 10000000000
     */
    size: number;
    /** @maxLength 64 */
    content_type?: string;
}

export interface GoogleStorageSignedUrlResponse {
    signed_url: string;
}

export interface GoogleUpload {
    /** @maxLength 1024 */
    file_name: string;
    /** @min 1 */
    size: number;
    /** @maxLength 256 */
    content_type?: string;
    /** @maxLength 256 */
    field_name: string;
}

export interface GoogleUploadComplete {
    token: string;
}

export interface GoogleUploadResponse {
    /** @format uri */
    url: string;
    token: string;
}

export interface GroupedStatementDetail {
    /** @format uuid */
    uuid: string;
    /** Human-readable statement identifier (e.g. 2026-MAY-TWO-000042) */
    statement_id: string;
    buyer_company_name: string;
    /** @format uuid */
    buyer_company_uuid: string;
    payment_provider: PaymentProviderEnum;
    status: GroupedStatementStatusEnum;
    /**
     * Date by which payment is expected. Grouping key.
     * @format date
     */
    due_date: string;
    currency: AvailableCurrenciesEnum;
    /** Subtotal in cents (before tax). Sum of member orders' subtotals. */
    subtotal: number;
    /** Tax amount in cents. Sum of member orders' tax. */
    tax: number;
    /** Total in cents (subtotal + tax). Sum of member orders' totals. */
    total: number;
    /** Outstanding amount in cents. total - sum(OrderPayment.amount_cents) across member orders. Recomputed on allocation events. No default — services creating a statement must set this explicitly (typically equal to `total` before any payments arrive). */
    total_outstanding: number;
    order_count: number;
    /** @format date-time */
    paid_at: string | null;
    /** Payment reference copied from the provider's report. Used in reconciliation. */
    external_payment_id: string | null;
    has_warning: boolean;
    warning_count: number;
    /** @default "grouped_statement" */
    record_type: string;
    orders: GroupedStatementOrder[];
    bank_details: BankDetail[];
    warnings: GroupedStatementOrphanOrder[];
    warnings_truncated: boolean;
}

export interface GroupedStatementList {
    /** @format uuid */
    uuid: string;
    /** Human-readable statement identifier (e.g. 2026-MAY-TWO-000042) */
    statement_id: string;
    buyer_company_name: string;
    /** @format uuid */
    buyer_company_uuid: string;
    payment_provider: PaymentProviderEnum;
    status: GroupedStatementStatusEnum;
    /**
     * Date by which payment is expected. Grouping key.
     * @format date
     */
    due_date: string;
    currency: AvailableCurrenciesEnum;
    /** Subtotal in cents (before tax). Sum of member orders' subtotals. */
    subtotal: number;
    /** Tax amount in cents. Sum of member orders' tax. */
    tax: number;
    /** Total in cents (subtotal + tax). Sum of member orders' totals. */
    total: number;
    /** Outstanding amount in cents. total - sum(OrderPayment.amount_cents) across member orders. Recomputed on allocation events. No default — services creating a statement must set this explicitly (typically equal to `total` before any payments arrive). */
    total_outstanding: number;
    order_count: number;
    /** @format date-time */
    paid_at: string | null;
    /** Payment reference copied from the provider's report. Used in reconciliation. */
    external_payment_id: string | null;
    has_warning: boolean;
    warning_count: number;
    /** @default "grouped_statement" */
    record_type: string;
}

/**
 * Order summary nested in a grouped statement detail response.
 *
 * Distinct from StatementOrderSerializer (used by ServiceFeeInvoice), which exposes
 * service-fee subtotals. Buyers viewing grouped statements need the order's own
 * subtotal/tax/total, since that is what they are being billed for.
 */
export interface GroupedStatementOrder {
    /** @format uuid */
    uuid: string;
    order_number: string;
    pay_in_state: PayInStateEnum;
    buyer_company_name: string;
    supplier_company_name: string;
    subtotal_cents: number;
    tax_cents: number;
    total_cents: number;
    total_outstanding: number;
}

/**
 * Schema for a single entry in the grouped-statement `warnings` list.
 *
 * Surfaces dispatched Two orders whose estimated due date matches the statement
 * but whose `two_invoice_due_date` is still NULL — the MoR uses this to chase
 * the missing Two invoice before the statement goes out.
 */
export interface GroupedStatementOrphanOrder {
    /** @format uuid */
    order_uuid: string;
    order_number: string;
    /** @format date */
    dispatched_at: string;
}

export interface GroupedStatementPatch {
    /**
     * Payment reference copied from the provider's report. Used in reconciliation.
     * @maxLength 255
     */
    external_payment_id?: string | null;
}

/**
 * * `due` - Due
 * * `overdue` - Overdue
 * * `awaiting_reconciliation` - Awaiting Reconciliation
 * * `paid` - Paid
 * * `cancelled` - Cancelled
 */
export enum GroupedStatementStatusEnum {
    Due = "due",
    Overdue = "overdue",
    AwaitingReconciliation = "awaiting_reconciliation",
    Paid = "paid",
    Cancelled = "cancelled",
}

/**
 * * `supplier_delay` - Supplier delay
 * * `volume_confirmation` - Volume confirmation
 * * `credit_review` - Credit review
 * * `documents_required` - Documents required
 * * `fraud_review` - Fraud review
 * * `forecasting` - Forecasting
 * * `overdue_payments` - Overdue payments
 * * `other` - Other
 */
export enum HoldInternalReasonEnum {
    SupplierDelay = "supplier_delay",
    VolumeConfirmation = "volume_confirmation",
    CreditReview = "credit_review",
    DocumentsRequired = "documents_required",
    FraudReview = "fraud_review",
    Forecasting = "forecasting",
    OverduePayments = "overdue_payments",
    Other = "other",
}

export interface HubSpotCreateLeadsRequest {
    /** CrmCompany UUIDs to create leads for. */
    company_uuids: string[];
    /** HubSpot lead pipeline ID to assign to created leads. */
    pipeline_id: string;
    /** HubSpot owner ID to assign as lead owner. */
    owner_id: string;
}

/**
 * * `no_deal` - No Deal
 * * `in_progress` - In Progress
 * * `won` - Won
 * * `lost` - Lost
 */
export enum HubSpotDealStageEnum {
    NoDeal = "no_deal",
    InProgress = "in_progress",
    Won = "won",
    Lost = "lost",
}

export interface HubSpotOwner {
    id: string;
    email: string;
    first_name: string;
    last_name: string;
}

export interface HubSpotPipeline {
    id: string;
    label: string;
}

/**
 * Status payload for hubspot-create-leads runs.
 *
 * Includes phase + contact-enrichment counters when the run was started via
 * the LLM-gated flow (ENABLE_CONTACT_ENRICHMENT_HUBSPOT_SYNC). Existing
 * fields are preserved so older clients keep working.
 */
export interface HubSpotSyncRun {
    /** @format uuid */
    uuid: string;
    status: string;
    total_companies: number;
    synced_companies: number;
    not_found_companies: number;
    failed_companies: number;
    error: string;
    /** @format date-time */
    started_at: string | null;
    /** @format date-time */
    completed_at: string | null;
    phase: string;
    contacts_enrichment_total: number;
    contacts_enrichment_processed: number;
}

export interface HubSpotSyncRunCreated {
    /** @format uuid */
    run_uuid: string;
}

/** Detail representation for the run history endpoint. */
export interface HubSpotSyncRunDetail {
    /** @format uuid */
    uuid: string;
    /**
     * Type of sync run. Empty for legacy rows.
     *
     * * `view_sync` - View Sync
     * * `create_leads` - Create Leads
     * * `deal_state_refresh` - Deal/Lead State Refresh
     * * `companies_upload` - Companies Upload
     */
    run_type?: HubSpotSyncRunTypeEnum | BlankEnum;
    /** @format uuid */
    view_uuid: string;
    /**
     * * `pending` - Pending
     * * `in_progress` - In Progress
     * * `success` - Success
     * * `failure` - Failure
     */
    status?: CrmImportRunStatusEnum;
    /**
     * @min 0
     * @max 2147483647
     */
    total_companies?: number;
    /**
     * @min 0
     * @max 2147483647
     */
    synced_companies?: number;
    /**
     * @min 0
     * @max 2147483647
     */
    not_found_companies?: number;
    /**
     * @min 0
     * @max 2147483647
     */
    failed_companies?: number;
    /** @format uuid */
    triggered_by_uuid: string;
    /** @format date-time */
    created: string;
    /** @format date-time */
    completed_at?: string | null;
    error?: string;
    /** @format date-time */
    started_at?: string | null;
    /** List of CrmCompany UUIDs to process (Create Leads only). Empty for View Sync. */
    company_uuids?: any;
    /**
     * HubSpot lead pipeline ID selected for this Create Leads run.
     * @maxLength 100
     */
    pipeline_id?: string;
    /**
     * HubSpot owner ID selected for this Create Leads run.
     * @maxLength 100
     */
    owner_id?: string;
}

/** List representation for the run history endpoint. */
export interface HubSpotSyncRunList {
    /** @format uuid */
    uuid: string;
    /**
     * Type of sync run. Empty for legacy rows.
     *
     * * `view_sync` - View Sync
     * * `create_leads` - Create Leads
     * * `deal_state_refresh` - Deal/Lead State Refresh
     * * `companies_upload` - Companies Upload
     */
    run_type?: HubSpotSyncRunTypeEnum | BlankEnum;
    /** @format uuid */
    view_uuid: string;
    /**
     * * `pending` - Pending
     * * `in_progress` - In Progress
     * * `success` - Success
     * * `failure` - Failure
     */
    status?: CrmImportRunStatusEnum;
    /**
     * @min 0
     * @max 2147483647
     */
    total_companies?: number;
    /**
     * @min 0
     * @max 2147483647
     */
    synced_companies?: number;
    /**
     * @min 0
     * @max 2147483647
     */
    not_found_companies?: number;
    /**
     * @min 0
     * @max 2147483647
     */
    failed_companies?: number;
    /** @format uuid */
    triggered_by_uuid: string;
    /** @format date-time */
    created: string;
    /** @format date-time */
    completed_at?: string | null;
}

/**
 * * `view_sync` - View Sync
 * * `create_leads` - Create Leads
 * * `deal_state_refresh` - Deal/Lead State Refresh
 * * `companies_upload` - Companies Upload
 */
export enum HubSpotSyncRunTypeEnum {
    ViewSync = "view_sync",
    CreateLeads = "create_leads",
    DealStateRefresh = "deal_state_refresh",
    CompaniesUpload = "companies_upload",
}

/**
 * * `pending` - Pending
 * * `synced` - Synced
 * * `failed` - Failed
 * * `not_found` - Not Found
 */
export enum HubSpotSyncStatusEnum {
    Pending = "pending",
    Synced = "synced",
    Failed = "failed",
    NotFound = "not_found",
}

export interface Icon {
    /** @maxLength 255 */
    title: string;
    /** @format uri */
    icon: string;
}

/**
 * * `delivery_duty_paid` - delivery_duty_paid
 * * `delivery_duty_unpaid` - delivery_duty_unpaid
 * * `cost_insurance_and_freight` - cost_insurance_and_freight
 * * `carriage_and_insurance_paid_to` - carriage_and_insurance_paid_to
 * * `cost_and_freight` - cost_and_freight
 * * `carriage_paid_to` - carriage_paid_to
 * * `delivered_at_place` - delivered_at_place
 * * `ex_works` - ex_works
 * * `free_alongside_ship` - free_alongside_ship
 * * `free_on_board` - free_on_board
 */
export enum IncotermsEnum {
    DeliveryDutyPaid = "delivery_duty_paid",
    DeliveryDutyUnpaid = "delivery_duty_unpaid",
    CostInsuranceAndFreight = "cost_insurance_and_freight",
    CarriageAndInsurancePaidTo = "carriage_and_insurance_paid_to",
    CostAndFreight = "cost_and_freight",
    CarriagePaidTo = "carriage_paid_to",
    DeliveredAtPlace = "delivered_at_place",
    ExWorks = "ex_works",
    FreeAlongsideShip = "free_alongside_ship",
    FreeOnBoard = "free_on_board",
}

export interface Ingredient {
    id: number;
    /** @format uuid */
    uuid: string;
    /** @maxLength 255 */
    name: string;
    /**
     * @format uri
     * @maxLength 2048
     */
    logo_url?: string;
    /**
     * @format decimal
     * @default "0.00"
     * @pattern ^-?\d{0,13}(?:\.\d{0,2})?$
     */
    current_unit_price?: string | null;
    /**
     * * `EUR` - EUR
     * * `USD` - USD
     * * `GBP` - GBP
     * * `CAD` - CAD
     */
    currency?: Currencies;
    description: string;
    /**
     * @format decimal
     * @default "0.00"
     * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
     */
    quantity?: string | null;
    /** @default "kg" */
    unit_of_measurement?: UnitOfMeasurementEnum | BlankEnum | NullEnum | null;
    allergen_requirements?: (AllergenRequirementsEnum | BlankEnum)[];
    allergen_declaration?: boolean;
    dietary_certificate?: boolean;
    diet_requirements?: (DietRequirementsEnum | BlankEnum)[];
    current_supplier?: string;
    frequency?: FrequencyEnum | BlankEnum | NullEnum | null;
    /** @format uuid */
    article?: string | null;
    existing_suppliers: string[] | null;
    /** @format uuid */
    parent_uuid?: string | null;
}

export interface IngredientsForQuote {
    id: number;
    /** @format uuid */
    uuid: string;
    /** @maxLength 255 */
    name: string;
}

export interface InitializeSupplier {
    /** @maxLength 255 */
    name: string;
    /** @format uri */
    website?: string | null;
    /** @maxLength 100 */
    industry?: string | null;
    /** @maxLength 50 */
    phone_number?: string | null;
    country: string;
    state: string;
    /** @format email */
    email: string;
    /** @format uuid */
    inquiry_uuid?: string | null;
    /** @maxLength 50 */
    mongo_id?: string | null;
}

export interface InitiateResponse {
    /** @format uri */
    authorization_url: string;
    provider: string;
}

export interface Inquiry {
    id: number;
    /** @format uuid */
    uuid: string;
    /**
     * * `awaiting_quotes` - Awaiting Quotes
     * * `quotes_available` - Quotes Available
     * * `ordered` - Ordered
     * * `expired` - Expired
     * * `proceeded` - Proceeded
     * * `contract_confirmed` - Contract Confirmed
     * * `supplier_decline_to_quote` - Supplier Decline To Quote
     * * `cancelled` - Cancelled
     */
    state?: InquiryState;
    /**
     * * `non_recurring` - Non Recurring
     * * `recurring` - Recurring
     * * `purchase_request` - Purchase Request
     * * `ingredient` - Ingredient
     * * `ingredient_copy` - Ingredient Copy
     */
    category?: InquiryCategory;
    /** @maxLength 255 */
    name: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
     */
    current_unit_price: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
     */
    target_unit_price: string;
    /**
     * * `EUR` - EUR
     * * `USD` - USD
     * * `GBP` - GBP
     * * `CAD` - CAD
     */
    currency?: Currencies;
    description: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
     */
    quantity: string;
    /**
     * * `fl oz` - Fluid Ounces
     * * `g` - Grams
     * * `mg` - milligrams
     * * `gals` - Gallons
     * * `kg` - Kilograms
     * * `L` - Liters
     * * `tons` - Metric Tons
     * * `oz` - Ounces
     * * `lbs` - Pounds
     * * `pcs` - Pieces
     * * `pt` - Pints
     * * `ml` - Milliliter
     * * `boxes` - Boxes
     * * `pallets` - Pallets
     * * `tsp` - Teaspoons
     * * `tbsp` - Tablespoons
     * * `units` - Units
     * * `cases` - Cases
     * * `trays` - Trays
     */
    unit_of_measurement?: UnitOfMeasurementEnum;
    allergen_requirements?: (AllergenRequirementsEnum | BlankEnum)[];
    allergen_declaration?: boolean;
    dietary_certificate?: boolean;
    diet_requirements?: (DietRequirementsEnum | BlankEnum)[];
    forecast?: ForecastEnum | BlankEnum | NullEnum | null;
    /** @format date */
    due_date: string;
    delivery_address?: number | null;
    /** @maxItems 250 */
    supplier_countries: (Country | BlankEnum)[];
    current_supplier?: string;
    /**
     * Datetime when the inquiry becomes published. Leave empty to keep it unpublished.
     * @format date-time
     */
    published?: string | null;
    /**
     * @format uri
     * @maxLength 2048
     */
    logo_url?: string;
    is_new: boolean;
    /** @format uuid */
    article?: string | null;
    existing_suppliers: string[] | null;
    supply_priorities?: SupplyPriorities[];
    /** @format date */
    first_order_delivery_date?: string | null;
    /**
     * @format decimal
     * @pattern ^-?\d{0,7}(?:\.\d{0,2})?$
     */
    opply_brand_commission?: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,7}(?:\.\d{0,2})?$
     */
    opply_supplier_commission?: string;
    /** @default false */
    is_recurring?: boolean;
    frequency?: FrequencyEnum | BlankEnum | NullEnum | null;
    /** @min 0 */
    desired_contract_length?: number | null;
    is_delivery_date_flexible?: boolean;
    /** @format uuid */
    parent_uuid?: string | null;
    ingredient?: number | null;
    reason_for_request?: string | null;
    desired_packaging_format?: string;
    desired_packaging_format_is_flexible?: boolean;
    ai_generated?: boolean;
    documents_to_copy?: string[] | null;
}

export interface InquiryAdmin {
    /** @format uuid */
    uuid: string;
    /** @maxLength 255 */
    name: string;
    company_name: string;
    /** @format date-time */
    created: string;
    /**
     * @min 0
     * @default 0
     */
    assigned_suppliers?: number;
    /**
     * @min 0
     * @default 0
     */
    quotes_count?: number;
    /**
     * * `awaiting_quotes` - Awaiting Quotes
     * * `quotes_available` - Quotes Available
     * * `ordered` - Ordered
     * * `expired` - Expired
     * * `proceeded` - Proceeded
     * * `contract_confirmed` - Contract Confirmed
     * * `supplier_decline_to_quote` - Supplier Decline To Quote
     * * `cancelled` - Cancelled
     */
    state?: InquiryState;
    /** @format date */
    due_date: string;
    /**
     * Datetime when the inquiry becomes published. Leave empty to keep it unpublished.
     * @format date-time
     */
    published?: string | null;
    description: string;
    /**
     * @format uri
     * @maxLength 2048
     */
    logo_url?: string;
    /**
     * * `EUR` - EUR
     * * `USD` - USD
     * * `GBP` - GBP
     * * `CAD` - CAD
     */
    currency?: Currencies;
    /**
     * @format decimal
     * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
     */
    quantity: string;
    /**
     * * `fl oz` - Fluid Ounces
     * * `g` - Grams
     * * `mg` - milligrams
     * * `gals` - Gallons
     * * `kg` - Kilograms
     * * `L` - Liters
     * * `tons` - Metric Tons
     * * `oz` - Ounces
     * * `lbs` - Pounds
     * * `pcs` - Pieces
     * * `pt` - Pints
     * * `ml` - Milliliter
     * * `boxes` - Boxes
     * * `pallets` - Pallets
     * * `tsp` - Teaspoons
     * * `tbsp` - Tablespoons
     * * `units` - Units
     * * `cases` - Cases
     * * `trays` - Trays
     */
    unit_of_measurement?: UnitOfMeasurementEnum;
    /** @maxItems 250 */
    supplier_countries: (Country | BlankEnum)[];
    /**
     * @format decimal
     * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
     */
    target_unit_price: string;
    allergen_requirements?: (AllergenRequirementsEnum | BlankEnum)[];
    allergen_declaration?: boolean;
    dietary_certificate?: boolean;
    diet_requirements?: (DietRequirementsEnum | BlankEnum)[];
    forecast?: ForecastEnum | BlankEnum | NullEnum | null;
    current_supplier?: string;
    total_forecast_quantity: string;
    reason_for_request?: string | null;
    is_delivery_date_flexible?: boolean;
    /** @format date */
    first_order_delivery_date?: string | null;
    ai_generated?: boolean;
}

/**
 * * `non_recurring` - Non Recurring
 * * `recurring` - Recurring
 * * `purchase_request` - Purchase Request
 * * `ingredient` - Ingredient
 * * `ingredient_copy` - Ingredient Copy
 */
export enum InquiryCategory {
    NonRecurring = "non_recurring",
    Recurring = "recurring",
    PurchaseRequest = "purchase_request",
    Ingredient = "ingredient",
    IngredientCopy = "ingredient_copy",
}

export interface InquiryCreateAdmin {
    /** @format uuid */
    uuid: string;
    /** @format uuid */
    company_uuid: string;
    /** @maxLength 255 */
    name: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
     */
    current_unit_price: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
     */
    target_unit_price: string;
    /**
     * * `EUR` - EUR
     * * `USD` - USD
     * * `GBP` - GBP
     * * `CAD` - CAD
     */
    currency?: Currencies;
    description: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
     */
    quantity: string;
    /**
     * * `fl oz` - Fluid Ounces
     * * `g` - Grams
     * * `mg` - milligrams
     * * `gals` - Gallons
     * * `kg` - Kilograms
     * * `L` - Liters
     * * `tons` - Metric Tons
     * * `oz` - Ounces
     * * `lbs` - Pounds
     * * `pcs` - Pieces
     * * `pt` - Pints
     * * `ml` - Milliliter
     * * `boxes` - Boxes
     * * `pallets` - Pallets
     * * `tsp` - Teaspoons
     * * `tbsp` - Tablespoons
     * * `units` - Units
     * * `cases` - Cases
     * * `trays` - Trays
     */
    unit_of_measurement?: UnitOfMeasurementEnum;
    allergen_requirements?: (AllergenRequirementsEnum | BlankEnum)[];
    allergen_declaration?: boolean;
    dietary_certificate?: boolean;
    diet_requirements?: (DietRequirementsEnum | BlankEnum)[];
    forecast?: ForecastEnum | BlankEnum | NullEnum | null;
    /** @format date */
    due_date: string;
    /** @maxItems 250 */
    supplier_countries: (Country | BlankEnum)[];
    current_supplier?: string;
    /**
     * @format uri
     * @maxLength 2048
     */
    logo_url?: string;
    /** @format uuid */
    article?: string | null;
    /**
     * Datetime when the inquiry becomes published. Leave empty to keep it unpublished.
     * @format date-time
     */
    published: string | null;
    state: InquiryState;
    /** @format uuid */
    existing_supplier?: string;
    existing_supplier_name: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,7}(?:\.\d{0,2})?$
     */
    opply_brand_commission?: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,7}(?:\.\d{0,2})?$
     */
    opply_supplier_commission?: string;
}

export interface InquiryDeclinedResponse {
    decline_reason: InquiryDeclinedResponseDeclineReasonEnum[];
    decline_reason_extended?: string | null;
}

/**
 * * `do_not_sell_this_ingredient` - Not Sell
 * * `request_quantity_too_small` - Too Small
 * * `request_quantity_too_large` - Too Large
 * * `cant_meet_specification` - Cant Meet Specification
 * * `cant_meet_delivery_date` - Cant Meet Delivery Date
 * * `ingredient_out_of_stock` - Out Of Stock
 * * `other` - Other
 */
export enum InquiryDeclinedResponseDeclineReasonEnum {
    DoNotSellThisIngredient = "do_not_sell_this_ingredient",
    RequestQuantityTooSmall = "request_quantity_too_small",
    RequestQuantityTooLarge = "request_quantity_too_large",
    CantMeetSpecification = "cant_meet_specification",
    CantMeetDeliveryDate = "cant_meet_delivery_date",
    IngredientOutOfStock = "ingredient_out_of_stock",
    Other = "other",
}

export interface InquiryDeliveryAddress {
    id: number;
    /** @maxLength 255 */
    name: string;
    /** @maxLength 255 */
    street_1?: string | null;
    /** @maxLength 255 */
    street_2?: string | null;
    /** @maxLength 255 */
    contact_full_name?: string | null;
    /** @maxLength 50 */
    contact_phone?: string | null;
    phone_country_code?: PhoneCountryCodeEnum | BlankEnum | NullEnum | null;
    /** @maxLength 100 */
    town?: string | null;
    /** @maxLength 100 */
    region?: string | null;
    /** @maxLength 100 */
    postcode?: string | null;
    /** @maxLength 20 */
    eori_number?: string;
    delivery_instructions?: string | null;
    /** @maxLength 100 */
    building?: string | null;
    /**
     * @format decimal
     * @pattern ^-?\d{0,4}(?:\.\d{0,15})?$
     */
    latitude?: string | null;
    /**
     * @format decimal
     * @pattern ^-?\d{0,4}(?:\.\d{0,15})?$
     */
    longitude?: string | null;
    collection_instructions?: string | null;
    /** @format uuid */
    uuid: string;
    country: Country | NullEnum | null;
    place_id: string | null;
    vat_number: string | null;
    vat_country_code: Country | NullEnum | null;
    vat_exempt: boolean;
    country_type: CountryTypeEnum;
}

export interface InquiryDocument {
    /** @format uuid */
    uuid: string;
    /** @format uri */
    document: string;
    description?: string | null;
}

export interface InquiryList {
    id: number;
    /** @format uuid */
    uuid: string;
    /**
     * * `awaiting_quotes` - Awaiting Quotes
     * * `quotes_available` - Quotes Available
     * * `ordered` - Ordered
     * * `expired` - Expired
     * * `proceeded` - Proceeded
     * * `contract_confirmed` - Contract Confirmed
     * * `supplier_decline_to_quote` - Supplier Decline To Quote
     * * `cancelled` - Cancelled
     */
    state?: InquiryState;
    /**
     * * `non_recurring` - Non Recurring
     * * `recurring` - Recurring
     * * `purchase_request` - Purchase Request
     * * `ingredient` - Ingredient
     * * `ingredient_copy` - Ingredient Copy
     */
    category?: InquiryCategory;
    /** @maxLength 255 */
    name: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
     */
    current_unit_price: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
     */
    target_unit_price: string;
    /**
     * * `EUR` - EUR
     * * `USD` - USD
     * * `GBP` - GBP
     * * `CAD` - CAD
     */
    currency?: Currencies;
    description: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
     */
    quantity: string;
    /**
     * * `fl oz` - Fluid Ounces
     * * `g` - Grams
     * * `mg` - milligrams
     * * `gals` - Gallons
     * * `kg` - Kilograms
     * * `L` - Liters
     * * `tons` - Metric Tons
     * * `oz` - Ounces
     * * `lbs` - Pounds
     * * `pcs` - Pieces
     * * `pt` - Pints
     * * `ml` - Milliliter
     * * `boxes` - Boxes
     * * `pallets` - Pallets
     * * `tsp` - Teaspoons
     * * `tbsp` - Tablespoons
     * * `units` - Units
     * * `cases` - Cases
     * * `trays` - Trays
     */
    unit_of_measurement?: UnitOfMeasurementEnum;
    allergen_requirements?: (AllergenRequirementsEnum | BlankEnum)[];
    allergen_declaration?: boolean;
    dietary_certificate?: boolean;
    diet_requirements?: (DietRequirementsEnum | BlankEnum)[];
    forecast?: ForecastEnum | BlankEnum | NullEnum | null;
    /** @format date */
    due_date: string;
    delivery_address?: number | null;
    /** @maxItems 250 */
    supplier_countries: (Country | BlankEnum)[];
    current_supplier?: string;
    /**
     * Datetime when the inquiry becomes published. Leave empty to keep it unpublished.
     * @format date-time
     */
    published?: string | null;
    /**
     * @format uri
     * @maxLength 2048
     */
    logo_url?: string;
    is_new: boolean;
    /** @format uuid */
    article?: string | null;
    existing_suppliers: string[] | null;
    supply_priorities?: SupplyPriorities[];
    /** @format date */
    first_order_delivery_date?: string | null;
    /**
     * @format decimal
     * @pattern ^-?\d{0,7}(?:\.\d{0,2})?$
     */
    opply_brand_commission?: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,7}(?:\.\d{0,2})?$
     */
    opply_supplier_commission?: string;
    /** @default false */
    is_recurring?: boolean;
    frequency?: FrequencyEnum | BlankEnum | NullEnum | null;
    /** @min 0 */
    desired_contract_length?: number | null;
    is_delivery_date_flexible?: boolean;
    /** @format uuid */
    parent_uuid?: string | null;
    ingredient?: number | null;
    reason_for_request?: string | null;
    desired_packaging_format?: string;
    desired_packaging_format_is_flexible?: boolean;
    ai_generated?: boolean;
    documents_to_copy?: string[] | null;
    orders_uuid: string[];
    /** @format uuid */
    existing_supplier_uuid: string;
    total_forecast_quantity: string;
    /** @format uuid */
    original_quote_uuid: string;
    declined: string;
    decline_reason: string;
}

export interface InquiryResponse {
    id: number;
    /** @format uuid */
    uuid: string;
    /**
     * * `awaiting_quotes` - Awaiting Quotes
     * * `quotes_available` - Quotes Available
     * * `ordered` - Ordered
     * * `expired` - Expired
     * * `proceeded` - Proceeded
     * * `contract_confirmed` - Contract Confirmed
     * * `supplier_decline_to_quote` - Supplier Decline To Quote
     * * `cancelled` - Cancelled
     */
    state?: InquiryState;
    /**
     * * `non_recurring` - Non Recurring
     * * `recurring` - Recurring
     * * `purchase_request` - Purchase Request
     * * `ingredient` - Ingredient
     * * `ingredient_copy` - Ingredient Copy
     */
    category?: InquiryCategory;
    /** @maxLength 255 */
    name: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
     */
    current_unit_price: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
     */
    target_unit_price: string;
    /**
     * * `EUR` - EUR
     * * `USD` - USD
     * * `GBP` - GBP
     * * `CAD` - CAD
     */
    currency?: Currencies;
    description: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
     */
    quantity: string;
    /**
     * * `fl oz` - Fluid Ounces
     * * `g` - Grams
     * * `mg` - milligrams
     * * `gals` - Gallons
     * * `kg` - Kilograms
     * * `L` - Liters
     * * `tons` - Metric Tons
     * * `oz` - Ounces
     * * `lbs` - Pounds
     * * `pcs` - Pieces
     * * `pt` - Pints
     * * `ml` - Milliliter
     * * `boxes` - Boxes
     * * `pallets` - Pallets
     * * `tsp` - Teaspoons
     * * `tbsp` - Tablespoons
     * * `units` - Units
     * * `cases` - Cases
     * * `trays` - Trays
     */
    unit_of_measurement?: UnitOfMeasurementEnum;
    allergen_requirements?: (AllergenRequirementsEnum | BlankEnum)[];
    allergen_declaration?: boolean;
    dietary_certificate?: boolean;
    diet_requirements?: (DietRequirementsEnum | BlankEnum)[];
    forecast?: ForecastEnum | BlankEnum | NullEnum | null;
    /** @format date */
    due_date: string;
    delivery_address: CompanyAddress;
    /** @maxItems 250 */
    supplier_countries: (Country | BlankEnum)[];
    current_supplier?: string;
    /**
     * Datetime when the inquiry becomes published. Leave empty to keep it unpublished.
     * @format date-time
     */
    published?: string | null;
    /**
     * @format uri
     * @maxLength 2048
     */
    logo_url?: string;
    is_new: boolean;
    /** @format uuid */
    article?: string | null;
    existing_suppliers: string[] | null;
    supply_priorities?: SupplyPriorities[];
    /** @format date */
    first_order_delivery_date?: string | null;
    /**
     * @format decimal
     * @pattern ^-?\d{0,7}(?:\.\d{0,2})?$
     */
    opply_brand_commission?: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,7}(?:\.\d{0,2})?$
     */
    opply_supplier_commission?: string;
    /** @default false */
    is_recurring?: boolean;
    frequency?: FrequencyEnum | BlankEnum | NullEnum | null;
    /** @min 0 */
    desired_contract_length?: number | null;
    is_delivery_date_flexible?: boolean;
    /** @format uuid */
    parent_uuid?: string | null;
    ingredient?: number | null;
    reason_for_request?: string | null;
    desired_packaging_format?: string;
    desired_packaging_format_is_flexible?: boolean;
    ai_generated?: boolean;
    documents_to_copy?: string[] | null;
    orders_uuid: string[];
    /** @format uuid */
    existing_supplier_uuid: string;
    total_forecast_quantity: string;
    /** @format uuid */
    original_quote_uuid: string;
    declined: string;
    decline_reason: string;
    company_address: Address;
    progress: string;
    possible_suppliers: string;
    suppliers_found: string;
    number_of_quotes: string;
    company: Company;
    existing_supplier_name: string;
    supplier_matching: string;
    total_forecast_spend: string;
}

export interface InquiryRetrieveAdmin {
    /** @format uuid */
    uuid: string;
    /** @maxLength 255 */
    name: string;
    company_name: string;
    /** @format date-time */
    created: string;
    assigned_suppliers: InquiryTargetSupplier[];
    /**
     * @min 0
     * @default 0
     */
    quotes_count?: number;
    /**
     * * `awaiting_quotes` - Awaiting Quotes
     * * `quotes_available` - Quotes Available
     * * `ordered` - Ordered
     * * `expired` - Expired
     * * `proceeded` - Proceeded
     * * `contract_confirmed` - Contract Confirmed
     * * `supplier_decline_to_quote` - Supplier Decline To Quote
     * * `cancelled` - Cancelled
     */
    state?: InquiryState;
    /** @format date */
    due_date: string;
    /**
     * Datetime when the inquiry becomes published. Leave empty to keep it unpublished.
     * @format date-time
     */
    published?: string | null;
    description: string;
    /**
     * @format uri
     * @maxLength 2048
     */
    logo_url?: string;
    /**
     * * `EUR` - EUR
     * * `USD` - USD
     * * `GBP` - GBP
     * * `CAD` - CAD
     */
    currency?: Currencies;
    /**
     * @format decimal
     * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
     */
    quantity: string;
    /**
     * * `fl oz` - Fluid Ounces
     * * `g` - Grams
     * * `mg` - milligrams
     * * `gals` - Gallons
     * * `kg` - Kilograms
     * * `L` - Liters
     * * `tons` - Metric Tons
     * * `oz` - Ounces
     * * `lbs` - Pounds
     * * `pcs` - Pieces
     * * `pt` - Pints
     * * `ml` - Milliliter
     * * `boxes` - Boxes
     * * `pallets` - Pallets
     * * `tsp` - Teaspoons
     * * `tbsp` - Tablespoons
     * * `units` - Units
     * * `cases` - Cases
     * * `trays` - Trays
     */
    unit_of_measurement?: UnitOfMeasurementEnum;
    /** @maxItems 250 */
    supplier_countries: (Country | BlankEnum)[];
    /**
     * @format decimal
     * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
     */
    target_unit_price: string;
    allergen_requirements?: (AllergenRequirementsEnum | BlankEnum)[];
    allergen_declaration?: boolean;
    dietary_certificate?: boolean;
    diet_requirements?: (DietRequirementsEnum | BlankEnum)[];
    forecast?: ForecastEnum | BlankEnum | NullEnum | null;
    current_supplier?: string;
    total_forecast_quantity: string;
    reason_for_request?: string | null;
    is_delivery_date_flexible?: boolean;
    /** @format date */
    first_order_delivery_date?: string | null;
    ai_generated?: boolean;
    created_by: string;
    delivery_address: CompanyAddress;
    /**
     * @format decimal
     * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
     */
    current_unit_price: string;
    company_number: string;
    quotes: QuoteForRetrieveInquiryAdmin[];
    existing_supplier: string;
    supply_priorities: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,7}(?:\.\d{0,2})?$
     */
    opply_brand_commission?: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,7}(?:\.\d{0,2})?$
     */
    opply_supplier_commission?: string;
    /**
     * * `non_recurring` - Non Recurring
     * * `recurring` - Recurring
     * * `purchase_request` - Purchase Request
     * * `ingredient` - Ingredient
     * * `ingredient_copy` - Ingredient Copy
     */
    category?: InquiryCategory;
    frequency?: FrequencyEnum | BlankEnum | NullEnum | null;
    /**
     * @min -2147483648
     * @max 2147483647
     */
    desired_contract_length?: number | null;
    existing_supplier_name: string;
    supplier_matching: string;
    buyer_name: string;
    buyer_uuid: string;
    purchase_order_supplier_uuid: string;
}

/**
 * * `awaiting_quotes` - Awaiting Quotes
 * * `quotes_available` - Quotes Available
 * * `ordered` - Ordered
 * * `expired` - Expired
 * * `proceeded` - Proceeded
 * * `contract_confirmed` - Contract Confirmed
 * * `supplier_decline_to_quote` - Supplier Decline To Quote
 * * `cancelled` - Cancelled
 */
export enum InquiryState {
    AwaitingQuotes = "awaiting_quotes",
    QuotesAvailable = "quotes_available",
    Ordered = "ordered",
    Expired = "expired",
    Proceeded = "proceeded",
    ContractConfirmed = "contract_confirmed",
    SupplierDeclineToQuote = "supplier_decline_to_quote",
    Cancelled = "cancelled",
}

export interface InquiryTargetCreate {
    inquiry: Inquiry;
    company: Company;
    id: number;
    /** @format uuid */
    inquiry_uuid: string;
    /** @format date-time */
    created: string;
    /** @format date-time */
    modified: string;
    /** @default false */
    is_existing_supplier?: boolean;
}

export interface InquiryTargetSupplier {
    /** @format uuid */
    uuid: string;
    name: string;
    country: string;
    /** @format date-time */
    created: string;
    quote_status: string;
    kyb_status: string;
    decline_info: string;
}

export interface InquiryUpdate {
    id: number;
    /** @format uuid */
    uuid: string;
    state: string;
    /**
     * * `non_recurring` - Non Recurring
     * * `recurring` - Recurring
     * * `purchase_request` - Purchase Request
     * * `ingredient` - Ingredient
     * * `ingredient_copy` - Ingredient Copy
     */
    category?: InquiryCategory;
    /** @maxLength 255 */
    name?: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
     */
    current_unit_price: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
     */
    target_unit_price: string;
    /**
     * * `EUR` - EUR
     * * `USD` - USD
     * * `GBP` - GBP
     * * `CAD` - CAD
     */
    currency?: Currencies;
    description: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
     */
    quantity?: string;
    /**
     * * `fl oz` - Fluid Ounces
     * * `g` - Grams
     * * `mg` - milligrams
     * * `gals` - Gallons
     * * `kg` - Kilograms
     * * `L` - Liters
     * * `tons` - Metric Tons
     * * `oz` - Ounces
     * * `lbs` - Pounds
     * * `pcs` - Pieces
     * * `pt` - Pints
     * * `ml` - Milliliter
     * * `boxes` - Boxes
     * * `pallets` - Pallets
     * * `tsp` - Teaspoons
     * * `tbsp` - Tablespoons
     * * `units` - Units
     * * `cases` - Cases
     * * `trays` - Trays
     */
    unit_of_measurement?: UnitOfMeasurementEnum;
    allergen_requirements?: (AllergenRequirementsEnum | BlankEnum)[];
    allergen_declaration?: boolean;
    dietary_certificate?: boolean;
    diet_requirements?: (DietRequirementsEnum | BlankEnum)[];
    forecast?: ForecastEnum | BlankEnum | NullEnum | null;
    /** @format date */
    due_date: string;
    delivery_address?: number | null;
    /** @maxItems 250 */
    supplier_countries: (Country | BlankEnum)[];
    current_supplier?: string;
    /**
     * Datetime when the inquiry becomes published. Leave empty to keep it unpublished.
     * @format date-time
     */
    published?: string | null;
    /**
     * @format uri
     * @maxLength 2048
     */
    logo_url?: string;
    is_new: boolean;
    /** @format uuid */
    article?: string | null;
    existing_suppliers: string[] | null;
    supply_priorities?: SupplyPriorities[];
    /** @format date */
    first_order_delivery_date?: string | null;
    /**
     * @format decimal
     * @pattern ^-?\d{0,7}(?:\.\d{0,2})?$
     */
    opply_brand_commission?: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,7}(?:\.\d{0,2})?$
     */
    opply_supplier_commission?: string;
    /** @default false */
    is_recurring?: boolean;
    frequency?: FrequencyEnum | BlankEnum | NullEnum | null;
    /** @min 0 */
    desired_contract_length?: number | null;
    is_delivery_date_flexible?: boolean;
    /** @format uuid */
    parent_uuid?: string | null;
    ingredient?: number | null;
    reason_for_request?: string | null;
    desired_packaging_format?: string;
    desired_packaging_format_is_flexible?: boolean;
    ai_generated?: boolean;
    documents_to_copy?: string[] | null;
    existing_supplier_name: string;
}

export interface InquiryUpdateAdmin {
    id: number;
    /** @format uuid */
    uuid: string;
    state?: string;
    /**
     * * `non_recurring` - Non Recurring
     * * `recurring` - Recurring
     * * `purchase_request` - Purchase Request
     * * `ingredient` - Ingredient
     * * `ingredient_copy` - Ingredient Copy
     */
    category?: InquiryCategory;
    /** @maxLength 255 */
    name?: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
     */
    current_unit_price: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
     */
    target_unit_price: string;
    /**
     * * `EUR` - EUR
     * * `USD` - USD
     * * `GBP` - GBP
     * * `CAD` - CAD
     */
    currency?: Currencies;
    description: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
     */
    quantity?: string;
    /**
     * * `fl oz` - Fluid Ounces
     * * `g` - Grams
     * * `mg` - milligrams
     * * `gals` - Gallons
     * * `kg` - Kilograms
     * * `L` - Liters
     * * `tons` - Metric Tons
     * * `oz` - Ounces
     * * `lbs` - Pounds
     * * `pcs` - Pieces
     * * `pt` - Pints
     * * `ml` - Milliliter
     * * `boxes` - Boxes
     * * `pallets` - Pallets
     * * `tsp` - Teaspoons
     * * `tbsp` - Tablespoons
     * * `units` - Units
     * * `cases` - Cases
     * * `trays` - Trays
     */
    unit_of_measurement?: UnitOfMeasurementEnum;
    allergen_requirements?: (AllergenRequirementsEnum | BlankEnum)[];
    allergen_declaration?: boolean;
    dietary_certificate?: boolean;
    diet_requirements?: (DietRequirementsEnum | BlankEnum)[];
    forecast?: ForecastEnum | BlankEnum | NullEnum | null;
    /** @format date */
    due_date: string;
    delivery_address?: number | null;
    /** @maxItems 250 */
    supplier_countries: (Country | BlankEnum)[];
    current_supplier?: string;
    /**
     * Datetime when the inquiry becomes published. Leave empty to keep it unpublished.
     * @format date-time
     */
    published?: string | null;
    /**
     * @format uri
     * @maxLength 2048
     */
    logo_url?: string;
    is_new: boolean;
    /** @format uuid */
    article?: string | null;
    existing_suppliers: string[] | null;
    supply_priorities?: SupplyPriorities[];
    /** @format date */
    first_order_delivery_date?: string | null;
    /**
     * @format decimal
     * @pattern ^-?\d{0,7}(?:\.\d{0,2})?$
     */
    opply_brand_commission?: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,7}(?:\.\d{0,2})?$
     */
    opply_supplier_commission?: string;
    /** @default false */
    is_recurring?: boolean;
    frequency?: FrequencyEnum | BlankEnum | NullEnum | null;
    /** @min 0 */
    desired_contract_length?: number | null;
    is_delivery_date_flexible?: boolean;
    /** @format uuid */
    parent_uuid?: string | null;
    ingredient?: number | null;
    reason_for_request?: string | null;
    desired_packaging_format?: string;
    desired_packaging_format_is_flexible?: boolean;
    ai_generated?: boolean;
    documents_to_copy?: string[] | null;
    existing_supplier_name: string;
}

export interface InquiryUpdateResponseAdmin {
    id: number;
    /** @format uuid */
    uuid: string;
    state?: string;
    /**
     * * `non_recurring` - Non Recurring
     * * `recurring` - Recurring
     * * `purchase_request` - Purchase Request
     * * `ingredient` - Ingredient
     * * `ingredient_copy` - Ingredient Copy
     */
    category?: InquiryCategory;
    /** @maxLength 255 */
    name?: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
     */
    current_unit_price: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
     */
    target_unit_price: string;
    /**
     * * `EUR` - EUR
     * * `USD` - USD
     * * `GBP` - GBP
     * * `CAD` - CAD
     */
    currency?: Currencies;
    description: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
     */
    quantity?: string;
    /**
     * * `fl oz` - Fluid Ounces
     * * `g` - Grams
     * * `mg` - milligrams
     * * `gals` - Gallons
     * * `kg` - Kilograms
     * * `L` - Liters
     * * `tons` - Metric Tons
     * * `oz` - Ounces
     * * `lbs` - Pounds
     * * `pcs` - Pieces
     * * `pt` - Pints
     * * `ml` - Milliliter
     * * `boxes` - Boxes
     * * `pallets` - Pallets
     * * `tsp` - Teaspoons
     * * `tbsp` - Tablespoons
     * * `units` - Units
     * * `cases` - Cases
     * * `trays` - Trays
     */
    unit_of_measurement?: UnitOfMeasurementEnum;
    allergen_requirements?: (AllergenRequirementsEnum | BlankEnum)[];
    allergen_declaration?: boolean;
    dietary_certificate?: boolean;
    diet_requirements?: (DietRequirementsEnum | BlankEnum)[];
    forecast?: ForecastEnum | BlankEnum | NullEnum | null;
    /** @format date */
    due_date: string;
    delivery_address?: number | null;
    /** @maxItems 250 */
    supplier_countries: (Country | BlankEnum)[];
    current_supplier?: string;
    /**
     * Datetime when the inquiry becomes published. Leave empty to keep it unpublished.
     * @format date-time
     */
    published?: string | null;
    /**
     * @format uri
     * @maxLength 2048
     */
    logo_url?: string;
    is_new: boolean;
    /** @format uuid */
    article?: string | null;
    existing_suppliers: string[] | null;
    supply_priorities?: SupplyPriorities[];
    /** @format date */
    first_order_delivery_date?: string | null;
    /**
     * @format decimal
     * @pattern ^-?\d{0,7}(?:\.\d{0,2})?$
     */
    opply_brand_commission?: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,7}(?:\.\d{0,2})?$
     */
    opply_supplier_commission?: string;
    /** @default false */
    is_recurring?: boolean;
    frequency?: FrequencyEnum | BlankEnum | NullEnum | null;
    /** @min 0 */
    desired_contract_length?: number | null;
    is_delivery_date_flexible?: boolean;
    /** @format uuid */
    parent_uuid?: string | null;
    ingredient?: number | null;
    reason_for_request?: string | null;
    desired_packaging_format?: string;
    desired_packaging_format_is_flexible?: boolean;
    ai_generated?: boolean;
    documents_to_copy?: string[] | null;
    existing_supplier_name: string;
    company_id: number;
}

/**
 * Read view of an Insight for the buyer-facing rail.
 *
 * `insight_type` is the model column verbatim where it matches one of the
 * known `InsightType` values; otherwise it falls through to
 * `InsightType.INVESTOR` so the FE never has to deal with stale or
 * experimental category strings. ``sector`` is a proper enum at the DB
 * level, so it's returned verbatim — values outside ``InsightSector``
 * fall through to ``undefined`` (the brain UI filters those out).
 */
export interface InsightRead {
    /** @format uuid */
    uuid: string;
    /**
     * Producer identifier, e.g. opply.enrichment, hubspot
     * @maxLength 128
     */
    source: string;
    /**
     * Short uppercase label rendered above the insight headline (e.g. 'Pricing trend', 'Peer-network signal'). Optional — defaults to empty string when not set.
     * @maxLength 128
     */
    kicker?: string;
    /**
     * Short headline for the insight
     * @maxLength 512
     */
    title: string;
    /** Longer body text describing the insight */
    description: string;
    insight_type: string;
    sector: string;
    /**
     * Optional subtitle rendered next to the kicker on the InsightCard (e.g. 'Diageo · Littleconnell Brewery · €300M'). Defaults to empty string when not set.
     * @maxLength 255
     */
    meta?: string;
    /** Free-text labels attached to the insight (e.g. category, severity, topic) */
    tags?: string[];
    /**
     * When the insight was generated by its producer
     * @format date-time
     */
    occurred_at: string;
    /** @format date-time */
    created: string;
    /**
     * External identifier for the news article (when sourced from a news producer).
     * @maxLength 128
     */
    news_id?: string;
    /**
     * Canonical URL for the underlying news article, if any.
     * @format uri
     * @maxLength 2048
     */
    url?: string;
    /** Verbatim excerpt from the source article. `description` is the producer's summary written for the buyer; `body_excerpt` is the original text for reference. */
    body_excerpt?: string;
    /**
     * When the underlying news article was published. Distinct from `occurred_at`, which is when the producer emitted the insight.
     * @format date-time
     */
    published_at?: string | null;
}

/**
 * * `exceeds_effective_available` - Exceeds Effective Available
 * * `exceeds_per_order_limit` - Exceeds Per Order Limit
 */
export enum InsufficientCreditReasonEnum {
    ExceedsEffectiveAvailable = "exceeds_effective_available",
    ExceedsPerOrderLimit = "exceeds_per_order_limit",
}

/**
 * * `supplier_delay` - Supplier delay
 * * `volume_confirmation` - Volume confirmation
 * * `credit_review` - Credit review
 * * `documents_required` - Documents required
 * * `fraud_review` - Fraud review
 * * `forecasting` - Forecasting
 * * `overdue_payments` - Overdue payments
 * * `other` - Other
 */
export enum InternalReasonEnum {
    SupplierDelay = "supplier_delay",
    VolumeConfirmation = "volume_confirmation",
    CreditReview = "credit_review",
    DocumentsRequired = "documents_required",
    FraudReview = "fraud_review",
    Forecasting = "forecasting",
    OverduePayments = "overdue_payments",
    Other = "other",
}

/**
 * Serializer for inviting a buyer through the new MoR onboarding flow
 * (feature flag `isBuyerInvitationFlowEnabled` on).
 *
 * Required fields:
 * - name: Buyer's trading name (used as Company.name when company_name
 *   is not separately provided).
 * - email: Buyer contact email (must not already belong to a registered user).
 * - country: US or UK.
 *
 * Optional:
 * - company_name: Explicit Company.name override. When omitted the serializer
 *   falls back to `name`.
 * - first_name / last_name: Contact-person name on the new dialog. When
 *   omitted, the trading name is used as first_name so the welcome email
 *   greeting stays non-empty.
 * - registration_name / registration_number: Legal registration name and
 *   registration/incorporation number, stored on the new Company row.
 *   `registration_country_code` is not a separate input — it is derived
 *   from `country` (us -> US, uk -> GB).
 * - is_connected_to_allianz / is_connected_to_two: Integration flags set on
 *   the new Company row (default False).
 * - allianz_company_id: Allianz company id for the credit-limit
 *   integration, stored on the new Company row.
 * - two_us_company_id: Two US company id (e.g. DUNS) for US buyers, stored
 *   on the new Company row.
 *
 * Creates, atomically:
 *   - User (no password — set via the password-create email link)
 *   - Company (brand, onboarding_state=in_progress, scoped to the MoR)
 *   - Employee linking the new User to the new Company
 *   - BuyerOnboarding row carrying the contact/country fields (form data
 *     for Phase 2 will hang off this)
 *
 * On commit, dispatches `EmailSender.send_password_create` so the buyer
 * receives the `commit-onboarding` link to set their password and log in.
 * The MoR no longer receives a shareable link — the buyer enters the app
 * via the standard authenticated flow.
 */
export interface InviteBuyer {
    /**
     * Buyer contact name
     * @maxLength 255
     */
    name: string;
    /**
     * Buyer contact email
     * @format email
     * @maxLength 255
     */
    email: string;
    /**
     * * `us` - United States
     * * `uk` - United Kingdom
     */
    country: BuyerOnboardingCountry;
    /** @maxLength 255 */
    company_name?: string;
    /** @maxLength 150 */
    first_name?: string;
    /** @maxLength 150 */
    last_name?: string;
    /** @maxLength 255 */
    registration_name?: string;
    /** @maxLength 255 */
    registration_number?: string;
    /** @default false */
    is_connected_to_allianz?: boolean;
    /** @maxLength 255 */
    allianz_company_id?: string;
    /** @default false */
    is_connected_to_two?: boolean;
    /** @maxLength 255 */
    two_us_company_id?: string;
}

/**
 * Response shape for the new `invite` endpoint.
 *
 * No `link` field — the buyer is invited via the `commit-onboarding`
 * email and enters the app authenticated.
 */
export interface InviteBuyerResponse {
    /** @format uuid */
    uuid: string;
    name: string;
    /** @format email */
    email: string;
    country: BuyerOnboardingCountry;
    /** @format date-time */
    created_at: string;
}

/**
 * * `INCORRECT_OUTPUT` - Incorrect Output
 * * `INCOMPLETE` - Incomplete
 * * `SLOW` - Slow
 * * `HALLUCINATION` - Hallucination
 * * `FORMATTING_ISSUE` - Formatting Issue
 * * `UX_ISSUE` - UX Issue
 * * `SECURITY_RISK` - Security/Risk
 * * `OTHER` - Other
 */
export enum IssueTypeEnum {
    INCORRECT_OUTPUT = "INCORRECT_OUTPUT",
    INCOMPLETE = "INCOMPLETE",
    SLOW = "SLOW",
    HALLUCINATION = "HALLUCINATION",
    FORMATTING_ISSUE = "FORMATTING_ISSUE",
    UX_ISSUE = "UX_ISSUE",
    SECURITY_RISK = "SECURITY_RISK",
    OTHER = "OTHER",
}

export interface KYBStep1 {
    phone_number: string;
    phone_country_code: string;
}

export interface KYBStep1Response {
    /** @format uri */
    redirect_url: string;
}

export interface KYBVerificationStatusResponse {
    /**
     * * `Not started` - Not started
     * * `Started` - Started
     * * `In Review` - In Review
     * * `Completed` - Completed
     */
    status: KYBVerificationStatusResponseStatusEnum;
    /**
     * @min 1
     * @max 4
     */
    current_step: number;
    /** @format uri */
    redirect_url?: string | null;
}

/**
 * * `Not started` - Not started
 * * `Started` - Started
 * * `In Review` - In Review
 * * `Completed` - Completed
 */
export enum KYBVerificationStatusResponseStatusEnum {
    NotStarted = "Not started",
    Started = "Started",
    InReview = "In Review",
    Completed = "Completed",
}

/**
 * * `Draft` - Draft
 * * `Submitted` - Submitted
 * * `ReadyToAdvance` - Ready To Advance
 * * `Advanced` - Advanced
 * * `Repaid` - Repaid
 * * `Due` - Due
 * * `Overdue` - Overdue
 * * `Closed` - Closed
 * * `Cancelled` - Cancelled
 */
export enum KriyaStatusEnum {
    Draft = "Draft",
    Submitted = "Submitted",
    ReadyToAdvance = "ReadyToAdvance",
    Advanced = "Advanced",
    Repaid = "Repaid",
    Due = "Due",
    Overdue = "Overdue",
    Closed = "Closed",
    Cancelled = "Cancelled",
}

export interface LastLogin {
    user_full_name: string | null;
    /** @format date-time */
    last_login: string | null;
}

/** Serializer for LeadGenerationJob model - isolated feature */
export interface LeadGenerationJob {
    /** @format uuid */
    uuid: string;
    /**
     * Job title
     * @maxLength 255
     */
    title: string;
    /** Job description */
    description: string;
    /** @format date-time */
    created_at: string;
}

export enum LegacyDeliveryStatusEnum {
    PendingDispatch = "pending_dispatch",
    Dispatched = "dispatched",
    Delivered = "delivered",
}

export enum LegacyLifecycleStatusEnum {
    Checkout = "checkout",
    Confirmed = "confirmed",
    PendingPayment = "pending_payment",
    Canceled = "canceled",
    AwaitingApproval = "awaiting_approval",
    OnHold = "on_hold",
    Placed = "placed",
    Dispatched = "dispatched",
    Completed = "completed",
}

export enum LegacyPaymentStatusEnum {
    Paid = "paid",
    PaymentUpcoming = "payment_upcoming",
    PaymentProcessing = "payment_processing",
    PaymentDue = "payment_due",
}

export enum LegacyPayoutStatusEnum {
    Paid = "paid",
    NotStarted = "not_started",
}

/**
 * * `ltd` - Limited Company (Ltd)
 * * `llp` - Limited Liability Partnership (LLP)
 * * `plc` - Public Limited Company (PLC)
 * * `sole_trader` - Sole Trader
 * * `partnership` - Partnership
 * * `other` - Other
 */
export enum LegalEntityTypeEnum {
    Ltd = "ltd",
    Llp = "llp",
    Plc = "plc",
    SoleTrader = "sole_trader",
    Partnership = "partnership",
    Other = "other",
}

/**
 * * `initializing` - Initializing
 * * `confirmed` - Confirmed
 * * `canceled` - Cancelled
 * * `pending_merchant_of_record_approval` - Pending Merchant of Record Approval
 * * `order_received` - Order Received
 * * `order_sent_to_supplier` - Order Sent To Supplier
 * * `order_confirming_price` - Order Confirming Price
 * * `forecasted` - Forecasted
 */
export enum LifecycleStateEnum {
    Initializing = "initializing",
    Confirmed = "confirmed",
    Canceled = "canceled",
    PendingMerchantOfRecordApproval = "pending_merchant_of_record_approval",
    OrderReceived = "order_received",
    OrderSentToSupplier = "order_sent_to_supplier",
    OrderConfirmingPrice = "order_confirming_price",
    Forecasted = "forecasted",
}

/** Credit limit with sufficiency check for a single provider. */
export interface LimitCheck {
    /** Available credit after allocations (cents) */
    effective_available: number;
    /** Whether the limit covers the requested amount (null if no amount) */
    is_sufficient: boolean | null;
    /**
     * Reason the limit is insufficient
     *
     * * `exceeds_effective_available` - Exceeds Effective Available
     * * `exceeds_per_order_limit` - Exceeds Per Order Limit
     */
    insufficient_reason: InsufficientCreditReasonEnum | NullEnum | null;
}

/**
 * * `INGREDIENT` - Ingredient
 * * `PACKAGING` - Packaging
 * * `LOGISTICS` - Logistics
 * * `SERVICES` - Services
 * * `OTHER` - Other
 */
export enum LineItemClassificationEnum {
    INGREDIENT = "INGREDIENT",
    PACKAGING = "PACKAGING",
    LOGISTICS = "LOGISTICS",
    SERVICES = "SERVICES",
    OTHER = "OTHER",
}

export interface Login {
    /** @format email */
    email: string;
    password: string;
}

/** Serializer for marking an order as forecasted with a target date. */
export interface MarkForecasted {
    /**
     * Date when the order should automatically transition from forecasted to confirmed
     * @format date
     */
    forecast_date: string;
}

export interface MarkRelatedCleared {
    /** @format uuid */
    related_object_uuid: string;
    related_object_type: string;
    /**
     * * `Mark samples as dispatched` - Mark Samples Dispatched
     * * `Reject samples request` - Reject Samples Request
     * * `Buyer marks samples as delivered` - Buyer Marks Samples Delivered
     * * `Order is marked as dispatched or Buyer marks order as delivered` - Order Marked As Dispatched Or Buyer Marks Order Delivered
     * * `Order has been delivered` - Order Delivered
     * * `Purchase Order is Accepted or Declined` - Purchase Order Accepted Or Declined
     * * `Clear Time to Order Action` - Clear Time To Order Action
     * * `Payment has been received` - Payment Received
     * * `Signed Agreement Uploaded` - Signed Agreement Uploaded
     * * `Purchase Order is placed` - Purchase Order Placed
     * * `Update quote or reject negotiation` - Update Quote Or Reject Negotiation
     * * `One or more ingredients are created` - Ingredients Created
     * * `One of more products are created` - Products Created
     * * `Samples are marked as received` - Samples Marked As Received
     * * `Marked as delivered` - Marked As Delivered
     * * `Quote for request or decline request` - Quote For Request Or Decline
     * * `Product list is uploaded` - Product List Uploaded
     * * `Respond to Request` - Respond To Request
     * * `Respond to negotiations` - Respond To Negotiations
     * * `Contract is created` - Contract Created
     * * `Buyer has created a request` - Buyer Created Request
     * * `Order or decline quote` - Order Or Decline Quote
     * * `Open contract details page` - Open Contract Details Page
     * * `Accept contract renewal` - Accept Contract Renewal
     * * `Decline contract renewal` - Decline Contract Renewal
     * * `Negotiate contract renewal` - Negotiate Contract Renewal
     * * `Place first request` - Place First Request
     * * `Feedback has been given for a sample` - Feedback Given For Sample
     * * `5 or more ingredients are created` - Upload Ingredient List
     * * `2 or more products are created` - Upload Product List
     */
    action_clear_trigger: ActionClearTriggerEnum;
}

export interface MarkRelatedRead {
    /** @format uuid */
    related_object_uuid: string;
    related_object_type: string;
}

/**
 * * `acknowledged` - Acknowledged
 * * `pending_banner` - Pending (Banner)
 * * `pending_blocking` - Pending (Blocking)
 */
export enum MarketplaceTcStatusEnum {
    Acknowledged = "acknowledged",
    PendingBanner = "pending_banner",
    PendingBlocking = "pending_blocking",
}

/** Request serializer for masquerade target user. */
export interface MasqueradeTargetUser {
    /** @format uuid */
    user_uuid: string;
}

/** Response serializer containing the temporary token and target user/company info. */
export interface MasqueradeTokenResponse {
    token: string;
    /** @format email */
    target_user_email: string;
    target_user_name: string;
    target_company_name: string;
    /**
     * * `brand` - Brand
     * * `supplier` - Supplier
     * * `merchant_of_record` - Merchant of Record
     */
    target_company_type: CompanyTypeEnum;
}

/** Serializer for listing users that can be masqueraded. */
export interface MasqueradeableUser {
    /** @format uuid */
    uuid: string;
    /** @format email */
    email: string;
    full_name: string;
}

export interface McpAccessRequest {
    /**
     * Public identifier for this access request
     * @format uuid
     */
    uuid: string;
    /** @format uuid */
    user_uuid: string;
    /** @format email */
    user_email: string;
    requested_scopes: McpScopeKeyEnum[];
    /**
     * Brief explanation from the user of why they need MCP access
     * @maxLength 500
     */
    justification: string;
    status: McpAccessRequestStatusEnum;
    /** @default "" */
    review_note?: string;
    /** @format email */
    reviewed_by_email: string | null;
    /**
     * When the admin reviewed this request
     * @format date-time
     */
    reviewed_at: string | null;
    /** @format date-time */
    created: string;
}

/**
 * * `pending` - Pending
 * * `approved` - Approved
 * * `denied` - Denied
 */
export enum McpAccessRequestStatusEnum {
    Pending = "pending",
    Approved = "approved",
    Denied = "denied",
}

export interface McpAuditLog {
    /**
     * Public identifier for this audit entry
     * @format uuid
     */
    uuid: string;
    /** @format email */
    user_email: string | null;
    /** Name of the MCP tool that was called, e.g. 'list_orders' */
    tool_name: string;
    /** Tool category derived from its scope, e.g. 'orders' */
    tool_category: string;
    /** LLM's explanation of why this tool was called (max 280 chars, tweet-length) */
    reason: string;
    /** OAuth scopes active on the token used for this call */
    scopes_used: any;
    /**
     * Outcome of the tool call: success, error, or denied
     *
     * * `success` - Success
     * * `error` - Error
     * * `denied` - Denied
     */
    status: McpAuditStatusEnum;
    /** Error detail when status is 'error' */
    error_message: string;
    /** Elapsed milliseconds for tool execution */
    duration_ms: number | null;
    /** Denormalized name of the OAuth application at the time of the call. Preserved even if the application is later deleted or renamed. */
    oauth_application_name: string;
    /** Client IP address from the request */
    ip_address: string | null;
    /** MCP session ID from the Mcp-Session-Id header */
    session_id: string;
    /** User-Agent header — identifies the MCP client (Cursor, VS Code, Claude Desktop, etc.) */
    user_agent: string;
    /** @format date-time */
    created: string;
}

/**
 * * `success` - Success
 * * `error` - Error
 * * `denied` - Denied
 */
export enum McpAuditStatusEnum {
    Success = "success",
    Error = "error",
    Denied = "denied",
}

/**
 * * `all:read` - Read access to all MCP tools
 * * `all:write` - Write access to all MCP tools
 * * `orders:read` - Read order data
 * * `orders:write` - Create and modify orders
 * * `companies:read` - Read company and supplier data
 * * `companies:write` - Modify company data
 * * `crm:read` - Read CRM contacts and companies
 * * `crm:write` - Modify CRM data
 * * `catalog:read` - Read product catalog
 * * `catalog:write` - Modify product catalog
 * * `activities:read` - Read tasks and notes
 * * `activities:write` - Create and modify tasks and notes
 * * `tasks:read` - Read tasks assigned to the calling user
 * * `tasks:write` - Update tasks, create subtasks, upload plans, complete agent runs
 * * `payments:read` - Read payments and statements
 * * `payments:write` - Record payments, payouts, refunds
 * * `agreements:read` - Read agreements
 * * `agreements:write` - Create and modify agreements
 * * `onboarding:read` - Read onboarding workflows
 * * `onboarding:write` - Modify onboarding workflows
 * * `agents:read` - Read installable agents and their installation status
 * * `agents:write` - Activate, pause, or revoke agent installations
 * * `files:read` - Read tenant files the caller can already access via REST
 */
export enum McpScopeKeyEnum {
    AllRead = "all:read",
    AllWrite = "all:write",
    OrdersRead = "orders:read",
    OrdersWrite = "orders:write",
    CompaniesRead = "companies:read",
    CompaniesWrite = "companies:write",
    CrmRead = "crm:read",
    CrmWrite = "crm:write",
    CatalogRead = "catalog:read",
    CatalogWrite = "catalog:write",
    ActivitiesRead = "activities:read",
    ActivitiesWrite = "activities:write",
    TasksRead = "tasks:read",
    TasksWrite = "tasks:write",
    PaymentsRead = "payments:read",
    PaymentsWrite = "payments:write",
    AgreementsRead = "agreements:read",
    AgreementsWrite = "agreements:write",
    OnboardingRead = "onboarding:read",
    OnboardingWrite = "onboarding:write",
    AgentsRead = "agents:read",
    AgentsWrite = "agents:write",
    FilesRead = "files:read",
}

export interface McpUserAccess {
    /**
     * Public identifier for this access record
     * @format uuid
     */
    uuid: string;
    /** @format uuid */
    user_uuid: string;
    /** @format email */
    user_email: string;
    /** Whether MCP access is currently active for this user */
    is_enabled?: boolean;
    /** OAuth scopes this user is permitted to use, e.g. ['orders:read', 'orders:write'] */
    allowed_scopes?: any;
    /** Specific tool names this user may call. Empty list means all tools within the allowed scopes are permitted. */
    allowed_tools?: any;
    /** @format email */
    granted_by_email: string | null;
    last_used: string;
    last_reason: string;
    last_tool: string;
    total_calls_30d: string;
    /** @format date-time */
    created: string;
    /** @format date-time */
    modified: string;
}

export interface MerchantOfRecordAgreementCreate {
    /** @format uuid */
    buyer_company: string;
    /**
     * * `EUR` - EUR
     * * `GBP` - GBP
     * * `USD` - USD
     */
    buyer_currency?: AvailableCurrenciesEnum;
    /** @format uuid */
    supplier_company: string;
    /** @format uuid */
    delivery_address_uuid: string;
    /**
     * * `EUR` - EUR
     * * `GBP` - GBP
     * * `USD` - USD
     */
    supplier_currency?: AvailableCurrenciesEnum;
    /**
     * * `stripe` - Stripe
     * * `two` - Two
     * * `direct` - Direct
     */
    payment_provider?: PaymentProviderEnum;
    /**
     * @format decimal
     * @pattern ^-?\d{0,9}(?:\.\d{0,6})?$
     */
    supplier_to_buyer_currency_conversion_rate?: string;
    /**
     * @format int64
     * @min 0
     * @max 9223372036854776000
     */
    shipping_price_in_supplier_currency: number;
    /**
     * @format decimal
     * @pattern ^-?\d{0,1}(?:\.\d{0,4})?$
     */
    supplier_shipping_tax_rate?: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,1}(?:\.\d{0,4})?$
     */
    buyer_shipping_tax_rate?: string;
    /**
     * @format int64
     * @min 0
     * @max 9223372036854776000
     */
    import_fee_price_in_buyer_currency?: number;
    /**
     * @format int64
     * @min 0
     * @max 9223372036854776000
     */
    export_fee_price_in_supplier_currency?: number;
    /**
     * * `pay_before_dispatch` - Pay Before Dispatch
     * * `pay_after_dispatch` - Pay After Dispatch
     * * `pay_on_28th_second_month_after_dispatch` - Pay on 28th second month after dispatch
     * * `pay_end_of_month_of_dispatch_date` - Pay End of Month of Dispatch Date
     */
    payment_terms?: AppOrderPaymentTermsEnum;
    /**
     * * `payout_before_dispatch` - Payout Before Dispatch
     * * `payout_after_dispatch` - Payout After Dispatch
     */
    payout_terms?: PayoutTermsEnum;
    /**
     * @min 0
     * @max 2147483647
     */
    days_until_payment_due?: number;
    /**
     * @min 0
     * @max 2147483647
     */
    days_until_payout_due?: number;
    /**
     * @min 0
     * @max 2147483647
     */
    estimated_number_of_orders: number;
    /**
     * @min 0
     * @max 2147483647
     */
    minimum_lead_time_for_first_order_in_days: number;
    /**
     * @min 0
     * @max 2147483647
     */
    minimum_lead_time_for_following_orders_in_days: number;
    line_items: MerchantOfRecordAgreementLineItemCreate[];
    /** @format date */
    contract_start_date: string;
    /** @format date */
    contract_end_date: string;
    /** @format uuid */
    order_management_contract_uuid?: string | null;
}

export interface MerchantOfRecordAgreementDetails {
    /** @format uuid */
    uuid: string;
    agreement_number: string;
    /** @format date-time */
    created_at: string;
    line_items: MerchantOfRecordAgreementLineItem[];
    supplier_company_name: string;
    buyer_company_name: string;
    delivery_address: DeliveryAddressResponse | null;
    buyer_currency: string;
    /**
     * * `EUR` - EUR
     * * `GBP` - GBP
     * * `USD` - USD
     */
    supplier_currency?: AvailableCurrenciesEnum;
    /**
     * @format int64
     * @min 0
     * @max 9223372036854776000
     */
    shipping_price_in_supplier_currency: number;
    /**
     * @format int64
     * @min 0
     * @max 9223372036854776000
     */
    import_fee_price_in_buyer_currency?: number;
    /**
     * @format int64
     * @min 0
     * @max 9223372036854776000
     */
    export_fee_price_in_supplier_currency?: number;
    shipping_price_for_buyer_in_cents: number;
    /** @format double */
    buyer_shipping_tax_rate: number;
    buyer_total_shipping_tax_amount_in_buyer_currency_in_cents: number;
    /**
     * @min 0
     * @max 2147483647
     */
    estimated_number_of_orders: number;
    /**
     * @min 0
     * @max 2147483647
     */
    minimum_lead_time_for_first_order_in_days: number;
    /**
     * @min 0
     * @max 2147483647
     */
    minimum_lead_time_for_following_orders_in_days: number;
    /**
     * @min 0
     * @max 2147483647
     */
    days_until_payment_due?: number;
    supplier_total_shipping_price_in_supplier_currency_in_cents: number;
    supplier_total_shipping_tax_amount_in_supplier_currency_in_cents: number;
    /** @format double */
    supplier_shipping_tax_rate: number;
    /**
     * @min 0
     * @max 2147483647
     */
    days_until_payout_due?: number;
    /**
     * * `pay_before_dispatch` - Pay Before Dispatch
     * * `pay_after_dispatch` - Pay After Dispatch
     * * `pay_on_28th_second_month_after_dispatch` - Pay on 28th second month after dispatch
     * * `pay_end_of_month_of_dispatch_date` - Pay End of Month of Dispatch Date
     */
    payment_terms?: AppOrderPaymentTermsEnum;
    /**
     * * `payout_before_dispatch` - Payout Before Dispatch
     * * `payout_after_dispatch` - Payout After Dispatch
     */
    payout_terms?: PayoutTermsEnum;
    /** @format uuid */
    channel_uuid: string;
    /**
     * * `stripe` - Stripe
     * * `two` - Two
     * * `direct` - Direct
     */
    payment_provider?: PaymentProviderEnum;
}

export interface MerchantOfRecordAgreementLineItem {
    /** @format uuid */
    uuid: string;
    /** @maxLength 255 */
    product_name: string;
    /**
     * * `fl oz` - Fluid Ounces
     * * `g` - Grams
     * * `mg` - milligrams
     * * `gals` - Gallons
     * * `kg` - Kilograms
     * * `L` - Liters
     * * `tons` - Metric Tons
     * * `oz` - Ounces
     * * `lbs` - Pounds
     * * `pcs` - Pieces
     * * `pt` - Pints
     * * `ml` - Milliliter
     * * `boxes` - Boxes
     * * `pallets` - Pallets
     * * `tsp` - Teaspoons
     * * `tbsp` - Tablespoons
     * * `units` - Units
     * * `cases` - Cases
     * * `trays` - Trays
     */
    unit_of_measurement?: UnitOfMeasurementEnum;
    /** @format float */
    buyer_tax_rate: number;
    buyer_unit_price_in_buyer_currency: number;
    buyer_total_price_in_buyer_currency_in_cents: number;
    buyer_total_tax_amount_in_buyer_currency_in_cents: number;
    quantity_ordered: number;
    /** @format float */
    supplier_tax_rate: number;
    supplier_unit_price_in_supplier_currency: number;
    supplier_total_price_in_supplier_currency_in_cents: number;
    supplier_total_tax_amount_in_supplier_currency_in_cents: number;
    /** @format float */
    buyer_commission_percentage: number;
    /**
     * @format decimal
     * @pattern ^-?\d{0,10}(?:\.\d{0,2})?$
     */
    total_quantity_agreed: string;
    /** @maxLength 255 */
    sku?: string | null;
    /** @maxLength 255 */
    product_description?: string | null;
    /** @maxLength 255 */
    packaging_format?: string | null;
    quantity: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,10}(?:\.\d{0,2})?$
     */
    minimum_order_quantity: string;
    spec_sheet_document: AgreementLineItemDocument;
    signed_agreement_document: AgreementLineItemDocument;
    /**
     * @format int64
     * @min 0
     * @max 9223372036854776000
     */
    delivery_surcharge_price_in_supplier_currency?: number;
}

export interface MerchantOfRecordAgreementLineItemCreate {
    /** @maxLength 255 */
    product_name: string;
    /**
     * * `fl oz` - Fluid Ounces
     * * `g` - Grams
     * * `mg` - milligrams
     * * `gals` - Gallons
     * * `kg` - Kilograms
     * * `L` - Liters
     * * `tons` - Metric Tons
     * * `oz` - Ounces
     * * `lbs` - Pounds
     * * `pcs` - Pieces
     * * `pt` - Pints
     * * `ml` - Milliliter
     * * `boxes` - Boxes
     * * `pallets` - Pallets
     * * `tsp` - Teaspoons
     * * `tbsp` - Tablespoons
     * * `units` - Units
     * * `cases` - Cases
     * * `trays` - Trays
     */
    unit_of_measurement?: UnitOfMeasurementEnum;
    /**
     * @format decimal
     * @pattern ^-?\d{0,1}(?:\.\d{0,4})?$
     */
    buyer_tax_rate?: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,1}(?:\.\d{0,4})?$
     */
    supplier_tax_rate?: string;
    /**
     * @format int64
     * @min 0
     * @max 9223372036854776000
     */
    supplier_unit_price_in_supplier_currency: number;
    /**
     * @format decimal
     * @pattern ^-?\d{0,6}(?:\.\d{0,20})?$
     */
    buyer_commission_percentage?: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,10}(?:\.\d{0,2})?$
     */
    total_quantity_agreed: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,10}(?:\.\d{0,2})?$
     */
    minimum_order_quantity: string;
    /** @maxLength 255 */
    sku?: string | null;
    /** @maxLength 255 */
    product_description?: string | null;
    /** @maxLength 255 */
    packaging_format?: string | null;
    /**
     * @format int64
     * @min 0
     * @max 9223372036854776000
     */
    delivery_surcharge_price_in_supplier_currency?: number;
}

export interface MerchantOfRecordAgreementList {
    /** @format uuid */
    uuid: string;
    agreement_number: string;
    /** @format date-time */
    created_at: string;
    line_items: MerchantOfRecordAgreementLineItem[];
    supplier_company_name: string;
    buyer_company_name: string;
    /** @format date */
    contract_end_date: string;
    /** @format date */
    contract_start_date: string;
}

/** Serializer for Allianz credit information for MoR endpoints */
export interface MerchantOfRecordAllianzCreditInformation {
    /** Allianz cover ID */
    cover_id: string;
    /** Cover status code */
    cover_status_code: string;
    /**
     * Response date from Allianz API
     * @format date
     */
    response_date: string | null;
    /**
     * Cover start date
     * @format date
     */
    start_date: string | null;
    /**
     * Total credit limit amount in base currency (NOT in cents)
     * @format decimal
     * @pattern ^-?\d{0,13}(?:\.\d{0,2})?$
     */
    total_amount: string;
    /** Currency code */
    total_amount_currency_code: string;
    /**
     * Last update timestamp
     * @format date-time
     */
    last_updated: string | null;
}

/**
 * Serializer for creating new app orders by merchant of record companies.
 *
 * This serializer handles the creation of app orders with validation to
 * ensure:
 * - Buyer and supplier companies are associated with the merchant of
 *   record
 * - Delivery address belongs to the buyer company
 * - Ordered by user is associated with the buyer company
 * - At least one line item is provided
 *
 * The serializer also handles the creation of delivery addresses and
 * line items as part of the order creation process.
 */
export interface MerchantOfRecordAppOrderCreate {
    /** @format uuid */
    ordered_by: string;
    /** @format uuid */
    company_ordered_by: string;
    /**
     * * `EUR` - EUR
     * * `GBP` - GBP
     * * `USD` - USD
     */
    buyer_currency?: AvailableCurrenciesEnum;
    /** @format uuid */
    company_ordered_from: string;
    /** @format uuid */
    delivery_address_uuid: string;
    /** @format date */
    delivery_date: string;
    /**
     * * `EUR` - EUR
     * * `GBP` - GBP
     * * `USD` - USD
     */
    supplier_currency?: AvailableCurrenciesEnum;
    /**
     * @format decimal
     * @pattern ^-?\d{0,9}(?:\.\d{0,6})?$
     */
    supplier_to_buyer_currency_conversion_rate?: string;
    /**
     * @format int64
     * @min 0
     * @max 9223372036854776000
     */
    shipping_price_in_supplier_currency: number;
    /**
     * @format decimal
     * @pattern ^-?\d{0,1}(?:\.\d{0,4})?$
     */
    supplier_shipping_tax_rate?: string;
    /**
     * @format int64
     * @min 0
     * @max 9223372036854776000
     */
    import_fee_price_in_buyer_currency?: number | null;
    /**
     * @format int64
     * @min 0
     * @max 9223372036854776000
     */
    export_fee_price_in_supplier_currency?: number | null;
    /**
     * * `stripe` - Stripe
     * * `two` - Two
     * * `direct` - Direct
     */
    payment_provider?: PaymentProviderEnum;
    /**
     * @format decimal
     * @pattern ^-?\d{0,1}(?:\.\d{0,4})?$
     */
    service_fee_percentage?: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,1}(?:\.\d{0,4})?$
     */
    service_fee_tax_rate?: string;
    /**
     * * `pay_before_dispatch` - Pay Before Dispatch
     * * `pay_after_dispatch` - Pay After Dispatch
     * * `pay_on_28th_second_month_after_dispatch` - Pay on 28th second month after dispatch
     * * `pay_end_of_month_of_dispatch_date` - Pay End of Month of Dispatch Date
     */
    payment_terms?: AppOrderPaymentTermsEnum;
    /**
     * * `payout_before_dispatch` - Payout Before Dispatch
     * * `payout_after_dispatch` - Payout After Dispatch
     */
    supplier_payout_terms?: SupplierPayoutTermsEnum;
    /**
     * @min 0
     * @max 2147483647
     */
    buyer_payment_period?: number;
    /**
     * @min 0
     * @max 2147483647
     */
    supplier_payment_period?: number;
    /**
     * * `ingredient_sourcing` - Ingredient Sourcing
     * * `sampling` - Sampling
     * * `other` - Other
     */
    service_type?: ServiceTypeEnum;
    line_items: MerchantOfRecordAppOrderLineItemCreate[];
    buyer_purchase_order_reference?: string | null;
    /**
     * * `buyer` - Buyer
     * * `supplier` - Supplier
     * * `unknown` - Unknown
     * * `to_be_confirmed` - To Be Confirmed
     * * `merchant_of_record` - Merchant of Record
     */
    shipping_responsibility?: ShippingResponsibilityEnum;
    /** @format uuid */
    order_management_contract_uuid?: string | null;
    /**
     * @format decimal
     * @pattern ^-?\d{0,1}(?:\.\d{0,4})?$
     */
    buyer_shipping_tax_rate?: string;
    /**
     * US-only. Flat sales-tax amount as it appears on the supplier invoice, in supplier currency cents. This value is the tax itself — it is added to the order's with-tax totals and excluded from the without-tax totals (no further tax is applied to it). Buyer-side amount is derived via the order's supplier_to_buyer_currency_conversion_rate.
     * @format int64
     * @min 0
     * @max 9223372036854776000
     */
    sales_tax_in_supplier_currency_in_cents?: number | null;
    /**
     * Indicates who holds the credit exposure for this order
     *
     * * `two` - Two
     * * `allianz` - Allianz
     * * `opply` - Opply
     */
    credit_risk_owner?: CreditRiskOwnerEnum | BlankEnum | NullEnum | null;
    /** @format uuid */
    supplier_site?: string | null;
    /**
     * If provided, order starts in FORECASTED state with this target confirmation date
     * @format date
     */
    forecasted_due_date?: string | null;
    /**
     * UUID of a pending spot buy request to link to this order and mark as completed
     * @format uuid
     */
    spot_buy_request_uuid?: string | null;
}

/** MoR surface — uses the nested serializer that exposes `supplier_document_url`. */
export interface MerchantOfRecordAppOrderDetails {
    /** @format uuid */
    uuid: string;
    order_number: string;
    /** @format date-time */
    created_at: string;
    /** @format date-time */
    modified_at: string;
    ordered_by: ShortUser;
    company_ordered_by: CompanyNameAndId;
    company_ordered_from: CompanyNameAndId;
    /**
     * * `initializing` - Initializing
     * * `confirmed` - Confirmed
     * * `canceled` - Cancelled
     * * `pending_merchant_of_record_approval` - Pending Merchant of Record Approval
     * * `order_received` - Order Received
     * * `order_sent_to_supplier` - Order Sent To Supplier
     * * `order_confirming_price` - Order Confirming Price
     * * `forecasted` - Forecasted
     */
    lifecycle_state?: LifecycleStateEnum;
    /**
     * * `initializing` - Initializing
     * * `not_started` - Not Started
     * * `due` - Due
     * * `overdue` - Overdue
     * * `awaiting_reconciliation` - Awaiting Reconciliation
     * * `paid` - Paid
     * * `refunded` - Refunded
     * * `partially_refunded` - Partially Refunded
     */
    pay_in_state?: PayInStateEnum;
    /**
     * * `initializing` - Initializing
     * * `not_started` - Not Started
     * * `due` - Due
     * * `overdue` - Overdue
     * * `paid` - Paid
     * * `refunded` - Refunded
     * * `partially_refunded` - Partially Refunded
     */
    payout_state?: PayoutStateEnum;
    /**
     * * `initializing` - Initializing
     * * `not_started` - Not Started
     * * `pending_dispatch` - Pending Dispatch
     * * `in_transit` - In Transit
     * * `delivered` - Delivered
     * * `freight_ownership_pending` - Freight Ownership Pending
     * * `gathering_quotes` - Gathering Quotes
     * * `dispatch_scheduled` - Dispatch Scheduled
     * * `awaiting_collection_details` - Awaiting Collection Details
     * * `ready_for_pickup` - Ready for Pickup
     * * `picked_up` - Picked Up
     * * `preparing_freight` - Preparing Freight
     * * `freight_scheduled` - Freight Scheduled
     * * `gathering_freight_quotes` - Gathering Freight Quotes
     * * `quotes_confirmed` - Quotes Confirmed
     */
    delivery_state?: DeliveryStateEnum;
    /**
     * * `pay_before_dispatch` - Pay Before Dispatch
     * * `pay_after_dispatch` - Pay After Dispatch
     * * `pay_on_28th_second_month_after_dispatch` - Pay on 28th second month after dispatch
     * * `pay_end_of_month_of_dispatch_date` - Pay End of Month of Dispatch Date
     */
    payment_terms?: AppOrderPaymentTermsEnum;
    /**
     * * `EUR` - EUR
     * * `GBP` - GBP
     * * `USD` - USD
     */
    buyer_currency?: AvailableCurrenciesEnum;
    /**
     * * `EUR` - EUR
     * * `GBP` - GBP
     * * `USD` - USD
     */
    supplier_currency?: AvailableCurrenciesEnum;
    /**
     * @format int64
     * @min 0
     * @max 9223372036854776000
     */
    shipping_price_in_supplier_currency: number;
    /**
     * @format int64
     * @min 0
     * @max 9223372036854776000
     */
    import_fee_price_in_buyer_currency?: number | null;
    /**
     * @format int64
     * @min 0
     * @max 9223372036854776000
     */
    export_fee_price_in_supplier_currency?: number | null;
    line_items: MerchantOfRecordOrderLineItem[];
    shipping_price_for_buyer: number;
    total_order_price_for_buyer: number;
    total_order_vat: number;
    delivery_address: DeliveryAddressResponse | null;
    delivery_tracking?: DeliveryTracking;
    payment_due_date: string;
    /**
     * Invoice due date from Two, set when order.reconciliation.invoiced.v1 webhook is received
     * @format date
     */
    two_invoice_due_date?: string | null;
    /**
     * @min 0
     * @max 2147483647
     */
    buyer_payment_period?: number;
    supplier_payout_due_date: string;
    supplier_payout_due_date_calculated: string;
    /** @format date */
    supplier_payout_due_date_override?: string | null;
    /**
     * @min 0
     * @max 2147483647
     */
    supplier_payment_period?: number;
    /**
     * * `payout_before_dispatch` - Payout Before Dispatch
     * * `payout_after_dispatch` - Payout After Dispatch
     */
    supplier_payout_terms?: SupplierPayoutTermsEnum;
    /** @format double */
    buyer_shipping_tax_rate: number;
    /** @format double */
    supplier_shipping_tax_rate: number;
    buyer_total_shipping_tax_amount_in_buyer_currency: number;
    supplier_total_shipping_tax_amount_in_supplier_currency: number;
    /**
     * US-only. Flat sales-tax amount as it appears on the supplier invoice, in supplier currency cents. This value is the tax itself — it is added to the order's with-tax totals and excluded from the without-tax totals (no further tax is applied to it). Buyer-side amount is derived via the order's supplier_to_buyer_currency_conversion_rate.
     * @format int64
     * @min 0
     * @max 9223372036854776000
     */
    sales_tax_in_supplier_currency_in_cents?: number | null;
    /** US-only flat sales tax in buyer-currency cents. 0 when unset. */
    buyer_total_sales_tax_amount_in_buyer_currency: number;
    /** US-only flat sales tax in supplier-currency cents. 0 when unset. */
    supplier_total_sales_tax_amount_in_supplier_currency: number;
    supplier_total_shipping_price_in_supplier_currency: number;
    /** @format date */
    delivery_date: string;
    /**
     * @format int64
     * @min 0
     * @max 9223372036854776000
     */
    extra_shipping_price_exclusive_to_supplier_in_supplier_currency?: number;
    account_executive: StaffUser;
    sales_representative: StaffUser;
    /** @format date */
    estimated_delivery_date?: string | null;
    /**
     * * `ingredient_sourcing` - Ingredient Sourcing
     * * `sampling` - Sampling
     * * `other` - Other
     */
    service_type?: ServiceTypeEnum;
    /**
     * @format decimal
     * @pattern ^-?\d{0,9}(?:\.\d{0,6})?$
     */
    supplier_to_buyer_currency_conversion_rate?: string;
    /** @maxLength 255 */
    buyer_purchase_order_reference?: string | null;
    skip_stripe_invoice_creation: boolean;
    /** @format float */
    service_fee_percentage: number;
    /** @format float */
    service_fee_tax_rate: number;
    service_fee_subtotal: number;
    service_fee_tax: number;
    service_fee_total: number;
    /**
     * * `stripe` - Stripe
     * * `two` - Two
     * * `direct` - Direct
     */
    payment_provider: PaymentProviderEnum;
    external_payment_id: string | null;
    payment_received_from_extended_terms_provider: boolean;
    /**
     * * `not_started` - Not Started
     * * `invoice_sent` - Invoice Sent
     * * `paid` - Paid
     */
    service_fee_status: ServiceFeeStatusEnum;
    is_etom_order: boolean;
    is_direct_order: boolean;
    /**
     * * `buyer` - Buyer
     * * `supplier` - Supplier
     * * `unknown` - Unknown
     * * `to_be_confirmed` - To Be Confirmed
     * * `merchant_of_record` - Merchant of Record
     */
    shipping_responsibility: ShippingResponsibilityEnum;
    credit_risk_owner: CreditRiskOwnerEnum | NullEnum | null;
    requires_credit_review: boolean;
    supplier_site: SupplierSite;
    is_on_hold: boolean;
    hold_details: OrderHoldDetails;
    delivery_state_label: string;
    /** @format date */
    forecast_date: string;
    total_pay_in_refunded_amount: number;
    total_payout_refunded_amount: number;
    originating_adjustments: MerchantOfRecordNestedOrderAdjustment[];
    applied_adjustments: MerchantOfRecordNestedOrderAdjustment[];
}

export interface MerchantOfRecordAppOrderDispatch {
    tracking_code?: string | null;
    shipping_provider?: string | null;
    /** @format date */
    estimated_delivery_date: string;
    /** @format date */
    dispatched_at: string;
}

export interface MerchantOfRecordAppOrderDocument {
    /** @format uuid */
    uuid: string;
    /** @format uri */
    document: string;
    /**
     * * `uploaded_by_admin` - Uploaded by admin
     * * `uploaded_by_supplier` - Uploaded by supplier
     * * `uploaded_by_merchant_of_record` - Uploaded by merchant of record
     * * `uploaded_by_buyer` - Uploaded by buyer
     */
    category?: AppOrderDocumentCategory;
    file_name: string;
    /** @format date-time */
    created_at: string;
    /**
     * * `supplier_invoice` - Supplier Invoice
     * * `delivery_note` - Delivery Note
     * * `organic` - Organic
     * * `halal` - Halal
     * * `trading_schedule` - Trading Schedule
     * * `kosher` - Kosher
     * * `certificate_of_conformity` - Certificate of Conformity
     * * `packing_list` - Packing List
     * * `technical_data_sheet` - Technical Data Sheet
     * * `certificate_of_insurance` - Certificate of Insurance
     * * `customs_declaration_summary` - Customs Declaration Summary
     * * `bill_of_lading` - Bill of Lading
     * * `proof_of_payment` - Proof of Payment
     */
    type?: AppOrderDocumentType;
}

export interface MerchantOfRecordAppOrderEdit {
    shipping_price_in_supplier_currency?: number;
    extra_shipping_price_exclusive_to_supplier_in_supplier_currency?: number;
    /** @format uuid */
    sales_representative?: string | null;
    /** @format uuid */
    account_executive?: string | null;
    /** @format date */
    delivery_date?: string;
    line_items?: MerchantOfRecordAppOrderLineItemEdit[];
    /** UUIDs of line items to remove from the order */
    remove_line_item_uuids?: string[];
    import_fee_price_in_buyer_currency?: number | null;
    export_fee_price_in_supplier_currency?: number | null;
    /**
     * @format decimal
     * @pattern ^-?\d{0,1}(?:\.\d{0,4})?$
     */
    supplier_shipping_tax_rate?: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,1}(?:\.\d{0,4})?$
     */
    buyer_shipping_tax_rate?: string;
    /** @min 0 */
    sales_tax_in_supplier_currency_in_cents?: number | null;
    /**
     * * `pay_before_dispatch` - Pay Before Dispatch
     * * `pay_after_dispatch` - Pay After Dispatch
     * * `pay_on_28th_second_month_after_dispatch` - Pay on 28th second month after dispatch
     * * `pay_end_of_month_of_dispatch_date` - Pay End of Month of Dispatch Date
     */
    payment_terms?: AppOrderPaymentTermsEnum;
    /** @format date */
    estimated_delivery_date?: string | null;
    /** @maxLength 255 */
    shipping_provider?: string | null;
    /** @maxLength 255 */
    tracking_code?: string | null;
    /** @format date */
    dispatched_at?: string | null;
    /** @min 0 */
    buyer_payment_period?: number;
    /** @min 0 */
    supplier_payment_period?: number;
    /**
     * * `payout_before_dispatch` - Payout Before Dispatch
     * * `payout_after_dispatch` - Payout After Dispatch
     */
    supplier_payout_terms?: SupplierPayoutTermsEnum;
    /**
     * * `ingredient_sourcing` - Ingredient Sourcing
     * * `sampling` - Sampling
     * * `other` - Other
     */
    service_type?: ServiceTypeEnum;
    /**
     * * `EUR` - EUR
     * * `GBP` - GBP
     * * `USD` - USD
     */
    supplier_currency?: AvailableCurrenciesEnum;
    /**
     * * `EUR` - EUR
     * * `GBP` - GBP
     * * `USD` - USD
     */
    buyer_currency?: AvailableCurrenciesEnum;
    /**
     * @format decimal
     * @pattern ^-?\d{0,9}(?:\.\d{0,6})?$
     */
    supplier_to_buyer_currency_conversion_rate?: string;
    buyer_purchase_order_reference?: string | null;
    skip_stripe_invoice_creation?: boolean;
    payment_received_from_extended_terms_provider?: boolean;
    external_payment_id?: string | null;
    /**
     * * `buyer` - Buyer
     * * `supplier` - Supplier
     * * `unknown` - Unknown
     * * `to_be_confirmed` - To Be Confirmed
     * * `merchant_of_record` - Merchant of Record
     */
    shipping_responsibility?: ShippingResponsibilityEnum;
    /** @format uuid */
    order_management_contract_uuid?: string | null;
    credit_risk_owner?: CreditRiskOwnerEnum | NullEnum | null;
    /** @format uuid */
    supplier_site?: string | null;
    add_line_items?: MerchantOfRecordAppOrderLineItemAdd[];
    /** @format date */
    supplier_payout_due_date_override?: string | null;
}

export interface MerchantOfRecordAppOrderEvent {
    /** @format uuid */
    uuid: string;
    /** @format date-time */
    created_at: string;
    user: User;
    event_type: string;
    text: string;
}

export interface MerchantOfRecordAppOrderEventCreate {
    text: string;
}

/** Serializer for adding new line items to an existing order. */
export interface MerchantOfRecordAppOrderLineItemAdd {
    /** @maxLength 255 */
    product_name: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,9}(?:\.\d{0,3})?$
     */
    quantity: string;
    /**
     * * `fl oz` - Fluid Ounces
     * * `g` - Grams
     * * `mg` - milligrams
     * * `gals` - Gallons
     * * `kg` - Kilograms
     * * `L` - Liters
     * * `tons` - Metric Tons
     * * `oz` - Ounces
     * * `lbs` - Pounds
     * * `pcs` - Pieces
     * * `pt` - Pints
     * * `ml` - Milliliter
     * * `boxes` - Boxes
     * * `pallets` - Pallets
     * * `tsp` - Teaspoons
     * * `tbsp` - Tablespoons
     * * `units` - Units
     * * `cases` - Cases
     * * `trays` - Trays
     */
    unit_of_measurement?: UnitOfMeasurementEnum;
    /**
     * @format decimal
     * @pattern ^-?\d{0,1}(?:\.\d{0,4})?$
     */
    buyer_tax_rate?: string | null;
    /**
     * @format decimal
     * @pattern ^-?\d{0,1}(?:\.\d{0,4})?$
     */
    supplier_tax_rate?: string | null;
    /**
     * @format int64
     * @min 0
     * @max 9223372036854776000
     */
    supplier_unit_price_in_supplier_currency: number;
    /**
     * @format decimal
     * @pattern ^-?\d{0,6}(?:\.\d{0,20})?$
     */
    buyer_commission_percentage?: string;
    /**
     * @format int64
     * @min 0
     * @max 9223372036854776000
     */
    delivery_surcharge_price_in_supplier_currency?: number | null;
    /** @maxLength 255 */
    sku?: string | null;
    /** @maxLength 255 */
    packaging_info?: string | null;
    product_description?: string | null;
    /** @format uuid */
    category?: string | null;
    reporting_units?: ReportingUnitsEnum | NullEnum | null;
    /**
     * @format decimal
     * @pattern ^-?\d{0,8}(?:\.\d{0,8})?$
     */
    reporting_units_per_sales_unit?: string | null;
    reporting_units_is_ai_generated?: boolean;
}

export interface MerchantOfRecordAppOrderLineItemCreate {
    /** @maxLength 255 */
    product_name: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,9}(?:\.\d{0,3})?$
     */
    quantity: string;
    /**
     * * `fl oz` - Fluid Ounces
     * * `g` - Grams
     * * `mg` - milligrams
     * * `gals` - Gallons
     * * `kg` - Kilograms
     * * `L` - Liters
     * * `tons` - Metric Tons
     * * `oz` - Ounces
     * * `lbs` - Pounds
     * * `pcs` - Pieces
     * * `pt` - Pints
     * * `ml` - Milliliter
     * * `boxes` - Boxes
     * * `pallets` - Pallets
     * * `tsp` - Teaspoons
     * * `tbsp` - Tablespoons
     * * `units` - Units
     * * `cases` - Cases
     * * `trays` - Trays
     */
    unit_of_measurement?: UnitOfMeasurementEnum;
    /**
     * @format decimal
     * @pattern ^-?\d{0,1}(?:\.\d{0,4})?$
     */
    buyer_tax_rate?: string | null;
    /**
     * @format decimal
     * @pattern ^-?\d{0,1}(?:\.\d{0,4})?$
     */
    supplier_tax_rate?: string | null;
    /**
     * @format int64
     * @min 0
     * @max 9223372036854776000
     */
    supplier_unit_price_in_supplier_currency: number;
    /**
     * @format decimal
     * @pattern ^-?\d{0,6}(?:\.\d{0,20})?$
     */
    buyer_commission_percentage?: string;
    /**
     * @format int64
     * @min 0
     * @max 9223372036854776000
     */
    delivery_surcharge_price_in_supplier_currency?: number | null;
    /** @maxLength 255 */
    sku?: string | null;
    /** @maxLength 255 */
    packaging_info?: string | null;
    product_description?: string | null;
    /** @format uuid */
    category?: string | null;
    reporting_units?: ReportingUnitsEnum | NullEnum | null;
    /**
     * @format decimal
     * @pattern ^-?\d{0,8}(?:\.\d{0,8})?$
     */
    reporting_units_per_sales_unit?: string | null;
    reporting_units_is_ai_generated?: boolean;
}

export interface MerchantOfRecordAppOrderLineItemEdit {
    /** @format uuid */
    uuid: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,9}(?:\.\d{0,3})?$
     */
    quantity?: string;
    supplier_unit_price_in_supplier_currency?: number;
    /** @maxLength 255 */
    product_name?: string;
    /**
     * * `fl oz` - Fluid Ounces
     * * `g` - Grams
     * * `mg` - milligrams
     * * `gals` - Gallons
     * * `kg` - Kilograms
     * * `L` - Liters
     * * `tons` - Metric Tons
     * * `oz` - Ounces
     * * `lbs` - Pounds
     * * `pcs` - Pieces
     * * `pt` - Pints
     * * `ml` - Milliliter
     * * `boxes` - Boxes
     * * `pallets` - Pallets
     * * `tsp` - Teaspoons
     * * `tbsp` - Tablespoons
     * * `units` - Units
     * * `cases` - Cases
     * * `trays` - Trays
     */
    unit_of_measurement?: UnitOfMeasurementEnum;
    /**
     * @format decimal
     * @pattern ^-?\d{0,1}(?:\.\d{0,4})?$
     */
    buyer_tax_rate?: string | null;
    /**
     * @format decimal
     * @pattern ^-?\d{0,1}(?:\.\d{0,4})?$
     */
    supplier_tax_rate?: string | null;
    /**
     * @format decimal
     * @pattern ^-?\d{0,6}(?:\.\d{0,20})?$
     */
    buyer_commission_percentage?: string;
    delivery_surcharge_price_in_supplier_currency?: number;
    /** @format uri */
    logo_url?: string;
    /** @maxLength 255 */
    sku?: string | null;
    /** @maxLength 255 */
    packaging_info?: string | null;
    product_description?: string | null;
    /** @format uuid */
    category?: string | null;
    reporting_units?: ReportingUnitsEnum | NullEnum | null;
    /**
     * @format decimal
     * @pattern ^-?\d{0,8}(?:\.\d{0,8})?$
     */
    reporting_units_per_sales_unit?: string | null;
    reporting_units_is_ai_generated?: boolean;
    /** Serializer for editing OTIF data within line item updates. */
    otif_data?: OrderLineItemOtifDataEdit;
}

export interface MerchantOfRecordAppOrderList {
    /** @format uuid */
    uuid: string;
    order_number: string;
    /** @format date-time */
    created_at: string;
    /** @format date-time */
    modified_at: string;
    ordered_by: ShortUser;
    company_ordered_by: CompanyNameAndId;
    company_ordered_from: CompanyNameAndId;
    /**
     * * `initializing` - Initializing
     * * `confirmed` - Confirmed
     * * `canceled` - Cancelled
     * * `pending_merchant_of_record_approval` - Pending Merchant of Record Approval
     * * `order_received` - Order Received
     * * `order_sent_to_supplier` - Order Sent To Supplier
     * * `order_confirming_price` - Order Confirming Price
     * * `forecasted` - Forecasted
     */
    lifecycle_state?: LifecycleStateEnum;
    /**
     * * `initializing` - Initializing
     * * `not_started` - Not Started
     * * `due` - Due
     * * `overdue` - Overdue
     * * `awaiting_reconciliation` - Awaiting Reconciliation
     * * `paid` - Paid
     * * `refunded` - Refunded
     * * `partially_refunded` - Partially Refunded
     */
    pay_in_state?: PayInStateEnum;
    /**
     * * `initializing` - Initializing
     * * `not_started` - Not Started
     * * `due` - Due
     * * `overdue` - Overdue
     * * `paid` - Paid
     * * `refunded` - Refunded
     * * `partially_refunded` - Partially Refunded
     */
    payout_state?: PayoutStateEnum;
    /**
     * * `initializing` - Initializing
     * * `not_started` - Not Started
     * * `pending_dispatch` - Pending Dispatch
     * * `in_transit` - In Transit
     * * `delivered` - Delivered
     * * `freight_ownership_pending` - Freight Ownership Pending
     * * `gathering_quotes` - Gathering Quotes
     * * `dispatch_scheduled` - Dispatch Scheduled
     * * `awaiting_collection_details` - Awaiting Collection Details
     * * `ready_for_pickup` - Ready for Pickup
     * * `picked_up` - Picked Up
     * * `preparing_freight` - Preparing Freight
     * * `freight_scheduled` - Freight Scheduled
     * * `gathering_freight_quotes` - Gathering Freight Quotes
     * * `quotes_confirmed` - Quotes Confirmed
     */
    delivery_state?: DeliveryStateEnum;
    is_on_hold: boolean;
    /**
     * * `stripe` - Stripe
     * * `two` - Two
     * * `direct` - Direct
     */
    payment_provider?: PaymentProviderEnum;
}

/** Detailed serializer for buyer/brand information for MoR users */
export interface MerchantOfRecordBuyerDetail {
    /** @format uuid */
    uuid: string;
    /** @maxLength 255 */
    name: string;
    /** @maxLength 255 */
    registration_name?: string | null;
    /** @maxLength 255 */
    registration_number?: string | null;
    /** @maxLength 255 */
    website?: string | null;
    phone_country_code?: PhoneCountryCodeEnum | BlankEnum | NullEnum | null;
    /** @maxLength 50 */
    phone_number?: string | null;
    /**
     * @format email
     * @maxLength 254
     */
    buyer_accounts_email_address?: string | null;
    /**
     * @format email
     * @maxLength 254
     */
    buyer_delivery_email_address?: string | null;
    sku_ordering_enabled?: boolean;
    /**
     * DUNS number for creditworthiness checks and payouts
     * @maxLength 50
     */
    duns?: string | null;
    /**
     * * `confect_snacks` - Confectionery & Snacks
     * * `conv_food` - Convenience Food
     * * `bread_cereals` - Bread & Cereals
     * * `sauces_spices` - Sauces & Spices
     * * `spreads` - Spreads
     * * `tea` - Tea
     * * `coffee` - Coffee
     * * `water` - Water
     * * `carb_drinks` - Carbonated Drinks
     * * `alc_drinks` - Alcoholic Drinks
     * * `juice_drinks` - Juice Drinks
     * * `energy_drinks` - Energy Drinks
     * * `cosmetics` - Cosmetics
     * * `milk_dairy` - Milk & Dairy
     * * `free_form_alt` - Free Form Alternative
     * * `other` - Other
     */
    product_type?: ProductTypeEnum;
    /** @format date-time */
    created: string;
    primary_address: string;
    primary_user: string;
    /** Indicates if company is integrated with Allianz credit insurance */
    is_connected_to_allianz?: boolean;
    /**
     * Allianz company ID for credit limit integration
     * @maxLength 255
     */
    allianz_company_id?: string | null;
    two_buyer_config: TwoBuyerConfig;
}

export interface MerchantOfRecordBuyerPurchaseOrderPDFUrl {
    /** @format uri */
    pdf_url: string;
}

export interface MerchantOfRecordCompany {
    /** @format uuid */
    uuid: string;
    /** @maxLength 255 */
    name: string;
    /**
     * * `brand` - Brand
     * * `supplier` - Supplier
     * * `merchant_of_record` - Merchant of Record
     */
    company_type?: CompanyTypeEnum;
    supplier_payout_terms?: SupplierPayoutTermsEnum | BlankEnum | NullEnum | null;
    /**
     * @min 0
     * @max 2147483647
     */
    supplier_days_until_payout_due?: number | null;
}

/** Serializer for invoice URL response for Stripe and Two */
export interface MerchantOfRecordInvoiceUrlResponse {
    /**
     * The hosted invoice URL for Stripe or the internal url to the invoice PDF for Two
     * @format uri
     */
    url: string;
}

/**
 * MoR variant of the nested order-detail adjustment payload — adds
 * `supplier_document_url`, which the buyer surface must not expose.
 *
 * Subclassing rather than sharing keeps the buyer / MoR contracts independent:
 * adding a future MoR-only field here won't accidentally leak to buyers.
 */
export interface MerchantOfRecordNestedOrderAdjustment {
    /** @format uuid */
    uuid: string;
    /**
     * CREDIT_NOTE reduces the buyer's amount due; DEBIT_NOTE adds an additional charge to the buyer
     *
     * * `credit_note` - Credit Note
     * * `debit_note` - Debit Note
     */
    type: OrderAdjustmentTypeEnum;
    status: OrderAdjustmentStatusEnum;
    /** Pre-tax adjustment amount in cents */
    base_amount: number;
    /** Tax amount in cents */
    tax_amount: number;
    /** Total in cents (base_amount + tax_amount); always positive — type indicates direction */
    total_amount: number;
    currency: AvailableCurrenciesEnum;
    /** MoR-entered reason for the adjustment (internal/audit). Required for source=MANUAL; null for WEBHOOK / BACKFILL rows. */
    reason: string | null;
    /** @format uuid */
    originating_order_uuid: string;
    originating_order_number: string;
    /** @format uuid */
    applied_to_order_uuid: string;
    applied_to_order_number: string;
    /** Provider invoice ID at apply time (snapshotted) */
    applied_to_invoice_id: string | null;
    /** Cached PDF URL from the provider; refresh via API as needed */
    provider_document_pdf_url: string | null;
    /** @format date-time */
    pending_application_at: string | null;
    /** @format date-time */
    applied_at: string | null;
    /** @format date-time */
    created_at: string;
    /** @format uri */
    supplier_document_url: string;
}

export interface MerchantOfRecordNote {
    /** @format uuid */
    uuid: string;
    body: string;
    /** @format date-time */
    created: string;
    /** @format date-time */
    modified: string;
    created_by: CreatedBy;
}

/** Serializer for reading order activities with all fields including internal status and task fields. */
export interface MerchantOfRecordOrderActivity {
    /** @format uuid */
    uuid: string;
    /** @format date-time */
    created_at: string;
    user: ShortUser;
    message: string | null;
    category: OrderActivityCategory;
    is_internal: boolean;
    /** @format date-time */
    task_due_date: string | null;
    task_assignee: ShortUser;
    zendesk_ticket_id: string | null;
    is_created_from_automation: boolean;
    task_state: TaskStateEnum | NullEnum | null;
    documents: OrderActivityDocument[];
}

/** Serializer for creating order activities by merchant of record companies. */
export interface MerchantOfRecordOrderActivityCreate {
    message: string;
    /** @default "note" */
    category?: OrderActivityCategory;
    /** @default false */
    is_internal?: boolean;
    /** @format date-time */
    task_due_date?: string | null;
    /** @format uuid */
    task_assignee?: string | null;
    /** @maxLength 255 */
    zendesk_ticket_id?: string | null;
    /** @default false */
    is_created_from_automation?: boolean;
    documents?: string[];
    /** @default false */
    create_new_zendesk_ticket?: boolean;
    /** @maxLength 255 */
    zendesk_ticket_id_to_update?: string | null;
}

/**
 * Read-only feed serializer used by the MoR home dashboard's order
 * activity widget. Same fields as `MerchantOfRecordOrderActivitySerializer`,
 * plus the order identifiers the FE needs to deep-link each row back
 * to the specific order in the legacy app.
 */
export interface MerchantOfRecordOrderActivityFeedItem {
    /** @format uuid */
    uuid: string;
    /** @format date-time */
    created_at: string;
    user: ShortUser;
    message: string | null;
    category: OrderActivityCategory;
    is_internal: boolean;
    /** @format date-time */
    task_due_date: string | null;
    task_assignee: ShortUser;
    zendesk_ticket_id: string | null;
    is_created_from_automation: boolean;
    task_state: TaskStateEnum | NullEnum | null;
    documents: OrderActivityDocument[];
    /** @format uuid */
    order_uuid: string;
    order_number: string;
}

export interface MerchantOfRecordOrderLineItem {
    /** @format uuid */
    uuid: string;
    /** @format date-time */
    created_at: string;
    /** @format date-time */
    modified_at: string;
    /** @maxLength 255 */
    product_name: string;
    /**
     * @format uri
     * @maxLength 2048
     */
    logo_url?: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,10}(?:\.\d{0,2})?$
     */
    quantity: string;
    /**
     * * `fl oz` - Fluid Ounces
     * * `g` - Grams
     * * `mg` - milligrams
     * * `gals` - Gallons
     * * `kg` - Kilograms
     * * `L` - Liters
     * * `tons` - Metric Tons
     * * `oz` - Ounces
     * * `lbs` - Pounds
     * * `pcs` - Pieces
     * * `pt` - Pints
     * * `ml` - Milliliter
     * * `boxes` - Boxes
     * * `pallets` - Pallets
     * * `tsp` - Teaspoons
     * * `tbsp` - Tablespoons
     * * `units` - Units
     * * `cases` - Cases
     * * `trays` - Trays
     */
    unit_of_measurement?: UnitOfMeasurementEnum;
    /** @format float */
    buyer_tax_rate: number;
    /**
     * @format int64
     * @min 0
     * @max 9223372036854776000
     */
    delivery_surcharge_price_in_supplier_currency?: number | null;
    buyer_unit_price_in_buyer_currency: number;
    buyer_total_price_in_buyer_currency: number;
    buyer_total_tax_amount_in_buyer_currency: number;
    supplier_unit_price_in_supplier_currency: number;
    supplier_total_price_in_supplier_currency: number;
    supplier_total_tax_amount_in_supplier_currency: number;
    /** @format float */
    supplier_tax_rate: number;
    /**
     * @format decimal
     * @pattern ^-?\d{0,6}(?:\.\d{0,20})?$
     */
    buyer_commission_percentage?: string;
    documents: OrderLineItemDocument[];
    /** @maxLength 255 */
    sku?: string | null;
    /** @maxLength 255 */
    packaging_info?: string | null;
    product_description?: string | null;
    /** @format uuid */
    category?: string | null;
    reporting_units?: ReportingUnitsEnum | NullEnum | null;
    /**
     * @format decimal
     * @pattern ^-?\d{0,8}(?:\.\d{0,8})?$
     */
    reporting_units_per_sales_unit?: string | null;
    reporting_units_is_ai_generated?: boolean;
    otif_data: OrderLineItemOtifDataNested;
}

/** Serializer for the response when pushing an order to Two. */
export interface MerchantOfRecordPushToTwoResponse {
    /** Two order ID */
    id: string;
    /** True if the order was newly created on Two */
    created: boolean;
    /** True if a new billing account was created as part of this operation */
    billing_account_created?: boolean;
    /** Order status on Two */
    status?: string | null;
    /** Our order number as stored on Two */
    merchant_order_id?: string | null;
}

/** Read-only serializer for listing spot buy requests from the MoR perspective. */
export interface MerchantOfRecordSpotBuyRequestList {
    /** @format uuid */
    uuid: string;
    /** Unique request number in format REQ-XXXX-XXXX-XXXX */
    request_number: string;
    /**
     * Current status of the spot buy request
     *
     * * `pending` - Pending
     * * `completed` - Completed
     * * `cancelled` - Cancelled
     */
    status: SpotBuyRequestStatusEnum;
    description: string;
    /** @format date-time */
    created_at: string;
    company: CompanyNameAndId;
    supplier: CompanyNameAndId;
    /** @format uuid */
    delivery_address_uuid: string;
    /**
     * Requested delivery date
     * @format date
     */
    delivery_date: string | null;
    line_items: any;
    skus: any;
    has_po_upload: boolean;
    /** Associated Zendesk ticket ID for this request */
    zendesk_ticket_id: string | null;
}

export interface MerchantOfRecordSupplier {
    /** @format uuid */
    uuid: string;
    /** @maxLength 255 */
    name: string;
    supplier_payout_terms?: SupplierPayoutTermsEnum | BlankEnum | NullEnum | null;
    /**
     * @min 0
     * @max 2147483647
     */
    supplier_days_until_payout_due?: number | null;
    /**
     * DUNS number for creditworthiness checks and payouts
     * @maxLength 50
     */
    duns?: string | null;
    supplier_type?: SupplierTypeEnum | BlankEnum | NullEnum | null;
    /**
     * Default number of calendar days this supplier needs between order and delivery. Factored into the earliest selectable delivery date on orders.
     * @min 0
     * @max 365
     */
    supplier_lead_time_days?: number | null;
}

export interface MerchantOfRecordSupplierPurchaseOrderPDFUrl {
    /** @format uri */
    pdf_url: string;
}

export interface MerchantOfRecordSupplierSiteCreate {
    /** @maxLength 255 */
    name: string;
}

/** Serializer for Two billing account information for MoR endpoints. */
export interface MerchantOfRecordTwoBillingAccount {
    /** Two billing account ID */
    id: string;
    /** True if the billing account was newly created, False if existing */
    created: boolean;
    /** Billing schedule (e.g., 'MONTHLY') */
    schedule?: string | null;
    /** Number of days until payment is due */
    due_in_days?: number | null;
    /** Currency code (e.g., 'GBP', 'USD') */
    currency?: string | null;
}

/**
 * Serializer for Two credit information for MoR endpoints.
 * All monetary values are in cents in the buyer's currency.
 */
export interface MerchantOfRecordTwoCreditInformation {
    /** Currency code (e.g., 'GBP', 'EUR', 'USD') */
    currency: string;
    /** Total credit limit from Two in cents */
    total_limit: number;
    /** Current credit usage from Two (confirmed orders) in cents */
    exposure: number;
    /** Available credit from Two (total_limit - exposure) in cents */
    available_limit: number;
    /**
     * Timestamp of last credit check from Two API
     * @format date-time
     */
    last_updated: string | null;
    /** Recourse information if available */
    recourse: MerchantOfRecordTwoRecourseInformation | null;
    /** Credit decision from Two (e.g., 'APPROVED', 'DECLINED') */
    decision: string | null;
    /** List of reasons if credit was declined */
    decline_reason?: string[] | null;
}

/** Serializer for checking if an order has already been pushed to Two. */
export interface MerchantOfRecordTwoOrderStatus {
    /** True if the order has been pushed to Two */
    pushed_to_two: boolean;
    /** Two order ID if pushed */
    two_order_id?: string | null;
    /** Order status on Two if available */
    two_order_status?: string | null;
}

/** Serializer for Two recourse information for MoR endpoints */
export interface MerchantOfRecordTwoRecourseInformation {
    /** Indicates if recourse is enabled */
    is_recourse_enabled: boolean | null;
    /** Recourse flag from Two API */
    recourse_flag: boolean | null;
    /** Recourse decline reason if recourse was declined */
    recourse_decline_reason: string | null;
    /** Buyer's merchant-defined limit in recourse (in cents) */
    buyer_merchant_defined_limit: number | null;
    /** Buyer's exposure in recourse (in cents) */
    buyer_exposure: number | null;
    /** Buyer's available limit in recourse (in cents) */
    buyer_available_limit: number | null;
}

export interface MerchantOfRecordUserCreate {
    /** @format uuid */
    uuid: string;
    /**
     * @format email
     * @maxLength 254
     */
    email: string;
    /** @maxLength 150 */
    first_name: string;
    /** @maxLength 150 */
    last_name: string;
    /**
     * Staff status
     * Designates whether the user can log into this admin site.
     */
    is_staff: boolean;
    /**
     * Active
     * Designates whether this user should be treated as active. Unselect this instead of deleting accounts.
     */
    is_active: boolean;
    /** @format date-time */
    date_joined: string;
}

export interface MerchantOfRecordUserList {
    /** @format uuid */
    uuid: string;
    /** @format email */
    email: string;
    first_name: string;
    last_name: string;
    /**
     * Staff status
     * Designates whether the user can log into this admin site.
     */
    is_staff: boolean;
    /**
     * Active
     * Designates whether this user should be treated as active. Unselect this instead of deleting accounts.
     */
    is_active: boolean;
    /** @format date-time */
    date_joined: string;
}

export interface MerchantOfRecordUserUpdate {
    /** @format uuid */
    uuid: string;
    /** @format email */
    email: string;
    /** @maxLength 150 */
    first_name?: string;
    /** @maxLength 150 */
    last_name?: string;
    /**
     * Staff status
     * Designates whether the user can log into this admin site.
     */
    is_staff?: boolean;
    /**
     * Active
     * Designates whether this user should be treated as active. Unselect this instead of deleting accounts.
     */
    is_active?: boolean;
    /** @format date-time */
    date_joined: string;
}

export interface Message {
    /** @format uuid */
    uuid: string;
    text?: string | null;
    /** @format uri */
    attachment: string | null;
    sender: ShortUser;
    is_read: string;
    /** @format date-time */
    created: string;
    /** @format date-time */
    modified: string;
    channel: ChannelForMessage;
    buyer_name: string;
    supplier_name: string;
    file_name?: string;
}

/** Serializer for nested address creation within buyer creation. */
export interface MoRBuyerAddressCreate {
    /** @maxLength 255 */
    address_line_1: string;
    /** @maxLength 255 */
    address_line_2?: string;
    /** @maxLength 100 */
    town: string;
    /** @maxLength 100 */
    region?: string;
    /** @maxLength 100 */
    postcode: string;
    /** @maxLength 2 */
    country: string;
    /** @maxLength 2 */
    vat_country_code?: string;
    /** @maxLength 50 */
    vat_number?: string;
    /** @maxLength 20 */
    ein?: string;
}

/** Serializer for nested address updates. Country cannot be changed. */
export interface MoRBuyerAddressUpdate {
    /** @maxLength 255 */
    address_line_1?: string;
    /** @maxLength 255 */
    address_line_2?: string;
    /** @maxLength 100 */
    town?: string;
    /** @maxLength 100 */
    region?: string;
    /** @maxLength 100 */
    postcode?: string;
    /** @maxLength 2 */
    vat_country_code?: string;
    /** @maxLength 50 */
    vat_number?: string;
    /** @maxLength 20 */
    ein?: string;
}

/**
 * Serializer for creating a new Buyer (Brand) company by MoR users.
 * Creates the company, user, address, and employee atomically.
 */
export interface MoRBuyerCreate {
    /** @maxLength 150 */
    first_name: string;
    /** @maxLength 150 */
    last_name: string;
    /** @format email */
    email: string;
    /** @maxLength 255 */
    company_name: string;
    /** @default ["other"] */
    product_type?: ProductTypeEnum[];
    /** @maxLength 255 */
    registration_name?: string | null;
    /** @maxLength 255 */
    registration_number?: string | null;
    /** @maxLength 255 */
    website?: string | null;
    /** @maxLength 10 */
    phone_country_code?: string | null;
    /** @maxLength 50 */
    phone_number?: string | null;
    /** @format email */
    buyer_accounts_email_address?: string | null;
    /** @format email */
    buyer_delivery_email_address?: string | null;
    /** @maxLength 50 */
    duns?: string | null;
    /** Serializer for nested address creation within buyer creation. */
    company_address: MoRBuyerAddressCreate;
    /** @default true */
    send_welcome_email?: boolean;
    /** @default false */
    send_contract_ready_email?: boolean;
}

/**
 * Response serializer for buyer details after create/update.
 * Returns comprehensive buyer information.
 */
export interface MoRBuyerDetailResponse {
    /** @format uuid */
    uuid: string;
    /** @maxLength 255 */
    name: string;
    /** @maxLength 255 */
    registration_name?: string | null;
    /** @maxLength 255 */
    registration_number?: string | null;
    /** @maxLength 255 */
    website?: string | null;
    phone_country_code?: PhoneCountryCodeEnum | BlankEnum | NullEnum | null;
    /** @maxLength 50 */
    phone_number?: string | null;
    /**
     * @format email
     * @maxLength 254
     */
    buyer_accounts_email_address?: string | null;
    /**
     * @format email
     * @maxLength 254
     */
    buyer_delivery_email_address?: string | null;
    sku_ordering_enabled?: boolean;
    /**
     * DUNS number for creditworthiness checks and payouts
     * @maxLength 50
     */
    duns?: string | null;
    /**
     * * `confect_snacks` - Confectionery & Snacks
     * * `conv_food` - Convenience Food
     * * `bread_cereals` - Bread & Cereals
     * * `sauces_spices` - Sauces & Spices
     * * `spreads` - Spreads
     * * `tea` - Tea
     * * `coffee` - Coffee
     * * `water` - Water
     * * `carb_drinks` - Carbonated Drinks
     * * `alc_drinks` - Alcoholic Drinks
     * * `juice_drinks` - Juice Drinks
     * * `energy_drinks` - Energy Drinks
     * * `cosmetics` - Cosmetics
     * * `milk_dairy` - Milk & Dairy
     * * `free_form_alt` - Free Form Alternative
     * * `other` - Other
     */
    product_type?: ProductTypeEnum;
    /** @format date-time */
    created: string;
    primary_address: string;
    primary_user: string;
    /** Indicates if company is integrated with Allianz credit insurance */
    is_connected_to_allianz?: boolean;
    /**
     * Allianz company ID for credit limit integration
     * @maxLength 255
     */
    allianz_company_id?: string | null;
}

/**
 * Payload for `POST .../supplier-submissions/{id}/match/`.
 *
 * The candidate Company is constrained to suppliers scoped to the calling
 * MoR (`merchant_of_record=context['merchant_of_record']`) so an MoR can
 * never match a buyer to another MoR's supplier.
 */
export interface MoRSupplierMatch {
    /** @format uuid */
    company_uuid: string;
}

/** Shape of a single match candidate (existing supplier Company). */
export interface MoRSupplierMatchCandidate {
    /** @format uuid */
    uuid: string;
    name: string;
    registration_name: string | null;
    registration_number: string | null;
    website: string | null;
}

/**
 * MoR-side read of a buyer's `buyer_onboarding.Supplier` submission.
 * Adds buyer context (company + contact) and review-pipeline pointers
 * so an operator can decide whether to match the submission to an
 * existing supplier company or promote it into the OnboardingSupplier
 * pipeline.
 */
export interface MoRSupplierSubmission {
    id: number;
    /** Supplier name */
    supplier_name: string;
    /** Description of products purchased from this supplier */
    products_description: string;
    /**
     * Average monthly spend with this supplier
     * @format decimal
     * @pattern ^-?\d{0,10}(?:\.\d{0,2})?$
     */
    average_monthly_spend: string | null;
    /** Invoice/Payment currency (e.g., USD, GBP, EUR) */
    invoice_currency: string;
    /** Supplier payment terms */
    payment_terms: string;
    /**
     * Priority to onboard this supplier
     *
     * * `high` - High
     * * `medium` - Medium
     * * `low` - Low
     */
    priority: PriorityEnum;
    /** Supplier country */
    supplier_country: string;
    /**
     * Supplier State/County
     * Supplier state or county
     */
    supplier_state: string;
    /** Supplier address */
    supplier_address: string;
    /** Supplier contact name */
    contact_name: string;
    /**
     * Supplier contact email
     * @format email
     */
    contact_email: string;
    /** Supplier contact phone number */
    contact_phone: string;
    /** Does the supplier arrange delivery? */
    arranges_delivery: boolean;
    /** Agreed lead time */
    lead_time: string;
    /** Is this an organic supplier? */
    is_organic: boolean;
    /** Any noteworthy information about your trading relationship */
    relationship_notes: string;
    /** Additional notes about the supplier */
    notes: string;
    /**
     * Where this submission sits in the MoR review queue.
     *
     * * `pending_review` - Pending review
     * * `matched` - Matched to existing supplier
     * * `onboarding` - Onboarding new supplier
     */
    review_status: SupplierReviewStatusEnum;
    /**
     * Timestamp of the most recent MoR review action.
     * @format date-time
     */
    reviewed_at: string | null;
    reviewed_by_email: string;
    matched_supplier_uuid: string;
    matched_supplier_name: string;
    onboarding_supplier_uuid: string;
    /** @format uuid */
    buyer_onboarding_uuid: string;
    buyer_company_uuid: string;
    buyer_company_name: string;
    buyer_contact_name: string;
    /** @format email */
    buyer_contact_email: string;
    /** @format date-time */
    created_at: string;
}

export interface MorKYBDetails {
    /**
     * * `Not started` - Not started
     * * `Started` - Started
     * * `In Review` - In Review
     * * `Completed` - Completed
     */
    mor_rapyd_kyb_status: KYBVerificationStatusResponseStatusEnum;
}

/**
 * * `0 USD - 199 USD` - 0 USD - 199 USD
 * * `200 USD - 499 USD` - 200 USD - 499 USD
 * * `500 USD - 2999 USD` - 500 USD - 2999 USD
 * * `3000+ USD` - 3000+ USD
 */
export enum MovEnum {
    Value0USD199USD = "0 USD - 199 USD",
    Value200USD499USD = "200 USD - 499 USD",
    Value500USD2999USD = "500 USD - 2999 USD",
    Value3000USD = "3000+ USD",
}

/** Serializer for moving order to an intermediate lifecycle status. */
export interface MoveLifecycleIntermediateStatus {
    /**
     * The target lifecycle status to transition to
     *
     * * `order_received` - Order Received
     * * `order_sent_to_supplier` - Order Sent To Supplier
     * * `order_confirming_price` - Order Confirming Price
     */
    target_status: TargetStatusEnum;
}

export interface Note {
    /** @format uuid */
    uuid: string;
    /** Note content */
    body: string;
    /** Whether this note should be pinned to the top */
    is_pinned?: boolean;
    created_by: UserMinimal;
    target: Target;
    target_type?: string;
    /** @format uuid */
    target_uuid?: string;
    /** @format date-time */
    created: string;
    /** @format date-time */
    modified: string;
}

export interface Notes {
    /** @format uuid */
    uuid: string;
    /** @format date-time */
    created: string;
    /** @format uuid */
    created_by_uuid: string;
    /** @format uuid */
    deal_uuid: string;
    content: string;
    /** @maxLength 100 */
    external_user_identifier: string;
}

export interface Notification {
    /** @format uuid */
    uuid: string;
    /**
     * * `Kriya KYB Reminder` - Kriya Kyb Reminder
     * * `New Quote` - New Quote
     * * `New Quote Reminder` - New Quote Reminder
     * * `New Request` - New Request
     * * `New Request Reminder` - New Request Reminder
     * * `New Samples Request` - New Samples Request
     * * `Samples Request Reminder` - Samples Request Reminder
     * * `Samples Dispatched` - Samples Dispatched
     * * `Samples Received Reminder` - Samples Received Reminder
     * * `Samples Approved` - Samples Approved
     * * `Samples Not Approved` - Samples Not Approved
     * * `Buyer Started Negotiation` - Buyer Started Negotiation
     * * `Supplier Negotiation Response` - Supplier Negotiation Response
     * * `Quote updated` - Quote Updated
     * * `New Order` - New Order
     * * `Order Dispatched` - Order Dispatched
     * * `Payment Due` - Payment Due
     * * `Quote Proceeded` - Quote Proceeded
     * * `Create Contract Reminder` - Create Contract Reminder
     * * `Proceed with Contract` - Proceed With Contract
     * * `Reminder: Proceed with Contract` - Reminder Proceed With Contract
     * * `Confirm Contract` - Confirm Contract
     * * `Contract Created` - Contract Created
     * * `New Purchase Request` - New Purchase Request
     * * `New Purchase Request Reminder` - New Purchase Request Reminder
     * * `Response to Purchase Request` - Response To Purchase Request
     * * `Purchase Request Cancelled` - Purchase Request Cancelled
     * * `Quote Expiring` - Quote Expiring
     * * `Request Expiring` - Request Expiring
     * * `New Message` - New Message
     * * `New User` - New User
     * * `Contract Renewal Declined` - Contract Renewal Declined
     * * `Supplier Accepts Contract Renewal` - Contract Renewal Accepted
     * * `Sign New Contract Purchase Agreement` - Contract Renewal Accepted With Agreement
     * * `Contract Renewal Requested` - Contract Renewal Requested
     * * `Contract Renewal Terms accepted` - Contract Renewal Terms Accepted
     * * `Supplier Negotiates Contract Renewal` - Supplier Negotiates Contract Renewal
     * * `Re-order` - Reorder
     * * `Request for Re-order Declined` - Reorder Declined
     * * `Supplier change payment terms` - Supplier Updated Payment Terms
     */
    title: TitleEnum;
    description: string;
    content: string;
    /** @format date-time */
    created_at: string;
    /** @format date-time */
    read_at?: string | null;
    /**
     * * `trigger-based` - Triggerbased
     * * `time-based` - Timebased
     * * `user-specific` - Userspecific
     * * `global` - Global
     */
    type: NotificationTypeEnum;
    /**
     * * `chats` - Chats
     * * `requests` - Requests
     * * `quotes` - Quotes
     * * `orders` - Orders
     * * `contracts` - Contracts
     * * `settings` - Settings
     * * `ingredients` - Ingredients
     */
    category: NotificationCategoryEnum;
    /**
     * @min -2147483648
     * @max 2147483647
     */
    priority?: number;
    duration?: string | null;
    /** @maxLength 255 */
    location?: string | null;
    receiver: ShortUser;
    sender: ShortUser;
    related_object_type: string;
    related_object_uuid: string;
    is_read: string;
    /**
     * * `general_notifications` - General Notifications
     * * `actions` - Actions
     */
    used_for?: UsedForEnum;
    action_type?: ActionTypeEnum | BlankEnum | NullEnum | null;
    action_clear_trigger?: ActionClearTriggerEnum | BlankEnum | NullEnum | null;
}

/**
 * * `chats` - Chats
 * * `requests` - Requests
 * * `quotes` - Quotes
 * * `orders` - Orders
 * * `contracts` - Contracts
 * * `settings` - Settings
 * * `ingredients` - Ingredients
 */
export enum NotificationCategoryEnum {
    Chats = "chats",
    Requests = "requests",
    Quotes = "quotes",
    Orders = "orders",
    Contracts = "contracts",
    Settings = "settings",
    Ingredients = "ingredients",
}

/** * `order_created` - order_created */
export enum NotificationKindCodeEnum {
    OrderCreated = "order_created",
}

export interface NotificationPreference {
    /** * `order_created` - order_created */
    kind: NotificationKindCodeEnum;
    /**
     * * `email` - Email
     * * `in_app` - In App
     */
    channel: ChannelEnum;
    enabled?: boolean;
}

/** One in-app inbox row from the recipient's perspective. */
export interface NotificationRecipient {
    /** @format uuid */
    uuid: string;
    /** @format uuid */
    notification_uuid: string;
    kind: string;
    category: string;
    title: string;
    body: string;
    context: any;
    state: NotificationRecipientStateEnum;
    is_read: boolean;
    is_archived: boolean;
    /** @format date-time */
    read_at: string | null;
    /** @format date-time */
    archived_at: string | null;
    /** @format date-time */
    created_at: string;
}

/**
 * * `queued` - Queued
 * * `sent` - Sent
 * * `delivered` - Delivered
 * * `read` - Read
 * * `archived` - Archived
 * * `failed` - Failed
 */
export enum NotificationRecipientStateEnum {
    Queued = "queued",
    Sent = "sent",
    Delivered = "delivered",
    Read = "read",
    Archived = "archived",
    Failed = "failed",
}

/**
 * * `trigger-based` - Triggerbased
 * * `time-based` - Timebased
 * * `user-specific` - Userspecific
 * * `global` - Global
 */
export enum NotificationTypeEnum {
    TriggerBased = "trigger-based",
    TimeBased = "time-based",
    UserSpecific = "user-specific",
    Global = "global",
}

export enum NullEnum {
    Null = null,
}

/**
 * * `0 - 20` - 0 - 20
 * * `21 - 100` - 21 - 100
 * * `101 - 500` - 101 - 500
 * * `500+` - 500+
 */
export enum NumOfEmployeesEnum {
    Value020 = "0 - 20",
    Value21100 = "21 - 100",
    Value101500 = "101 - 500",
    Value500 = "500+",
}

/**
 * * `0 - 10` - 0 - 10
 * * `10 - 100` - 10 - 100
 * * `100 - 500` - 100 - 500
 * * `500+` - 500+
 */
export enum NumOfSkusEnum {
    Value010 = "0 - 10",
    Value10100 = "10 - 100",
    Value100500 = "100 - 500",
    Value500 = "500+",
}

/** Serializer for OAuth Application management (admin-only). */
export interface OAuthApplication {
    id: number;
    /** @maxLength 255 */
    name?: string;
    client_id: string;
    /**
     * * `confidential` - Confidential
     * * `public` - Public
     */
    client_type: ClientTypeEnum;
    /**
     * * `authorization-code` - Authorization code
     * * `urn:ietf:params:oauth:grant-type:device_code` - Device Code
     * * `implicit` - Implicit
     * * `password` - Resource owner password-based
     * * `client-credentials` - Client credentials
     * * `openid-hybrid` - OpenID connect hybrid
     */
    authorization_grant_type: AuthorizationGrantTypeEnum;
    /** Allowed URIs list, space separated */
    redirect_uris?: string;
    /** @format date-time */
    created: string;
    /** @format date-time */
    updated: string;
}

/**
 * Buyer Banking & payments section. A 1:1 resource on Company: a single
 * optional IBAN. The section is treated as complete when an IBAN is
 * saved; "Skip for now" is handled FE-side and does not write to the BE.
 */
export interface OnboardingBanking {
    /**
     * Optional IBAN.
     * @maxLength 64
     */
    iban?: string;
}

export interface OnboardingExtraction {
    /** @format uuid */
    uuid: string;
    /** @format uuid */
    batch_uuid: string;
    status: OnboardingExtractionStatusEnum;
    /** Aggregate company-profile fields (name, VAT, registered address). */
    proposed_business_profile: any;
    /** Aggregate banking fields the agent extracted (e.g. IBAN). */
    proposed_banking: any;
    /** Delivery addresses inferred from invoice headers. */
    proposed_delivery: any;
    /** Tweet-length human-readable summary from the orchestrator. */
    agent_reasoning: string;
    /** AgentCore session id; correlates back to the originating run. */
    extraction_session_id: string;
    suppliers: ExtractedSupplierRead[];
    /** @format date-time */
    created_at: string;
    /** @format date-time */
    modified_at: string;
}

/**
 * * `staged` - Staged
 * * `reviewed` - Reviewed
 * * `partially_committed` - Partially committed
 * * `committed` - Committed
 * * `discarded` - Discarded
 */
export enum OnboardingExtractionStatusEnum {
    Staged = "staged",
    Reviewed = "reviewed",
    PartiallyCommitted = "partially_committed",
    Committed = "committed",
    Discarded = "discarded",
}

/**
 * Body of ``POST /onboarding-extractions/``.
 *
 * Idempotent per batch: re-running for an existing batch wipes the
 * previous suppliers + line_items and re-stages the new proposal in
 * place. The viewset enforces that ``batch_uuid`` belongs to
 * ``request.user_company``.
 */
export interface OnboardingExtractionWrite {
    /** @format uuid */
    batch_uuid: string;
    proposed_business_profile?: Record<string, any>;
    proposed_banking?: Record<string, any>;
    proposed_delivery?: Record<string, any>[];
    /**
     * @maxLength 2000
     * @default ""
     */
    agent_reasoning?: string;
    /**
     * @maxLength 64
     * @default ""
     */
    extraction_session_id?: string;
    suppliers?: SupplierWrite[];
}

/**
 * Buyer Ingredients & SKUs section. Creates `catalog.BuyerItem` rows for
 * the authenticated buyer's company — the same model the post-onboarding
 * Materials page reads from (`/api/v1/catalog/items/`), so anything
 * committed here shows up immediately after finishing onboarding.
 *
 * The agent commit POSTs one row per INGREDIENT/PACKAGING-classified
 * line item; `kind` discriminates the two (defaults to `ingredient`).
 * Price / quantity / current-supplier extracted off the invoice are NOT
 * persisted — `BuyerItem` carries material identity only; commercial
 * attributes live on future order/supplier entities (see SC-3405).
 *
 * Writes are idempotent on `(buyer_company, item_name)` — the model's
 * uniqueness constraint. Re-running the commit (e.g. retry after a
 * partial failure) updates the existing row instead of erroring, and an
 * ingredient and a packaging item sharing a name resolve last-write-wins
 * on `kind`.
 */
export interface OnboardingIngredient {
    /** @format uuid */
    uuid: string;
    /** @maxLength 255 */
    item_name: string;
    item_description?: string | null;
    /**
     * What kind of material this row represents (ingredient, packaging, ...).
     *
     * * `ingredient` - Ingredient
     * * `packaging` - Packaging
     */
    kind?: CatalogItemKindEnum;
    /**
     * Natural unit the material is measured in.
     *
     * * `fl oz` - Fluid Ounces
     * * `g` - Grams
     * * `mg` - milligrams
     * * `gals` - Gallons
     * * `kg` - Kilograms
     * * `L` - Liters
     * * `tons` - Metric Tons
     * * `oz` - Ounces
     * * `lbs` - Pounds
     * * `pcs` - Pieces
     * * `pt` - Pints
     * * `ml` - Milliliter
     * * `boxes` - Boxes
     * * `pallets` - Pallets
     * * `tsp` - Teaspoons
     * * `tbsp` - Tablespoons
     * * `units` - Units
     * * `cases` - Cases
     * * `trays` - Trays
     */
    unit_of_measurement?: UnitOfMeasurementEnum;
}

export interface OnboardingInvoiceBatch {
    /** @format uuid */
    uuid: string;
    status: OnboardingInvoiceBatchStatusEnum;
    total_invoice_count: number;
    extracted_invoice_count: number;
    /** @format date-time */
    extraction_started_at: string | null;
    /** @format date-time */
    extraction_completed_at: string | null;
    extraction_failed_reason: string;
    invoices: OnboardingInvoiceList[];
    /** @format date-time */
    created_at: string;
    /** @format date-time */
    modified_at: string;
}

/**
 * * `uploading` - Uploading
 * * `ready_for_extraction` - Ready for extraction
 * * `extracting` - Extracting
 * * `extracted` - Extracted
 * * `extraction_failed` - Extraction failed
 * * `committed` - Committed
 * * `discarded` - Discarded
 */
export enum OnboardingInvoiceBatchStatusEnum {
    Uploading = "uploading",
    ReadyForExtraction = "ready_for_extraction",
    Extracting = "extracting",
    Extracted = "extracted",
    ExtractionFailed = "extraction_failed",
    Committed = "committed",
    Discarded = "discarded",
}

/**
 * Body of ``GET /onboarding-invoices/{uuid}/content/``.
 *
 * ``signed_url`` is short-TTL and tied to a single object. Mirrors
 * the shape the agent proxy will forward inside its payload.
 */
export interface OnboardingInvoiceContent {
    /** @format uri */
    signed_url: string;
    mime_type: string;
    size_bytes: number;
    page_count: number;
    expires_in_seconds: number;
}

/**
 * Identical shape to the list serializer in v1 — exists as a
 * separate class so we have a place to add detail-only fields later
 * without renaming the list response.
 */
export interface OnboardingInvoiceDetail {
    /** @format uuid */
    uuid: string;
    original_filename: string;
    mime_type: string;
    size_bytes: number;
    page_count: number;
    status: OnboardingInvoiceStatusEnum;
    /** @format date-time */
    created_at: string;
}

/**
 * Compact shape used inside batch responses and list endpoints.
 *
 * Intentionally never exposes ``storage_object_key`` / ``storage_bucket`` —
 * the private path stays on the server.
 */
export interface OnboardingInvoiceList {
    /** @format uuid */
    uuid: string;
    original_filename: string;
    mime_type: string;
    size_bytes: number;
    page_count: number;
    status: OnboardingInvoiceStatusEnum;
    /** @format date-time */
    created_at: string;
}

/**
 * * `uploaded` - Uploaded
 * * `agent_extracted` - Agent extracted
 * * `agent_extraction_failed` - Agent extraction failed
 * * `discarded` - Discarded
 */
export enum OnboardingInvoiceStatusEnum {
    Uploaded = "uploaded",
    AgentExtracted = "agent_extracted",
    AgentExtractionFailed = "agent_extraction_failed",
    Discarded = "discarded",
}

/**
 * Multipart input for ``POST /onboarding-invoices/``.
 *
 * Validation of the file's bytes (MIME sniff, size cap, batch caps)
 * is performed in the viewset because it depends on the batch's
 * current totals.
 */
export interface OnboardingInvoiceUpload {
    /** @format uuid */
    batch_uuid: string;
    /** @format uri */
    file: string;
}

/** Serializer for onboarding step template. */
export interface OnboardingStepTemplate {
    id: number;
    /**
     * * `phase_1` - Phase 1
     * * `phase_2` - Phase 2
     * * `phase_3` - Phase 3
     * * `phase_4` - Phase 4
     */
    phase: PhaseEnum;
    phase_display: string;
    /** Description of the process step */
    process_description: string;
    /**
     * Order in which steps should appear within the phase
     * @min 0
     * @max 2147483647
     */
    step_order?: number;
    /** Whether this step is active and will be included for new buyers */
    is_template_active?: boolean;
}

/** Serializer for OnboardingSupplier model */
export interface OnboardingSupplier {
    /** @format uuid */
    uuid: string;
    /** @maxLength 255 */
    company_name: string;
    status: string;
    /** The buyer company that referred this supplier - DEPRECATED, use buyers field */
    buyer: number | null;
    buyer_name: string;
    buyers_list: BuyerSummary[];
    /** List of buyer UUIDs to associate with this supplier */
    buyer_uuids?: string[];
    owners_list: StaffUser[];
    /** List of staff user UUIDs to assign as owners */
    owner_uuids?: string[];
    /** Reference to the final supplier company after completing onboarding */
    final_supplier: number | null;
    /** @format uuid */
    final_supplier_uuid: string | null;
    final_supplier_name: string | null;
    /** @format date-time */
    created: string;
    /** @format date-time */
    modified: string;
    address_name: string | null;
    address_street_1: string | null;
    address_street_2: string | null;
    address_town: string | null;
    address_region: string | null;
    address_postcode: string | null;
    address_country?: Country | NullEnum | null;
    address_contact_full_name: string | null;
    address_contact_phone_country_code?: AddressContactPhoneCountryCodeEnum | BlankEnum | NullEnum | null;
    address_contact_phone: string | null;
    /** @format email */
    address_contact_email: string | null;
    address_vat_number: string | null;
    address_vat_country_code?: Country | NullEnum | null;
    /** EIN number for US suppliers (format: XX-XXXXXXX) */
    address_ein_number: string | null;
    address_note?: string;
    /** DUNS number for US suppliers */
    duns: string | null;
    /**
     * Default supplier lead time in calendar days, copied to the final supplier on completion.
     * @min 0
     * @max 365
     */
    lead_time_days?: number | null;
    /** Canonical registered name from Companies House (GB) — captured at onboarding-supplier creation. */
    registration_name: string | null;
    /** Canonical Companies House registration number (GB) — captured at onboarding-supplier creation. */
    registration_number: string | null;
    registration_country_code?: Country | NullEnum | null;
    is_archived: boolean;
}

/** Serializer for OnboardingSupplierActivity */
export interface OnboardingSupplierActivity {
    /** @format uuid */
    uuid: string;
    /**
     * The status that was set during this activity
     *
     * * `onboarding_not_started` - Onboarding has not started
     * * `supplier_contacted` - Supplier contacted
     * * `setting_up_account` - Setting up account
     * * `ready_to_trade` - Ready to trade with Opply
     * * `blocked` - Blocked
     */
    status_changed_to: OnboardingSupplierStatus;
    status_display: string;
    /** Optional message or note about the activity */
    message?: string;
    /** The user who created this activity */
    user: number;
    user_email: string;
    user_name: string;
    /** @format date-time */
    created: string;
}

/** Serializer for creating OnboardingSupplierActivity (used when status update with message) */
export interface OnboardingSupplierActivityCreate {
    /**
     * The status that was set during this activity
     *
     * * `onboarding_not_started` - Onboarding has not started
     * * `supplier_contacted` - Supplier contacted
     * * `setting_up_account` - Setting up account
     * * `ready_to_trade` - Ready to trade with Opply
     * * `blocked` - Blocked
     */
    status_changed_to: OnboardingSupplierStatus;
    /** Optional message or note about the activity */
    message?: string;
}

/** Serializer for buyer information associated with an onboarding supplier */
export interface OnboardingSupplierBuyer {
    /** @format uuid */
    uuid: string;
    name: string;
    company_type: string;
    /** @format date-time */
    created: string;
}

export interface OnboardingSupplierContact {
    /** @format uuid */
    uuid: string;
    /** @maxLength 150 */
    first_name: string;
    /** @maxLength 150 */
    last_name?: string;
    /**
     * @format email
     * @maxLength 254
     */
    email: string;
    /** @maxLength 50 */
    phone_number?: string;
    /**
     * * `orders` - Orders
     * * `logistics` - Logistics and Supply Chain
     * * `finance` - Finance
     * * `other` - Other
     */
    category: SupplierContactCategoryEnum;
    /** @format date-time */
    created: string;
    /** @format date-time */
    modified: string;
    notes?: string;
}

/** Serializer for creating OnboardingSupplier */
export interface OnboardingSupplierCreate {
    /** @maxLength 255 */
    company_name: string;
    /**
     * Initial buyer UUID (for backward compatibility)
     * @format uuid
     */
    buyer_uuid: string;
    /** List of buyer UUIDs to associate with this supplier */
    buyer_uuids?: string[];
    /**
     * Current status of the supplier onboarding process
     *
     * * `onboarding_not_started` - Onboarding has not started
     * * `supplier_contacted` - Supplier contacted
     * * `setting_up_account` - Setting up account
     * * `ready_to_trade` - Ready to trade with Opply
     * * `blocked` - Blocked
     */
    status?: OnboardingSupplierStatus;
    /**
     * DUNS number for US suppliers
     * @maxLength 50
     */
    duns?: string | null;
    /**
     * Default supplier lead time in calendar days, copied to the final supplier on completion.
     * @min 0
     * @max 365
     */
    lead_time_days?: number | null;
    /**
     * ISO 3166-1 alpha-2 country code. When 'GB', `company_name` is validated against an active Companies House record and canonicalised to the registered casing.
     * @maxLength 2
     */
    registration_country_code?: string | null;
}

/** Lightweight serializer for list views */
export interface OnboardingSupplierList {
    /** @format uuid */
    uuid: string;
    company_name: string;
    status: string;
    buyer_name: string;
    is_archived: boolean;
    /** @format date-time */
    created: string;
}

export interface OnboardingSupplierPayoutDetails {
    /** @format uuid */
    uuid: string;
    /**
     * * `US` - Us
     * * `GB` - Gb
     * * `CA` - Ca
     * * `AT` - At
     * * `BE` - Be
     * * `CY` - Cy
     * * `DE` - De
     * * `EE` - Ee
     * * `ES` - Es
     * * `FI` - Fi
     * * `FR` - Fr
     * * `GR` - Gr
     * * `IE` - Ie
     * * `IT` - It
     * * `LT` - Lt
     * * `LU` - Lu
     * * `LV` - Lv
     * * `MT` - Mt
     * * `NL` - Nl
     * * `PT` - Pt
     * * `SI` - Si
     * * `SK` - Sk
     * * `BG` - Bg
     * * `CZ` - Cz
     * * `DK` - Dk
     * * `HR` - Hr
     * * `HU` - Hu
     * * `PL` - Pl
     * * `RO` - Ro
     * * `SE` - Se
     * * `EU` - Eu
     */
    bank_country: BankingCountryTypeEnum;
    /** @maxLength 255 */
    bank_name?: string;
    /** @maxLength 255 */
    account_holder_name: string;
    /** @maxLength 64 */
    account_number?: string;
    /** @maxLength 16 */
    sort_code?: string;
    /** @maxLength 32 */
    routing_number?: string;
    account_type?: AccountTypeEnum | BlankEnum;
    /** @maxLength 64 */
    iban?: string;
    /** @maxLength 32 */
    bic?: string;
    /** @maxLength 100 */
    account_holder_building?: string;
    /** @maxLength 255 */
    account_holder_street_1?: string;
    /** @maxLength 255 */
    account_holder_street_2?: string;
    /** @maxLength 100 */
    account_holder_town?: string;
    /** @maxLength 100 */
    account_holder_region?: string;
    /** @maxLength 100 */
    account_holder_postcode?: string;
    account_holder_country?: Country | NullEnum | null;
    /** @format date-time */
    created: string;
    /** @format date-time */
    modified: string;
    note?: string;
}

/**
 * * `onboarding_not_started` - Onboarding has not started
 * * `supplier_contacted` - Supplier contacted
 * * `setting_up_account` - Setting up account
 * * `ready_to_trade` - Ready to trade with Opply
 * * `blocked` - Blocked
 */
export enum OnboardingSupplierStatus {
    OnboardingNotStarted = "onboarding_not_started",
    SupplierContacted = "supplier_contacted",
    SettingUpAccount = "setting_up_account",
    ReadyToTrade = "ready_to_trade",
    Blocked = "blocked",
}

/** Serializer for updating OnboardingSupplier status with optional activity message */
export interface OnboardingSupplierUpdate {
    /**
     * Current status of the supplier onboarding process
     *
     * * `onboarding_not_started` - Onboarding has not started
     * * `supplier_contacted` - Supplier contacted
     * * `setting_up_account` - Setting up account
     * * `ready_to_trade` - Ready to trade with Opply
     * * `blocked` - Blocked
     */
    status?: OnboardingSupplierStatus;
    /** Optional message to record with the status change */
    message?: string;
    /** List of buyer UUIDs to associate with this supplier */
    buyer_uuids?: string[];
    /** List of staff user UUIDs to assign as owners */
    owner_uuids?: string[];
    /**
     * DUNS number for US suppliers
     * @maxLength 50
     */
    duns?: string | null;
    /**
     * Default supplier lead time in calendar days, copied to the final supplier on completion.
     * @min 0
     * @max 365
     */
    lead_time_days?: number | null;
}

/**
 * Serializer for OpplyDocument - for MoR users.
 *
 * Handles CRUD operations with computed status fields.
 */
export interface OpplyDocument {
    /** @format uuid */
    uuid: string;
    /** The Merchant of Record that owns this document */
    merchant_of_record: number;
    type: DocumentType;
    /** @format uuid */
    type_uuid?: string;
    /** @format uuid */
    renewing_uuid?: string | null;
    /**
     * The uploaded document file
     * @format uri
     */
    file: string;
    /**
     * Display name for the document
     * @maxLength 255
     */
    name: string;
    /**
     * Start date of document validity
     * @format date
     */
    start_date?: string | null;
    /**
     * End/expiry date of document validity
     * @format date
     */
    end_date?: string | null;
    status: DocumentLifecycleStatusEnum;
    /** Return whether the document is archived (expired or renewed). */
    is_archived: boolean;
    /** @format uuid */
    superseded_by_uuid: string | null;
    /** @format date-time */
    created: string;
    /** @format date-time */
    modified: string;
    /** ISO country codes this document applies to. Empty = all countries. */
    countries?: Country[];
}

/**
 * Read-only serializer for buyers viewing Opply documents.
 *
 * Returns all documents (including archived) with computed status.
 */
export interface OpplyDocumentBuyer {
    /** @format uuid */
    uuid: string;
    type: DocumentType;
    /**
     * The uploaded document file
     * @format uri
     */
    file: string;
    /** Display name for the document */
    name: string;
    /**
     * Start date of document validity
     * @format date
     */
    start_date: string | null;
    /**
     * End/expiry date of document validity
     * @format date
     */
    end_date: string | null;
    status: DocumentLifecycleStatusEnum;
    /** Return whether the document is archived (expired or renewed). */
    is_archived: boolean;
    /** ISO country codes this document applies to. Empty = all countries. */
    countries: Country[];
}

export interface Order {
    /** @format uuid */
    uuid: string;
    /** @format date-time */
    created: string;
    /** * `regular` - Regular */
    category?: OrderCategory;
    /**
     * * `checkout` - Checkout
     * * `confirmed` - confirmed
     * * `pending_payment` - pending_payment
     * * `canceled` - canceled
     * * `awaiting_approval` - awaiting_approval
     * * `on_hold` - on_hold
     * * `placed` - placed
     * * `dispatched` - dispatched
     * * `completed` - completed
     */
    state?: OrderState;
    payment_status?: PaymentStatusEnum | BlankEnum | NullEnum | null;
    kriya_status?: KriyaStatusEnum | BlankEnum | NullEnum | null;
    /**
     * if this is not None, then during payment was chosen not default currency and this field should be passed to the payment as selected_currency
     *
     * * `EUR` - EUR
     * * `USD` - USD
     * * `GBP` - GBP
     * * `CAD` - CAD
     */
    payment_currency?: Currencies | BlankEnum | NullEnum | null;
    /** @format date-time */
    payment_due_date?: string | null;
    /** @format date-time */
    kriya_payment_due_date?: string | null;
    payment_method?: PaymentMethod | NullEnum | null;
    payment_scenario: string;
    /**
     * * `pending_dispatch` - pending_dispatch
     * * `dispatched` - Dispatched
     * * `delivered` - Delivered
     */
    shipment_status?: ShipmentStatusEnum;
    /** @format date */
    dispatch_confirmation_date: string | null;
    /** @format date */
    delivery_confirmation_date?: string | null;
    is_new: boolean;
    order_number: string;
    number_of_quotes_ordered: number;
    total_price: number;
    total_price_currency: string;
    /** @format date */
    delivery_date: string;
    shipping_price: number;
    shipping_cost_no_vat: number;
    sum_to_pay: number;
    /** @format date */
    latest_delivery_date: string | null;
    discount_amount: number;
    sum_to_pay_no_discount: number;
    quotes_prices: PricesRetrieve[];
    vat_sum: number;
    sum_payout: number;
    /** @format date */
    order_date?: string | null;
    payment_delay: number | null;
    has_pending_purchase_request: boolean;
    is_recurring: boolean;
    /** @format uuid */
    related_contract_uuid: string;
    /** @format uuid */
    purchase_quote_uuid: string;
}

/**
 * * `confirming_price` - Confirming Price
 * * `price_confirmed` - Price Confirmed
 * * `confirming_delivery_date` - Confirming Delivery
 * * `delivery_date_confirmed` - Delivery Confirmed
 * * `note` - Note
 * * `order_put_on_hold` - Order Put On Hold
 * * `order_resumed` - Order Resumed
 * * `order_received` - Order Received
 * * `order_sent_to_supplier` - Order Sent To Supplier
 * * `order_confirming_price` - Order Confirming Price
 * * `order_forecasted` - Order Forecasted
 * * `order_unforecasted` - Order Unforecasted
 * * `refund_processed` - Refund Processed
 * * `payment_terms_changed` - Payment Terms Changed
 * * `order_pushed_to_two` - Order Pushed to Two
 */
export enum OrderActivityCategory {
    ConfirmingPrice = "confirming_price",
    PriceConfirmed = "price_confirmed",
    ConfirmingDeliveryDate = "confirming_delivery_date",
    DeliveryDateConfirmed = "delivery_date_confirmed",
    Note = "note",
    OrderPutOnHold = "order_put_on_hold",
    OrderResumed = "order_resumed",
    OrderReceived = "order_received",
    OrderSentToSupplier = "order_sent_to_supplier",
    OrderConfirmingPrice = "order_confirming_price",
    OrderForecasted = "order_forecasted",
    OrderUnforecasted = "order_unforecasted",
    RefundProcessed = "refund_processed",
    PaymentTermsChanged = "payment_terms_changed",
    OrderPushedToTwo = "order_pushed_to_two",
}

/** Serializer for order activity documents */
export interface OrderActivityDocument {
    /** @format uuid */
    uuid: string;
    /** @format uri */
    document: string;
    /** @format date-time */
    created_at: string;
}

/**
 * Body for `POST .../order-adjustments/{uuid}/apply/`.
 *
 * `target_order_uuid` is validated for UUID format only; the view performs a
 * tenant-scoped lookup. See OrderAdjustmentCreateSerializer for rationale.
 */
export interface OrderAdjustmentApply {
    /** @format uuid */
    target_order_uuid: string;
}

/**
 * Multipart create payload for `POST .../order-adjustments/`.
 *
 * `originating_order_uuid` is validated for UUID format only — the order is looked
 * up against a tenant-scoped queryset in the view. Resolving against an unscoped
 * queryset would let a MoR user probe foreign order UUIDs and read tenant-specific
 * business-rule errors (e.g. "different buyer", "different currency") back from
 * the service layer.
 */
export interface OrderAdjustmentCreate {
    /** @format uuid */
    originating_order_uuid: string;
    /**
     * * `credit_note` - Credit Note
     * * `debit_note` - Debit Note
     */
    type: OrderAdjustmentTypeEnum;
    /**
     * Pre-tax amount in cents
     * @min 0
     */
    base_amount: number;
    /**
     * Tax amount in cents
     * @min 0
     */
    tax_amount: number;
    /** Why the adjustment was issued (internal/audit) */
    reason: string;
    /**
     * Supplier-provided credit/debit note (PDF/PNG/JPG)
     * @format uri
     */
    supplier_document: string;
}

/**
 * Full read serializer for the MoR detail / post-action responses.
 *
 * Exposes `supplier_document_url` because the supplier-uploaded credit/debit note
 * is internal-facing — only MoR users see it. The buyer-side counterpart
 * (`BuyerOrderAdjustmentDetailSerializer`) hides the field.
 */
export interface OrderAdjustmentDetail {
    /** @format uuid */
    uuid: string;
    /**
     * CREDIT_NOTE reduces the buyer's amount due; DEBIT_NOTE adds an additional charge to the buyer
     *
     * * `credit_note` - Credit Note
     * * `debit_note` - Debit Note
     */
    type: OrderAdjustmentTypeEnum;
    status: OrderAdjustmentStatusEnum;
    /** Pre-tax adjustment amount in cents */
    base_amount: number;
    /** Tax amount in cents */
    tax_amount: number;
    /** Total in cents (base_amount + tax_amount); always positive — type indicates direction */
    total_amount: number;
    currency: AvailableCurrenciesEnum;
    /**
     * Derived from originating_order at create time
     *
     * * `stripe` - Stripe
     * * `two` - Two
     * * `direct` - Direct
     */
    payment_provider: PaymentProviderEnum;
    /** MoR-entered reason for the adjustment (internal/audit). Required for source=MANUAL; null for WEBHOOK / BACKFILL rows. */
    reason: string | null;
    /** @format uuid */
    originating_order_uuid: string;
    originating_order_number: string;
    /** @format uuid */
    applied_to_order_uuid: string;
    applied_to_order_number: string;
    /** Provider invoice ID at apply time (snapshotted) */
    applied_to_invoice_id: string | null;
    /** @format uuid */
    supplier_company_uuid: string;
    /** @format uuid */
    buyer_company_uuid: string;
    /** @format uuid */
    merchant_of_record_company_uuid: string;
    /** @format uri */
    supplier_document_url: string;
    /** Provider artefact ID created on apply. For CREDIT_NOTE: Stripe credit note id or Two credit note ref. For DEBIT_NOTE: Stripe new invoice id or Two new invoice ref. */
    provider_document_id: string | null;
    /** Cached PDF URL from the provider; refresh via API as needed */
    provider_document_pdf_url: string | null;
    /** @format date-time */
    pending_application_at: string | null;
    /** @format date-time */
    applied_at: string | null;
    /** @format date-time */
    voided_at: string | null;
    /** @format date-time */
    created_at: string;
    /** @format date-time */
    modified_at: string;
}

/** Lightweight read serializer for the apply-picker list endpoint. */
export interface OrderAdjustmentList {
    /** @format uuid */
    uuid: string;
    /**
     * CREDIT_NOTE reduces the buyer's amount due; DEBIT_NOTE adds an additional charge to the buyer
     *
     * * `credit_note` - Credit Note
     * * `debit_note` - Debit Note
     */
    type: OrderAdjustmentTypeEnum;
    status: OrderAdjustmentStatusEnum;
    /** Pre-tax adjustment amount in cents */
    base_amount: number;
    /** Tax amount in cents */
    tax_amount: number;
    /** Total in cents (base_amount + tax_amount); always positive — type indicates direction */
    total_amount: number;
    currency: AvailableCurrenciesEnum;
    /**
     * Derived from originating_order at create time
     *
     * * `stripe` - Stripe
     * * `two` - Two
     * * `direct` - Direct
     */
    payment_provider: PaymentProviderEnum;
    /** MoR-entered reason for the adjustment (internal/audit). Required for source=MANUAL; null for WEBHOOK / BACKFILL rows. */
    reason: string | null;
    /** @format uuid */
    originating_order_uuid: string;
    originating_order_number: string;
    /** @format uuid */
    applied_to_order_uuid: string;
    applied_to_order_number: string;
    /** @format date-time */
    created_at: string;
}

/**
 * * `available` - Available
 * * `pending_application` - Pending Application
 * * `applied` - Applied
 * * `void` - Void
 */
export enum OrderAdjustmentStatusEnum {
    Available = "available",
    PendingApplication = "pending_application",
    Applied = "applied",
    Void = "void",
}

/**
 * * `credit_note` - Credit Note
 * * `debit_note` - Debit Note
 */
export enum OrderAdjustmentTypeEnum {
    CreditNote = "credit_note",
    DebitNote = "debit_note",
}

/** * `regular` - Regular */
export enum OrderCategory {
    Regular = "regular",
}

export interface OrderConfirmDelivered {
    /** @format uuid */
    quote_uuid: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
     */
    delivered_quantity: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
     */
    converted_quantity?: string | null;
    unit_of_measurement?: UnitOfMeasurementEnum | NullEnum | null;
}

export interface OrderConfirmDispatched {
    tracking_code?: string | null;
    /** @format date */
    dispatch_confirmation_date: string;
    /** @format date */
    expected_delivery_date: string;
    shipping_provider: string;
}

export interface OrderCreateSwagger {
    quotes: string[];
}

export interface OrderDetail {
    /** @format uuid */
    uuid: string;
    /** @format date-time */
    created: string;
    /** * `regular` - Regular */
    category?: OrderCategory;
    /**
     * * `checkout` - Checkout
     * * `confirmed` - confirmed
     * * `pending_payment` - pending_payment
     * * `canceled` - canceled
     * * `awaiting_approval` - awaiting_approval
     * * `on_hold` - on_hold
     * * `placed` - placed
     * * `dispatched` - dispatched
     * * `completed` - completed
     */
    state?: OrderState;
    payment_status?: PaymentStatusEnum | BlankEnum | NullEnum | null;
    kriya_status?: KriyaStatusEnum | BlankEnum | NullEnum | null;
    /**
     * if this is not None, then during payment was chosen not default currency and this field should be passed to the payment as selected_currency
     *
     * * `EUR` - EUR
     * * `USD` - USD
     * * `GBP` - GBP
     * * `CAD` - CAD
     */
    payment_currency?: Currencies | BlankEnum | NullEnum | null;
    /** @format date-time */
    payment_due_date?: string | null;
    /** @format date-time */
    kriya_payment_due_date?: string | null;
    payment_method?: PaymentMethod | NullEnum | null;
    payment_scenario: string;
    /**
     * * `pending_dispatch` - pending_dispatch
     * * `dispatched` - Dispatched
     * * `delivered` - Delivered
     */
    shipment_status?: ShipmentStatusEnum;
    /** @format date */
    dispatch_confirmation_date: string | null;
    /** @format date */
    delivery_confirmation_date?: string | null;
    is_new: boolean;
    order_number: string;
    number_of_quotes_ordered: number;
    total_price: number;
    total_price_currency: string;
    /** @format date */
    delivery_date: string;
    shipping_price: number;
    shipping_cost_no_vat: number;
    sum_to_pay: number;
    /** @format date */
    latest_delivery_date: string | null;
    discount_amount: number;
    sum_to_pay_no_discount: number;
    quotes_prices: PricesRetrieve[];
    vat_sum: number;
    sum_payout: number;
    /** @format date */
    order_date?: string | null;
    payment_delay: number | null;
    has_pending_purchase_request: boolean;
    is_recurring: boolean;
    /** @format uuid */
    related_contract_uuid: string;
    /** @format uuid */
    purchase_quote_uuid: string;
    /** @format date-time */
    state_updated: string;
    tracking_code?: string | null;
    selected_currency: string;
    virtual_bank_account: VirtualBankTransfer | null;
    quotes: QuoteOrderDetail[];
    delivery_address: DeliveryAddressResponse;
    terms?: string | null;
    /** @format date */
    expected_delivery_date?: string | null;
    /** @maxLength 255 */
    shipping_provider?: string | null;
    delivery_contact: string;
    delivery_contact_number: string;
    /** @format uuid */
    contract_uuid: string;
    bank_transfer_details: BankTransfer;
}

export interface OrderDetailAdmin {
    /** @format uuid */
    uuid: string;
    order_number: string;
    /** @format date-time */
    created: string;
    buyer_name: string;
    supplier_name: string;
    /**
     * * `pending_dispatch` - pending_dispatch
     * * `dispatched` - Dispatched
     * * `delivered` - Delivered
     */
    shipment_status?: ShipmentStatusEnum;
    /** * `regular` - Regular */
    category?: OrderCategory;
    /**
     * * `checkout` - Checkout
     * * `confirmed` - confirmed
     * * `pending_payment` - pending_payment
     * * `canceled` - canceled
     * * `awaiting_approval` - awaiting_approval
     * * `on_hold` - on_hold
     * * `placed` - placed
     * * `dispatched` - dispatched
     * * `completed` - completed
     */
    state?: OrderState;
    payment_status?: PaymentStatusEnum | BlankEnum | NullEnum | null;
    kriya_status?: KriyaStatusEnum | BlankEnum | NullEnum | null;
    /** @format date-time */
    kriya_payment_due_date?: string | null;
    /** @format date-time */
    payment_due_date?: string | null;
    payment_method?: PaymentMethod | NullEnum | null;
    /** @format date */
    confirmation_date?: string | null;
    quotes: QuoteOrderDetail[];
    created_by: string;
    payment_currency: string;
    tracking_code?: string | null;
    prices: OrderPrices;
    /**
     * holds the date when payment was received, use get_paid_date to get the value
     * @format date-time
     */
    paid_date: string | null;
    is_order_paid_out?: boolean;
    /** @format date */
    payout_date?: string | null;
}

export interface OrderDispute {
    /** @format uuid */
    uuid: string;
    /** @format date-time */
    created: string;
    reasons_for_dispute: string;
}

export interface OrderDisputeRequest {
    /** @format uuid */
    uuid: string;
    reasons_for_dispute: string;
    /** @format uri */
    documents: string;
}

export interface OrderDocument {
    /** @format uuid */
    uuid: string;
    /** @format uri */
    document: string;
    category: OrderDocumentCategory;
}

/**
 * * `uploaded_by_admin` - Uploaded By Admin
 * * `uploaded_by_supplier` - Uploaded By Supplier
 */
export enum OrderDocumentCategory {
    UploadedByAdmin = "uploaded_by_admin",
    UploadedBySupplier = "uploaded_by_supplier",
}

export interface OrderEventAdmin {
    id: number;
    /** @format date-time */
    created: string;
    /** @format uuid */
    uuid: string;
    order: number;
    text?: string | null;
    /**
     * * `mark_order_as_paid_out` - mark_order_as_paid_out
     * * `mark_as_paid` - mark_as_paid
     * * `comment` - comment
     */
    event_type?: OrderEventTypeEnum;
    user: User;
}

export interface OrderEventMarkAsPaidAdmin {
    id: number;
    /** @format date-time */
    created: string;
    /** @format uuid */
    uuid: string;
    order: number;
    text?: string | null;
    event_type: OrderEventTypeEnum;
    user: User;
}

/**
 * * `mark_order_as_paid_out` - mark_order_as_paid_out
 * * `mark_as_paid` - mark_as_paid
 * * `comment` - comment
 */
export enum OrderEventTypeEnum {
    MarkOrderAsPaidOut = "mark_order_as_paid_out",
    MarkAsPaid = "mark_as_paid",
    Comment = "comment",
}

/**
 * * `weekly` - Weekly
 * * `monthly` - Monthly
 * * `quarterly` - Quarterly
 * * `annually` - Annually
 */
export enum OrderFrequencyEnum {
    Weekly = "weekly",
    Monthly = "monthly",
    Quarterly = "quarterly",
    Annually = "annually",
}

/** Serializer for creating an order hold. */
export interface OrderHoldCreate {
    /** @default "" */
    public_notes?: string;
    /**
     * * `supplier_delay` - Supplier delay
     * * `volume_confirmation` - Volume confirmation
     * * `credit_review` - Credit review
     * * `documents_required` - Documents required
     * * `fraud_review` - Fraud review
     * * `forecasting` - Forecasting
     * * `overdue_payments` - Overdue payments
     * * `other` - Other
     */
    internal_reason: InternalReasonEnum;
    /** @default "" */
    internal_notes?: string;
}

/** Serializer for displaying hold details on an order. */
export interface OrderHoldDetails {
    /** @format uuid */
    uuid: string;
    /** @format date-time */
    held_at: string;
    held_by: ShortUser;
    hold_public_notes?: string;
    /**
     * * `supplier_delay` - Supplier delay
     * * `volume_confirmation` - Volume confirmation
     * * `credit_review` - Credit review
     * * `documents_required` - Documents required
     * * `fraud_review` - Fraud review
     * * `forecasting` - Forecasting
     * * `overdue_payments` - Overdue payments
     * * `other` - Other
     */
    hold_internal_reason: HoldInternalReasonEnum;
    hold_internal_notes?: string;
}

export interface OrderLineItemDocument {
    /** @format uuid */
    uuid: string;
    /** @format uri */
    document: string;
    /**
     * * `spec_sheet` - Spec Sheet
     * * `certificate_of_analysis` - Certificate of Analysis
     * * `british_retail_consortium` - British Retail Consortium
     * * `international_organisation_for_standardisation` - International Organisation for Standardisation
     * * `foundation_food_safety_system_certification` - Foundation Food Safety System Certification
     * * `international_featured_standards` - International Featured Standards
     * * `safe_quality_food` - Safe Quality Food
     */
    category: CatalogItemDocumentCategoryEnum;
}

export interface OrderLineItemDocumentUpload {
    file_name: string;
    /**
     * * `spec_sheet` - Spec Sheet
     * * `certificate_of_analysis` - Certificate of Analysis
     * * `british_retail_consortium` - British Retail Consortium
     * * `international_organisation_for_standardisation` - International Organisation for Standardisation
     * * `foundation_food_safety_system_certification` - Foundation Food Safety System Certification
     * * `international_featured_standards` - International Featured Standards
     * * `safe_quality_food` - Safe Quality Food
     */
    category: CatalogItemDocumentCategoryEnum;
}

export interface OrderLineItemOtifData {
    /** @format uuid */
    uuid: string;
    /** @format uuid */
    line_item_uuid: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,9}(?:\.\d{0,3})?$
     */
    quantity_supplied?: string | null;
    /**
     * @format decimal
     * @pattern ^-?\d{0,9}(?:\.\d{0,3})?$
     */
    quality_issues?: string | null;
    /** @format date */
    expected_delivery?: string | null;
    /** @format date */
    actual_delivery?: string | null;
    quality_issue_type?: QualityIssueTypeEnum[];
    delivery_issue_type: OtifDataDeliveryIssueType[];
    delivery_issue_type_uuids?: string[];
    /** @maxLength 1024 */
    notes?: string;
    /** @format date-time */
    created_at: string;
    /** @format date-time */
    modified_at: string;
}

/** Serializer for editing OTIF data within line item updates. */
export interface OrderLineItemOtifDataEdit {
    /**
     * @format decimal
     * @pattern ^-?\d{0,9}(?:\.\d{0,3})?$
     */
    quantity_supplied?: string | null;
    /**
     * @format decimal
     * @pattern ^-?\d{0,9}(?:\.\d{0,3})?$
     */
    quality_issues?: string | null;
    /** @format date */
    expected_delivery?: string | null;
    /** @format date */
    actual_delivery?: string | null;
    quality_issue_type?: QualityIssueTypeEnum[];
    delivery_issue_type_uuids?: string[];
    /** @maxLength 1024 */
    notes?: string;
}

/** Nested serializer for reading OTIF data within line items. */
export interface OrderLineItemOtifDataNested {
    /** @format uuid */
    uuid: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,9}(?:\.\d{0,3})?$
     */
    quantity_supplied: string | null;
    /**
     * @format decimal
     * @pattern ^-?\d{0,9}(?:\.\d{0,3})?$
     */
    quality_issues: string | null;
    /** @format date */
    expected_delivery: string | null;
    /** @format date */
    actual_delivery: string | null;
    quality_issue_type: string[];
    delivery_issue_type: OtifDataDeliveryIssueTypeNested[];
    notes: string;
}

export interface OrderLineItemSourceCreate {
    /** @format uuid */
    order_line_item_uuid: string;
    /** @format uuid */
    traded_item_uuid: string;
}

export interface OrderLineItemSourceDetail {
    /** @format uuid */
    uuid: string;
    /** @format uuid */
    order_line_item_uuid: string;
    /** @format uuid */
    traded_item_uuid: string | null;
    traded_item_name: string | null;
    /** @format uuid */
    linked_by_uuid: string | null;
    /** @format date-time */
    created_at: string;
    /** @format date-time */
    modified_at: string;
}

export interface OrderListAdmin {
    /** @format uuid */
    uuid: string;
    order_number: string;
    /** @format date-time */
    created: string;
    buyer_name: string;
    supplier_name: string;
    /**
     * * `pending_dispatch` - pending_dispatch
     * * `dispatched` - Dispatched
     * * `delivered` - Delivered
     */
    shipment_status?: ShipmentStatusEnum;
    /** * `regular` - Regular */
    category?: OrderCategory;
    /**
     * * `checkout` - Checkout
     * * `confirmed` - confirmed
     * * `pending_payment` - pending_payment
     * * `canceled` - canceled
     * * `awaiting_approval` - awaiting_approval
     * * `on_hold` - on_hold
     * * `placed` - placed
     * * `dispatched` - dispatched
     * * `completed` - completed
     */
    state?: OrderState;
    payment_status?: PaymentStatusEnum | BlankEnum | NullEnum | null;
    kriya_status?: KriyaStatusEnum | BlankEnum | NullEnum | null;
    /** @format date-time */
    kriya_payment_due_date?: string | null;
    /** @format date-time */
    payment_due_date?: string | null;
    payment_method?: PaymentMethod | NullEnum | null;
    /** @format date */
    confirmation_date?: string | null;
}

export interface OrderManagementContractCreate {
    /** @format uuid */
    buyer: string;
    /**
     * * `EUR` - EUR
     * * `GBP` - GBP
     * * `USD` - USD
     */
    currency?: AvailableCurrenciesEnum;
    /** @format date */
    start_date: string;
    /** @format date */
    signed_date: string;
    /** @min 1 */
    period_in_months: number;
    /** @min 0 */
    total_contract_value: number;
    /**
     * @format decimal
     * @pattern ^-?\d{0,1}(?:\.\d{0,4})?$
     */
    service_fee_percentage?: string;
    service_fees?: OrderManagementContractServiceFeeCreate[];
}

export interface OrderManagementContractDetail {
    /** @format uuid */
    uuid: string;
    contract_number: string;
    buyer: CompanyNameAndId;
    merchant_of_record_company: CompanyNameAndId;
    /**
     * * `EUR` - EUR
     * * `GBP` - GBP
     * * `USD` - USD
     */
    currency?: AvailableCurrenciesEnum;
    /** @format date */
    start_date: string;
    /** @format date */
    signed_date: string;
    /**
     * @min 1
     * @max 2147483647
     */
    period_in_months: number;
    /**
     * Total contract value in micro-units (1 GBP = 1,000,000)
     * @format int64
     * @min 0
     * @max 9223372036854776000
     */
    total_contract_value: number;
    /**
     * @format decimal
     * @pattern ^-?\d{0,1}(?:\.\d{0,4})?$
     */
    service_fee_percentage?: string;
    service_fees: OrderManagementContractServiceFee[];
    /** @format date */
    end_date: string;
    orders: Record<string, any>;
    agreements: Record<string, any>;
    /** @format date-time */
    created_at: string;
    /** @format date-time */
    modified_at: string;
}

export interface OrderManagementContractList {
    /** @format uuid */
    uuid: string;
    contract_number: string;
    buyer: CompanyNameAndId;
    /**
     * * `EUR` - EUR
     * * `GBP` - GBP
     * * `USD` - USD
     */
    currency?: AvailableCurrenciesEnum;
    /** @format date */
    start_date: string;
    /** @format date */
    signed_date: string;
    /**
     * @min 1
     * @max 2147483647
     */
    period_in_months: number;
    /**
     * Total contract value in micro-units (1 GBP = 1,000,000)
     * @format int64
     * @min 0
     * @max 9223372036854776000
     */
    total_contract_value: number;
    /**
     * @format decimal
     * @pattern ^-?\d{0,1}(?:\.\d{0,4})?$
     */
    service_fee_percentage?: string;
    service_fees: OrderManagementContractServiceFee[];
    /** @format date */
    end_date: string;
    /** @format date-time */
    created_at: string;
    /** @format date-time */
    modified_at: string;
}

/** Read serializer for service fees - includes uuid for identification */
export interface OrderManagementContractServiceFee {
    /** @format uuid */
    uuid: string;
    /**
     * * `order_management_only` - Order Management Only
     * * `order_management_with_payment_support` - Order Management with Payment Support
     */
    service_fee_type?: ServiceFeeTypeEnum;
    /**
     * @format decimal
     * @pattern ^-?\d{0,1}(?:\.\d{0,4})?$
     */
    service_fee_percentage?: string;
}

/** Write serializer for service fees - no uuid needed on create/update */
export interface OrderManagementContractServiceFeeCreate {
    /**
     * * `order_management_only` - Order Management Only
     * * `order_management_with_payment_support` - Order Management with Payment Support
     */
    service_fee_type: ServiceFeeTypeEnum;
    /**
     * @format decimal
     * @pattern ^-?\d{0,1}(?:\.\d{0,4})?$
     */
    service_fee_percentage: string;
}

export interface OrderManagementContractUpdate {
    /**
     * * `EUR` - EUR
     * * `GBP` - GBP
     * * `USD` - USD
     */
    currency?: AvailableCurrenciesEnum;
    /** @format date */
    start_date: string;
    /** @format date */
    signed_date: string;
    /** @min 1 */
    period_in_months?: number;
    /** @min 0 */
    total_contract_value?: number;
    /**
     * @format decimal
     * @pattern ^-?\d{0,1}(?:\.\d{0,4})?$
     */
    service_fee_percentage?: string;
    service_fees?: OrderManagementContractServiceFeeCreate[];
}

/** Serializer for orders on hold alert list. */
export interface OrderOnHoldAlert {
    /** @format uuid */
    uuid: string;
    order_number: string;
    /** @format date */
    delivery_date: string;
    /**
     * * `initializing` - Initializing
     * * `confirmed` - Confirmed
     * * `canceled` - Cancelled
     * * `pending_merchant_of_record_approval` - Pending Merchant of Record Approval
     * * `order_received` - Order Received
     * * `order_sent_to_supplier` - Order Sent To Supplier
     * * `order_confirming_price` - Order Confirming Price
     * * `forecasted` - Forecasted
     */
    lifecycle_state?: LifecycleStateEnum;
    /**
     * * `initializing` - Initializing
     * * `not_started` - Not Started
     * * `pending_dispatch` - Pending Dispatch
     * * `in_transit` - In Transit
     * * `delivered` - Delivered
     * * `freight_ownership_pending` - Freight Ownership Pending
     * * `gathering_quotes` - Gathering Quotes
     * * `dispatch_scheduled` - Dispatch Scheduled
     * * `awaiting_collection_details` - Awaiting Collection Details
     * * `ready_for_pickup` - Ready for Pickup
     * * `picked_up` - Picked Up
     * * `preparing_freight` - Preparing Freight
     * * `freight_scheduled` - Freight Scheduled
     * * `gathering_freight_quotes` - Gathering Freight Quotes
     * * `quotes_confirmed` - Quotes Confirmed
     */
    delivery_state?: DeliveryStateEnum;
    company_ordered_by: CompanyNameAndId;
    company_ordered_from: CompanyNameAndId;
    /** Serializer for displaying hold details on an order. */
    hold_details: OrderHoldDetails;
}

export interface OrderPrices {
    /**
     * @format decimal
     * @pattern ^-?\d{0,13}(?:\.\d{0,2})?$
     */
    commission_payout_with_vat: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,13}(?:\.\d{0,2})?$
     */
    shipping_cost_with_vat: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,13}(?:\.\d{0,2})?$
     */
    sum_to_pay: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,13}(?:\.\d{0,2})?$
     */
    sum_payout: string;
    quotes: PricesRetrieve[];
    /**
     * * `CNH` - CNH
     * * `NIC` - NIC
     * * `BOV` - BOV
     * * `GIP` - GIP
     * * `ZAL` - ZAL
     * * `ILR` - ILR
     * * `LRD` - LRD
     * * `YUD` - YUD
     * * `BRR` - BRR
     * * `SUR` - SUR
     * * `NLG` - NLG
     * * `CLP` - CLP
     * * `EEK` - EEK
     * * `XPT` - XPT
     * * `MZE` - MZE
     * * `IQD` - IQD
     * * `XBA` - XBA
     * * `TWD` - TWD
     * * `VEF` - VEF
     * * `DOP` - DOP
     * * `UGX` - UGX
     * * `LUF` - LUF
     * * `FJD` - FJD
     * * `BOP` - BOP
     * * `BAM` - BAM
     * * `VND` - VND
     * * `BEL` - BEL
     * * `EGP` - EGP
     * * `MVP` - MVP
     * * `YUR` - YUR
     * * `BND` - BND
     * * `SSP` - SSP
     * * `UYU` - UYU
     * * `KRW` - KRW
     * * `BOB` - BOB
     * * `TJR` - TJR
     * * `USN` - USN
     * * `GQE` - GQE
     * * `ZRZ` - ZRZ
     * * `GBP` - GBP
     * * `VEB` - VEB
     * * `MGF` - MGF
     * * `LSL` - LSL
     * * `BOL` - BOL
     * * `JPY` - JPY
     * * `SDD` - SDD
     * * `BEF` - BEF
     * * `YUM` - YUM
     * * `GNS` - GNS
     * * `ROL` - ROL
     * * `BIF` - BIF
     * * `DKK` - DKK
     * * `MAF` - MAF
     * * `RSD` - RSD
     * * `OMR` - OMR
     * * `NAD` - NAD
     * * `TMM` - TMM
     * * `BEC` - BEC
     * * `ECS` - ECS
     * * `BRE` - BRE
     * * `KZT` - KZT
     * * `SOS` - SOS
     * * `ZWR` - ZWR
     * * `VUV` - VUV
     * * `VED` - VED
     * * `IEP` - IEP
     * * `ESA` - ESA
     * * `KGS` - KGS
     * * `RON` - RON
     * * `RUR` - RUR
     * * `SLL` - SLL
     * * `XFO` - XFO
     * * `KMF` - KMF
     * * `SDP` - SDP
     * * `BGN` - BGN
     * * `ZWD` - ZWD
     * * `MXN` - MXN
     * * `HNL` - HNL
     * * `AON` - AON
     * * `ZMW` - ZMW
     * * `LTL` - LTL
     * * `LUC` - LUC
     * * `VNN` - VNN
     * * `CLF` - CLF
     * * `BAD` - BAD
     * * `PLZ` - PLZ
     * * `ZWL` - ZWL
     * * `AZM` - AZM
     * * `IRR` - IRR
     * * `ISK` - ISK
     * * `CLE` - CLE
     * * `CRC` - CRC
     * * `JMD` - JMD
     * * `RUB` - RUB
     * * `JOD` - JOD
     * * `ETB` - ETB
     * * `UAK` - UAK
     * * `CDF` - CDF
     * * `CHF` - CHF
     * * `ESB` - ESB
     * * `KRO` - KRO
     * * `MZN` - MZN
     * * `BMD` - BMD
     * * `XRE` - XRE
     * * `BWP` - BWP
     * * `NZD` - NZD
     * * `CSD` - CSD
     * * `BUK` - BUK
     * * `ERN` - ERN
     * * `MWK` - MWK
     * * `XDR` - XDR
     * * `GWE` - GWE
     * * `LYD` - LYD
     * * `DDM` - DDM
     * * `XFU` - XFU
     * * `KWD` - KWD
     * * `TTD` - TTD
     * * `PGK` - PGK
     * * `XAG` - XAG
     * * `AZN` - AZN
     * * `NGN` - NGN
     * * `ANG` - ANG
     * * `BGM` - BGM
     * * `MVR` - MVR
     * * `TPE` - TPE
     * * `TZS` - TZS
     * * `CUP` - CUP
     * * `SEK` - SEK
     * * `AED` - AED
     * * `XEU` - XEU
     * * `BYB` - BYB
     * * `MNT` - MNT
     * * `SGD` - SGD
     * * `LAK` - LAK
     * * `ZWG` - ZWG
     * * `SDG` - SDG
     * * `SCR` - SCR
     * * `XAU` - XAU
     * * `THB` - THB
     * * `ARL` - ARL
     * * `XBC` - XBC
     * * `COP` - COP
     * * `MAD` - MAD
     * * `FIM` - FIM
     * * `NPR` - NPR
     * * `GWP` - GWP
     * * `XBB` - XBB
     * * `MTL` - MTL
     * * `EUR` - EUR
     * * `ZRN` - ZRN
     * * `CHW` - CHW
     * * `TRL` - TRL
     * * `GHS` - GHS
     * * `SKK` - SKK
     * * `PYG` - PYG
     * * `XOF` - XOF
     * * `BZD` - BZD
     * * `IDR` - IDR
     * * `STN` - STN
     * * `UYI` - UYI
     * * `XUA` - XUA
     * * `KPW` - KPW
     * * `USD` - USD
     * * `UYP` - UYP
     * * `XPD` - XPD
     * * `BAN` - BAN
     * * `GYD` - GYD
     * * `UGS` - UGS
     * * `CSK` - CSK
     * * `HUF` - HUF
     * * `AFA` - AFA
     * * `SRG` - SRG
     * * `CNX` - CNX
     * * `ALK` - ALK
     * * `GTQ` - GTQ
     * * `MGA` - MGA
     * * `KYD` - KYD
     * * `INR` - INR
     * * `XAF` - XAF
     * * `USS` - USS
     * * `ALL` - ALL
     * * `LKR` - LKR
     * * `XSU` - XSU
     * * `AOA` - AOA
     * * `SAR` - SAR
     * * `PKR` - PKR
     * * `XBD` - XBD
     * * `KES` - KES
     * * `SZL` - SZL
     * * `SVC` - SVC
     * * `MMK` - MMK
     * * `QAR` - QAR
     * * `TRY` - TRY
     * * `PES` - PES
     * * `BGL` - BGL
     * * `PLN` - PLN
     * * `CZK` - CZK
     * * `TND` - TND
     * * `GRD` - GRD
     * * `BYN` - BYN
     * * `MCF` - MCF
     * * `WST` - WST
     * * `VES` - VES
     * * `BTN` - BTN
     * * `PHP` - PHP
     * * `ILP` - ILP
     * * `MLF` - MLF
     * * `HRD` - HRD
     * * `MDC` - MDC
     * * `PAB` - PAB
     * * `SIT` - SIT
     * * `COU` - COU
     * * `MXV` - MXV
     * * `AWG` - AWG
     * * `SYP` - SYP
     * * `DEM` - DEM
     * * `ZMK` - ZMK
     * * `MKN` - MKN
     * * `XPF` - XPF
     * * `AMD` - AMD
     * * `CYP` - CYP
     * * `PEN` - PEN
     * * `TOP` - TOP
     * * `GEK` - GEK
     * * `FRF` - FRF
     * * `MTP` - MTP
     * * `SBD` - SBD
     * * `LVL` - LVL
     * * `MRU` - MRU
     * * `XTS` - XTS
     * * `RHD` - RHD
     * * `MKD` - MKD
     * * `MRO` - MRO
     * * `RWF` - RWF
     * * `AOR` - AOR
     * * `AOK` - AOK
     * * `ILS` - ILS
     * * `BBD` - BBD
     * * `ARP` - ARP
     * * `CVE` - CVE
     * * `LUL` - LUL
     * * `NIO` - NIO
     * * `STD` - STD
     * * `CHE` - CHE
     * * `GMD` - GMD
     * * `FKP` - FKP
     * * `MZM` - MZM
     * * `PEI` - PEI
     * * `ESP` - ESP
     * * `CAD` - CAD
     * * `MUR` - MUR
     * * `NOK` - NOK
     * * `UZS` - UZS
     * * `CUC` - CUC
     * * `MYR` - MYR
     * * `GHC` - GHC
     * * `ISJ` - ISJ
     * * `YDD` - YDD
     * * `BRC` - BRC
     * * `CNY` - CNY
     * * `PTE` - PTE
     * * `DZD` - DZD
     * * `LBP` - LBP
     * * `MOP` - MOP
     * * `DJF` - DJF
     * * `SRD` - SRD
     * * `AUD` - AUD
     * * `YUN` - YUN
     * * `BRN` - BRN
     * * `TMT` - TMT
     * * `XCG` - XCG
     * * `GNF` - GNF
     * * `UAH` - UAH
     * * `ARA` - ARA
     * * `MXP` - MXP
     * * `BRL` - BRL
     * * `AFN` - AFN
     * * `HKD` - HKD
     * * `BHD` - BHD
     * * `YER` - YER
     * * `ARM` - ARM
     * * `ARS` - ARS
     * * `SHP` - SHP
     * * `ITL` - ITL
     * * `KHR` - KHR
     * * `LVR` - LVR
     * * `SLE` - SLE
     * * `XXX` - XXX
     * * `BYR` - BYR
     * * `BRB` - BRB
     * * `ADP` - ADP
     * * `HRK` - HRK
     * * `BDT` - BDT
     * * `BSD` - BSD
     * * `ATS` - ATS
     * * `KRH` - KRH
     * * `ZAR` - ZAR
     * * `ECV` - ECV
     * * `HTG` - HTG
     * * `LTT` - LTT
     * * `MDL` - MDL
     * * `UYW` - UYW
     * * `TJS` - TJS
     * * `BGO` - BGO
     * * `GEL` - GEL
     * * `BRZ` - BRZ
     * * `XCD` - XCD
     */
    currency: AllCurrencies;
    /**
     * @format decimal
     * @pattern ^-?\d{0,13}(?:\.\d{0,2})?$
     */
    commission_payout: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,13}(?:\.\d{0,2})?$
     */
    payment_commission: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,13}(?:\.\d{0,2})?$
     */
    total_price: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,13}(?:\.\d{0,2})?$
     */
    total_price_commission: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,13}(?:\.\d{0,2})?$
     */
    total_price_commission_vat: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,13}(?:\.\d{0,2})?$
     */
    total_price_fx_fee: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,13}(?:\.\d{0,2})?$
     */
    commission_payout_vat: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,13}(?:\.\d{0,2})?$
     */
    buyer_total_price_sum_to_pay_without_fx: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,13}(?:\.\d{0,2})?$
     */
    total_price_with_commission_with_vat: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,13}(?:\.\d{0,2})?$
     */
    discount_amount?: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,13}(?:\.\d{0,2})?$
     */
    sum_to_pay_no_discount?: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,13}(?:\.\d{0,2})?$
     */
    unit_price_with_commission_with_vat?: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,13}(?:\.\d{0,2})?$
     */
    unit_price_no_vat_with_shipping?: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,13}(?:\.\d{0,2})?$
     */
    total_price_no_vat_with_shipping?: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,13}(?:\.\d{0,2})?$
     */
    unit_price_no_vat?: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,13}(?:\.\d{0,2})?$
     */
    total_price_no_vat?: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,13}(?:\.\d{0,2})?$
     */
    shipping_cost_no_vat?: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,13}(?:\.\d{0,2})?$
     */
    vat_sum?: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,13}(?:\.\d{0,2})?$
     */
    unit_price_with_vat_with_shipping?: string;
}

/**
 * * `checkout` - Checkout
 * * `confirmed` - confirmed
 * * `pending_payment` - pending_payment
 * * `canceled` - canceled
 * * `awaiting_approval` - awaiting_approval
 * * `on_hold` - on_hold
 * * `placed` - placed
 * * `dispatched` - dispatched
 * * `completed` - completed
 */
export enum OrderState {
    Checkout = "checkout",
    Confirmed = "confirmed",
    PendingPayment = "pending_payment",
    Canceled = "canceled",
    AwaitingApproval = "awaiting_approval",
    OnHold = "on_hold",
    Placed = "placed",
    Dispatched = "dispatched",
    Completed = "completed",
}

export interface OrderUpdateAdmin {
    /** @format date */
    payout_date?: string | null;
    is_order_paid_out?: boolean;
    /** @default false */
    send_email?: boolean;
}

export interface OtifDataDeliveryIssueType {
    /** @format uuid */
    uuid: string;
    name: string;
    label: string;
}

/** Nested serializer for delivery issue types in OTIF data. */
export interface OtifDataDeliveryIssueTypeNested {
    /** @format uuid */
    uuid: string;
    name: string;
    label: string;
}

export interface OurAddress {
    /** @maxLength 64 */
    address_line_1: string;
    /** @maxLength 64 */
    address_line_2: string;
    /** @maxLength 64 */
    city: string;
    /** @maxLength 64 */
    postal_code: string;
    /** @maxLength 64 */
    country: string;
    /** @maxLength 32 */
    vat_number: string;
    /** @format email */
    email: string;
    /** @maxLength 128 */
    phone: string;
    /** @maxLength 64 */
    company_number: string;
}

export interface OutstandingPayment {
    type: string;
    identifier: string;
    reference_number: string;
    provider_name: string | null;
    /** Decimal-pounds string with 2dp (legacy contract). Prefer total_cents. */
    total: string;
    /** Total in cents — preferred over the decimal string. */
    total_cents: number;
    currency: string;
    /** @format date */
    due_date: string;
    status: string;
    payment_provider: string;
    provider_uuid: string | null;
    blocking_payment: boolean;
    two_order_has_invoice: boolean;
}

export interface PDFUrl {
    /** @format uri */
    pdf_url: string;
}

export interface PaginatedAdminAppOrderDocumentList {
    /** @example 123 */
    count: number;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=4"
     */
    next?: string | null;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=2"
     */
    previous?: string | null;
    results: AdminAppOrderDocument[];
}

export interface PaginatedAdminAppOrderEventList {
    /** @example 123 */
    count: number;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=4"
     */
    next?: string | null;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=2"
     */
    previous?: string | null;
    results: AdminAppOrderEvent[];
}

export interface PaginatedAdminAppOrderListList {
    /** @example 123 */
    count: number;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=4"
     */
    next?: string | null;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=2"
     */
    previous?: string | null;
    results: AdminAppOrderList[];
}

export interface PaginatedAdminCompanyDocumentList {
    /** @example 123 */
    count: number;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=4"
     */
    next?: string | null;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=2"
     */
    previous?: string | null;
    results: AdminCompanyDocument[];
}

export interface PaginatedAdminCompanyList {
    /** @example 123 */
    count: number;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=4"
     */
    next?: string | null;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=2"
     */
    previous?: string | null;
    results: AdminCompany[];
}

export interface PaginatedAdminIngredientResponseList {
    /** @example 123 */
    count: number;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=4"
     */
    next?: string | null;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=2"
     */
    previous?: string | null;
    results: AdminIngredientResponse[];
}

export interface PaginatedAdminMessagesResponseList {
    /** @example 123 */
    count: number;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=4"
     */
    next?: string | null;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=2"
     */
    previous?: string | null;
    results: AdminMessagesResponse[];
}

export interface PaginatedAgentActivityList {
    /** @example 123 */
    count: number;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=4"
     */
    next?: string | null;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=2"
     */
    previous?: string | null;
    results: AgentActivity[];
}

export interface PaginatedAgentFeedbackList {
    /** @example 123 */
    count: number;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=4"
     */
    next?: string | null;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=2"
     */
    previous?: string | null;
    results: AgentFeedback[];
}

export interface PaginatedAlertsList {
    /** @example 123 */
    count: number;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=4"
     */
    next?: string | null;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=2"
     */
    previous?: string | null;
    results: Alerts[];
}

export interface PaginatedBrandBuyerItemListList {
    /** @example 123 */
    count: number;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=4"
     */
    next?: string | null;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=2"
     */
    previous?: string | null;
    results: BrandBuyerItemList[];
}

export interface PaginatedBrandUserList {
    /** @example 123 */
    count: number;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=4"
     */
    next?: string | null;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=2"
     */
    previous?: string | null;
    results: BrandUser[];
}

export interface PaginatedBuyerAgreementListList {
    /** @example 123 */
    count: number;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=4"
     */
    next?: string | null;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=2"
     */
    previous?: string | null;
    results: BuyerAgreementList[];
}

export interface PaginatedBuyerAppOrderListList {
    /** @example 123 */
    count: number;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=4"
     */
    next?: string | null;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=2"
     */
    previous?: string | null;
    results: BuyerAppOrderList[];
}

export interface PaginatedBuyerAppOrderListSuppliersList {
    /** @example 123 */
    count: number;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=4"
     */
    next?: string | null;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=2"
     */
    previous?: string | null;
    results: BuyerAppOrderListSuppliers[];
}

export interface PaginatedBuyerBalanceList {
    /** @example 123 */
    count: number;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=4"
     */
    next?: string | null;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=2"
     */
    previous?: string | null;
    results: BuyerBalance[];
}

export interface PaginatedBuyerDocumentList {
    /** @example 123 */
    count: number;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=4"
     */
    next?: string | null;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=2"
     */
    previous?: string | null;
    results: BuyerDocument[];
}

export interface PaginatedBuyerFinancialDocumentList {
    /** @example 123 */
    count: number;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=4"
     */
    next?: string | null;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=2"
     */
    previous?: string | null;
    results: BuyerFinancialDocument[];
}

export interface PaginatedBuyerGroupedStatementListList {
    /** @example 123 */
    count: number;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=4"
     */
    next?: string | null;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=2"
     */
    previous?: string | null;
    results: BuyerGroupedStatementList[];
}

export interface PaginatedBuyerItemDocumentList {
    /** @example 123 */
    count: number;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=4"
     */
    next?: string | null;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=2"
     */
    previous?: string | null;
    results: BuyerItemDocument[];
}

export interface PaginatedBuyerItemListList {
    /** @example 123 */
    count: number;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=4"
     */
    next?: string | null;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=2"
     */
    previous?: string | null;
    results: BuyerItemList[];
}

export interface PaginatedBuyerOnboardingDeliveryAddressList {
    /** @example 123 */
    count: number;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=4"
     */
    next?: string | null;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=2"
     */
    previous?: string | null;
    results: BuyerOnboardingDeliveryAddress[];
}

export interface PaginatedBuyerOnboardingDocumentList {
    /** @example 123 */
    count: number;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=4"
     */
    next?: string | null;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=2"
     */
    previous?: string | null;
    results: BuyerOnboardingDocument[];
}

export interface PaginatedBuyerOnboardingListList {
    /** @example 123 */
    count: number;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=4"
     */
    next?: string | null;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=2"
     */
    previous?: string | null;
    results: BuyerOnboardingList[];
}

export interface PaginatedBuyerOnboardingStepList {
    /** @example 123 */
    count: number;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=4"
     */
    next?: string | null;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=2"
     */
    previous?: string | null;
    results: BuyerOnboardingStep[];
}

export interface PaginatedBuyerOrderActivityList {
    /** @example 123 */
    count: number;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=4"
     */
    next?: string | null;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=2"
     */
    previous?: string | null;
    results: BuyerOrderActivity[];
}

export interface PaginatedBuyerOrderActivityWithOrderList {
    /** @example 123 */
    count: number;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=4"
     */
    next?: string | null;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=2"
     */
    previous?: string | null;
    results: BuyerOrderActivityWithOrder[];
}

export interface PaginatedBuyerSpotBuyRequestListList {
    /** @example 123 */
    count: number;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=4"
     */
    next?: string | null;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=2"
     */
    previous?: string | null;
    results: BuyerSpotBuyRequestList[];
}

export interface PaginatedBuyerSupplierList {
    /** @example 123 */
    count: number;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=4"
     */
    next?: string | null;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=2"
     */
    previous?: string | null;
    results: BuyerSupplier[];
}

export interface PaginatedChannelExpandedList {
    /** @example 123 */
    count: number;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=4"
     */
    next?: string | null;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=2"
     */
    previous?: string | null;
    results: ChannelExpanded[];
}

export interface PaginatedChannelList {
    /** @example 123 */
    count: number;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=4"
     */
    next?: string | null;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=2"
     */
    previous?: string | null;
    results: Channel[];
    /** @example 123 */
    unread_count?: number;
}

export interface PaginatedCompanyAddressList {
    /** @example 123 */
    count: number;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=4"
     */
    next?: string | null;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=2"
     */
    previous?: string | null;
    results: CompanyAddress[];
}

export interface PaginatedCompanyDocumentList {
    /** @example 123 */
    count: number;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=4"
     */
    next?: string | null;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=2"
     */
    previous?: string | null;
    results: CompanyDocument[];
}

export interface PaginatedCompanyList {
    /** @example 123 */
    count: number;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=4"
     */
    next?: string | null;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=2"
     */
    previous?: string | null;
    results: Company[];
}

export interface PaginatedCompanyMembersListList {
    /** @example 123 */
    count: number;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=4"
     */
    next?: string | null;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=2"
     */
    previous?: string | null;
    results: CompanyMembersList[];
}

export interface PaginatedCompanyNotificationOverrideList {
    /** @example 123 */
    count: number;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=4"
     */
    next?: string | null;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=2"
     */
    previous?: string | null;
    results: CompanyNotificationOverride[];
}

export interface PaginatedCompanyUserAdminList {
    /** @example 123 */
    count: number;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=4"
     */
    next?: string | null;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=2"
     */
    previous?: string | null;
    results: CompanyUserAdmin[];
}

export interface PaginatedContractRenewNegotiationList {
    /** @example 123 */
    count: number;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=4"
     */
    next?: string | null;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=2"
     */
    previous?: string | null;
    results: ContractRenewNegotiation[];
}

export interface PaginatedCortexJobList {
    /** @example 123 */
    count: number;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=4"
     */
    next?: string | null;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=2"
     */
    previous?: string | null;
    results: CortexJob[];
}

export interface PaginatedCortexWorkflowWithJobsList {
    /** @example 123 */
    count: number;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=4"
     */
    next?: string | null;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=2"
     */
    previous?: string | null;
    results: CortexWorkflowWithJobs[];
}

export interface PaginatedCrmCompanyList {
    /** @example 123 */
    count: number;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=4"
     */
    next?: string | null;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=2"
     */
    previous?: string | null;
    results: CrmCompany[];
}

export interface PaginatedCrmContactList {
    /** @example 123 */
    count: number;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=4"
     */
    next?: string | null;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=2"
     */
    previous?: string | null;
    results: CrmContact[];
}

export interface PaginatedCrmImportRunListList {
    /** @example 123 */
    count: number;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=4"
     */
    next?: string | null;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=2"
     */
    previous?: string | null;
    results: CrmImportRunList[];
}

export interface PaginatedCustomerStatusList {
    /** @example 123 */
    count: number;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=4"
     */
    next?: string | null;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=2"
     */
    previous?: string | null;
    results: CustomerStatus[];
}

export interface PaginatedDashboardContractsListList {
    /** @example 123 */
    count: number;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=4"
     */
    next?: string | null;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=2"
     */
    previous?: string | null;
    results: DashboardContractsList[];
}

export interface PaginatedDashboardInquiriesForSupplierList {
    /** @example 123 */
    count: number;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=4"
     */
    next?: string | null;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=2"
     */
    previous?: string | null;
    results: DashboardInquiriesForSupplier[];
}

export interface PaginatedDashboardInquiriesList {
    /** @example 123 */
    count: number;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=4"
     */
    next?: string | null;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=2"
     */
    previous?: string | null;
    results: DashboardInquiries[];
}

export interface PaginatedDashboardOrdersList {
    /** @example 123 */
    count: number;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=4"
     */
    next?: string | null;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=2"
     */
    previous?: string | null;
    results: DashboardOrders[];
}

export interface PaginatedDeliveryEmailList {
    /** @example 123 */
    count: number;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=4"
     */
    next?: string | null;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=2"
     */
    previous?: string | null;
    results: DeliveryEmail[];
}

export interface PaginatedEnrichmentRunListList {
    /** @example 123 */
    count: number;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=4"
     */
    next?: string | null;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=2"
     */
    previous?: string | null;
    results: EnrichmentRunList[];
}

export interface PaginatedExistingSuppliersListList {
    /** @example 123 */
    count: number;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=4"
     */
    next?: string | null;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=2"
     */
    previous?: string | null;
    results: ExistingSuppliersList[];
}

export interface PaginatedFeedItemReadList {
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?cursor=cD00ODY%3D""
     */
    next?: string | null;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?cursor=cj0xJnA9NDg3"
     */
    previous?: string | null;
    results: FeedItemRead[];
}

export interface PaginatedForecastList {
    /** @example 123 */
    count: number;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=4"
     */
    next?: string | null;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=2"
     */
    previous?: string | null;
    results: Forecast[];
}

export interface PaginatedGroupedStatementListList {
    /** @example 123 */
    count: number;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=4"
     */
    next?: string | null;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=2"
     */
    previous?: string | null;
    results: GroupedStatementList[];
}

export interface PaginatedHubSpotOwnerList {
    /** @example 123 */
    count: number;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=4"
     */
    next?: string | null;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=2"
     */
    previous?: string | null;
    results: HubSpotOwner[];
}

export interface PaginatedHubSpotPipelineList {
    /** @example 123 */
    count: number;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=4"
     */
    next?: string | null;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=2"
     */
    previous?: string | null;
    results: HubSpotPipeline[];
}

export interface PaginatedHubSpotSyncRunListList {
    /** @example 123 */
    count: number;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=4"
     */
    next?: string | null;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=2"
     */
    previous?: string | null;
    results: HubSpotSyncRunList[];
}

export interface PaginatedIngredientList {
    /** @example 123 */
    count: number;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=4"
     */
    next?: string | null;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=2"
     */
    previous?: string | null;
    results: Ingredient[];
}

export interface PaginatedInquiryAdminList {
    /** @example 123 */
    count: number;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=4"
     */
    next?: string | null;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=2"
     */
    previous?: string | null;
    results: InquiryAdmin[];
}

export interface PaginatedInquiryDocumentList {
    /** @example 123 */
    count: number;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=4"
     */
    next?: string | null;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=2"
     */
    previous?: string | null;
    results: InquiryDocument[];
}

export interface PaginatedInquiryList {
    /** @example 123 */
    count: number;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=4"
     */
    next?: string | null;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=2"
     */
    previous?: string | null;
    results: Inquiry[];
}

export interface PaginatedInquiryListList {
    /** @example 123 */
    count: number;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=4"
     */
    next?: string | null;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=2"
     */
    previous?: string | null;
    results: InquiryList[];
}

export interface PaginatedInsightReadList {
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?cursor=cD00ODY%3D""
     */
    next?: string | null;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?cursor=cj0xJnA9NDg3"
     */
    previous?: string | null;
    results: InsightRead[];
}

export interface PaginatedLeadGenerationJobList {
    /** @example 123 */
    count: number;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=4"
     */
    next?: string | null;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=2"
     */
    previous?: string | null;
    results: LeadGenerationJob[];
}

export interface PaginatedMasqueradeableUserList {
    /** @example 123 */
    count: number;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=4"
     */
    next?: string | null;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=2"
     */
    previous?: string | null;
    results: MasqueradeableUser[];
}

export interface PaginatedMcpAccessRequestList {
    /** @example 123 */
    count: number;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=4"
     */
    next?: string | null;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=2"
     */
    previous?: string | null;
    results: McpAccessRequest[];
}

export interface PaginatedMcpAuditLogList {
    /** @example 123 */
    count: number;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=4"
     */
    next?: string | null;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=2"
     */
    previous?: string | null;
    results: McpAuditLog[];
}

export interface PaginatedMcpUserAccessList {
    /** @example 123 */
    count: number;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=4"
     */
    next?: string | null;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=2"
     */
    previous?: string | null;
    results: McpUserAccess[];
}

export interface PaginatedMerchantOfRecordAgreementListList {
    /** @example 123 */
    count: number;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=4"
     */
    next?: string | null;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=2"
     */
    previous?: string | null;
    results: MerchantOfRecordAgreementList[];
}

export interface PaginatedMerchantOfRecordAppOrderDocumentList {
    /** @example 123 */
    count: number;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=4"
     */
    next?: string | null;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=2"
     */
    previous?: string | null;
    results: MerchantOfRecordAppOrderDocument[];
}

export interface PaginatedMerchantOfRecordAppOrderEventList {
    /** @example 123 */
    count: number;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=4"
     */
    next?: string | null;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=2"
     */
    previous?: string | null;
    results: MerchantOfRecordAppOrderEvent[];
}

export interface PaginatedMerchantOfRecordAppOrderListList {
    /** @example 123 */
    count: number;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=4"
     */
    next?: string | null;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=2"
     */
    previous?: string | null;
    results: MerchantOfRecordAppOrderList[];
}

export interface PaginatedMerchantOfRecordCompanyList {
    /** @example 123 */
    count: number;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=4"
     */
    next?: string | null;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=2"
     */
    previous?: string | null;
    results: MerchantOfRecordCompany[];
}

export interface PaginatedMerchantOfRecordOrderActivityFeedItemList {
    /** @example 123 */
    count: number;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=4"
     */
    next?: string | null;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=2"
     */
    previous?: string | null;
    results: MerchantOfRecordOrderActivityFeedItem[];
}

export interface PaginatedMerchantOfRecordOrderActivityList {
    /** @example 123 */
    count: number;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=4"
     */
    next?: string | null;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=2"
     */
    previous?: string | null;
    results: MerchantOfRecordOrderActivity[];
}

export interface PaginatedMerchantOfRecordSpotBuyRequestListList {
    /** @example 123 */
    count: number;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=4"
     */
    next?: string | null;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=2"
     */
    previous?: string | null;
    results: MerchantOfRecordSpotBuyRequestList[];
}

export interface PaginatedMerchantOfRecordUserListList {
    /** @example 123 */
    count: number;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=4"
     */
    next?: string | null;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=2"
     */
    previous?: string | null;
    results: MerchantOfRecordUserList[];
}

export interface PaginatedMessageList {
    /** @example 123 */
    count: number;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=4"
     */
    next?: string | null;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=2"
     */
    previous?: string | null;
    results: Message[];
    /** @example 123 */
    unread_count?: number;
}

export interface PaginatedMoRSupplierMatchCandidateList {
    /** @example 123 */
    count: number;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=4"
     */
    next?: string | null;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=2"
     */
    previous?: string | null;
    results: MoRSupplierMatchCandidate[];
}

export interface PaginatedMoRSupplierSubmissionList {
    /** @example 123 */
    count: number;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=4"
     */
    next?: string | null;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=2"
     */
    previous?: string | null;
    results: MoRSupplierSubmission[];
}

export interface PaginatedNoteList {
    /** @example 123 */
    count: number;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=4"
     */
    next?: string | null;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=2"
     */
    previous?: string | null;
    results: Note[];
}

export interface PaginatedNotificationList {
    /** @example 123 */
    count: number;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=4"
     */
    next?: string | null;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=2"
     */
    previous?: string | null;
    results: Notification[];
    /** @example 123 */
    unread_count?: number;
}

export interface PaginatedNotificationPreferenceList {
    /** @example 123 */
    count: number;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=4"
     */
    next?: string | null;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=2"
     */
    previous?: string | null;
    results: NotificationPreference[];
}

export interface PaginatedNotificationRecipientList {
    /** @example 123 */
    count: number;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=4"
     */
    next?: string | null;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=2"
     */
    previous?: string | null;
    results: NotificationRecipient[];
}

export interface PaginatedOAuthApplicationList {
    /** @example 123 */
    count: number;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=4"
     */
    next?: string | null;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=2"
     */
    previous?: string | null;
    results: OAuthApplication[];
}

export interface PaginatedOnboardingExtractionList {
    /** @example 123 */
    count: number;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=4"
     */
    next?: string | null;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=2"
     */
    previous?: string | null;
    results: OnboardingExtraction[];
}

export interface PaginatedOnboardingStepTemplateList {
    /** @example 123 */
    count: number;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=4"
     */
    next?: string | null;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=2"
     */
    previous?: string | null;
    results: OnboardingStepTemplate[];
}

export interface PaginatedOnboardingSupplierActivityList {
    /** @example 123 */
    count: number;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=4"
     */
    next?: string | null;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=2"
     */
    previous?: string | null;
    results: OnboardingSupplierActivity[];
}

export interface PaginatedOnboardingSupplierBuyerList {
    /** @example 123 */
    count: number;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=4"
     */
    next?: string | null;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=2"
     */
    previous?: string | null;
    results: OnboardingSupplierBuyer[];
}

export interface PaginatedOnboardingSupplierContactList {
    /** @example 123 */
    count: number;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=4"
     */
    next?: string | null;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=2"
     */
    previous?: string | null;
    results: OnboardingSupplierContact[];
}

export interface PaginatedOnboardingSupplierList {
    /** @example 123 */
    count: number;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=4"
     */
    next?: string | null;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=2"
     */
    previous?: string | null;
    results: OnboardingSupplier[];
}

export interface PaginatedOnboardingSupplierListList {
    /** @example 123 */
    count: number;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=4"
     */
    next?: string | null;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=2"
     */
    previous?: string | null;
    results: OnboardingSupplierList[];
}

export interface PaginatedOpplyDocumentBuyerList {
    /** @example 123 */
    count: number;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=4"
     */
    next?: string | null;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=2"
     */
    previous?: string | null;
    results: OpplyDocumentBuyer[];
}

export interface PaginatedOpplyDocumentList {
    /** @example 123 */
    count: number;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=4"
     */
    next?: string | null;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=2"
     */
    previous?: string | null;
    results: OpplyDocument[];
}

export interface PaginatedOrderAdjustmentListList {
    /** @example 123 */
    count: number;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=4"
     */
    next?: string | null;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=2"
     */
    previous?: string | null;
    results: OrderAdjustmentList[];
}

export interface PaginatedOrderDisputeList {
    /** @example 123 */
    count: number;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=4"
     */
    next?: string | null;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=2"
     */
    previous?: string | null;
    results: OrderDispute[];
}

export interface PaginatedOrderDocumentList {
    /** @example 123 */
    count: number;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=4"
     */
    next?: string | null;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=2"
     */
    previous?: string | null;
    results: OrderDocument[];
}

export interface PaginatedOrderEventAdminList {
    /** @example 123 */
    count: number;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=4"
     */
    next?: string | null;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=2"
     */
    previous?: string | null;
    results: OrderEventAdmin[];
}

export interface PaginatedOrderLineItemSourceDetailList {
    /** @example 123 */
    count: number;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=4"
     */
    next?: string | null;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=2"
     */
    previous?: string | null;
    results: OrderLineItemSourceDetail[];
}

export interface PaginatedOrderList {
    /** @example 123 */
    count: number;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=4"
     */
    next?: string | null;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=2"
     */
    previous?: string | null;
    results: Order[];
}

export interface PaginatedOrderListAdminList {
    /** @example 123 */
    count: number;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=4"
     */
    next?: string | null;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=2"
     */
    previous?: string | null;
    results: OrderListAdmin[];
}

export interface PaginatedOrderManagementContractListList {
    /** @example 123 */
    count: number;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=4"
     */
    next?: string | null;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=2"
     */
    previous?: string | null;
    results: OrderManagementContractList[];
}

export interface PaginatedOrderOnHoldAlertList {
    /** @example 123 */
    count: number;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=4"
     */
    next?: string | null;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=2"
     */
    previous?: string | null;
    results: OrderOnHoldAlert[];
}

export interface PaginatedPurchaseRequestList {
    /** @example 123 */
    count: number;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=4"
     */
    next?: string | null;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=2"
     */
    previous?: string | null;
    results: PurchaseRequest[];
}

export interface PaginatedQuoteDetailList {
    /** @example 123 */
    count: number;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=4"
     */
    next?: string | null;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=2"
     */
    previous?: string | null;
    results: QuoteDetail[];
}

export interface PaginatedQuoteDetailSupplierList {
    /** @example 123 */
    count: number;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=4"
     */
    next?: string | null;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=2"
     */
    previous?: string | null;
    results: QuoteDetailSupplier[];
}

export interface PaginatedQuoteDocumentList {
    /** @example 123 */
    count: number;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=4"
     */
    next?: string | null;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=2"
     */
    previous?: string | null;
    results: QuoteDocument[];
}

export interface PaginatedQuoteFeesAdminList {
    /** @example 123 */
    count: number;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=4"
     */
    next?: string | null;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=2"
     */
    previous?: string | null;
    results: QuoteFeesAdmin[];
}

export interface PaginatedQuoteListAdminList {
    /** @example 123 */
    count: number;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=4"
     */
    next?: string | null;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=2"
     */
    previous?: string | null;
    results: QuoteListAdmin[];
}

export interface PaginatedQuoteListList {
    /** @example 123 */
    count: number;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=4"
     */
    next?: string | null;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=2"
     */
    previous?: string | null;
    results: QuoteList[];
}

export interface PaginatedQuoteNegotiationList {
    /** @example 123 */
    count: number;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=4"
     */
    next?: string | null;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=2"
     */
    previous?: string | null;
    results: QuoteNegotiation[];
}

export interface PaginatedQuoteRetrieveList {
    /** @example 123 */
    count: number;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=4"
     */
    next?: string | null;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=2"
     */
    previous?: string | null;
    results: QuoteRetrieve[];
}

export interface PaginatedStaffUserList {
    /** @example 123 */
    count: number;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=4"
     */
    next?: string | null;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=2"
     */
    previous?: string | null;
    results: StaffUser[];
}

export interface PaginatedStatementListList {
    /** @example 123 */
    count: number;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=4"
     */
    next?: string | null;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=2"
     */
    previous?: string | null;
    results: StatementList[];
}

export interface PaginatedSupplierAppOrderListList {
    /** @example 123 */
    count: number;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=4"
     */
    next?: string | null;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=2"
     */
    previous?: string | null;
    results: SupplierAppOrderList[];
}

export interface PaginatedSupplierBuyerList {
    /** @example 123 */
    count: number;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=4"
     */
    next?: string | null;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=2"
     */
    previous?: string | null;
    results: SupplierBuyer[];
}

export interface PaginatedSupplierCompanyList {
    /** @example 123 */
    count: number;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=4"
     */
    next?: string | null;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=2"
     */
    previous?: string | null;
    results: SupplierCompany[];
}

export interface PaginatedSupplierContactList {
    /** @example 123 */
    count: number;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=4"
     */
    next?: string | null;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=2"
     */
    previous?: string | null;
    results: SupplierContact[];
}

export interface PaginatedSupplierDocumentList {
    /** @example 123 */
    count: number;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=4"
     */
    next?: string | null;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=2"
     */
    previous?: string | null;
    results: SupplierDocument[];
}

export interface PaginatedSupplierInquiryListList {
    /** @example 123 */
    count: number;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=4"
     */
    next?: string | null;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=2"
     */
    previous?: string | null;
    results: SupplierInquiryList[];
}

export interface PaginatedSupplierItemDocumentList {
    /** @example 123 */
    count: number;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=4"
     */
    next?: string | null;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=2"
     */
    previous?: string | null;
    results: SupplierItemDocument[];
}

export interface PaginatedSupplierItemListList {
    /** @example 123 */
    count: number;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=4"
     */
    next?: string | null;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=2"
     */
    previous?: string | null;
    results: SupplierItemList[];
}

export interface PaginatedSupplierList {
    /** @example 123 */
    count: number;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=4"
     */
    next?: string | null;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=2"
     */
    previous?: string | null;
    results: Supplier[];
}

export interface PaginatedSupplierSiteList {
    /** @example 123 */
    count: number;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=4"
     */
    next?: string | null;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=2"
     */
    previous?: string | null;
    results: SupplierSite[];
}

export interface PaginatedTaskList {
    /** @example 123 */
    count: number;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=4"
     */
    next?: string | null;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=2"
     */
    previous?: string | null;
    results: Task[];
}

export interface PaginatedTradedItemDocumentList {
    /** @example 123 */
    count: number;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=4"
     */
    next?: string | null;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=2"
     */
    previous?: string | null;
    results: TradedItemDocument[];
}

export interface PaginatedTradedItemListList {
    /** @example 123 */
    count: number;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=4"
     */
    next?: string | null;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=2"
     */
    previous?: string | null;
    results: TradedItemList[];
}

export interface PaginatedTrendsList {
    /** @example 123 */
    count: number;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=4"
     */
    next?: string | null;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=2"
     */
    previous?: string | null;
    results: Trends[];
}

export interface PaginatedUploadedProductsCatalogueList {
    /** @example 123 */
    count: number;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=4"
     */
    next?: string | null;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=2"
     */
    previous?: string | null;
    results: UploadedProductsCatalogue[];
}

export interface PaginatedUserActionList {
    /** @example 123 */
    count: number;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=4"
     */
    next?: string | null;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=2"
     */
    previous?: string | null;
    results: UserAction[];
}

export interface PaginatedUserListList {
    /** @example 123 */
    count: number;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=4"
     */
    next?: string | null;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=2"
     */
    previous?: string | null;
    results: UserList[];
}

export interface PaginatedZendeskTicketList {
    /** @example 123 */
    count: number;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=4"
     */
    next?: string | null;
    /**
     * @format uri
     * @example "http://api.example.org/accounts/?page=2"
     */
    previous?: string | null;
    results: ZendeskTicket[];
}

export interface PasswordResetCommit {
    key: string;
    password: string;
    confirm_password: string;
    /**
     * If true, the response includes the user's auth token so the client can log them in immediately. Used by the welcome / first-password-set onboarding flow to avoid bouncing the user back through the login screen.
     * @default false
     */
    auto_login?: boolean;
}

export interface PasswordResetInit {
    /** @format email */
    email: string;
}

/**
 * Serializer for account details with country-specific validation.
 * Supports DUNS field and AccountEmail management.
 *
 * UK buyers require: company_name, vat_number, company_registration_number,
 *                   registered_address, contact_name, contact_phone_number,
 *                   contact_email_address
 *
 * US buyers require: company_name, vat_number (as EIN), registered_address,
 *                   contact_name, contact_phone_number, contact_email_address
 */
export interface PatchedAccountDetail {
    id?: number;
    /**
     * Company name
     * @maxLength 255
     */
    company_name?: string;
    /**
     * VAT number
     * @maxLength 100
     */
    vat_number?: string;
    duns?: string | null;
    /**
     * Company Registration Number (UK only)
     * @maxLength 100
     */
    company_registration_number?: string;
    /** Registered company address */
    registered_address?: string;
    /** @maxLength 255 */
    contact_name?: string;
    /** @maxLength 50 */
    contact_phone_number?: string;
    /**
     * Contact email address (DEPRECATED: Use account_emails relationship instead)
     * @format email
     * @maxLength 255
     */
    contact_email_address?: string;
    /** Tax exemption certificate (US only) */
    tax_exemption_certificate?: boolean;
    account_emails?: AccountEmail[];
    /** @format date-time */
    created_at?: string;
    /** @format date-time */
    modified_at?: string;
}

/** Used for reading feedbacks. */
export interface PatchedAgentFeedback {
    /** @format uuid */
    uuid?: string;
    /** @format uuid */
    workflow_uuid?: string;
    workflow_type?: string;
    /**
     * * `GOOD` - Good
     * * `BAD` - Bad
     */
    feedback_rating?: FeedbackRatingEnum;
    issue_type?: IssueTypeEnum[] | null;
    confidence_level?: ConfidenceLevelEnum | BlankEnum | NullEnum | null;
    /**
     * * `ACCEPT_FINAL` - Accept as Final
     * * `NEEDS_REVIEW` - Needs Manual Review
     * * `RERUN` - Rerun
     * * `ESCALATE` - Escalate to Human
     * * `DISCARD` - Discard
     */
    action_preference?: ActionPreferenceEnum;
    /** @maxLength 200 */
    comment?: string;
    /** @format email */
    created_by_email?: string;
    metadata?: any;
    /** @format date-time */
    created?: string;
    /** @format date-time */
    modified?: string;
}

export interface PatchedBrandBuyerItemDetail {
    /** @format uuid */
    uuid?: string;
    /** @maxLength 255 */
    item_name?: string;
    /** @maxLength 255 */
    sku?: string | null;
    item_description?: string | null;
    /**
     * @format uri
     * @maxLength 2048
     */
    logo_url?: string;
    /** @format uuid */
    category_uuid?: string | null;
    /**
     * What kind of material this row represents (ingredient, packaging, ...).
     *
     * * `ingredient` - Ingredient
     * * `packaging` - Packaging
     */
    kind?: CatalogItemKindEnum;
    /**
     * Natural unit the material is measured in.
     *
     * * `fl oz` - Fluid Ounces
     * * `g` - Grams
     * * `mg` - milligrams
     * * `gals` - Gallons
     * * `kg` - Kilograms
     * * `L` - Liters
     * * `tons` - Metric Tons
     * * `oz` - Ounces
     * * `lbs` - Pounds
     * * `pcs` - Pieces
     * * `pt` - Pints
     * * `ml` - Milliliter
     * * `boxes` - Boxes
     * * `pallets` - Pallets
     * * `tsp` - Teaspoons
     * * `tbsp` - Tablespoons
     * * `units` - Units
     * * `cases` - Cases
     * * `trays` - Trays
     */
    unit_of_measurement?: UnitOfMeasurementEnum;
    allergen_requirements?: AllergenRequirementsEnum[];
    /** A signed allergen declaration is required to source this material. */
    require_allergen_declaration?: boolean;
    diet_requirements?: DietRequirementsEnum[];
    /** A dietary certificate is required to validate the diet requirements. */
    require_dietary_certificate?: boolean;
    is_active?: boolean;
    documents?: BuyerItemDocument[];
    /** @format date-time */
    created_at?: string;
    /** @format date-time */
    modified_at?: string;
}

export interface PatchedBrandQuoteUpdate {
    /**
     * * `available` - Available
     * * `requested` - Requested
     * * `sent` - Sent
     * * `received` - Received
     * * `accepted` - Accepted
     * * `rejected` - Rejected
     * * `declined` - Declined
     */
    samples_status?: SamplesStatusEnum;
    /** @format uuid */
    samples_delivery_address?: string;
    samples_feedback?: SamplesFeedbackEnum[] | null;
    samples_feedback_comment?: string;
    /** @format date */
    samples_received_date?: string | null;
    /** @format date */
    samples_accepted_date?: string | null;
    /** @format date */
    samples_rejected_date?: string | null;
    /** @format date */
    samples_declined_date?: string | null;
    /** @format date */
    samples_requested_date?: string | null;
    /**
     * * `in_advance` - In Advance
     * * `on_dispatch` - On Dispatch
     * * `7_days_after_dispatch` - Days After Dispatch 7
     * * `14_days_after_dispatch` - Days After Dispatch 14
     * * `30_days_after_dispatch` - Days After Dispatch 30
     * * `60_days_after_dispatch` - Days After Dispatch 60
     */
    requested_payment_terms?: PaymentTermsEnum;
    extension_accepted?: boolean | null;
    payment_terms_updated_by_supplier?: boolean;
}

/**
 * Buyer Business Profile section. Writes a flat shape that the agent's
 * Step-3 Verify panel posts. Mutates `Company` plus a paired
 * `CompanyAddress(address_type=COMPANY)` and (when `use_as_billing` is
 * true) mirrors to `CompanyAddress(address_type=BILLING)`.
 */
export interface PatchedBusinessProfile {
    /** @maxLength 255 */
    name?: string;
    /** @maxLength 255 */
    registration_name?: string | null;
    /** @maxLength 255 */
    registration_number?: string | null;
    /**
     * Legal entity type captured on the buyer Business Profile section. Required for buyers; left blank for suppliers and merchants of record.
     *
     * * `ltd` - Limited Company (Ltd)
     * * `llp` - Limited Liability Partnership (LLP)
     * * `plc` - Public Limited Company (PLC)
     * * `sole_trader` - Sole Trader
     * * `partnership` - Partnership
     * * `other` - Other
     */
    legal_entity_type?: LegalEntityTypeEnum;
    /** @maxLength 255 */
    website?: string | null;
    /** @maxLength 50 */
    vat_number?: string | null;
    /** @maxLength 2 */
    vat_country_code?: string | null;
    phone_country_code?: PhoneCountryCodeEnum | BlankEnum | NullEnum | null;
    /** @maxLength 50 */
    phone_number?: string | null;
    /**
     * @format email
     * @maxLength 254
     */
    buyer_accounts_email_address?: string | null;
    /**
     * @format email
     * @maxLength 254
     */
    buyer_delivery_email_address?: string | null;
    /**
     * The buyer's primary `CompanyAddress(address_type=COMPANY)`. The address
     * country is set server-side from `Company.registration_country_code`, so
     * it is read-only on the wire.
     */
    address?: BusinessProfileAddress;
    /** @default true */
    use_as_billing?: boolean;
    billing_matches_company?: string;
    email?: string;
    country?: string;
}

/** Buyer surface — uses the nested serializer that hides `supplier_document_url`. */
export interface PatchedBuyerAppOrderDetails {
    /** @format uuid */
    uuid?: string;
    /** @format date-time */
    created_at?: string;
    /** @format date-time */
    modified_at?: string;
    ordered_by?: number;
    /**
     * * `initializing` - Initializing
     * * `not_started` - Not Started
     * * `due` - Due
     * * `overdue` - Overdue
     * * `awaiting_reconciliation` - Awaiting Reconciliation
     * * `paid` - Paid
     * * `refunded` - Refunded
     * * `partially_refunded` - Partially Refunded
     */
    pay_in_state?: PayInStateEnum;
    /**
     * * `initializing` - Initializing
     * * `confirmed` - Confirmed
     * * `canceled` - Cancelled
     * * `pending_merchant_of_record_approval` - Pending Merchant of Record Approval
     * * `order_received` - Order Received
     * * `order_sent_to_supplier` - Order Sent To Supplier
     * * `order_confirming_price` - Order Confirming Price
     * * `forecasted` - Forecasted
     */
    lifecycle_state?: LifecycleStateEnum;
    /**
     * * `initializing` - Initializing
     * * `not_started` - Not Started
     * * `pending_dispatch` - Pending Dispatch
     * * `in_transit` - In Transit
     * * `delivered` - Delivered
     * * `freight_ownership_pending` - Freight Ownership Pending
     * * `gathering_quotes` - Gathering Quotes
     * * `dispatch_scheduled` - Dispatch Scheduled
     * * `awaiting_collection_details` - Awaiting Collection Details
     * * `ready_for_pickup` - Ready for Pickup
     * * `picked_up` - Picked Up
     * * `preparing_freight` - Preparing Freight
     * * `freight_scheduled` - Freight Scheduled
     * * `gathering_freight_quotes` - Gathering Freight Quotes
     * * `quotes_confirmed` - Quotes Confirmed
     */
    delivery_state?: DeliveryStateEnum;
    /**
     * * `pay_before_dispatch` - Pay Before Dispatch
     * * `pay_after_dispatch` - Pay After Dispatch
     * * `pay_on_28th_second_month_after_dispatch` - Pay on 28th second month after dispatch
     * * `pay_end_of_month_of_dispatch_date` - Pay End of Month of Dispatch Date
     */
    payment_terms?: AppOrderPaymentTermsEnum;
    order_number?: string;
    company_ordered_by?: CompanyNameAndId;
    company_ordered_from?: CompanyNameAndId;
    /**
     * Check if the supplier has a registered CompanyReferral with the buyer,
     * meaning the buyer can access the supplier through the my-suppliers endpoint.
     */
    is_supplier_accessible?: boolean;
    buyer_currency?: string;
    shipping_price_in_supplier_currency?: number;
    import_fee_price_in_buyer_currency?: number | null;
    export_fee_price_in_supplier_currency?: number | null;
    /**
     * US-only. Flat sales-tax amount as it appears on the supplier invoice, in supplier currency cents. This value is the tax itself — it is added to the order's with-tax totals and excluded from the without-tax totals (no further tax is applied to it). Buyer-side amount is derived via the order's supplier_to_buyer_currency_conversion_rate.
     * @format int64
     * @min 0
     * @max 9223372036854776000
     */
    sales_tax_in_supplier_currency_in_cents?: number | null;
    line_items?: BuyerOrderLineItem[];
    /** @format date */
    dispatched_at?: string | null;
    /** @format date */
    estimated_delivery_date?: string | null;
    tracking_code?: string | null;
    shipping_provider?: string | null;
    shipping_price_for_buyer?: number;
    buyer_total_shipping_tax_amount_in_buyer_currency?: number;
    /** US-only flat sales tax in buyer-currency cents. 0 when unset. */
    buyer_total_sales_tax_amount_in_buyer_currency?: number;
    total_order_price_for_buyer?: number;
    total_order_vat?: number;
    delivery_address?: DeliveryAddressResponse | null;
    payment_due_date?: string;
    /**
     * Invoice due date from Two, set when order.reconciliation.invoiced.v1 webhook is received
     * @format date
     */
    two_invoice_due_date?: string | null;
    /** @format double */
    buyer_shipping_tax_rate?: number;
    /** @format uuid */
    channel_uuid?: string;
    /**
     * @min 0
     * @max 2147483647
     */
    buyer_payment_period?: number;
    /** @format date */
    delivery_date?: string;
    legacy_order_uuid?: string;
    legacy_order_payment_status?: string;
    documents?: BuyerAppOrderDocument[];
    is_spot_order?: string;
    buyer_purchase_order_reference?: string | null;
    payment_provider?: string | null;
    /**
     * * `buyer` - Buyer
     * * `supplier` - Supplier
     * * `unknown` - Unknown
     * * `to_be_confirmed` - To Be Confirmed
     * * `merchant_of_record` - Merchant of Record
     */
    shipping_responsibility?: ShippingResponsibilityEnum;
    supplier_site?: SupplierSite;
    is_direct_order?: boolean;
    supplier_payout_details?: SupplierPayoutDetails | null;
    is_on_hold?: boolean;
    hold_details?: {
        /** @format date-time */
        held_at?: string;
        hold_public_notes?: string;
    } | null;
    /** @format date */
    forecast_date?: string;
    total_pay_in_refunded_amount?: number;
    two_order_has_invoice?: boolean;
    direct_order_has_invoice?: boolean;
    bank_details?: BankDetail[];
    originating_adjustments?: BuyerNestedOrderAdjustment[];
    applied_adjustments?: BuyerNestedOrderAdjustment[];
}

/**
 * Serializer for BuyerDocument — buyer certification and compliance documents.
 *
 * Handles CRUD with computed status fields, mirroring OpplyDocumentSerializer.
 */
export interface PatchedBuyerDocument {
    /** @format uuid */
    uuid?: string;
    type?: DocumentType;
    /** @format uuid */
    type_uuid?: string;
    /** @format uuid */
    renewing_uuid?: string | null;
    /**
     * The uploaded document file
     * @format uri
     */
    file?: string;
    /**
     * Display name for the document
     * @maxLength 255
     */
    name?: string;
    /**
     * Start date of document validity
     * @format date
     */
    start_date?: string | null;
    /**
     * End/expiry date of document validity
     * @format date
     */
    end_date?: string | null;
    /** ISO country codes this document applies to. Empty = all countries. */
    countries?: Country[];
    /**
     * Optional notes about this document
     * @maxLength 2048
     */
    notes?: string | null;
    status?: DocumentLifecycleStatusEnum;
    /** Return whether the document is archived (expired or renewed). */
    is_archived?: boolean;
    /** @format uuid */
    superseded_by_uuid?: string | null;
    /** @format date-time */
    created?: string;
    /** @format date-time */
    modified?: string;
}

export interface PatchedBuyerItemDetail {
    /** @format uuid */
    uuid?: string;
    /** @maxLength 255 */
    item_name?: string;
    /** @maxLength 255 */
    sku?: string | null;
    item_description?: string | null;
    /**
     * @format uri
     * @maxLength 2048
     */
    logo_url?: string;
    /** @format uuid */
    buyer_company_uuid?: string;
    buyer_company_name?: string;
    /** @format uuid */
    category_uuid?: string | null;
    /**
     * What kind of material this row represents (ingredient, packaging, ...).
     *
     * * `ingredient` - Ingredient
     * * `packaging` - Packaging
     */
    kind?: CatalogItemKindEnum;
    /**
     * Natural unit the material is measured in.
     *
     * * `fl oz` - Fluid Ounces
     * * `g` - Grams
     * * `mg` - milligrams
     * * `gals` - Gallons
     * * `kg` - Kilograms
     * * `L` - Liters
     * * `tons` - Metric Tons
     * * `oz` - Ounces
     * * `lbs` - Pounds
     * * `pcs` - Pieces
     * * `pt` - Pints
     * * `ml` - Milliliter
     * * `boxes` - Boxes
     * * `pallets` - Pallets
     * * `tsp` - Teaspoons
     * * `tbsp` - Tablespoons
     * * `units` - Units
     * * `cases` - Cases
     * * `trays` - Trays
     */
    unit_of_measurement?: UnitOfMeasurementEnum;
    allergen_requirements?: AllergenRequirementsEnum[];
    /** A signed allergen declaration is required to source this material. */
    require_allergen_declaration?: boolean;
    diet_requirements?: DietRequirementsEnum[];
    /** A dietary certificate is required to validate the diet requirements. */
    require_dietary_certificate?: boolean;
    is_active?: boolean;
    documents?: BuyerItemDocument[];
    /** @format date-time */
    created_at?: string;
    /** @format date-time */
    modified_at?: string;
}

/**
 * Serializer for BuyerOnboardingDeliveryAddress model.
 * Includes all BaseAddress fields plus delivery-specific fields.
 */
export interface PatchedBuyerOnboardingDeliveryAddress {
    /** @format uuid */
    uuid?: string;
    /** @maxLength 255 */
    name?: string;
    /**
     * * `billing_address` - Billing address
     * * `delivery_address` - Delivery address
     * * `dispatch_address` - Dispatch address
     * * `company_address` - Company address
     */
    address_type?: AddressTypeEnum;
    /** @maxLength 255 */
    contact_full_name?: string | null;
    /** @maxLength 50 */
    contact_phone?: string | null;
    /** @maxLength 100 */
    building?: string | null;
    /** @maxLength 255 */
    street_1?: string | null;
    /** @maxLength 255 */
    street_2?: string | null;
    /** @maxLength 100 */
    town?: string | null;
    /** @maxLength 100 */
    region?: string | null;
    /** @maxLength 100 */
    postcode?: string | null;
    country?: Country | BlankEnum | NullEnum | null;
    /** @maxLength 100 */
    place_id?: string | null;
    /**
     * @format decimal
     * @pattern ^-?\d{0,4}(?:\.\d{0,15})?$
     */
    latitude?: string | null;
    /**
     * @format decimal
     * @pattern ^-?\d{0,4}(?:\.\d{0,15})?$
     */
    longitude?: string | null;
    /** @maxLength 50 */
    vat_number?: string | null;
    vat_country_code?: Country | BlankEnum | NullEnum | null;
    vat_exempt?: boolean;
    phone_country_code?: PhoneCountryCodeEnum | BlankEnum | NullEnum | null;
    delivery_instructions?: string | null;
    collection_instructions?: string | null;
    /**
     * * `EU` - Eu
     * * `GB` - Gb
     * * `Other` - Other
     */
    country_type?: CountryTypeEnum;
    /** @maxLength 20 */
    eori_number?: string;
    /** @maxLength 20 */
    ein_number?: string;
    /**
     * Type of delivery location
     *
     * * `warehouse` - Warehouse
     * * `factory` - Factory
     * * `distribution_center` - Distribution Center
     * * `retail_location` - Retail Location
     * * `other` - Other
     */
    delivery_location_type?: DeliveryLocationTypeEnum | BlankEnum;
    delivery_location_type_display?: string;
    /**
     * Specify delivery location type when 'Other' is selected
     * @maxLength 255
     */
    delivery_location_type_other?: string;
    /**
     * Warehouse receiving hours
     * @maxLength 255
     */
    warehouse_receiving_hours?: string;
    /** @format date-time */
    created?: string;
    /** @format date-time */
    modified?: string;
}

/**
 * Detailed serializer for buyer onboarding.
 * Includes all related information.
 *
 * For self-onboarded buyers (`buyer_onboarding.company` is set), the
 * name / email fields are derived from the canonical `Company` /
 * `User`, and `has_account_details` / `has_delivery_details` consider
 * Company columns alongside the legacy AccountDetail/DeliveryDetails
 * tables.
 */
export interface PatchedBuyerOnboardingDetail {
    /**
     * Unique identifier for sharing the onboarding form
     * @format uuid
     */
    uuid?: string;
    name?: string;
    email?: string;
    /**
     * * `us` - United States
     * * `uk` - United Kingdom
     */
    country?: BuyerOnboardingCountry;
    company_uuid?: string;
    company_name?: string;
    /** Internal notes */
    notes?: string;
    /**
     * When the buyer submitted the form
     * @format date-time
     */
    submitted_at?: string | null;
    is_submitted?: string;
    total_steps?: string;
    completed_steps?: string;
    has_account_details?: string;
    has_delivery_details?: string;
    suppliers_count?: string;
    suppliers_pending_review_count?: string;
    suppliers_completed?: string;
    /**
     * When the supplier section was marked as complete
     * @format date-time
     */
    suppliers_completed_at?: string | null;
    /** @format date-time */
    created_at?: string;
    /** @format date-time */
    modified_at?: string;
}

/** Serializer for buyer onboarding step with template information. */
export interface PatchedBuyerOnboardingStep {
    id?: number;
    /** The template this step is based on */
    template_step?: number;
    template_phase?: string;
    template_phase_display?: string;
    process_description?: string;
    template_step_order?: number;
    /** Buyer-specific notes for this step */
    notes?: string;
    /** Whether this step is completed */
    is_completed?: boolean;
    /**
     * When this step was completed
     * @format date-time
     */
    completed_at?: string | null;
    /** Who completed this step */
    completed_by?: number | null;
    /** @format email */
    completed_by_email?: string;
    /**
     * Custom order for this buyer (overrides template step order)
     * @min 0
     * @max 2147483647
     */
    custom_step_order?: number | null;
    /** Whether this step is visible for this buyer */
    is_step_visible?: boolean;
    /** @format date-time */
    created_at?: string;
    /** @format date-time */
    modified_at?: string;
}

export interface PatchedBuyerSupplierPaymentTermsCreate {
    /** @format uuid */
    uuid?: string;
    /** @format uuid */
    buyer_uuid?: string;
    /** @format uuid */
    supplier_uuid?: string;
    /**
     * * `pay_before_dispatch` - Pay Before Dispatch
     * * `pay_after_dispatch` - Pay After Dispatch
     * * `pay_on_28th_second_month_after_dispatch` - Pay on 28th second month after dispatch
     * * `pay_end_of_month_of_dispatch_date` - Pay End of Month of Dispatch Date
     */
    payment_terms?: AppOrderPaymentTermsEnum;
    /**
     * Number of days after dispatch until payment is due from the buyer
     * @min 0
     * @max 2147483647
     */
    days_until_payment_due?: number;
    /** @format date-time */
    created?: string;
    /** @format date-time */
    modified?: string;
}

export interface PatchedCompany {
    id?: number;
    /** @format uuid */
    uuid?: string;
    /** @maxLength 255 */
    website?: string | null;
    /** @maxLength 255 */
    name?: string;
    /** @format uri */
    logo?: string | null;
    /** @maxLength 100 */
    industry?: string | null;
    kyb_status?: string;
    /** @maxLength 50 */
    phone_number?: string | null;
    country?: string;
    state?: string;
    /**
     * * `brand` - Brand
     * * `supplier` - Supplier
     * * `merchant_of_record` - Merchant of Record
     */
    company_type?: CompanyTypeEnum;
    /** @default ["e","h","o","r","t"] */
    product_type?: ProductTypeEnum[];
    /** @default ["e","h","o","r","t"] */
    activity_type?: ActivityTypeEnum[];
    /** @maxLength 255 */
    registration_number?: string | null;
    /** @maxLength 255 */
    registration_name?: string | null;
    mongo_id?: string | null;
    referral_code?: string;
    phone_country_code?: PhoneCountryCodeEnum | BlankEnum | NullEnum | null;
    company_addresses?: CompanyAddress[];
    currency?: string;
    /**
     * rapyd payout method
     * @maxLength 45
     */
    payout_method_type?: string | null;
    bank_account_country?: Country | BlankEnum | NullEnum | null;
    /**
     * DUNS number for creditworthiness checks and payouts
     * @maxLength 50
     */
    duns?: string | null;
}

export interface PatchedCompanyAddress {
    id?: number;
    /** @format date-time */
    created?: string;
    /** @format date-time */
    modified?: string;
    /** @format uuid */
    uuid?: string;
    /** @maxLength 255 */
    name?: string;
    /**
     * * `billing_address` - Billing address
     * * `delivery_address` - Delivery address
     * * `dispatch_address` - Dispatch address
     * * `company_address` - Company address
     */
    address_type?: AddressTypeEnum;
    /** @maxLength 255 */
    contact_full_name?: string | null;
    /** @maxLength 50 */
    contact_phone?: string | null;
    /** @maxLength 100 */
    building?: string | null;
    /** @maxLength 255 */
    street_1?: string | null;
    /** @maxLength 255 */
    street_2?: string | null;
    /** @maxLength 100 */
    town?: string | null;
    /** @maxLength 100 */
    region?: string | null;
    /** @maxLength 100 */
    postcode?: string | null;
    country?: Country | BlankEnum | NullEnum | null;
    /** @maxLength 100 */
    place_id?: string | null;
    /**
     * @format decimal
     * @pattern ^-?\d{0,4}(?:\.\d{0,15})?$
     */
    latitude?: string | null;
    /**
     * @format decimal
     * @pattern ^-?\d{0,4}(?:\.\d{0,15})?$
     */
    longitude?: string | null;
    /** @maxLength 50 */
    vat_number?: string | null;
    vat_country_code?: Country | BlankEnum | NullEnum | null;
    vat_exempt?: boolean;
    phone_country_code?: PhoneCountryCodeEnum | BlankEnum | NullEnum | null;
    delivery_instructions?: string | null;
    collection_instructions?: string | null;
    /**
     * * `EU` - Eu
     * * `GB` - Gb
     * * `Other` - Other
     */
    country_type?: CountryTypeEnum;
    /** @maxLength 20 */
    eori_number?: string;
    /** @maxLength 20 */
    ein_number?: string;
    notes?: string;
    /**
     * Type of delivery location (warehouse, factory, distribution_center, retail_location, other).
     * @maxLength 50
     */
    delivery_location_type?: string;
    /**
     * Free-text description when delivery_location_type == 'other'.
     * @maxLength 255
     */
    delivery_location_type_other?: string;
    /**
     * Free-text receiving hours (e.g. 'Mon-Fri 9am-5pm').
     * @maxLength 255
     */
    warehouse_receiving_hours?: string;
}

export interface PatchedCompanyNotificationOverride {
    /** * `order_created` - order_created */
    kind?: NotificationKindCodeEnum;
    enabled?: boolean;
}

export interface PatchedContractRenewNegotiation {
    /** @format uuid */
    uuid?: string;
    /** @format uuid */
    company_uuid?: string;
    /**
     * Duration of the contract in months.
     * @min -2147483648
     * @max 2147483647
     */
    contract_length?: number | null;
    /**
     * @min 0
     * @max 2147483647
     */
    quantity_per_order?: number;
    /**
     * @format decimal
     * @pattern ^-?\d{0,17}(?:\.\d{0,2})?$
     */
    total_forecast_volume?: string;
    /** @format date */
    first_order_delivery_date?: string | null;
    /**
     * @format decimal
     * @pattern ^-?\d{0,9}(?:\.\d{0,10})?$
     */
    unit_price?: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
     */
    price_per_order?: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
     */
    shipping_cost_per_order?: string | null;
    /**
     * * `created` - Created
     * * `accepted` - Accepted
     * * `declined` - Declined
     * * `completed` - Completed
     */
    status?: QuoteNegotiationStatus;
    /** @format date */
    declined_date?: string | null;
    /** @format date */
    accepted_date?: string | null;
    /** @format date */
    confirmed_date?: string | null;
    /** @format uuid */
    new_contract_uuid?: string | null;
    /** @format date-time */
    created?: string;
    /** @format date-time */
    modified?: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
     */
    payout_per_unit_no_shipping?: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
     */
    sum_payout_no_shipping?: string;
}

/** Partial updates: agent_name, description, status. */
export interface PatchedCortexJobUpdate {
    agent_name?: string;
    description?: string;
    /**
     * * `PENDING` - Pending
     * * `EXECUTING` - Executing
     * * `COMPLETED` - Completed
     * * `AWAITING_HUMAN` - Awaiting Human
     */
    status?: CortexJobStatusEnum;
    /**
     * @min 0
     * @max 2147483647
     */
    job_index?: number;
}

/** List all workflows with their associated jobs. */
export interface PatchedCortexWorkflowWithJobs {
    /** @format uuid */
    uuid?: string;
    input?: string;
    /**
     * * `FINANCE` - Finance
     * * `PREDICTIONS` - Predictions
     * * `COMPLIANCE` - Compliance
     * * `LOGISTICS` - Logistics
     * * `ORDERS` - Orders
     */
    type?: CortexWorkflowTypeEnum;
    /** @maxLength 100 */
    zendesk_ticket_id?: string | null;
    /** @format date-time */
    created?: string;
    /** @format date-time */
    modified?: string;
    jobs?: CortexJob[];
    workFlowAlreadyHasFeedback?: string;
}

export interface PatchedCrmCustomColumn {
    /** @format uuid */
    uuid?: string;
    /** @maxLength 255 */
    name?: string;
    /**
     * * `numeric` - Numeric
     * * `text` - Text
     * * `llm` - LLM
     * * `score` - Score
     */
    type?: CrmCustomColumnTypeEnum;
    config?: any;
    /** @format uuid */
    created_by_uuid?: string;
    is_owner?: boolean;
    /** @format date-time */
    created?: string;
    /** @format date-time */
    modified?: string;
}

export interface PatchedCrmSavedView {
    /** @format uuid */
    uuid?: string;
    /** @maxLength 255 */
    name?: string;
    config?: any;
    columns?: CrmCustomColumn[];
    column_uuids?: string[];
    /** @format uuid */
    created_by_uuid?: string;
    is_owner?: boolean;
    /** @format date-time */
    created?: string;
    /** @format date-time */
    modified?: string;
    /**
     * Timestamp of the most recent change to `config`. Used to determine whether the latest HubSpot sync is stale relative to the current view config.
     * @format date-time
     */
    config_last_changed_at?: string | null;
    latest_hubspot_sync_run?: string;
    hubspot_sync_is_stale?: boolean;
}

/**
 * Serializer for per-company CRM settings (singleton).
 *
 * The `company` field is set server-side and is not exposed.
 */
export interface PatchedCrmSettings {
    /** @format uuid */
    uuid?: string;
    /** When False, the automatic HubSpot View Sync that fires on saved view create/update is suppressed. Manual syncs via the hubspot-sync endpoint are unaffected. */
    sync_hubspot_on_view_save?: boolean;
    /** @format date-time */
    created?: string;
    /** @format date-time */
    modified?: string;
}

/** Serializer for delivery details. */
export interface PatchedDeliveryDetails {
    id?: number;
    /** Delivery address (DEPRECATED: Use buyer_onboarding_delivery_address instead) */
    delivery_address?: string;
    /**
     * * `warehouse` - Warehouse
     * * `factory` - Factory
     * * `distribution_center` - Distribution Center
     * * `retail_location` - Retail Location
     * * `other` - Other
     */
    delivery_location_type?: DeliveryLocationTypeEnum;
    delivery_location_type_display?: string;
    /**
     * Specify delivery location type when 'Other' is selected
     * @maxLength 255
     */
    delivery_location_type_other?: string;
    /** Delivery instructions */
    delivery_instructions?: string;
    /**
     * Delivery contact name (DEPRECATED: Use delivery_address relationship instead)
     * @maxLength 255
     */
    delivery_contact_name?: string;
    /**
     * Delivery contact phone number (DEPRECATED: Use delivery_address relationship instead)
     * @maxLength 50
     */
    delivery_contact_phone_number?: string;
    /**
     * Delivery contact email (DEPRECATED: Use delivery_emails relationship instead)
     * @format email
     * @maxLength 255
     */
    delivery_contact_email?: string;
    /**
     * Warehouse receiving hours
     * @maxLength 255
     */
    warehouse_receiving_hours?: string;
    /**
     * Storage capacity
     * @maxLength 255
     */
    storage_capacity?: string;
    /**
     * Access requirements
     *
     * * `delivery_appointment` - Delivery appointment requirement
     * * `inside_delivery` - Inside delivery Required
     * * `lift_gate` - Lift gate required
     */
    access_requirements?: AccessRequirementsEnum | BlankEnum;
    /** Is a sample required? */
    is_sample_required?: boolean;
    /** @format date-time */
    created_at?: string;
    /** @format date-time */
    modified_at?: string;
}

export interface PatchedGroupedStatementPatch {
    /**
     * Payment reference copied from the provider's report. Used in reconciliation.
     * @maxLength 255
     */
    external_payment_id?: string | null;
}

export interface PatchedIngredient {
    id?: number;
    /** @format uuid */
    uuid?: string;
    /** @maxLength 255 */
    name?: string;
    /**
     * @format uri
     * @maxLength 2048
     */
    logo_url?: string;
    /**
     * @format decimal
     * @default "0.00"
     * @pattern ^-?\d{0,13}(?:\.\d{0,2})?$
     */
    current_unit_price?: string | null;
    /**
     * * `EUR` - EUR
     * * `USD` - USD
     * * `GBP` - GBP
     * * `CAD` - CAD
     */
    currency?: Currencies;
    description?: string;
    /**
     * @format decimal
     * @default "0.00"
     * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
     */
    quantity?: string | null;
    /** @default "kg" */
    unit_of_measurement?: UnitOfMeasurementEnum | BlankEnum | NullEnum | null;
    allergen_requirements?: (AllergenRequirementsEnum | BlankEnum)[];
    allergen_declaration?: boolean;
    dietary_certificate?: boolean;
    diet_requirements?: (DietRequirementsEnum | BlankEnum)[];
    current_supplier?: string;
    frequency?: FrequencyEnum | BlankEnum | NullEnum | null;
    /** @format uuid */
    article?: string | null;
    existing_suppliers?: string[] | null;
    /** @format uuid */
    parent_uuid?: string | null;
}

export interface PatchedInquiry {
    id?: number;
    /** @format uuid */
    uuid?: string;
    /**
     * * `awaiting_quotes` - Awaiting Quotes
     * * `quotes_available` - Quotes Available
     * * `ordered` - Ordered
     * * `expired` - Expired
     * * `proceeded` - Proceeded
     * * `contract_confirmed` - Contract Confirmed
     * * `supplier_decline_to_quote` - Supplier Decline To Quote
     * * `cancelled` - Cancelled
     */
    state?: InquiryState;
    /**
     * * `non_recurring` - Non Recurring
     * * `recurring` - Recurring
     * * `purchase_request` - Purchase Request
     * * `ingredient` - Ingredient
     * * `ingredient_copy` - Ingredient Copy
     */
    category?: InquiryCategory;
    /** @maxLength 255 */
    name?: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
     */
    current_unit_price?: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
     */
    target_unit_price?: string;
    /**
     * * `EUR` - EUR
     * * `USD` - USD
     * * `GBP` - GBP
     * * `CAD` - CAD
     */
    currency?: Currencies;
    description?: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
     */
    quantity?: string;
    /**
     * * `fl oz` - Fluid Ounces
     * * `g` - Grams
     * * `mg` - milligrams
     * * `gals` - Gallons
     * * `kg` - Kilograms
     * * `L` - Liters
     * * `tons` - Metric Tons
     * * `oz` - Ounces
     * * `lbs` - Pounds
     * * `pcs` - Pieces
     * * `pt` - Pints
     * * `ml` - Milliliter
     * * `boxes` - Boxes
     * * `pallets` - Pallets
     * * `tsp` - Teaspoons
     * * `tbsp` - Tablespoons
     * * `units` - Units
     * * `cases` - Cases
     * * `trays` - Trays
     */
    unit_of_measurement?: UnitOfMeasurementEnum;
    allergen_requirements?: (AllergenRequirementsEnum | BlankEnum)[];
    allergen_declaration?: boolean;
    dietary_certificate?: boolean;
    diet_requirements?: (DietRequirementsEnum | BlankEnum)[];
    forecast?: ForecastEnum | BlankEnum | NullEnum | null;
    /** @format date */
    due_date?: string;
    delivery_address?: number | null;
    /** @maxItems 250 */
    supplier_countries?: (Country | BlankEnum)[];
    current_supplier?: string;
    /**
     * Datetime when the inquiry becomes published. Leave empty to keep it unpublished.
     * @format date-time
     */
    published?: string | null;
    /**
     * @format uri
     * @maxLength 2048
     */
    logo_url?: string;
    is_new?: boolean;
    /** @format uuid */
    article?: string | null;
    existing_suppliers?: string[] | null;
    supply_priorities?: SupplyPriorities[];
    /** @format date */
    first_order_delivery_date?: string | null;
    /**
     * @format decimal
     * @pattern ^-?\d{0,7}(?:\.\d{0,2})?$
     */
    opply_brand_commission?: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,7}(?:\.\d{0,2})?$
     */
    opply_supplier_commission?: string;
    /** @default false */
    is_recurring?: boolean;
    frequency?: FrequencyEnum | BlankEnum | NullEnum | null;
    /** @min 0 */
    desired_contract_length?: number | null;
    is_delivery_date_flexible?: boolean;
    /** @format uuid */
    parent_uuid?: string | null;
    ingredient?: number | null;
    reason_for_request?: string | null;
    desired_packaging_format?: string;
    desired_packaging_format_is_flexible?: boolean;
    ai_generated?: boolean;
    documents_to_copy?: string[] | null;
}

export interface PatchedInquiryDeliveryAddress {
    id?: number;
    /** @maxLength 255 */
    name?: string;
    /** @maxLength 255 */
    street_1?: string | null;
    /** @maxLength 255 */
    street_2?: string | null;
    /** @maxLength 255 */
    contact_full_name?: string | null;
    /** @maxLength 50 */
    contact_phone?: string | null;
    phone_country_code?: PhoneCountryCodeEnum | BlankEnum | NullEnum | null;
    /** @maxLength 100 */
    town?: string | null;
    /** @maxLength 100 */
    region?: string | null;
    /** @maxLength 100 */
    postcode?: string | null;
    /** @maxLength 20 */
    eori_number?: string;
    delivery_instructions?: string | null;
    /** @maxLength 100 */
    building?: string | null;
    /**
     * @format decimal
     * @pattern ^-?\d{0,4}(?:\.\d{0,15})?$
     */
    latitude?: string | null;
    /**
     * @format decimal
     * @pattern ^-?\d{0,4}(?:\.\d{0,15})?$
     */
    longitude?: string | null;
    collection_instructions?: string | null;
    /** @format uuid */
    uuid?: string;
    country?: Country | NullEnum | null;
    place_id?: string | null;
    vat_number?: string | null;
    vat_country_code?: Country | NullEnum | null;
    vat_exempt?: boolean;
    country_type?: CountryTypeEnum;
}

export interface PatchedMcpAccessRequest {
    /**
     * Public identifier for this access request
     * @format uuid
     */
    uuid?: string;
    /** @format uuid */
    user_uuid?: string;
    /** @format email */
    user_email?: string;
    requested_scopes?: McpScopeKeyEnum[];
    /**
     * Brief explanation from the user of why they need MCP access
     * @maxLength 500
     */
    justification?: string;
    status?: McpAccessRequestStatusEnum;
    /** @default "" */
    review_note?: string;
    /** @format email */
    reviewed_by_email?: string | null;
    /**
     * When the admin reviewed this request
     * @format date-time
     */
    reviewed_at?: string | null;
    /** @format date-time */
    created?: string;
}

export interface PatchedMcpUserAccess {
    /**
     * Public identifier for this access record
     * @format uuid
     */
    uuid?: string;
    /** @format uuid */
    user_uuid?: string;
    /** @format email */
    user_email?: string;
    /** Whether MCP access is currently active for this user */
    is_enabled?: boolean;
    /** OAuth scopes this user is permitted to use, e.g. ['orders:read', 'orders:write'] */
    allowed_scopes?: any;
    /** Specific tool names this user may call. Empty list means all tools within the allowed scopes are permitted. */
    allowed_tools?: any;
    /** @format email */
    granted_by_email?: string | null;
    last_used?: string;
    last_reason?: string;
    last_tool?: string;
    total_calls_30d?: string;
    /** @format date-time */
    created?: string;
    /** @format date-time */
    modified?: string;
}

export interface PatchedMerchantOfRecordAgreementList {
    /** @format uuid */
    uuid?: string;
    agreement_number?: string;
    /** @format date-time */
    created_at?: string;
    line_items?: MerchantOfRecordAgreementLineItem[];
    supplier_company_name?: string;
    buyer_company_name?: string;
    /** @format date */
    contract_end_date?: string;
    /** @format date */
    contract_start_date?: string;
}

export interface PatchedMerchantOfRecordAppOrderDispatch {
    tracking_code?: string | null;
    shipping_provider?: string | null;
    /** @format date */
    estimated_delivery_date?: string;
    /** @format date */
    dispatched_at?: string;
}

/** Serializer for updating order activity */
export interface PatchedMerchantOfRecordOrderActivityUpdate {
    task_state?: TaskStateEnum | BlankEnum | NullEnum | null;
}

/** Serializer for updating spot buy request status (pending -> completed). */
export interface PatchedMerchantOfRecordSpotBuyRequestUpdate {
    /**
     * Current status of the spot buy request
     *
     * * `pending` - Pending
     * * `completed` - Completed
     * * `cancelled` - Cancelled
     */
    status?: SpotBuyRequestStatusEnum;
}

/** Serializer for updating supplier payout terms, days, DUNS, supplier type, and lead time */
export interface PatchedMerchantOfRecordSupplierUpdate {
    supplier_payout_terms?: SupplierPayoutTermsEnum | BlankEnum | NullEnum | null;
    /**
     * @min 0
     * @max 2147483647
     */
    supplier_days_until_payout_due?: number | null;
    /**
     * DUNS number for creditworthiness checks and payouts
     * @maxLength 50
     */
    duns?: string | null;
    supplier_type?: SupplierTypeEnum | BlankEnum | NullEnum | null;
    /**
     * Default number of calendar days this supplier needs between order and delivery. Factored into the earliest selectable delivery date on orders.
     * @min 0
     * @max 365
     */
    supplier_lead_time_days?: number | null;
}

export interface PatchedMerchantOfRecordUserUpdate {
    /** @format uuid */
    uuid?: string;
    /** @format email */
    email?: string;
    /** @maxLength 150 */
    first_name?: string;
    /** @maxLength 150 */
    last_name?: string;
    /**
     * Staff status
     * Designates whether the user can log into this admin site.
     */
    is_staff?: boolean;
    /**
     * Active
     * Designates whether this user should be treated as active. Unselect this instead of deleting accounts.
     */
    is_active?: boolean;
    /** @format date-time */
    date_joined?: string;
}

/**
 * Serializer for updating an existing Buyer (Brand) company by MoR users.
 * User email is NOT editable after creation.
 */
export interface PatchedMoRBuyerUpdate {
    /** @maxLength 150 */
    first_name?: string;
    /** @maxLength 150 */
    last_name?: string;
    /** @maxLength 255 */
    company_name?: string;
    product_type?: ProductTypeEnum[];
    /** @maxLength 255 */
    registration_name?: string | null;
    /** @maxLength 255 */
    registration_number?: string | null;
    /** @maxLength 255 */
    website?: string | null;
    /** @maxLength 10 */
    phone_country_code?: string | null;
    /** @maxLength 50 */
    phone_number?: string | null;
    /** @format email */
    buyer_accounts_email_address?: string | null;
    /** @format email */
    buyer_delivery_email_address?: string | null;
    /** @maxLength 50 */
    duns?: string | null;
    sku_ordering_enabled?: boolean;
    /** Serializer for nested address updates. Country cannot be changed. */
    company_address?: MoRBuyerAddressUpdate;
    two_buyer_config?: TwoBuyerConfigUpdate;
}

export interface PatchedNote {
    /** @format uuid */
    uuid?: string;
    /** Note content */
    body?: string;
    /** Whether this note should be pinned to the top */
    is_pinned?: boolean;
    created_by?: UserMinimal;
    target?: Target;
    target_type?: string;
    /** @format uuid */
    target_uuid?: string;
    /** @format date-time */
    created?: string;
    /** @format date-time */
    modified?: string;
}

export interface PatchedNotificationPreference {
    /** * `order_created` - order_created */
    kind?: NotificationKindCodeEnum;
    /**
     * * `email` - Email
     * * `in_app` - In App
     */
    channel?: ChannelEnum;
    enabled?: boolean;
}

/**
 * Buyer Banking & payments section. A 1:1 resource on Company: a single
 * optional IBAN. The section is treated as complete when an IBAN is
 * saved; "Skip for now" is handled FE-side and does not write to the BE.
 */
export interface PatchedOnboardingBanking {
    /**
     * Optional IBAN.
     * @maxLength 64
     */
    iban?: string;
}

export interface PatchedOnboardingSupplierAddress {
    /** @maxLength 255 */
    address_name?: string | null;
    /** @maxLength 255 */
    address_street_1?: string | null;
    /** @maxLength 255 */
    address_street_2?: string | null;
    /** @maxLength 255 */
    address_town?: string | null;
    /** @maxLength 255 */
    address_region?: string | null;
    /** @maxLength 64 */
    address_postcode?: string | null;
    address_country?: Country | BlankEnum | NullEnum | null;
    /** @maxLength 255 */
    address_contact_full_name?: string | null;
    address_contact_phone_country_code?: AddressContactPhoneCountryCodeEnum | BlankEnum | NullEnum | null;
    /** @maxLength 64 */
    address_contact_phone?: string | null;
    /**
     * @format email
     * @maxLength 254
     */
    address_contact_email?: string | null;
    address_note?: string;
    address_vat_country_code?: Country | NullEnum | null;
    address_vat_number?: string;
    address_ein_number?: string | null;
    duns?: string | null;
}

export interface PatchedOnboardingSupplierContact {
    /** @format uuid */
    uuid?: string;
    /** @maxLength 150 */
    first_name?: string;
    /** @maxLength 150 */
    last_name?: string;
    /**
     * @format email
     * @maxLength 254
     */
    email?: string;
    /** @maxLength 50 */
    phone_number?: string;
    /**
     * * `orders` - Orders
     * * `logistics` - Logistics and Supply Chain
     * * `finance` - Finance
     * * `other` - Other
     */
    category?: SupplierContactCategoryEnum;
    /** @format date-time */
    created?: string;
    /** @format date-time */
    modified?: string;
    notes?: string;
}

export interface PatchedOnboardingSupplierPayoutDetails {
    /** @format uuid */
    uuid?: string;
    /**
     * * `US` - Us
     * * `GB` - Gb
     * * `CA` - Ca
     * * `AT` - At
     * * `BE` - Be
     * * `CY` - Cy
     * * `DE` - De
     * * `EE` - Ee
     * * `ES` - Es
     * * `FI` - Fi
     * * `FR` - Fr
     * * `GR` - Gr
     * * `IE` - Ie
     * * `IT` - It
     * * `LT` - Lt
     * * `LU` - Lu
     * * `LV` - Lv
     * * `MT` - Mt
     * * `NL` - Nl
     * * `PT` - Pt
     * * `SI` - Si
     * * `SK` - Sk
     * * `BG` - Bg
     * * `CZ` - Cz
     * * `DK` - Dk
     * * `HR` - Hr
     * * `HU` - Hu
     * * `PL` - Pl
     * * `RO` - Ro
     * * `SE` - Se
     * * `EU` - Eu
     */
    bank_country?: BankingCountryTypeEnum;
    /** @maxLength 255 */
    bank_name?: string;
    /** @maxLength 255 */
    account_holder_name?: string;
    /** @maxLength 64 */
    account_number?: string;
    /** @maxLength 16 */
    sort_code?: string;
    /** @maxLength 32 */
    routing_number?: string;
    account_type?: AccountTypeEnum | BlankEnum;
    /** @maxLength 64 */
    iban?: string;
    /** @maxLength 32 */
    bic?: string;
    /** @maxLength 100 */
    account_holder_building?: string;
    /** @maxLength 255 */
    account_holder_street_1?: string;
    /** @maxLength 255 */
    account_holder_street_2?: string;
    /** @maxLength 100 */
    account_holder_town?: string;
    /** @maxLength 100 */
    account_holder_region?: string;
    /** @maxLength 100 */
    account_holder_postcode?: string;
    account_holder_country?: Country | NullEnum | null;
    /** @format date-time */
    created?: string;
    /** @format date-time */
    modified?: string;
    note?: string;
}

/** Serializer for updating OnboardingSupplier status with optional activity message */
export interface PatchedOnboardingSupplierUpdate {
    /**
     * Current status of the supplier onboarding process
     *
     * * `onboarding_not_started` - Onboarding has not started
     * * `supplier_contacted` - Supplier contacted
     * * `setting_up_account` - Setting up account
     * * `ready_to_trade` - Ready to trade with Opply
     * * `blocked` - Blocked
     */
    status?: OnboardingSupplierStatus;
    /** Optional message to record with the status change */
    message?: string;
    /** List of buyer UUIDs to associate with this supplier */
    buyer_uuids?: string[];
    /** List of staff user UUIDs to assign as owners */
    owner_uuids?: string[];
    /**
     * DUNS number for US suppliers
     * @maxLength 50
     */
    duns?: string | null;
    /**
     * Default supplier lead time in calendar days, copied to the final supplier on completion.
     * @min 0
     * @max 365
     */
    lead_time_days?: number | null;
}

/**
 * Serializer for OpplyDocument - for MoR users.
 *
 * Handles CRUD operations with computed status fields.
 */
export interface PatchedOpplyDocument {
    /** @format uuid */
    uuid?: string;
    /** The Merchant of Record that owns this document */
    merchant_of_record?: number;
    type?: DocumentType;
    /** @format uuid */
    type_uuid?: string;
    /** @format uuid */
    renewing_uuid?: string | null;
    /**
     * The uploaded document file
     * @format uri
     */
    file?: string;
    /**
     * Display name for the document
     * @maxLength 255
     */
    name?: string;
    /**
     * Start date of document validity
     * @format date
     */
    start_date?: string | null;
    /**
     * End/expiry date of document validity
     * @format date
     */
    end_date?: string | null;
    status?: DocumentLifecycleStatusEnum;
    /** Return whether the document is archived (expired or renewed). */
    is_archived?: boolean;
    /** @format uuid */
    superseded_by_uuid?: string | null;
    /** @format date-time */
    created?: string;
    /** @format date-time */
    modified?: string;
    /** ISO country codes this document applies to. Empty = all countries. */
    countries?: Country[];
}

export interface PatchedOrderDispute {
    /** @format uuid */
    uuid?: string;
    /** @format date-time */
    created?: string;
    reasons_for_dispute?: string;
}

export interface PatchedOrderEventAdmin {
    id?: number;
    /** @format date-time */
    created?: string;
    /** @format uuid */
    uuid?: string;
    order?: number;
    text?: string | null;
    /**
     * * `mark_order_as_paid_out` - mark_order_as_paid_out
     * * `mark_as_paid` - mark_as_paid
     * * `comment` - comment
     */
    event_type?: OrderEventTypeEnum;
    user?: User;
}

export interface PatchedOrderLineItemOtifData {
    /** @format uuid */
    uuid?: string;
    /** @format uuid */
    line_item_uuid?: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,9}(?:\.\d{0,3})?$
     */
    quantity_supplied?: string | null;
    /**
     * @format decimal
     * @pattern ^-?\d{0,9}(?:\.\d{0,3})?$
     */
    quality_issues?: string | null;
    /** @format date */
    expected_delivery?: string | null;
    /** @format date */
    actual_delivery?: string | null;
    quality_issue_type?: QualityIssueTypeEnum[];
    delivery_issue_type?: OtifDataDeliveryIssueType[];
    delivery_issue_type_uuids?: string[];
    /** @maxLength 1024 */
    notes?: string;
    /** @format date-time */
    created_at?: string;
    /** @format date-time */
    modified_at?: string;
}

export interface PatchedOrderLineItemSourceDetail {
    /** @format uuid */
    uuid?: string;
    /** @format uuid */
    order_line_item_uuid?: string;
    /** @format uuid */
    traded_item_uuid?: string | null;
    traded_item_name?: string | null;
    /** @format uuid */
    linked_by_uuid?: string | null;
    /** @format date-time */
    created_at?: string;
    /** @format date-time */
    modified_at?: string;
}

export interface PatchedOrderManagementContractUpdate {
    /**
     * * `EUR` - EUR
     * * `GBP` - GBP
     * * `USD` - USD
     */
    currency?: AvailableCurrenciesEnum;
    /** @format date */
    start_date?: string;
    /** @format date */
    signed_date?: string;
    /** @min 1 */
    period_in_months?: number;
    /** @min 0 */
    total_contract_value?: number;
    /**
     * @format decimal
     * @pattern ^-?\d{0,1}(?:\.\d{0,4})?$
     */
    service_fee_percentage?: string;
    service_fees?: OrderManagementContractServiceFeeCreate[];
}

export interface PatchedOrderUpdateAdmin {
    /** @format date */
    payout_date?: string | null;
    is_order_paid_out?: boolean;
    /** @default false */
    send_email?: boolean;
}

export interface PatchedQuoteDispatchAddress {
    id?: number;
    /** @maxLength 255 */
    name?: string;
    /** @maxLength 255 */
    street_1?: string | null;
    /** @maxLength 255 */
    street_2?: string | null;
    /** @maxLength 255 */
    contact_full_name?: string | null;
    /** @maxLength 50 */
    contact_phone?: string | null;
    phone_country_code?: PhoneCountryCodeEnum | BlankEnum | NullEnum | null;
    /** @maxLength 100 */
    town?: string | null;
    /** @maxLength 100 */
    region?: string | null;
    /** @maxLength 100 */
    postcode?: string | null;
    /** @maxLength 20 */
    eori_number?: string;
    delivery_instructions?: string | null;
    /** @maxLength 100 */
    building?: string | null;
    /**
     * @format decimal
     * @pattern ^-?\d{0,4}(?:\.\d{0,15})?$
     */
    latitude?: string | null;
    /**
     * @format decimal
     * @pattern ^-?\d{0,4}(?:\.\d{0,15})?$
     */
    longitude?: string | null;
    collection_instructions?: string | null;
    /** @format uuid */
    uuid?: string;
    country?: Country | NullEnum | null;
    place_id?: string | null;
    vat_number?: string | null;
    vat_country_code?: Country | NullEnum | null;
    vat_exempt?: boolean;
    country_type?: CountryTypeEnum;
}

export interface PatchedQuoteFeesAdmin {
    id?: number;
    /** @format uuid */
    uuid?: string;
    quote?: number;
    /** @maxLength 255 */
    title?: string;
    description?: string | null;
    /**
     * * `buyer_to_opply` - Buyer To Opply
     * * `buyer_to_supplier` - Buyer To Supplier
     * * `buyer_shipping_to_opply` - Buyer Shipping To Opply
     * * `supplier_to_buyer` - Supplier To Buyer
     * * `supplier_to_opply` - Supplier To Opply
     * * `opply_to_supplier` - Opply To Supplier
     */
    category?: QuoteFeesAdminCategoryEnum;
    /**
     * @format decimal
     * @pattern ^-?\d{0,9}(?:\.\d{0,10})?$
     */
    amount?: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,1}(?:\.\d{0,4})?$
     */
    vat_rate?: string;
    currency?: Currencies;
}

export interface PatchedQuoteUpdateAdmin {
    /**
     * @format decimal
     * @pattern ^-?\d{0,9}(?:\.\d{0,10})?$
     */
    buyer_unit_price?: string | null;
    /**
     * @format decimal
     * @pattern ^-?\d{0,9}(?:\.\d{0,10})?$
     */
    buyer_total_price?: string | null;
    /**
     * @format decimal
     * @pattern ^-?\d{0,1}(?:\.\d{0,4})?$
     */
    buyer_vat_rate?: string | null;
}

/**
 * Serializer for supplier information.
 *
 * Only includes fields that are actively used in the public buyer onboarding form.
 * Other model fields are kept for backward compatibility but not exposed in the API.
 */
export interface PatchedSupplier {
    id?: number;
    /**
     * Supplier name
     * @maxLength 255
     */
    supplier_name?: string;
    /**
     * Average monthly spend with this supplier
     * @format decimal
     * @pattern ^-?\d{0,10}(?:\.\d{0,2})?$
     */
    average_monthly_spend?: string | null;
    /**
     * Invoice/Payment currency (e.g., USD, GBP, EUR)
     * @maxLength 3
     */
    invoice_currency?: string;
    /** Supplier payment terms */
    payment_terms?: string;
    /**
     * Priority to onboard this supplier
     *
     * * `high` - High
     * * `medium` - Medium
     * * `low` - Low
     */
    priority?: PriorityEnum | BlankEnum;
    /**
     * Supplier country
     * @maxLength 100
     */
    supplier_country?: string;
    /** Does the supplier arrange delivery? */
    arranges_delivery?: boolean;
    /**
     * Agreed lead time
     * @maxLength 255
     */
    lead_time?: string;
    /** Is this an organic supplier? */
    is_organic?: boolean;
    /** Any noteworthy information about your trading relationship */
    relationship_notes?: string;
    /**
     * Supplier spreadsheet
     * @format uri
     */
    supplier_spreadsheet?: string | null;
    supplier_spreadsheet_url?: string;
    /** @format date-time */
    created_at?: string;
    /** @format date-time */
    modified_at?: string;
}

/** Serializer for marking an order as dispatched with shipping details */
export interface PatchedSupplierAppOrderDispatch {
    tracking_code?: string | null;
    shipping_provider?: string;
    /** @format date */
    estimated_delivery_date?: string;
    /** @format date */
    dispatched_at?: string;
}

export interface PatchedSupplierCompany {
    id?: number;
    /** @format uuid */
    uuid?: string;
    /** @format uri */
    website?: string;
    /** @maxLength 255 */
    name?: string;
    /** @format uri */
    logo?: string | null;
    /** @maxLength 100 */
    industry?: string | null;
    kyb_status?: string;
    /** @maxLength 50 */
    phone_number?: string | null;
    country?: string;
    state?: string;
    /**
     * * `brand` - Brand
     * * `supplier` - Supplier
     * * `merchant_of_record` - Merchant of Record
     */
    company_type?: CompanyTypeEnum;
    /** @default ["e","h","o","r","t"] */
    product_type?: ProductTypeEnum[];
    /** @default ["e","h","o","r","t"] */
    activity_type?: ActivityTypeEnum[];
    /** @maxLength 255 */
    registration_number?: string | null;
    /** @maxLength 255 */
    registration_name?: string | null;
    mongo_id?: string | null;
    referral_code?: string;
    phone_country_code?: PhoneCountryCodeEnum | BlankEnum | NullEnum | null;
    company_addresses?: CompanyAddress[];
    currency?: string;
    /**
     * rapyd payout method
     * @maxLength 45
     */
    payout_method_type?: string | null;
    bank_account_country?: Country | BlankEnum | NullEnum | null;
    /**
     * DUNS number for creditworthiness checks and payouts
     * @maxLength 50
     */
    duns?: string | null;
}

export interface PatchedSupplierContact {
    /** @format uuid */
    uuid?: string;
    /** @maxLength 150 */
    first_name?: string;
    /** @maxLength 150 */
    last_name?: string;
    /**
     * @format email
     * @maxLength 254
     */
    email?: string;
    /** @maxLength 50 */
    phone_number?: string;
    /**
     * * `orders` - Orders
     * * `logistics` - Logistics and Supply Chain
     * * `finance` - Finance
     * * `other` - Other
     */
    category?: SupplierContactCategoryEnum;
    /** @format date-time */
    created?: string;
    /** @format date-time */
    modified?: string;
    notes?: string;
}

export interface PatchedSupplierDocument {
    /** @format uuid */
    uuid?: string;
    company?: number;
    /** @format uuid */
    supplier_uuid?: string;
    supplier_name?: string;
    type?: DocumentType;
    /** @format uuid */
    type_uuid?: string;
    /** @format uuid */
    renewing_uuid?: string | null;
    site?: SupplierSite;
    /** @format uuid */
    site_uuid?: string | null;
    /** Address/site name - auto-creates SupplierSite if not exists (SC-2293) */
    site_name?: string;
    /**
     * Buyer company UUID (optional)
     * @format uuid
     */
    buyer_uuid?: string | null;
    /** Return the buyer company name if assigned. */
    buyer_name?: string | null;
    /** @format uri */
    url?: string;
    /** @format date */
    start_date?: string | null;
    /** @format date */
    end_date?: string | null;
    /** @maxLength 2048 */
    notes?: string | null;
    status?: DocumentLifecycleStatusEnum;
    /** Return whether the document is archived. */
    is_archived?: boolean;
    /** @format uuid */
    superseded_by_uuid?: string | null;
}

export interface PatchedSupplierItemDetail {
    /** @format uuid */
    uuid?: string;
    /** @maxLength 255 */
    item_name?: string;
    /** @maxLength 255 */
    sku?: string | null;
    item_description?: string | null;
    /**
     * @format uri
     * @maxLength 2048
     */
    logo_url?: string;
    /** @format uuid */
    supplier_company_uuid?: string;
    supplier_company_name?: string;
    /** @format uuid */
    category_uuid?: string | null;
    /**
     * What kind of material this row represents (ingredient, packaging, ...).
     *
     * * `ingredient` - Ingredient
     * * `packaging` - Packaging
     */
    kind?: CatalogItemKindEnum;
    /**
     * Natural unit the material is measured in.
     *
     * * `fl oz` - Fluid Ounces
     * * `g` - Grams
     * * `mg` - milligrams
     * * `gals` - Gallons
     * * `kg` - Kilograms
     * * `L` - Liters
     * * `tons` - Metric Tons
     * * `oz` - Ounces
     * * `lbs` - Pounds
     * * `pcs` - Pieces
     * * `pt` - Pints
     * * `ml` - Milliliter
     * * `boxes` - Boxes
     * * `pallets` - Pallets
     * * `tsp` - Teaspoons
     * * `tbsp` - Tablespoons
     * * `units` - Units
     * * `cases` - Cases
     * * `trays` - Trays
     */
    unit_of_measurement?: UnitOfMeasurementEnum;
    contained_allergens?: ContainedAllergensEnum[];
    /** A signed allergen declaration is available on file for this material. */
    has_allergen_declaration?: boolean;
    diet_compliance?: DietComplianceEnum[];
    /** A dietary certificate is available on file for this material. */
    has_dietary_certificate?: boolean;
    is_active?: boolean;
    documents?: SupplierItemDocument[];
    /** @format date-time */
    created_at?: string;
    /** @format date-time */
    modified_at?: string;
}

export interface PatchedSupplierPayoutDetails {
    /** @format uuid */
    uuid?: string;
    /**
     * * `US` - Us
     * * `GB` - Gb
     * * `CA` - Ca
     * * `AT` - At
     * * `BE` - Be
     * * `CY` - Cy
     * * `DE` - De
     * * `EE` - Ee
     * * `ES` - Es
     * * `FI` - Fi
     * * `FR` - Fr
     * * `GR` - Gr
     * * `IE` - Ie
     * * `IT` - It
     * * `LT` - Lt
     * * `LU` - Lu
     * * `LV` - Lv
     * * `MT` - Mt
     * * `NL` - Nl
     * * `PT` - Pt
     * * `SI` - Si
     * * `SK` - Sk
     * * `BG` - Bg
     * * `CZ` - Cz
     * * `DK` - Dk
     * * `HR` - Hr
     * * `HU` - Hu
     * * `PL` - Pl
     * * `RO` - Ro
     * * `SE` - Se
     * * `EU` - Eu
     */
    bank_country?: BankingCountryTypeEnum;
    /** @maxLength 255 */
    bank_name?: string;
    /** @maxLength 255 */
    account_holder_name?: string;
    /** @maxLength 64 */
    account_number?: string;
    /** @maxLength 16 */
    sort_code?: string;
    /** @maxLength 32 */
    routing_number?: string;
    account_type?: AccountTypeEnum | BlankEnum;
    /** @maxLength 64 */
    iban?: string;
    /** @maxLength 32 */
    bic?: string;
    /** @maxLength 100 */
    account_holder_building?: string;
    /** @maxLength 255 */
    account_holder_street_1?: string;
    /** @maxLength 255 */
    account_holder_street_2?: string;
    /** @maxLength 100 */
    account_holder_town?: string;
    /** @maxLength 100 */
    account_holder_region?: string;
    /** @maxLength 100 */
    account_holder_postcode?: string;
    /**
     * * `AF` - Afghanistan
     * * `AX` - Åland Islands
     * * `AL` - Albania
     * * `DZ` - Algeria
     * * `AS` - American Samoa
     * * `AD` - Andorra
     * * `AO` - Angola
     * * `AI` - Anguilla
     * * `AQ` - Antarctica
     * * `AG` - Antigua and Barbuda
     * * `AR` - Argentina
     * * `AM` - Armenia
     * * `AW` - Aruba
     * * `AU` - Australia
     * * `AT` - Austria
     * * `AZ` - Azerbaijan
     * * `BS` - Bahamas
     * * `BH` - Bahrain
     * * `BD` - Bangladesh
     * * `BB` - Barbados
     * * `BY` - Belarus
     * * `BE` - Belgium
     * * `BZ` - Belize
     * * `BJ` - Benin
     * * `BM` - Bermuda
     * * `BT` - Bhutan
     * * `BO` - Bolivia
     * * `BQ` - Bonaire, Sint Eustatius and Saba
     * * `BA` - Bosnia and Herzegovina
     * * `BW` - Botswana
     * * `BV` - Bouvet Island
     * * `BR` - Brazil
     * * `IO` - British Indian Ocean Territory
     * * `BN` - Brunei
     * * `BG` - Bulgaria
     * * `BF` - Burkina Faso
     * * `BI` - Burundi
     * * `CV` - Cabo Verde
     * * `KH` - Cambodia
     * * `CM` - Cameroon
     * * `CA` - Canada
     * * `KY` - Cayman Islands
     * * `CF` - Central African Republic
     * * `TD` - Chad
     * * `CL` - Chile
     * * `CN` - China
     * * `CX` - Christmas Island
     * * `CC` - Cocos (Keeling) Islands
     * * `CO` - Colombia
     * * `KM` - Comoros
     * * `CG` - Congo
     * * `CD` - Congo (the Democratic Republic of the)
     * * `CK` - Cook Islands
     * * `CR` - Costa Rica
     * * `CI` - Côte d'Ivoire
     * * `HR` - Croatia
     * * `CU` - Cuba
     * * `CW` - Curaçao
     * * `CY` - Cyprus
     * * `CZ` - Czechia
     * * `DK` - Denmark
     * * `DJ` - Djibouti
     * * `DM` - Dominica
     * * `DO` - Dominican Republic
     * * `EC` - Ecuador
     * * `EG` - Egypt
     * * `SV` - El Salvador
     * * `GQ` - Equatorial Guinea
     * * `ER` - Eritrea
     * * `EE` - Estonia
     * * `SZ` - Eswatini
     * * `ET` - Ethiopia
     * * `FK` - Falkland Islands (Malvinas)
     * * `FO` - Faroe Islands
     * * `FJ` - Fiji
     * * `FI` - Finland
     * * `FR` - France
     * * `GF` - French Guiana
     * * `PF` - French Polynesia
     * * `TF` - French Southern Territories
     * * `GA` - Gabon
     * * `GM` - Gambia
     * * `GE` - Georgia
     * * `DE` - Germany
     * * `GH` - Ghana
     * * `GI` - Gibraltar
     * * `GR` - Greece
     * * `GL` - Greenland
     * * `GD` - Grenada
     * * `GP` - Guadeloupe
     * * `GU` - Guam
     * * `GT` - Guatemala
     * * `GG` - Guernsey
     * * `GN` - Guinea
     * * `GW` - Guinea-Bissau
     * * `GY` - Guyana
     * * `HT` - Haiti
     * * `HM` - Heard Island and McDonald Islands
     * * `VA` - Holy See
     * * `HN` - Honduras
     * * `HK` - Hong Kong
     * * `HU` - Hungary
     * * `IS` - Iceland
     * * `IN` - India
     * * `ID` - Indonesia
     * * `IR` - Iran
     * * `IQ` - Iraq
     * * `IE` - Ireland
     * * `IM` - Isle of Man
     * * `IL` - Israel
     * * `IT` - Italy
     * * `JM` - Jamaica
     * * `JP` - Japan
     * * `JE` - Jersey
     * * `JO` - Jordan
     * * `KZ` - Kazakhstan
     * * `KE` - Kenya
     * * `KI` - Kiribati
     * * `KW` - Kuwait
     * * `KG` - Kyrgyzstan
     * * `LA` - Laos
     * * `LV` - Latvia
     * * `LB` - Lebanon
     * * `LS` - Lesotho
     * * `LR` - Liberia
     * * `LY` - Libya
     * * `LI` - Liechtenstein
     * * `LT` - Lithuania
     * * `LU` - Luxembourg
     * * `MO` - Macao
     * * `MG` - Madagascar
     * * `MW` - Malawi
     * * `MY` - Malaysia
     * * `MV` - Maldives
     * * `ML` - Mali
     * * `MT` - Malta
     * * `MH` - Marshall Islands
     * * `MQ` - Martinique
     * * `MR` - Mauritania
     * * `MU` - Mauritius
     * * `YT` - Mayotte
     * * `MX` - Mexico
     * * `FM` - Micronesia
     * * `MD` - Moldova
     * * `MC` - Monaco
     * * `MN` - Mongolia
     * * `ME` - Montenegro
     * * `MS` - Montserrat
     * * `MA` - Morocco
     * * `MZ` - Mozambique
     * * `MM` - Myanmar
     * * `NA` - Namibia
     * * `NR` - Nauru
     * * `NP` - Nepal
     * * `NL` - Netherlands
     * * `NC` - New Caledonia
     * * `NZ` - New Zealand
     * * `NI` - Nicaragua
     * * `NE` - Niger
     * * `NG` - Nigeria
     * * `NU` - Niue
     * * `NF` - Norfolk Island
     * * `KP` - North Korea
     * * `MK` - North Macedonia
     * * `XI` - Northern Ireland
     * * `MP` - Northern Mariana Islands
     * * `NO` - Norway
     * * `OM` - Oman
     * * `PK` - Pakistan
     * * `PW` - Palau
     * * `PS` - Palestine, State of
     * * `PA` - Panama
     * * `PG` - Papua New Guinea
     * * `PY` - Paraguay
     * * `PE` - Peru
     * * `PH` - Philippines
     * * `PN` - Pitcairn
     * * `PL` - Poland
     * * `PT` - Portugal
     * * `PR` - Puerto Rico
     * * `QA` - Qatar
     * * `RE` - Réunion
     * * `RO` - Romania
     * * `RU` - Russia
     * * `RW` - Rwanda
     * * `BL` - Saint Barthélemy
     * * `SH` - Saint Helena, Ascension and Tristan da Cunha
     * * `KN` - Saint Kitts and Nevis
     * * `LC` - Saint Lucia
     * * `MF` - Saint Martin (French part)
     * * `PM` - Saint Pierre and Miquelon
     * * `VC` - Saint Vincent and the Grenadines
     * * `WS` - Samoa
     * * `SM` - San Marino
     * * `ST` - Sao Tome and Principe
     * * `SA` - Saudi Arabia
     * * `SN` - Senegal
     * * `RS` - Serbia
     * * `SC` - Seychelles
     * * `SL` - Sierra Leone
     * * `SG` - Singapore
     * * `SX` - Sint Maarten (Dutch part)
     * * `SK` - Slovakia
     * * `SI` - Slovenia
     * * `SB` - Solomon Islands
     * * `SO` - Somalia
     * * `ZA` - South Africa
     * * `GS` - South Georgia and the South Sandwich Islands
     * * `KR` - South Korea
     * * `SS` - South Sudan
     * * `ES` - Spain
     * * `LK` - Sri Lanka
     * * `SD` - Sudan
     * * `SR` - Suriname
     * * `SJ` - Svalbard and Jan Mayen
     * * `SE` - Sweden
     * * `CH` - Switzerland
     * * `SY` - Syria
     * * `TW` - Taiwan
     * * `TJ` - Tajikistan
     * * `TZ` - Tanzania
     * * `TH` - Thailand
     * * `TL` - Timor-Leste
     * * `TG` - Togo
     * * `TK` - Tokelau
     * * `TO` - Tonga
     * * `TT` - Trinidad and Tobago
     * * `TN` - Tunisia
     * * `TR` - Türkiye
     * * `TM` - Turkmenistan
     * * `TC` - Turks and Caicos Islands
     * * `TV` - Tuvalu
     * * `UG` - Uganda
     * * `UA` - Ukraine
     * * `AE` - United Arab Emirates
     * * `GB` - United Kingdom
     * * `UM` - United States Minor Outlying Islands
     * * `US` - United States of America
     * * `UY` - Uruguay
     * * `UZ` - Uzbekistan
     * * `VU` - Vanuatu
     * * `VE` - Venezuela
     * * `VN` - Vietnam
     * * `VG` - Virgin Islands (British)
     * * `VI` - Virgin Islands (U.S.)
     * * `WF` - Wallis and Futuna
     * * `EH` - Western Sahara
     * * `YE` - Yemen
     * * `ZM` - Zambia
     * * `ZW` - Zimbabwe
     */
    account_holder_country?: Country;
    /** @format date-time */
    created?: string;
    /** @format date-time */
    modified?: string;
    note?: string;
}

export interface PatchedSupplierQuoteUpdate {
    company?: Company;
    /** @maxLength 255 */
    product_name?: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,10}(?:\.\d{0,2})?$
     */
    quantity?: string;
    /** @format date */
    delivery_date?: string;
    /**
     * * `in_advance` - In Advance
     * * `on_dispatch` - On Dispatch
     */
    payment_scenario?: PaymentScenarioEnum;
    /**
     * @min 0
     * @max 365
     */
    payment_delay?: number;
    /**
     * @min 0
     * @default 0
     */
    shelf_life?: number | null;
    /**
     * @min 0
     * @max 2147483647
     */
    quote_valid_for?: number | null;
    /**
     * The maximum time a supplier agrees to deliver the product within (days)
     * @min 0
     * @max 2147483647
     */
    lead_time?: number;
    product_description?: string | null;
    /**
     * @format decimal
     * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
     */
    shipping_cost?: string | null;
    /**
     * * `EUR` - EUR
     * * `USD` - USD
     * * `GBP` - GBP
     * * `CAD` - CAD
     */
    currency?: Currencies;
    /**
     * Datetime when the quote becomes published. Leave empty to keep it unpublished.
     * @format date-time
     */
    published?: string | null;
    /**
     * * `fl oz` - Fluid Ounces
     * * `g` - Grams
     * * `mg` - milligrams
     * * `gals` - Gallons
     * * `kg` - Kilograms
     * * `L` - Liters
     * * `tons` - Metric Tons
     * * `oz` - Ounces
     * * `lbs` - Pounds
     * * `pcs` - Pieces
     * * `pt` - Pints
     * * `ml` - Milliliter
     * * `boxes` - Boxes
     * * `pallets` - Pallets
     * * `tsp` - Teaspoons
     * * `tbsp` - Tablespoons
     * * `units` - Units
     * * `cases` - Cases
     * * `trays` - Trays
     */
    unit_of_measurement?: UnitOfMeasurementEnum;
    /** @format date-time */
    created_date?: string;
    /**
     * @format uri
     * @maxLength 2048
     */
    logo_url?: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,9}(?:\.\d{0,10})?$
     */
    total_price?: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,9}(?:\.\d{0,10})?$
     */
    unit_price?: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,1}(?:\.\d{0,4})?$
     */
    vat_rate?: string | null;
    is_reverse_charge?: boolean;
    /**
     * @format decimal
     * @pattern ^-?\d{0,7}(?:\.\d{0,2})?$
     */
    commission_payout_vat_rate?: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,7}(?:\.\d{0,2})?$
     */
    commission_payin_vat_rate?: string;
    commission_is_reverse_charge?: boolean;
    /** @maxLength 32 */
    sku?: string | null;
    /** @default "delivery_duty_paid" */
    incoterms?: IncotermsEnum | NullEnum | null;
    dispatch_address?: number | null;
    /**
     * * `available` - Available
     * * `requested` - Requested
     * * `sent` - Sent
     * * `received` - Received
     * * `accepted` - Accepted
     * * `rejected` - Rejected
     * * `declined` - Declined
     */
    samples_status?: SamplesStatusEnum;
    samples_delivery_address?: number | null;
    /**
     * @min 0
     * @max 2147483647
     */
    recurring_order_lead_time?: number | null;
    /**
     * Duration of the contract in months.
     * @min -2147483648
     * @max 2147483647
     */
    contract_length?: number | null;
    /**
     * @format decimal
     * @pattern ^-?\d{0,17}(?:\.\d{0,2})?$
     */
    case_size?: string | null;
    /**
     * @format decimal
     * @pattern ^-?\d{0,17}(?:\.\d{0,2})?$
     */
    minimum_order_quantity?: string | null;
    agreement_required?: boolean;
    account_form_required?: boolean;
    /**
     * * `non_recurring` - Non Recurring
     * * `recurring` - Recurring
     * * `purchase_request_quote` - Purchase Request Quote
     */
    category?: QuoteCategory;
    /** @format date */
    samples_declined_date?: string | null;
    samples_feedback?: SamplesFeedbackEnum[] | null;
    samples_feedback_comment?: string;
    /**
     * * `in_advance` - In Advance
     * * `on_dispatch` - On Dispatch
     * * `7_days_after_dispatch` - Days After Dispatch 7
     * * `14_days_after_dispatch` - Days After Dispatch 14
     * * `30_days_after_dispatch` - Days After Dispatch 30
     * * `60_days_after_dispatch` - Days After Dispatch 60
     */
    payment_terms?: PaymentTermsEnum;
    is_custom_contract?: boolean;
    /** @format date */
    samples_dispatch_date?: string | null;
    /** @format date */
    samples_sent_date?: string | null;
    samples_tracking_code?: string | null;
    /** @format date */
    samples_expected_delivery_date?: string | null;
    /** @maxLength 255 */
    samples_shipping_provider?: string | null;
    autoconfirm_orders?: boolean;
    /**
     * @min 0
     * @max 2147483647
     */
    minimum_lead_time?: number | null;
    /**
     * @min 0
     * @max 2147483647
     */
    order_in_multiples_of?: number | null;
    /**
     * @min 0
     * @max 2147483647
     */
    minimum_autoconfirm_order_quantity?: number | null;
    /**
     * @min 0
     * @max 2147483647
     */
    maximum_autoconfirm_order_quantity?: number | null;
    packaging_format?: string;
    show_to_other_buyers?: boolean;
    description_blocks?: QuoteDescriptionBlockCreate[] | null;
    /**
     * @format decimal
     * @pattern ^-?\d{0,1}(?:\.\d{0,4})?$
     */
    shipping_vat_rate?: string | null;
    /**
     * @format decimal
     * @pattern ^-?\d{0,10}(?:\.\d{0,2})?$
     */
    total_forecast_quantity?: string | null;
    /**
     * * `total` - total
     * * `unit` - unit
     */
    selected_price_option?: SelectedPriceOptionEnum;
    update_requested?: boolean;
}

/** Serializer for updating the entire list of buyers for a supplier. */
export interface PatchedSupplierUpdateBuyers {
    /** List of buyer UUIDs to associate with this supplier */
    buyer_uuids?: string[];
}

export interface PatchedTask {
    /** @format uuid */
    uuid?: string;
    /** @maxLength 512 */
    title?: string;
    description?: string;
    /** @format date */
    due_date?: string | null;
    /**
     * * `open` - Open
     * * `in_progress` - In Progress
     * * `done` - Done
     */
    status?: TaskStatusEnum;
    /** @format date-time */
    completed_at?: string | null;
    /**
     * * `low` - Low
     * * `medium` - Medium
     * * `high` - High
     * * `urgent` - Urgent
     */
    priority?: TaskPriorityEnum;
    is_private?: boolean;
    assignee?: UserMinimal;
    /** @format uuid */
    assignee_uuid?: string | null;
    created_by?: UserMinimal;
    watchers?: UserMinimal[];
    watcher_uuids?: string[];
    target?: Target;
    target_type?: string | null;
    /** @format uuid */
    target_uuid?: string | null;
    parent_task?: Record<string, any>;
    /** @format uuid */
    parent_task_uuid?: string | null;
    subtasks?: Record<string, any>[];
    /** List of task attachments */
    attachments?: Record<string, any>[];
    /** @format date-time */
    created?: string;
    /** @format date-time */
    modified?: string;
}

export interface PatchedTradedItemDetail {
    /** @format uuid */
    uuid?: string;
    item_name?: string;
    /** @maxLength 255 */
    sku?: string | null;
    item_description?: string | null;
    /** @format uuid */
    supplier_company_uuid?: string;
    supplier_company_name?: string;
    /** @format uuid */
    buyer_company_uuid?: string | null;
    buyer_company_name?: string | null;
    /** @format uuid */
    category_uuid?: string | null;
    is_active?: boolean;
    documents?: TradedItemDocument[];
    /** @format date-time */
    created_at?: string;
    /** @format date-time */
    modified_at?: string;
}

export interface PatchedUpdatePurchaseRequest {
    /**
     * @format decimal
     * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
     */
    quantity?: string;
    /** @format date */
    due_date?: string;
    delivery_address?: number | null;
    /** @format uuid */
    purchase_quote_uuid?: string;
}

export interface PatchedUploadedProductsCatalogue {
    id?: number;
    /** @format uuid */
    uuid?: string;
    /**
     * * `pending` - Pending
     * * `being_processed` - Is being processed
     * * `processed` - Processed
     * * `failed` - Failed
     */
    status?: UploadedProductsCatalogueStatus;
    /** @format uri */
    catalogue?: string | null;
}

export interface PatchedUser {
    id?: number;
    /** @format uuid */
    uuid?: string;
    /** @format email */
    email?: string;
    /** @maxLength 150 */
    first_name?: string;
    /** @maxLength 150 */
    last_name?: string;
    /** @maxLength 255 */
    job_title?: string | null;
    /** @format double */
    tc_version?: number;
}

export interface PatchedUserList {
    /** @format uuid */
    uuid?: string;
    /** @maxLength 150 */
    first_name?: string;
    /** @maxLength 150 */
    last_name?: string;
    /**
     * @format email
     * @maxLength 254
     */
    email?: string;
    company_name?: string | null;
    last_login?: UserAction;
}

export interface PatchedSetStatusInput {
    /**
     * * `active` - Active
     * * `paused` - Paused
     * * `revoked` - Revoked
     */
    status?: AgentInstallationStatusEnum;
}

/**
 * * `initializing` - Initializing
 * * `not_started` - Not Started
 * * `due` - Due
 * * `overdue` - Overdue
 * * `awaiting_reconciliation` - Awaiting Reconciliation
 * * `paid` - Paid
 * * `refunded` - Refunded
 * * `partially_refunded` - Partially Refunded
 */
export enum PayInStateEnum {
    Initializing = "initializing",
    NotStarted = "not_started",
    Due = "due",
    Overdue = "overdue",
    AwaitingReconciliation = "awaiting_reconciliation",
    Paid = "paid",
    Refunded = "refunded",
    PartiallyRefunded = "partially_refunded",
}

export interface PaymentAvailability {
    /** @format uuid */
    order_id: string;
}

export interface PaymentBucket {
    count: number;
    /** Total amount in cents */
    total: number;
}

export interface PaymentDetailsInvoice {
    /**
     * * `card` - Card
     * * `bank_transfer` - Bank Transfer
     * * `PAY30` - Kriya 30
     * * `PAY30EOFM` - Kriya Next Month
     */
    payment_method: PaymentMethod;
    /**
     * * `in_advance` - In Advance
     * * `on_dispatch` - On Dispatch
     */
    payment_scenario: PaymentScenarioEnum;
    bank_transfer_details: any;
}

/** Serializer for the available filter options. */
export interface PaymentFilters {
    suppliers: BuyerAppOrderListSuppliers[];
}

/**
 * * `card` - Card
 * * `bank_transfer` - Bank Transfer
 * * `PAY30` - Kriya 30
 * * `PAY30EOFM` - Kriya Next Month
 */
export enum PaymentMethod {
    Card = "card",
    BankTransfer = "bank_transfer",
    PAY30 = "PAY30",
    PAY30EOFM = "PAY30EOFM",
}

/**
 * * `stripe` - Stripe
 * * `two` - Two
 * * `direct` - Direct
 */
export enum PaymentProviderEnum {
    Stripe = "stripe",
    Two = "two",
    Direct = "direct",
}

/**
 * * `in_advance` - In Advance
 * * `on_dispatch` - On Dispatch
 */
export enum PaymentScenarioEnum {
    InAdvance = "in_advance",
    OnDispatch = "on_dispatch",
}

/**
 * * `paid` - paid
 * * `payment_upcoming` - payment_upcoming
 * * `payment_processing` - payment_processing
 * * `payment_due` - payment_due
 */
export enum PaymentStatusEnum {
    Paid = "paid",
    PaymentUpcoming = "payment_upcoming",
    PaymentProcessing = "payment_processing",
    PaymentDue = "payment_due",
}

/**
 * * `in_advance` - In Advance
 * * `on_dispatch` - On Dispatch
 * * `7_days_after_dispatch` - Days After Dispatch 7
 * * `14_days_after_dispatch` - Days After Dispatch 14
 * * `30_days_after_dispatch` - Days After Dispatch 30
 * * `60_days_after_dispatch` - Days After Dispatch 60
 */
export enum PaymentTermsEnum {
    InAdvance = "in_advance",
    OnDispatch = "on_dispatch",
    Value7DaysAfterDispatch = "7_days_after_dispatch",
    Value14DaysAfterDispatch = "14_days_after_dispatch",
    Value30DaysAfterDispatch = "30_days_after_dispatch",
    Value60DaysAfterDispatch = "60_days_after_dispatch",
}

export interface PayoutCallback {
    beneficiary_id: string;
    payout_method_type: string;
    merchant_reference_id: string;
}

export interface PayoutCompanyType {
    /**
     * * `Sole Proprietor` - Sole Proprietor
     * * `Private Limited Company` - Private Limited Company
     */
    company_type: PayoutCompanyTypeCompanyTypeEnum;
}

/**
 * * `Sole Proprietor` - Sole Proprietor
 * * `Private Limited Company` - Private Limited Company
 */
export enum PayoutCompanyTypeCompanyTypeEnum {
    SoleProprietor = "Sole Proprietor",
    PrivateLimitedCompany = "Private Limited Company",
}

/**
 * * `initializing` - Initializing
 * * `not_started` - Not Started
 * * `due` - Due
 * * `overdue` - Overdue
 * * `paid` - Paid
 * * `refunded` - Refunded
 * * `partially_refunded` - Partially Refunded
 */
export enum PayoutStateEnum {
    Initializing = "initializing",
    NotStarted = "not_started",
    Due = "due",
    Overdue = "overdue",
    Paid = "paid",
    Refunded = "refunded",
    PartiallyRefunded = "partially_refunded",
}

/** Serializer for payout state lookup request. */
export interface PayoutStateForDateRequest {
    /**
     * The payout due date to check
     * @format date
     */
    due_date: string;
}

/** Serializer for payout state lookup response. */
export interface PayoutStateForDateResponse {
    /**
     * The payout due date that was checked
     * @format date
     */
    due_date: string;
    /**
     * The expected payout state for the given due date (DUE or OVERDUE)
     *
     * * `due` - Due
     * * `overdue` - Overdue
     */
    expected_payout_state: ExpectedPayoutStateEnum;
}

/**
 * * `payout_before_dispatch` - Payout Before Dispatch
 * * `payout_after_dispatch` - Payout After Dispatch
 */
export enum PayoutTermsEnum {
    PayoutBeforeDispatch = "payout_before_dispatch",
    PayoutAfterDispatch = "payout_after_dispatch",
}

/**
 * * `phase_1` - Phase 1
 * * `phase_2` - Phase 2
 * * `phase_3` - Phase 3
 * * `phase_4` - Phase 4
 */
export enum PhaseEnum {
    Phase1 = "phase_1",
    Phase2 = "phase_2",
    Phase3 = "phase_3",
    Phase4 = "phase_4",
}

/**
 * * `+376` - +376
 * * `+971` - +971
 * * `+93` - +93
 * * `+1268` - +1268
 * * `+1264` - +1264
 * * `+355` - +355
 * * `+374` - +374
 * * `+244` - +244
 * * `+672` - +672
 * * `+54` - +54
 * * `+1684` - +1684
 * * `+43` - +43
 * * `+61` - +61
 * * `+297` - +297
 * * `+994` - +994
 * * `+387` - +387
 * * `+1246` - +1246
 * * `+880` - +880
 * * `+32` - +32
 * * `+226` - +226
 * * `+359` - +359
 * * `+973` - +973
 * * `+257` - +257
 * * `+229` - +229
 * * `+590` - +590
 * * `+1441` - +1441
 * * `+673` - +673
 * * `+591` - +591
 * * `+55` - +55
 * * `+1242` - +1242
 * * `+975` - +975
 * * `+267` - +267
 * * `+375` - +375
 * * `+501` - +501
 * * `+1` - +1
 * * `+243` - +243
 * * `+236` - +236
 * * `+242` - +242
 * * `+41` - +41
 * * `+225` - +225
 * * `+682` - +682
 * * `+56` - +56
 * * `+237` - +237
 * * `+86` - +86
 * * `+57` - +57
 * * `+506` - +506
 * * `+53` - +53
 * * `+238` - +238
 * * `+357` - +357
 * * `+420` - +420
 * * `+49` - +49
 * * `+253` - +253
 * * `+45` - +45
 * * `+1767` - +1767
 * * `+1809` - +1809
 * * `+213` - +213
 * * `+593` - +593
 * * `+372` - +372
 * * `+20` - +20
 * * `+212` - +212
 * * `+291` - +291
 * * `+34` - +34
 * * `+251` - +251
 * * `+358` - +358
 * * `+679` - +679
 * * `+500` - +500
 * * `+691` - +691
 * * `+298` - +298
 * * `+33` - +33
 * * `+241` - +241
 * * `+44` - +44
 * * `+1473` - +1473
 * * `+995` - +995
 * * `+594` - +594
 * * `+441481` - +441481
 * * `+233` - +233
 * * `+350` - +350
 * * `+299` - +299
 * * `+220` - +220
 * * `+224` - +224
 * * `+240` - +240
 * * `+30` - +30
 * * `+502` - +502
 * * `+1671` - +1671
 * * `+245` - +245
 * * `+595` - +595
 * * `+852` - +852
 * * `+504` - +504
 * * `+385` - +385
 * * `+509` - +509
 * * `+36` - +36
 * * `+62` - +62
 * * `+353` - +353
 * * `+972` - +972
 * * `+441624` - +441624
 * * `+91` - +91
 * * `+246` - +246
 * * `+964` - +964
 * * `+98` - +98
 * * `+354` - +354
 * * `+39` - +39
 * * `+441534` - +441534
 * * `+1876` - +1876
 * * `+962` - +962
 * * `+81` - +81
 * * `+254` - +254
 * * `+996` - +996
 * * `+855` - +855
 * * `+686` - +686
 * * `+269` - +269
 * * `+1869` - +1869
 * * `+850` - +850
 * * `+82` - +82
 * * `+965` - +965
 * * `+345` - +345
 * * `+7` - +7
 * * `+856` - +856
 * * `+961` - +961
 * * `+1758` - +1758
 * * `+423` - +423
 * * `+94` - +94
 * * `+231` - +231
 * * `+266` - +266
 * * `+370` - +370
 * * `+352` - +352
 * * `+371` - +371
 * * `+218` - +218
 * * `+377` - +377
 * * `+373` - +373
 * * `+382` - +382
 * * `+261` - +261
 * * `+692` - +692
 * * `+389` - +389
 * * `+223` - +223
 * * `+95` - +95
 * * `+976` - +976
 * * `+853` - +853
 * * `+1670` - +1670
 * * `+596` - +596
 * * `+222` - +222
 * * `+1664` - +1664
 * * `+356` - +356
 * * `+230` - +230
 * * `+960` - +960
 * * `+265` - +265
 * * `+52` - +52
 * * `+60` - +60
 * * `+258` - +258
 * * `+264` - +264
 * * `+687` - +687
 * * `+227` - +227
 * * `+234` - +234
 * * `+505` - +505
 * * `+31` - +31
 * * `+47` - +47
 * * `+977` - +977
 * * `+674` - +674
 * * `+683` - +683
 * * `+64` - +64
 * * `+968` - +968
 * * `+507` - +507
 * * `+51` - +51
 * * `+689` - +689
 * * `+675` - +675
 * * `+63` - +63
 * * `+92` - +92
 * * `+48` - +48
 * * `+508` - +508
 * * `+1787` - +1787
 * * `+970` - +970
 * * `+351` - +351
 * * `+680` - +680
 * * `+974` - +974
 * * `+262` - +262
 * * `+40` - +40
 * * `+381` - +381
 * * `+250` - +250
 * * `+966` - +966
 * * `+677` - +677
 * * `+248` - +248
 * * `+249` - +249
 * * `+46` - +46
 * * `+65` - +65
 * * `+290` - +290
 * * `+386` - +386
 * * `+421` - +421
 * * `+232` - +232
 * * `+378` - +378
 * * `+221` - +221
 * * `+252` - +252
 * * `+597` - +597
 * * `+239` - +239
 * * `+503` - +503
 * * `+963` - +963
 * * `+268` - +268
 * * `+1649` - +1649
 * * `+235` - +235
 * * `+228` - +228
 * * `+66` - +66
 * * `+992` - +992
 * * `+690` - +690
 * * `+670` - +670
 * * `+993` - +993
 * * `+216` - +216
 * * `+676` - +676
 * * `+90` - +90
 * * `+1868` - +1868
 * * `+688` - +688
 * * `+886` - +886
 * * `+255` - +255
 * * `+380` - +380
 * * `+256` - +256
 * * `+598` - +598
 * * `+998` - +998
 * * `+379` - +379
 * * `+1784` - +1784
 * * `+58` - +58
 * * `+1284` - +1284
 * * `+1340` - +1340
 * * `+84` - +84
 * * `+678` - +678
 * * `+681` - +681
 * * `+685` - +685
 * * `+967` - +967
 * * `+27` - +27
 * * `+260` - +260
 * * `+263` - +263
 */
export enum PhoneCountryCodeEnum {
    Value376 = "+376",
    Value971 = "+971",
    Value93 = "+93",
    Value1268 = "+1268",
    Value1264 = "+1264",
    Value355 = "+355",
    Value374 = "+374",
    Value244 = "+244",
    Value672 = "+672",
    Value54 = "+54",
    Value1684 = "+1684",
    Value43 = "+43",
    Value61 = "+61",
    Value297 = "+297",
    Value994 = "+994",
    Value387 = "+387",
    Value1246 = "+1246",
    Value880 = "+880",
    Value32 = "+32",
    Value226 = "+226",
    Value359 = "+359",
    Value973 = "+973",
    Value257 = "+257",
    Value229 = "+229",
    Value590 = "+590",
    Value1441 = "+1441",
    Value673 = "+673",
    Value591 = "+591",
    Value55 = "+55",
    Value1242 = "+1242",
    Value975 = "+975",
    Value267 = "+267",
    Value375 = "+375",
    Value501 = "+501",
    Value1 = "+1",
    Value243 = "+243",
    Value236 = "+236",
    Value242 = "+242",
    Value41 = "+41",
    Value225 = "+225",
    Value682 = "+682",
    Value56 = "+56",
    Value237 = "+237",
    Value86 = "+86",
    Value57 = "+57",
    Value506 = "+506",
    Value53 = "+53",
    Value238 = "+238",
    Value357 = "+357",
    Value420 = "+420",
    Value49 = "+49",
    Value253 = "+253",
    Value45 = "+45",
    Value1767 = "+1767",
    Value1809 = "+1809",
    Value213 = "+213",
    Value593 = "+593",
    Value372 = "+372",
    Value20 = "+20",
    Value212 = "+212",
    Value291 = "+291",
    Value34 = "+34",
    Value251 = "+251",
    Value358 = "+358",
    Value679 = "+679",
    Value500 = "+500",
    Value691 = "+691",
    Value298 = "+298",
    Value33 = "+33",
    Value241 = "+241",
    Value44 = "+44",
    Value1473 = "+1473",
    Value995 = "+995",
    Value594 = "+594",
    Value441481 = "+441481",
    Value233 = "+233",
    Value350 = "+350",
    Value299 = "+299",
    Value220 = "+220",
    Value224 = "+224",
    Value240 = "+240",
    Value30 = "+30",
    Value502 = "+502",
    Value1671 = "+1671",
    Value245 = "+245",
    Value595 = "+595",
    Value852 = "+852",
    Value504 = "+504",
    Value385 = "+385",
    Value509 = "+509",
    Value36 = "+36",
    Value62 = "+62",
    Value353 = "+353",
    Value972 = "+972",
    Value441624 = "+441624",
    Value91 = "+91",
    Value246 = "+246",
    Value964 = "+964",
    Value98 = "+98",
    Value354 = "+354",
    Value39 = "+39",
    Value441534 = "+441534",
    Value1876 = "+1876",
    Value962 = "+962",
    Value81 = "+81",
    Value254 = "+254",
    Value996 = "+996",
    Value855 = "+855",
    Value686 = "+686",
    Value269 = "+269",
    Value1869 = "+1869",
    Value850 = "+850",
    Value82 = "+82",
    Value965 = "+965",
    Value345 = "+345",
    Value7 = "+7",
    Value856 = "+856",
    Value961 = "+961",
    Value1758 = "+1758",
    Value423 = "+423",
    Value94 = "+94",
    Value231 = "+231",
    Value266 = "+266",
    Value370 = "+370",
    Value352 = "+352",
    Value371 = "+371",
    Value218 = "+218",
    Value377 = "+377",
    Value373 = "+373",
    Value382 = "+382",
    Value261 = "+261",
    Value692 = "+692",
    Value389 = "+389",
    Value223 = "+223",
    Value95 = "+95",
    Value976 = "+976",
    Value853 = "+853",
    Value1670 = "+1670",
    Value596 = "+596",
    Value222 = "+222",
    Value1664 = "+1664",
    Value356 = "+356",
    Value230 = "+230",
    Value960 = "+960",
    Value265 = "+265",
    Value52 = "+52",
    Value60 = "+60",
    Value258 = "+258",
    Value264 = "+264",
    Value687 = "+687",
    Value227 = "+227",
    Value234 = "+234",
    Value505 = "+505",
    Value31 = "+31",
    Value47 = "+47",
    Value977 = "+977",
    Value674 = "+674",
    Value683 = "+683",
    Value64 = "+64",
    Value968 = "+968",
    Value507 = "+507",
    Value51 = "+51",
    Value689 = "+689",
    Value675 = "+675",
    Value63 = "+63",
    Value92 = "+92",
    Value48 = "+48",
    Value508 = "+508",
    Value1787 = "+1787",
    Value970 = "+970",
    Value351 = "+351",
    Value680 = "+680",
    Value974 = "+974",
    Value262 = "+262",
    Value40 = "+40",
    Value381 = "+381",
    Value250 = "+250",
    Value966 = "+966",
    Value677 = "+677",
    Value248 = "+248",
    Value249 = "+249",
    Value46 = "+46",
    Value65 = "+65",
    Value290 = "+290",
    Value386 = "+386",
    Value421 = "+421",
    Value232 = "+232",
    Value378 = "+378",
    Value221 = "+221",
    Value252 = "+252",
    Value597 = "+597",
    Value239 = "+239",
    Value503 = "+503",
    Value963 = "+963",
    Value268 = "+268",
    Value1649 = "+1649",
    Value235 = "+235",
    Value228 = "+228",
    Value66 = "+66",
    Value992 = "+992",
    Value690 = "+690",
    Value670 = "+670",
    Value993 = "+993",
    Value216 = "+216",
    Value676 = "+676",
    Value90 = "+90",
    Value1868 = "+1868",
    Value688 = "+688",
    Value886 = "+886",
    Value255 = "+255",
    Value380 = "+380",
    Value256 = "+256",
    Value598 = "+598",
    Value998 = "+998",
    Value379 = "+379",
    Value1784 = "+1784",
    Value58 = "+58",
    Value1284 = "+1284",
    Value1340 = "+1340",
    Value84 = "+84",
    Value678 = "+678",
    Value681 = "+681",
    Value685 = "+685",
    Value967 = "+967",
    Value27 = "+27",
    Value260 = "+260",
    Value263 = "+263",
}

export interface PricesRetrieve {
    currency?: string;
    name?: string;
    /** @format uuid */
    quote_uuid?: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,13}(?:\.\d{0,2})?$
     */
    sum_to_pay: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,13}(?:\.\d{0,2})?$
     */
    unit_price: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,13}(?:\.\d{0,2})?$
     */
    total_price_commission_with_vat: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,13}(?:\.\d{0,2})?$
     */
    sum_payout: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,13}(?:\.\d{0,2})?$
     */
    total_shipping_cost: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,13}(?:\.\d{0,2})?$
     */
    total_price: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,13}(?:\.\d{0,2})?$
     */
    total_price_with_vat: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,13}(?:\.\d{0,2})?$
     */
    unit_price_with_vat: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,13}(?:\.\d{0,2})?$
     */
    total_price_with_vat_with_shipping_with_vat: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,13}(?:\.\d{0,2})?$
     */
    unit_price_with_commission_with_vat: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,13}(?:\.\d{0,2})?$
     */
    unit_price_no_vat_with_shipping: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,13}(?:\.\d{0,2})?$
     */
    total_price_no_vat_with_shipping: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,13}(?:\.\d{0,2})?$
     */
    unit_price_no_vat: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,13}(?:\.\d{0,2})?$
     */
    total_price_no_vat: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,13}(?:\.\d{0,2})?$
     */
    shipping_cost_no_vat: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,13}(?:\.\d{0,2})?$
     */
    vat_sum: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,13}(?:\.\d{0,2})?$
     */
    unit_price_with_vat_with_shipping: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,13}(?:\.\d{0,2})?$
     */
    payout_per_unit: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,13}(?:\.\d{0,2})?$
     */
    sum_payout_no_shipping: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,13}(?:\.\d{0,2})?$
     */
    payout_per_unit_no_shipping: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,13}(?:\.\d{0,2})?$
     */
    vat_sum_no_commission: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,13}(?:\.\d{0,2})?$
     */
    additional_buyer_to_opply_fees_no_vat: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,13}(?:\.\d{0,2})?$
     */
    additional_buyer_to_opply_fees_with_vat: string;
    additional_fees_vat_rate: string[];
    /**
     * @format decimal
     * @pattern ^-?\d{0,13}(?:\.\d{0,2})?$
     */
    vat_sum_for_supplier: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,13}(?:\.\d{0,2})?$
     */
    vat_sum_no_commission_for_supplier: string;
}

/**
 * * `high` - High
 * * `medium` - Medium
 * * `low` - Low
 */
export enum PriorityEnum {
    High = "high",
    Medium = "medium",
    Low = "low",
}

/**
 * * `price` - Price
 * * `quality` - Quality
 * * `service` - Service
 */
export enum PriorityNameEnum {
    Price = "price",
    Quality = "quality",
    Service = "service",
}

export interface ProcessCSV {
    /** @format uuid */
    company_document_uuid: string;
}

/**
 * * `fresh_fruits_vegetables` - Fresh Fruit & Vegetables
 * * `nuts_seeds_dried_fruit` - Nuts, Seeds & Dried Fruit
 * * `herbs_spices_seasoning` - Herbs, Spices & Seasonings
 * * `meat_fish` - Meat & Fish
 * * `dairy_alts` - Dairy & Dairy Alternatives
 * * `beans_pulses_grains` - Beans, Pulses & Grains
 * * `flav_colours` - Flavourings & Colours
 * * `flours_baking_ing` - Flours & Baking Ingredients
 * * `sugars_sweeteners` - Sugars & Sweeteners
 * * `fats_oils` - Fats & Oils
 * * `tea_coffee` - Tea & Coffee
 * * `additives_preservatives` - Additives & Preservatives
 * * `juices_concentrates` - Juices & Concentrates
 * * `extracts_tinctures` - Extracts & Tinctures
 * * `pastes_purees` - Pastes & Purees
 * * `whole_food_powders` - Whole Food Powders
 * * `other` - Other
 */
export enum ProductCategoryEnum {
    FreshFruitsVegetables = "fresh_fruits_vegetables",
    NutsSeedsDriedFruit = "nuts_seeds_dried_fruit",
    HerbsSpicesSeasoning = "herbs_spices_seasoning",
    MeatFish = "meat_fish",
    DairyAlts = "dairy_alts",
    BeansPulsesGrains = "beans_pulses_grains",
    FlavColours = "flav_colours",
    FloursBakingIng = "flours_baking_ing",
    SugarsSweeteners = "sugars_sweeteners",
    FatsOils = "fats_oils",
    TeaCoffee = "tea_coffee",
    AdditivesPreservatives = "additives_preservatives",
    JuicesConcentrates = "juices_concentrates",
    ExtractsTinctures = "extracts_tinctures",
    PastesPurees = "pastes_purees",
    WholeFoodPowders = "whole_food_powders",
    Other = "other",
}

export interface ProductDetails {
    name: string;
    quantity: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,13}(?:\.\d{0,2})?$
     */
    unit_final_price: string;
    /**
     * * `fl oz` - Fluid Ounces
     * * `g` - Grams
     * * `mg` - milligrams
     * * `gals` - Gallons
     * * `kg` - Kilograms
     * * `L` - Liters
     * * `tons` - Metric Tons
     * * `oz` - Ounces
     * * `lbs` - Pounds
     * * `pcs` - Pieces
     * * `pt` - Pints
     * * `ml` - Milliliter
     * * `boxes` - Boxes
     * * `pallets` - Pallets
     * * `tsp` - Teaspoons
     * * `tbsp` - Tablespoons
     * * `units` - Units
     * * `cases` - Cases
     * * `trays` - Trays
     */
    unit_of_measurement: UnitOfMeasurementEnum;
    /**
     * @format decimal
     * @pattern ^-?\d{0,13}(?:\.\d{0,2})?$
     */
    total_price: string;
    sku: string;
    vat_rate?: string;
    description_blocks?: QuoteDescriptionBlockCreate[] | null;
    /** @default "0.00" */
    shipping_vat_rate?: string;
}

/**
 * * `confect_snacks` - Confectionery & Snacks
 * * `conv_food` - Convenience Food
 * * `bread_cereals` - Bread & Cereals
 * * `sauces_spices` - Sauces & Spices
 * * `spreads` - Spreads
 * * `tea` - Tea
 * * `coffee` - Coffee
 * * `water` - Water
 * * `carb_drinks` - Carbonated Drinks
 * * `alc_drinks` - Alcoholic Drinks
 * * `juice_drinks` - Juice Drinks
 * * `energy_drinks` - Energy Drinks
 * * `cosmetics` - Cosmetics
 * * `milk_dairy` - Milk & Dairy
 * * `free_form_alt` - Free Form Alternative
 * * `other` - Other
 */
export enum ProductTypeEnum {
    ConfectSnacks = "confect_snacks",
    ConvFood = "conv_food",
    BreadCereals = "bread_cereals",
    SaucesSpices = "sauces_spices",
    Spreads = "spreads",
    Tea = "tea",
    Coffee = "coffee",
    Water = "water",
    CarbDrinks = "carb_drinks",
    AlcDrinks = "alc_drinks",
    JuiceDrinks = "juice_drinks",
    EnergyDrinks = "energy_drinks",
    Cosmetics = "cosmetics",
    MilkDairy = "milk_dairy",
    FreeFormAlt = "free_form_alt",
    Other = "other",
}

/** Allocated credit for a single payment provider. */
export interface ProviderAllocatedCredit {
    /** Total allocated credit across all states in cents */
    total: number;
    /** Breakdown of allocated credit by order state. */
    breakdown: AllocatedCreditBreakdown;
}

/** Allocated credit for a provider, including forecasted order total. */
export interface ProviderAllocatedCreditWithForecast {
    /** Total allocated credit across all states in cents */
    total: number;
    /** Breakdown of allocated credit by order state. */
    breakdown: AllocatedCreditBreakdown;
    /** Total value of forecasted orders in cents (not included in total) */
    forecasted: number;
}

export interface ProviderBankDetails {
    stripe: BankDetail[];
    two: BankDetail[];
}

export interface PurchaseOrder {
    order_number: string;
    /** @format date-time */
    created: string;
    /** @format date-time */
    payment_due_date: string;
    shipping: PurchaseOrderShipping;
    /**
     * * `CNH` - CNH
     * * `NIC` - NIC
     * * `BOV` - BOV
     * * `GIP` - GIP
     * * `ZAL` - ZAL
     * * `ILR` - ILR
     * * `LRD` - LRD
     * * `YUD` - YUD
     * * `BRR` - BRR
     * * `SUR` - SUR
     * * `NLG` - NLG
     * * `CLP` - CLP
     * * `EEK` - EEK
     * * `XPT` - XPT
     * * `MZE` - MZE
     * * `IQD` - IQD
     * * `XBA` - XBA
     * * `TWD` - TWD
     * * `VEF` - VEF
     * * `DOP` - DOP
     * * `UGX` - UGX
     * * `LUF` - LUF
     * * `FJD` - FJD
     * * `BOP` - BOP
     * * `BAM` - BAM
     * * `VND` - VND
     * * `BEL` - BEL
     * * `EGP` - EGP
     * * `MVP` - MVP
     * * `YUR` - YUR
     * * `BND` - BND
     * * `SSP` - SSP
     * * `UYU` - UYU
     * * `KRW` - KRW
     * * `BOB` - BOB
     * * `TJR` - TJR
     * * `USN` - USN
     * * `GQE` - GQE
     * * `ZRZ` - ZRZ
     * * `GBP` - GBP
     * * `VEB` - VEB
     * * `MGF` - MGF
     * * `LSL` - LSL
     * * `BOL` - BOL
     * * `JPY` - JPY
     * * `SDD` - SDD
     * * `BEF` - BEF
     * * `YUM` - YUM
     * * `GNS` - GNS
     * * `ROL` - ROL
     * * `BIF` - BIF
     * * `DKK` - DKK
     * * `MAF` - MAF
     * * `RSD` - RSD
     * * `OMR` - OMR
     * * `NAD` - NAD
     * * `TMM` - TMM
     * * `BEC` - BEC
     * * `ECS` - ECS
     * * `BRE` - BRE
     * * `KZT` - KZT
     * * `SOS` - SOS
     * * `ZWR` - ZWR
     * * `VUV` - VUV
     * * `VED` - VED
     * * `IEP` - IEP
     * * `ESA` - ESA
     * * `KGS` - KGS
     * * `RON` - RON
     * * `RUR` - RUR
     * * `SLL` - SLL
     * * `XFO` - XFO
     * * `KMF` - KMF
     * * `SDP` - SDP
     * * `BGN` - BGN
     * * `ZWD` - ZWD
     * * `MXN` - MXN
     * * `HNL` - HNL
     * * `AON` - AON
     * * `ZMW` - ZMW
     * * `LTL` - LTL
     * * `LUC` - LUC
     * * `VNN` - VNN
     * * `CLF` - CLF
     * * `BAD` - BAD
     * * `PLZ` - PLZ
     * * `ZWL` - ZWL
     * * `AZM` - AZM
     * * `IRR` - IRR
     * * `ISK` - ISK
     * * `CLE` - CLE
     * * `CRC` - CRC
     * * `JMD` - JMD
     * * `RUB` - RUB
     * * `JOD` - JOD
     * * `ETB` - ETB
     * * `UAK` - UAK
     * * `CDF` - CDF
     * * `CHF` - CHF
     * * `ESB` - ESB
     * * `KRO` - KRO
     * * `MZN` - MZN
     * * `BMD` - BMD
     * * `XRE` - XRE
     * * `BWP` - BWP
     * * `NZD` - NZD
     * * `CSD` - CSD
     * * `BUK` - BUK
     * * `ERN` - ERN
     * * `MWK` - MWK
     * * `XDR` - XDR
     * * `GWE` - GWE
     * * `LYD` - LYD
     * * `DDM` - DDM
     * * `XFU` - XFU
     * * `KWD` - KWD
     * * `TTD` - TTD
     * * `PGK` - PGK
     * * `XAG` - XAG
     * * `AZN` - AZN
     * * `NGN` - NGN
     * * `ANG` - ANG
     * * `BGM` - BGM
     * * `MVR` - MVR
     * * `TPE` - TPE
     * * `TZS` - TZS
     * * `CUP` - CUP
     * * `SEK` - SEK
     * * `AED` - AED
     * * `XEU` - XEU
     * * `BYB` - BYB
     * * `MNT` - MNT
     * * `SGD` - SGD
     * * `LAK` - LAK
     * * `ZWG` - ZWG
     * * `SDG` - SDG
     * * `SCR` - SCR
     * * `XAU` - XAU
     * * `THB` - THB
     * * `ARL` - ARL
     * * `XBC` - XBC
     * * `COP` - COP
     * * `MAD` - MAD
     * * `FIM` - FIM
     * * `NPR` - NPR
     * * `GWP` - GWP
     * * `XBB` - XBB
     * * `MTL` - MTL
     * * `EUR` - EUR
     * * `ZRN` - ZRN
     * * `CHW` - CHW
     * * `TRL` - TRL
     * * `GHS` - GHS
     * * `SKK` - SKK
     * * `PYG` - PYG
     * * `XOF` - XOF
     * * `BZD` - BZD
     * * `IDR` - IDR
     * * `STN` - STN
     * * `UYI` - UYI
     * * `XUA` - XUA
     * * `KPW` - KPW
     * * `USD` - USD
     * * `UYP` - UYP
     * * `XPD` - XPD
     * * `BAN` - BAN
     * * `GYD` - GYD
     * * `UGS` - UGS
     * * `CSK` - CSK
     * * `HUF` - HUF
     * * `AFA` - AFA
     * * `SRG` - SRG
     * * `CNX` - CNX
     * * `ALK` - ALK
     * * `GTQ` - GTQ
     * * `MGA` - MGA
     * * `KYD` - KYD
     * * `INR` - INR
     * * `XAF` - XAF
     * * `USS` - USS
     * * `ALL` - ALL
     * * `LKR` - LKR
     * * `XSU` - XSU
     * * `AOA` - AOA
     * * `SAR` - SAR
     * * `PKR` - PKR
     * * `XBD` - XBD
     * * `KES` - KES
     * * `SZL` - SZL
     * * `SVC` - SVC
     * * `MMK` - MMK
     * * `QAR` - QAR
     * * `TRY` - TRY
     * * `PES` - PES
     * * `BGL` - BGL
     * * `PLN` - PLN
     * * `CZK` - CZK
     * * `TND` - TND
     * * `GRD` - GRD
     * * `BYN` - BYN
     * * `MCF` - MCF
     * * `WST` - WST
     * * `VES` - VES
     * * `BTN` - BTN
     * * `PHP` - PHP
     * * `ILP` - ILP
     * * `MLF` - MLF
     * * `HRD` - HRD
     * * `MDC` - MDC
     * * `PAB` - PAB
     * * `SIT` - SIT
     * * `COU` - COU
     * * `MXV` - MXV
     * * `AWG` - AWG
     * * `SYP` - SYP
     * * `DEM` - DEM
     * * `ZMK` - ZMK
     * * `MKN` - MKN
     * * `XPF` - XPF
     * * `AMD` - AMD
     * * `CYP` - CYP
     * * `PEN` - PEN
     * * `TOP` - TOP
     * * `GEK` - GEK
     * * `FRF` - FRF
     * * `MTP` - MTP
     * * `SBD` - SBD
     * * `LVL` - LVL
     * * `MRU` - MRU
     * * `XTS` - XTS
     * * `RHD` - RHD
     * * `MKD` - MKD
     * * `MRO` - MRO
     * * `RWF` - RWF
     * * `AOR` - AOR
     * * `AOK` - AOK
     * * `ILS` - ILS
     * * `BBD` - BBD
     * * `ARP` - ARP
     * * `CVE` - CVE
     * * `LUL` - LUL
     * * `NIO` - NIO
     * * `STD` - STD
     * * `CHE` - CHE
     * * `GMD` - GMD
     * * `FKP` - FKP
     * * `MZM` - MZM
     * * `PEI` - PEI
     * * `ESP` - ESP
     * * `CAD` - CAD
     * * `MUR` - MUR
     * * `NOK` - NOK
     * * `UZS` - UZS
     * * `CUC` - CUC
     * * `MYR` - MYR
     * * `GHC` - GHC
     * * `ISJ` - ISJ
     * * `YDD` - YDD
     * * `BRC` - BRC
     * * `CNY` - CNY
     * * `PTE` - PTE
     * * `DZD` - DZD
     * * `LBP` - LBP
     * * `MOP` - MOP
     * * `DJF` - DJF
     * * `SRD` - SRD
     * * `AUD` - AUD
     * * `YUN` - YUN
     * * `BRN` - BRN
     * * `TMT` - TMT
     * * `XCG` - XCG
     * * `GNF` - GNF
     * * `UAH` - UAH
     * * `ARA` - ARA
     * * `MXP` - MXP
     * * `BRL` - BRL
     * * `AFN` - AFN
     * * `HKD` - HKD
     * * `BHD` - BHD
     * * `YER` - YER
     * * `ARM` - ARM
     * * `ARS` - ARS
     * * `SHP` - SHP
     * * `ITL` - ITL
     * * `KHR` - KHR
     * * `LVR` - LVR
     * * `SLE` - SLE
     * * `XXX` - XXX
     * * `BYR` - BYR
     * * `BRB` - BRB
     * * `ADP` - ADP
     * * `HRK` - HRK
     * * `BDT` - BDT
     * * `BSD` - BSD
     * * `ATS` - ATS
     * * `KRH` - KRH
     * * `ZAR` - ZAR
     * * `ECV` - ECV
     * * `HTG` - HTG
     * * `LTT` - LTT
     * * `MDL` - MDL
     * * `UYW` - UYW
     * * `TJS` - TJS
     * * `BGO` - BGO
     * * `GEL` - GEL
     * * `BRZ` - BRZ
     * * `XCD` - XCD
     */
    currency: AllCurrencies;
    products: ProductDetails[];
    /**
     * @format decimal
     * @pattern ^-?\d{0,13}(?:\.\d{0,2})?$
     */
    shipping_price: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,13}(?:\.\d{0,2})?$
     */
    total_price: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,13}(?:\.\d{0,2})?$
     */
    vat_sum_no_commission: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,13}(?:\.\d{0,2})?$
     */
    sum_payout: string;
    supplier: PurchaseOrderCompanyInfo;
    buyer: PurchaseOrderCompanyInfo;
}

export interface PurchaseOrderCompanyInfo {
    name: string;
    contacts: string | null;
    address: string | null;
}

export interface PurchaseOrderShipping {
    /** @format date */
    delivery_date: string;
    delivery_address: string;
    contact_full_name: string | null;
    contact_phone_number: string | null;
    eori_number: string | null;
    delivery_instructions: string | null;
    delivery_contact: string | null;
}

export interface PurchaseRequest {
    id: number;
    /** @format uuid */
    uuid: string;
    /**
     * * `awaiting_quotes` - Awaiting Quotes
     * * `quotes_available` - Quotes Available
     * * `ordered` - Ordered
     * * `expired` - Expired
     * * `proceeded` - Proceeded
     * * `contract_confirmed` - Contract Confirmed
     * * `supplier_decline_to_quote` - Supplier Decline To Quote
     * * `cancelled` - Cancelled
     */
    state?: InquiryState;
    /**
     * * `non_recurring` - Non Recurring
     * * `recurring` - Recurring
     * * `purchase_request` - Purchase Request
     * * `ingredient` - Ingredient
     * * `ingredient_copy` - Ingredient Copy
     */
    category?: InquiryCategory;
    /** @maxLength 255 */
    name: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
     */
    current_unit_price: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
     */
    target_unit_price: string;
    /**
     * * `EUR` - EUR
     * * `USD` - USD
     * * `GBP` - GBP
     * * `CAD` - CAD
     */
    currency?: Currencies;
    description: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
     */
    quantity: string;
    /**
     * * `fl oz` - Fluid Ounces
     * * `g` - Grams
     * * `mg` - milligrams
     * * `gals` - Gallons
     * * `kg` - Kilograms
     * * `L` - Liters
     * * `tons` - Metric Tons
     * * `oz` - Ounces
     * * `lbs` - Pounds
     * * `pcs` - Pieces
     * * `pt` - Pints
     * * `ml` - Milliliter
     * * `boxes` - Boxes
     * * `pallets` - Pallets
     * * `tsp` - Teaspoons
     * * `tbsp` - Tablespoons
     * * `units` - Units
     * * `cases` - Cases
     * * `trays` - Trays
     */
    unit_of_measurement?: UnitOfMeasurementEnum;
    allergen_requirements?: (AllergenRequirementsEnum | BlankEnum)[];
    allergen_declaration?: boolean;
    dietary_certificate?: boolean;
    diet_requirements?: (DietRequirementsEnum | BlankEnum)[];
    forecast?: ForecastEnum | BlankEnum | NullEnum | null;
    /** @format date */
    due_date: string;
    delivery_address: InquiryDeliveryAddress;
    /** @maxItems 250 */
    supplier_countries: (Country | BlankEnum)[];
    current_supplier?: string;
    /**
     * Datetime when the inquiry becomes published. Leave empty to keep it unpublished.
     * @format date-time
     */
    published?: string | null;
    /**
     * @format uri
     * @maxLength 2048
     */
    logo_url?: string;
    is_new: boolean;
    /** @format uuid */
    article?: string | null;
    existing_suppliers: string[] | null;
    supply_priorities?: SupplyPriorities[];
    /** @format date */
    first_order_delivery_date?: string | null;
    /**
     * @format decimal
     * @pattern ^-?\d{0,7}(?:\.\d{0,2})?$
     */
    opply_brand_commission?: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,7}(?:\.\d{0,2})?$
     */
    opply_supplier_commission?: string;
    /** @default false */
    is_recurring?: boolean;
    frequency?: FrequencyEnum | BlankEnum | NullEnum | null;
    /** @min 0 */
    desired_contract_length?: number | null;
    is_delivery_date_flexible?: boolean;
    /** @format uuid */
    parent_uuid?: string | null;
    ingredient?: number | null;
    reason_for_request?: string | null;
    desired_packaging_format?: string;
    desired_packaging_format_is_flexible?: boolean;
    ai_generated?: boolean;
    documents_to_copy?: string[] | null;
    declined: string;
    decline_reason: string;
}

export interface PurchaseRequestCreate {
    /** @format uuid */
    quote_uuid: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
     */
    quantity: string;
    /** @format date */
    delivery_date: string;
    delivery_address: number;
    /** @format uuid */
    ingredient_uuid?: string | null;
}

export interface PurchaseRequestResponse {
    /** @format uuid */
    uuid: string;
    /** @format date */
    due_date: string;
    related_contract: number;
    /**
     * @format decimal
     * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
     */
    quantity: string;
    /** @format uuid */
    quote_uuid?: string | null;
}

/**
 * * `spoilage` - Spoilage
 * * `not_match_spec` - Not Match Spec
 * * `contamination` - Contamination
 * * `discolouration` - Discolouration
 * * `shelf_life_issue` - Shelf Life Issue
 */
export enum QualityIssueTypeEnum {
    Spoilage = "spoilage",
    NotMatchSpec = "not_match_spec",
    Contamination = "contamination",
    Discolouration = "discolouration",
    ShelfLifeIssue = "shelf_life_issue",
}

/**
 * * `non_recurring` - Non Recurring
 * * `recurring` - Recurring
 * * `purchase_request_quote` - Purchase Request Quote
 */
export enum QuoteCategory {
    NonRecurring = "non_recurring",
    Recurring = "recurring",
    PurchaseRequestQuote = "purchase_request_quote",
}

export interface QuoteCreate {
    company: Company;
    /** @maxLength 255 */
    product_name: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,10}(?:\.\d{0,2})?$
     */
    quantity: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,9}(?:\.\d{0,10})?$
     */
    unit_price?: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,9}(?:\.\d{0,10})?$
     */
    total_price?: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,1}(?:\.\d{0,4})?$
     */
    vat_rate?: string | null;
    /** @format date */
    delivery_date: string;
    /**
     * * `in_advance` - In Advance
     * * `on_dispatch` - On Dispatch
     */
    payment_scenario?: PaymentScenarioEnum;
    /**
     * @min 0
     * @max 365
     */
    payment_delay?: number;
    /**
     * @min 0
     * @default 0
     */
    shelf_life?: number | null;
    /**
     * @min 0
     * @max 2147483647
     */
    quote_valid_for?: number | null;
    /**
     * The maximum time a supplier agrees to deliver the product within (days)
     * @min 0
     * @max 2147483647
     */
    lead_time: number;
    product_description?: string | null;
    /**
     * @format decimal
     * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
     */
    shipping_cost?: string | null;
    /**
     * * `EUR` - EUR
     * * `USD` - USD
     * * `GBP` - GBP
     * * `CAD` - CAD
     */
    currency?: Currencies;
    /**
     * * `available` - available
     * * `ordered` - ordered
     * * `expired` - expired
     * * `declined` - declined
     * * `pending_payment` - pending_payment
     * * `proceeded` - proceeded
     * * `contract_created` - Contract Created
     * * `contract_proceeded` - contract_proceeded
     * * `contract_confirmed` - contract_confirmed
     */
    status?: QuoteState;
    /**
     * Datetime when the quote becomes published. Leave empty to keep it unpublished.
     * @format date-time
     */
    published?: string | null;
    /**
     * * `fl oz` - Fluid Ounces
     * * `g` - Grams
     * * `mg` - milligrams
     * * `gals` - Gallons
     * * `kg` - Kilograms
     * * `L` - Liters
     * * `tons` - Metric Tons
     * * `oz` - Ounces
     * * `lbs` - Pounds
     * * `pcs` - Pieces
     * * `pt` - Pints
     * * `ml` - Milliliter
     * * `boxes` - Boxes
     * * `pallets` - Pallets
     * * `tsp` - Teaspoons
     * * `tbsp` - Tablespoons
     * * `units` - Units
     * * `cases` - Cases
     * * `trays` - Trays
     */
    unit_of_measurement?: UnitOfMeasurementEnum;
    dispatch_address?: number | null;
    inquiry: number;
    created_by: number;
    is_reverse_charge?: boolean;
    vat_charged?: boolean;
    vat_remitted?: boolean;
    vat_exempt?: boolean;
    /**
     * @format decimal
     * @pattern ^-?\d{0,7}(?:\.\d{0,2})?$
     */
    commission_payout_vat_rate?: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,7}(?:\.\d{0,2})?$
     */
    commission_payin_vat_rate?: string;
    commission_is_reverse_charge?: boolean;
    sku?: string | null;
    /**
     * @format decimal
     * @pattern ^-?\d{0,9}(?:\.\d{0,6})?$
     */
    fx_rate?: string;
    /**
     * @format uri
     * @maxLength 2048
     */
    logo_url?: string;
    incoterms?: IncotermsEnum | NullEnum | null;
    /** @default false */
    is_recurring?: boolean;
    recurring_order_lead_time?: number | null;
    contract_length?: number | null;
    /**
     * @format decimal
     * @pattern ^-?\d{0,17}(?:\.\d{0,2})?$
     */
    case_size?: string | null;
    /**
     * @format decimal
     * @pattern ^-?\d{0,17}(?:\.\d{0,2})?$
     */
    minimum_order_quantity?: string | null;
    /** @default false */
    agreement_required?: boolean;
    account_form_required?: boolean;
    /**
     * * `non_recurring` - Non Recurring
     * * `recurring` - Recurring
     * * `purchase_request_quote` - Purchase Request Quote
     */
    category?: QuoteCategory;
    is_custom_contract?: boolean;
    show_to_other_buyers?: boolean;
    /**
     * @format decimal
     * @pattern ^-?\d{0,17}(?:\.\d{0,2})?$
     */
    minimum_order_quantity_for_other_buyers?: string | null;
    /**
     * @format decimal
     * @pattern ^-?\d{0,17}(?:\.\d{0,2})?$
     */
    maximum_order_quantity_for_other_buyers?: string | null;
    autoconfirm_orders?: boolean;
    /**
     * @min 0
     * @max 2147483647
     */
    minimum_lead_time?: number | null;
    /**
     * @min 0
     * @max 2147483647
     */
    order_in_multiples_of?: number | null;
    /**
     * @min 0
     * @max 2147483647
     */
    minimum_autoconfirm_order_quantity?: number | null;
    /**
     * @min 0
     * @max 2147483647
     */
    maximum_autoconfirm_order_quantity?: number | null;
    packaging_format?: string;
    description_blocks?: QuoteDescriptionBlockCreate[] | null;
    documents_to_copy?: string[] | null;
    /**
     * @format decimal
     * @pattern ^-?\d{0,1}(?:\.\d{0,4})?$
     */
    shipping_vat_rate?: string | null;
    /**
     * @format decimal
     * @pattern ^-?\d{0,10}(?:\.\d{0,2})?$
     */
    total_forecast_quantity?: string | null;
    /**
     * * `total` - total
     * * `unit` - unit
     */
    selected_price_option?: SelectedPriceOptionEnum;
}

/**
 * * `pricing` - pricing
 * * `delivery_date` - delivery_date
 * * `incorrect_quantities` - incorrect_quantities
 * * `sample_quality` - sample_quality
 * * `specification_not_met` - specification_not_met
 * * `other` - other
 */
export enum QuoteDeclineReason {
    Pricing = "pricing",
    DeliveryDate = "delivery_date",
    IncorrectQuantities = "incorrect_quantities",
    SampleQuality = "sample_quality",
    SpecificationNotMet = "specification_not_met",
    Other = "other",
}

export interface QuoteDeclined {
    decline_reason: QuoteDeclineReason[];
    decline_reason_extended?: string | null;
}

export interface QuoteDescriptionBlock {
    /** @format uuid */
    uuid: string;
    description: string;
}

export interface QuoteDescriptionBlockCreate {
    description: string;
}

export interface QuoteDetail {
    /** @format uuid */
    uuid: string;
    /** @maxLength 255 */
    product_name: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,10}(?:\.\d{0,2})?$
     */
    quantity: string;
    /** @format date */
    delivery_date: string;
    /**
     * * `in_advance` - In Advance
     * * `on_dispatch` - On Dispatch
     */
    payment_scenario?: PaymentScenarioEnum;
    /**
     * @min 0
     * @max 365
     */
    payment_delay?: number;
    /**
     * @min 0
     * @max 2147483647
     */
    quote_valid_for?: number | null;
    /**
     * The maximum time a supplier agrees to deliver the product within (days)
     * @min 0
     * @max 2147483647
     */
    lead_time: number;
    product_description?: string | null;
    /**
     * @format decimal
     * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
     */
    shipping_cost?: string | null;
    /**
     * * `EUR` - EUR
     * * `USD` - USD
     * * `GBP` - GBP
     * * `CAD` - CAD
     */
    currency?: Currencies;
    /**
     * * `available` - available
     * * `ordered` - ordered
     * * `expired` - expired
     * * `declined` - declined
     * * `pending_payment` - pending_payment
     * * `proceeded` - proceeded
     * * `contract_created` - Contract Created
     * * `contract_proceeded` - contract_proceeded
     * * `contract_confirmed` - contract_confirmed
     */
    status?: QuoteState;
    /**
     * Datetime when the quote becomes published. Leave empty to keep it unpublished.
     * @format date-time
     */
    published?: string | null;
    /**
     * * `fl oz` - Fluid Ounces
     * * `g` - Grams
     * * `mg` - milligrams
     * * `gals` - Gallons
     * * `kg` - Kilograms
     * * `L` - Liters
     * * `tons` - Metric Tons
     * * `oz` - Ounces
     * * `lbs` - Pounds
     * * `pcs` - Pieces
     * * `pt` - Pints
     * * `ml` - Milliliter
     * * `boxes` - Boxes
     * * `pallets` - Pallets
     * * `tsp` - Teaspoons
     * * `tbsp` - Tablespoons
     * * `units` - Units
     * * `cases` - Cases
     * * `trays` - Trays
     */
    unit_of_measurement?: UnitOfMeasurementEnum;
    inquiry_unit_of_measurement: string;
    /** @format date-time */
    created_date: string;
    /** @format date */
    expiry_date?: string | null;
    /** @format uuid */
    inquiry: string;
    /**
     * @format uri
     * @maxLength 2048
     */
    logo_url?: string;
    /** @format double */
    total_price: number;
    /** @format double */
    unit_price: number;
    /** @format double */
    vat_rate: number;
    is_reverse_charge?: boolean;
    vat_charged?: boolean;
    vat_remitted?: boolean;
    vat_exempt?: boolean;
    /**
     * @format decimal
     * @pattern ^-?\d{0,1}(?:\.\d{0,4})?$
     */
    fx_fee?: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,9}(?:\.\d{0,6})?$
     */
    fx_rate?: string;
    prices: PricesRetrieve;
    /**
     * @format decimal
     * @pattern ^-?\d{0,7}(?:\.\d{0,2})?$
     */
    commission_payout_vat_rate?: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,7}(?:\.\d{0,2})?$
     */
    commission_payin_vat_rate?: string;
    commission_is_reverse_charge?: boolean;
    inquiry_currency: string;
    is_new: boolean;
    /** @maxLength 32 */
    sku?: string | null;
    /**
     * * `non_recurring` - Non Recurring
     * * `recurring` - Recurring
     * * `purchase_request_quote` - Purchase Request Quote
     */
    category?: QuoteCategory;
    order_frequency: OrderFrequencyEnum;
    total_forecast_volume: string;
    is_contract_expired: boolean;
    /** @format uuid */
    inquiry_uuid: string;
    /** @format date */
    contract_end_date?: string | null;
    contract_status: string;
    total_forecast_price: string;
    /** @format double */
    total_forecast_price_for_supplier: number;
    number_of_recurring_orders: string;
    is_custom_contract?: boolean;
    custom_contract_frequency: string;
    /**
     * Duration of the contract in months.
     * @min -2147483648
     * @max 2147483647
     */
    contract_length?: number | null;
    buyer_company_name: string;
    agreement_required?: boolean;
    is_filled: boolean;
    total_forecast_payout: string;
    /** @format uuid */
    original_quote_uuid: string;
    /** @format double */
    shipping_vat_rate: number;
    expires_in: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,10}(?:\.\d{0,2})?$
     */
    total_forecast_quantity?: string | null;
    /**
     * * `total` - total
     * * `unit` - unit
     */
    selected_price_option?: SelectedPriceOptionEnum;
    update_requested?: boolean;
    ordered_volume: number;
    delivery_address: DeliveryAddressResponse;
    /** @default "delivery_duty_paid" */
    incoterms?: IncotermsEnum | NullEnum | null;
    /**
     * * `in_advance` - In Advance
     * * `on_dispatch` - On Dispatch
     * * `7_days_after_dispatch` - Days After Dispatch 7
     * * `14_days_after_dispatch` - Days After Dispatch 14
     * * `30_days_after_dispatch` - Days After Dispatch 30
     * * `60_days_after_dispatch` - Days After Dispatch 60
     */
    payment_terms?: PaymentTermsEnum;
    kyb_status: string;
    dispatch_address: number | null;
    /**
     * * `available` - Available
     * * `requested` - Requested
     * * `sent` - Sent
     * * `received` - Received
     * * `accepted` - Accepted
     * * `rejected` - Rejected
     * * `declined` - Declined
     */
    samples_status?: SamplesStatusEnum;
    samples_delivery_address: CompanyAddress;
    samples_feedback?: SamplesFeedbackEnum[] | null;
    samples_feedback_comment?: string;
    supplier: SectionSupplier | null;
    is_recurring: string;
    /**
     * @min 0
     * @max 2147483647
     */
    recurring_order_lead_time?: number | null;
    account_form_required?: boolean;
    payout_per_order: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,17}(?:\.\d{0,2})?$
     */
    case_size?: string | null;
    /**
     * @format decimal
     * @pattern ^-?\d{0,17}(?:\.\d{0,2})?$
     */
    minimum_order_quantity?: string | null;
    inquiry_frequency: string;
    delivery_address_id: number;
    /**
     * * `in_advance` - In Advance
     * * `on_dispatch` - On Dispatch
     * * `7_days_after_dispatch` - Days After Dispatch 7
     * * `14_days_after_dispatch` - Days After Dispatch 14
     * * `30_days_after_dispatch` - Days After Dispatch 30
     * * `60_days_after_dispatch` - Days After Dispatch 60
     */
    requested_payment_terms?: PaymentTermsEnum;
    is_opply_supplier: string;
    ingredient: IngredientsForQuote;
    /** @format date */
    samples_dispatch_date?: string | null;
    /** @format date */
    samples_sent_date?: string | null;
    /** @format date */
    samples_received_date?: string | null;
    /** @format date */
    samples_accepted_date?: string | null;
    /** @format date */
    samples_rejected_date?: string | null;
    /** @format date */
    samples_requested_date?: string | null;
    /** @format date */
    samples_declined_date?: string | null;
    samples_tracking_code?: string | null;
    /** @format date */
    samples_expected_delivery_date?: string | null;
    /** @maxLength 255 */
    samples_shipping_provider?: string | null;
    autoconfirm_orders?: boolean;
    /**
     * @min 0
     * @max 2147483647
     */
    minimum_lead_time?: number | null;
    /**
     * @min 0
     * @max 2147483647
     */
    order_in_multiples_of?: number | null;
    /**
     * @min 0
     * @max 2147483647
     */
    minimum_autoconfirm_order_quantity?: number | null;
    /**
     * @min 0
     * @max 2147483647
     */
    maximum_autoconfirm_order_quantity?: number | null;
    /**
     * @min 0
     * @max 2147483647
     */
    extension_length?: number | null;
    extension_accepted?: boolean | null;
    packaging_format?: string;
    original_quote: string;
    description_blocks?: QuoteDescriptionBlock[] | null;
    payment_terms_updated_by_supplier?: boolean;
}

export interface QuoteDetailDispatch {
    /** @format uuid */
    uuid: string;
    /** @maxLength 255 */
    product_name: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,10}(?:\.\d{0,2})?$
     */
    quantity: string;
    /** @format date */
    delivery_date: string;
    /**
     * * `in_advance` - In Advance
     * * `on_dispatch` - On Dispatch
     */
    payment_scenario?: PaymentScenarioEnum;
    /**
     * @min 0
     * @max 365
     */
    payment_delay?: number;
    /**
     * @min 0
     * @max 2147483647
     */
    quote_valid_for?: number | null;
    /**
     * The maximum time a supplier agrees to deliver the product within (days)
     * @min 0
     * @max 2147483647
     */
    lead_time: number;
    product_description?: string | null;
    /**
     * @format decimal
     * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
     */
    shipping_cost?: string | null;
    /**
     * * `EUR` - EUR
     * * `USD` - USD
     * * `GBP` - GBP
     * * `CAD` - CAD
     */
    currency?: Currencies;
    /**
     * * `available` - available
     * * `ordered` - ordered
     * * `expired` - expired
     * * `declined` - declined
     * * `pending_payment` - pending_payment
     * * `proceeded` - proceeded
     * * `contract_created` - Contract Created
     * * `contract_proceeded` - contract_proceeded
     * * `contract_confirmed` - contract_confirmed
     */
    status?: QuoteState;
    /**
     * Datetime when the quote becomes published. Leave empty to keep it unpublished.
     * @format date-time
     */
    published?: string | null;
    /**
     * * `fl oz` - Fluid Ounces
     * * `g` - Grams
     * * `mg` - milligrams
     * * `gals` - Gallons
     * * `kg` - Kilograms
     * * `L` - Liters
     * * `tons` - Metric Tons
     * * `oz` - Ounces
     * * `lbs` - Pounds
     * * `pcs` - Pieces
     * * `pt` - Pints
     * * `ml` - Milliliter
     * * `boxes` - Boxes
     * * `pallets` - Pallets
     * * `tsp` - Teaspoons
     * * `tbsp` - Tablespoons
     * * `units` - Units
     * * `cases` - Cases
     * * `trays` - Trays
     */
    unit_of_measurement?: UnitOfMeasurementEnum;
    inquiry_unit_of_measurement: string;
    /** @format date-time */
    created_date: string;
    /** @format date */
    expiry_date?: string | null;
    /** @format uuid */
    inquiry: string;
    /**
     * @format uri
     * @maxLength 2048
     */
    logo_url?: string;
    /** @format double */
    total_price: number;
    /** @format double */
    unit_price: number;
    /** @format double */
    vat_rate: number;
    is_reverse_charge?: boolean;
    vat_charged?: boolean;
    vat_remitted?: boolean;
    vat_exempt?: boolean;
    /**
     * @format decimal
     * @pattern ^-?\d{0,1}(?:\.\d{0,4})?$
     */
    fx_fee?: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,9}(?:\.\d{0,6})?$
     */
    fx_rate?: string;
    prices: PricesRetrieve;
    /**
     * @format decimal
     * @pattern ^-?\d{0,7}(?:\.\d{0,2})?$
     */
    commission_payout_vat_rate?: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,7}(?:\.\d{0,2})?$
     */
    commission_payin_vat_rate?: string;
    commission_is_reverse_charge?: boolean;
    inquiry_currency: string;
    is_new: boolean;
    /** @maxLength 32 */
    sku?: string | null;
    /**
     * * `non_recurring` - Non Recurring
     * * `recurring` - Recurring
     * * `purchase_request_quote` - Purchase Request Quote
     */
    category?: QuoteCategory;
    order_frequency: OrderFrequencyEnum;
    total_forecast_volume: string;
    is_contract_expired: boolean;
    /** @format uuid */
    inquiry_uuid: string;
    /** @format date */
    contract_end_date?: string | null;
    contract_status: string;
    total_forecast_price: string;
    /** @format double */
    total_forecast_price_for_supplier: number;
    number_of_recurring_orders: string;
    is_custom_contract?: boolean;
    custom_contract_frequency: string;
    /**
     * Duration of the contract in months.
     * @min -2147483648
     * @max 2147483647
     */
    contract_length?: number | null;
    buyer_company_name: string;
    agreement_required?: boolean;
    is_filled: boolean;
    total_forecast_payout: string;
    /** @format uuid */
    original_quote_uuid: string;
    /** @format double */
    shipping_vat_rate: number;
    expires_in: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,10}(?:\.\d{0,2})?$
     */
    total_forecast_quantity?: string | null;
    /**
     * * `total` - total
     * * `unit` - unit
     */
    selected_price_option?: SelectedPriceOptionEnum;
    update_requested?: boolean;
    ordered_volume: number;
    delivery_address: DeliveryAddressResponse;
    incoterms?: IncotermsEnum | NullEnum | null;
    /**
     * * `in_advance` - In Advance
     * * `on_dispatch` - On Dispatch
     * * `7_days_after_dispatch` - Days After Dispatch 7
     * * `14_days_after_dispatch` - Days After Dispatch 14
     * * `30_days_after_dispatch` - Days After Dispatch 30
     * * `60_days_after_dispatch` - Days After Dispatch 60
     */
    payment_terms?: PaymentTermsEnum;
    kyb_status: string;
    dispatch_address?: number | null;
    /**
     * * `available` - Available
     * * `requested` - Requested
     * * `sent` - Sent
     * * `received` - Received
     * * `accepted` - Accepted
     * * `rejected` - Rejected
     * * `declined` - Declined
     */
    samples_status?: SamplesStatusEnum;
    samples_delivery_address: CompanyAddress;
    samples_feedback?: SamplesFeedbackEnum[] | null;
    samples_feedback_comment?: string;
    supplier: SectionSupplier | null;
    is_recurring: string;
    /**
     * @min 0
     * @max 2147483647
     */
    recurring_order_lead_time?: number | null;
    account_form_required?: boolean;
    payout_per_order: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,17}(?:\.\d{0,2})?$
     */
    case_size?: string | null;
    /**
     * @format decimal
     * @pattern ^-?\d{0,17}(?:\.\d{0,2})?$
     */
    minimum_order_quantity?: string | null;
    inquiry_frequency: string;
    delivery_address_id: number;
    /**
     * * `in_advance` - In Advance
     * * `on_dispatch` - On Dispatch
     * * `7_days_after_dispatch` - Days After Dispatch 7
     * * `14_days_after_dispatch` - Days After Dispatch 14
     * * `30_days_after_dispatch` - Days After Dispatch 30
     * * `60_days_after_dispatch` - Days After Dispatch 60
     */
    requested_payment_terms?: PaymentTermsEnum;
    is_opply_supplier: string;
    ingredient: IngredientsForQuote;
    /** @format date */
    samples_dispatch_date?: string | null;
    /** @format date */
    samples_sent_date?: string | null;
    /** @format date */
    samples_received_date?: string | null;
    /** @format date */
    samples_accepted_date?: string | null;
    /** @format date */
    samples_rejected_date?: string | null;
    /** @format date */
    samples_requested_date?: string | null;
    /** @format date */
    samples_declined_date?: string | null;
    samples_tracking_code?: string | null;
    /** @format date */
    samples_expected_delivery_date?: string | null;
    /** @maxLength 255 */
    samples_shipping_provider?: string | null;
    autoconfirm_orders?: boolean;
    /**
     * @min 0
     * @max 2147483647
     */
    minimum_lead_time?: number | null;
    /**
     * @min 0
     * @max 2147483647
     */
    order_in_multiples_of?: number | null;
    /**
     * @min 0
     * @max 2147483647
     */
    minimum_autoconfirm_order_quantity?: number | null;
    /**
     * @min 0
     * @max 2147483647
     */
    maximum_autoconfirm_order_quantity?: number | null;
    /**
     * @min 0
     * @max 2147483647
     */
    extension_length?: number | null;
    extension_accepted?: boolean | null;
    packaging_format?: string;
    original_quote: string;
    description_blocks?: QuoteDescriptionBlock[] | null;
    payment_terms_updated_by_supplier?: boolean;
    company: Company;
    company_address: CompanyAddress;
}

export interface QuoteDetailSupplier {
    /** @format uuid */
    uuid: string;
    /** @maxLength 255 */
    product_name: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,10}(?:\.\d{0,2})?$
     */
    quantity: string;
    /** @format date */
    delivery_date: string;
    /**
     * * `in_advance` - In Advance
     * * `on_dispatch` - On Dispatch
     */
    payment_scenario?: PaymentScenarioEnum;
    /**
     * @min 0
     * @max 365
     */
    payment_delay?: number;
    /**
     * @min 0
     * @max 2147483647
     */
    quote_valid_for?: number | null;
    /**
     * The maximum time a supplier agrees to deliver the product within (days)
     * @min 0
     * @max 2147483647
     */
    lead_time: number;
    product_description?: string | null;
    /**
     * @format decimal
     * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
     */
    shipping_cost?: string | null;
    /**
     * * `EUR` - EUR
     * * `USD` - USD
     * * `GBP` - GBP
     * * `CAD` - CAD
     */
    currency?: Currencies;
    /**
     * * `available` - available
     * * `ordered` - ordered
     * * `expired` - expired
     * * `declined` - declined
     * * `pending_payment` - pending_payment
     * * `proceeded` - proceeded
     * * `contract_created` - Contract Created
     * * `contract_proceeded` - contract_proceeded
     * * `contract_confirmed` - contract_confirmed
     */
    status?: QuoteState;
    /**
     * Datetime when the quote becomes published. Leave empty to keep it unpublished.
     * @format date-time
     */
    published?: string | null;
    /**
     * * `fl oz` - Fluid Ounces
     * * `g` - Grams
     * * `mg` - milligrams
     * * `gals` - Gallons
     * * `kg` - Kilograms
     * * `L` - Liters
     * * `tons` - Metric Tons
     * * `oz` - Ounces
     * * `lbs` - Pounds
     * * `pcs` - Pieces
     * * `pt` - Pints
     * * `ml` - Milliliter
     * * `boxes` - Boxes
     * * `pallets` - Pallets
     * * `tsp` - Teaspoons
     * * `tbsp` - Tablespoons
     * * `units` - Units
     * * `cases` - Cases
     * * `trays` - Trays
     */
    unit_of_measurement?: UnitOfMeasurementEnum;
    inquiry_unit_of_measurement: string;
    /** @format date-time */
    created_date: string;
    /** @format date */
    expiry_date?: string | null;
    /** @format uuid */
    inquiry: string;
    /**
     * @format uri
     * @maxLength 2048
     */
    logo_url?: string;
    /** @format double */
    total_price: number;
    /** @format double */
    unit_price: number;
    /** @format double */
    vat_rate: number;
    is_reverse_charge?: boolean;
    vat_charged?: boolean;
    vat_remitted?: boolean;
    vat_exempt?: boolean;
    /**
     * @format decimal
     * @pattern ^-?\d{0,1}(?:\.\d{0,4})?$
     */
    fx_fee?: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,9}(?:\.\d{0,6})?$
     */
    fx_rate?: string;
    prices: PricesRetrieve;
    /**
     * @format decimal
     * @pattern ^-?\d{0,7}(?:\.\d{0,2})?$
     */
    commission_payout_vat_rate?: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,7}(?:\.\d{0,2})?$
     */
    commission_payin_vat_rate?: string;
    commission_is_reverse_charge?: boolean;
    inquiry_currency: string;
    is_new: boolean;
    /** @maxLength 32 */
    sku?: string | null;
    /**
     * * `non_recurring` - Non Recurring
     * * `recurring` - Recurring
     * * `purchase_request_quote` - Purchase Request Quote
     */
    category?: QuoteCategory;
    order_frequency: OrderFrequencyEnum;
    total_forecast_volume: string;
    is_contract_expired: boolean;
    /** @format uuid */
    inquiry_uuid: string;
    /** @format date */
    contract_end_date?: string | null;
    contract_status: string;
    total_forecast_price: string;
    /** @format double */
    total_forecast_price_for_supplier: number;
    number_of_recurring_orders: string;
    is_custom_contract?: boolean;
    custom_contract_frequency: string;
    /**
     * Duration of the contract in months.
     * @min -2147483648
     * @max 2147483647
     */
    contract_length?: number | null;
    buyer_company_name: string;
    agreement_required?: boolean;
    is_filled: boolean;
    total_forecast_payout: string;
    /** @format uuid */
    original_quote_uuid: string;
    /** @format double */
    shipping_vat_rate: number;
    expires_in: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,10}(?:\.\d{0,2})?$
     */
    total_forecast_quantity?: string | null;
    /**
     * * `total` - total
     * * `unit` - unit
     */
    selected_price_option?: SelectedPriceOptionEnum;
    update_requested?: boolean;
    ordered_volume: number;
    delivery_address: DeliveryAddressResponse;
    incoterms?: IncotermsEnum | NullEnum | null;
    /**
     * * `in_advance` - In Advance
     * * `on_dispatch` - On Dispatch
     * * `7_days_after_dispatch` - Days After Dispatch 7
     * * `14_days_after_dispatch` - Days After Dispatch 14
     * * `30_days_after_dispatch` - Days After Dispatch 30
     * * `60_days_after_dispatch` - Days After Dispatch 60
     */
    payment_terms?: PaymentTermsEnum;
    kyb_status: string;
    dispatch_address?: number | null;
    /**
     * * `available` - Available
     * * `requested` - Requested
     * * `sent` - Sent
     * * `received` - Received
     * * `accepted` - Accepted
     * * `rejected` - Rejected
     * * `declined` - Declined
     */
    samples_status?: SamplesStatusEnum;
    samples_delivery_address: CompanyAddress;
    samples_feedback?: SamplesFeedbackEnum[] | null;
    samples_feedback_comment?: string;
    supplier: SectionSupplier | null;
    is_recurring: string;
    /**
     * @min 0
     * @max 2147483647
     */
    recurring_order_lead_time?: number | null;
    account_form_required?: boolean;
    payout_per_order: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,17}(?:\.\d{0,2})?$
     */
    case_size?: string | null;
    /**
     * @format decimal
     * @pattern ^-?\d{0,17}(?:\.\d{0,2})?$
     */
    minimum_order_quantity?: string | null;
    inquiry_frequency: string;
    delivery_address_id: number;
    /**
     * * `in_advance` - In Advance
     * * `on_dispatch` - On Dispatch
     * * `7_days_after_dispatch` - Days After Dispatch 7
     * * `14_days_after_dispatch` - Days After Dispatch 14
     * * `30_days_after_dispatch` - Days After Dispatch 30
     * * `60_days_after_dispatch` - Days After Dispatch 60
     */
    requested_payment_terms?: PaymentTermsEnum;
    is_opply_supplier: string;
    ingredient: IngredientsForQuote;
    /** @format date */
    samples_dispatch_date?: string | null;
    /** @format date */
    samples_sent_date?: string | null;
    /** @format date */
    samples_received_date?: string | null;
    /** @format date */
    samples_accepted_date?: string | null;
    /** @format date */
    samples_rejected_date?: string | null;
    /** @format date */
    samples_requested_date?: string | null;
    /** @format date */
    samples_declined_date?: string | null;
    samples_tracking_code?: string | null;
    /** @format date */
    samples_expected_delivery_date?: string | null;
    /** @maxLength 255 */
    samples_shipping_provider?: string | null;
    autoconfirm_orders?: boolean;
    /**
     * @min 0
     * @max 2147483647
     */
    minimum_lead_time?: number | null;
    /**
     * @min 0
     * @max 2147483647
     */
    order_in_multiples_of?: number | null;
    /**
     * @min 0
     * @max 2147483647
     */
    minimum_autoconfirm_order_quantity?: number | null;
    /**
     * @min 0
     * @max 2147483647
     */
    maximum_autoconfirm_order_quantity?: number | null;
    /**
     * @min 0
     * @max 2147483647
     */
    extension_length?: number | null;
    extension_accepted?: boolean | null;
    packaging_format?: string;
    original_quote: string;
    description_blocks?: QuoteDescriptionBlock[] | null;
    payment_terms_updated_by_supplier?: boolean;
    company: Company;
    company_address: CompanyAddress;
}

export interface QuoteDispatchAddress {
    id: number;
    /** @maxLength 255 */
    name: string;
    /** @maxLength 255 */
    street_1?: string | null;
    /** @maxLength 255 */
    street_2?: string | null;
    /** @maxLength 255 */
    contact_full_name?: string | null;
    /** @maxLength 50 */
    contact_phone?: string | null;
    phone_country_code?: PhoneCountryCodeEnum | BlankEnum | NullEnum | null;
    /** @maxLength 100 */
    town?: string | null;
    /** @maxLength 100 */
    region?: string | null;
    /** @maxLength 100 */
    postcode?: string | null;
    /** @maxLength 20 */
    eori_number?: string;
    delivery_instructions?: string | null;
    /** @maxLength 100 */
    building?: string | null;
    /**
     * @format decimal
     * @pattern ^-?\d{0,4}(?:\.\d{0,15})?$
     */
    latitude?: string | null;
    /**
     * @format decimal
     * @pattern ^-?\d{0,4}(?:\.\d{0,15})?$
     */
    longitude?: string | null;
    collection_instructions?: string | null;
    /** @format uuid */
    uuid: string;
    country: Country | NullEnum | null;
    place_id: string | null;
    vat_number: string | null;
    vat_country_code: Country | NullEnum | null;
    vat_exempt: boolean;
    country_type: CountryTypeEnum;
}

export interface QuoteDocument {
    /** @format uri */
    documents: string;
    /** @format uuid */
    uuid: string;
    /** @default "other" */
    document_category?: QuoteDocumentDocumentCategoryEnum;
    /** @default false */
    is_filled?: boolean;
    file_name: string;
}

/**
 * * `other` - Other
 * * `account_form` - Account Form
 * * `agreement` - Agreement
 * * `invoice` - Invoice
 */
export enum QuoteDocumentDocumentCategoryEnum {
    Other = "other",
    AccountForm = "account_form",
    Agreement = "agreement",
    Invoice = "invoice",
}

export interface QuoteExtension {
    /**
     * @min 0
     * @max 2147483647
     */
    extension_length?: number | null;
}

export interface QuoteFeesAdmin {
    id: number;
    /** @format uuid */
    uuid: string;
    quote: number;
    /** @maxLength 255 */
    title: string;
    description?: string | null;
    /**
     * * `buyer_to_opply` - Buyer To Opply
     * * `buyer_to_supplier` - Buyer To Supplier
     * * `buyer_shipping_to_opply` - Buyer Shipping To Opply
     * * `supplier_to_buyer` - Supplier To Buyer
     * * `supplier_to_opply` - Supplier To Opply
     * * `opply_to_supplier` - Opply To Supplier
     */
    category?: QuoteFeesAdminCategoryEnum;
    /**
     * @format decimal
     * @pattern ^-?\d{0,9}(?:\.\d{0,10})?$
     */
    amount?: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,1}(?:\.\d{0,4})?$
     */
    vat_rate?: string;
    currency: Currencies;
}

/**
 * * `buyer_to_opply` - Buyer To Opply
 * * `buyer_to_supplier` - Buyer To Supplier
 * * `buyer_shipping_to_opply` - Buyer Shipping To Opply
 * * `supplier_to_buyer` - Supplier To Buyer
 * * `supplier_to_opply` - Supplier To Opply
 * * `opply_to_supplier` - Opply To Supplier
 */
export enum QuoteFeesAdminCategoryEnum {
    BuyerToOpply = "buyer_to_opply",
    BuyerToSupplier = "buyer_to_supplier",
    BuyerShippingToOpply = "buyer_shipping_to_opply",
    SupplierToBuyer = "supplier_to_buyer",
    SupplierToOpply = "supplier_to_opply",
    OpplyToSupplier = "opply_to_supplier",
}

export interface QuoteForPurchaseInquiryCreate {
    /**
     * @format decimal
     * @pattern ^-?\d{0,10}(?:\.\d{0,2})?$
     */
    quantity: string;
    /** @format date */
    delivery_date: string;
}

export interface QuoteForRetrieveInquiryAdmin {
    /** @format uuid */
    uuid: string;
    company: CompanyNameAndId;
    /** @maxLength 255 */
    product_name: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,10}(?:\.\d{0,2})?$
     */
    quantity: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,10}(?:\.\d{0,2})?$
     */
    total_forecast_quantity?: string | null;
    sum_to_pay: string;
    /** @format date-time */
    created_date: string;
    /**
     * * `available` - available
     * * `ordered` - ordered
     * * `expired` - expired
     * * `declined` - declined
     * * `pending_payment` - pending_payment
     * * `proceeded` - proceeded
     * * `contract_created` - Contract Created
     * * `contract_proceeded` - contract_proceeded
     * * `contract_confirmed` - contract_confirmed
     */
    status?: QuoteState;
    /**
     * @format uri
     * @maxLength 2048
     */
    logo_url?: string;
    /**
     * * `fl oz` - Fluid Ounces
     * * `g` - Grams
     * * `mg` - milligrams
     * * `gals` - Gallons
     * * `kg` - Kilograms
     * * `L` - Liters
     * * `tons` - Metric Tons
     * * `oz` - Ounces
     * * `lbs` - Pounds
     * * `pcs` - Pieces
     * * `pt` - Pints
     * * `ml` - Milliliter
     * * `boxes` - Boxes
     * * `pallets` - Pallets
     * * `tsp` - Teaspoons
     * * `tbsp` - Tablespoons
     * * `units` - Units
     * * `cases` - Cases
     * * `trays` - Trays
     */
    unit_of_measurement?: UnitOfMeasurementEnum;
    /**
     * * `EUR` - EUR
     * * `USD` - USD
     * * `GBP` - GBP
     * * `CAD` - CAD
     */
    currency?: Currencies;
}

export interface QuoteList {
    /** @format uuid */
    uuid: string;
    /** @maxLength 255 */
    product_name: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,10}(?:\.\d{0,2})?$
     */
    quantity: string;
    /** @format date */
    delivery_date: string;
    /**
     * * `in_advance` - In Advance
     * * `on_dispatch` - On Dispatch
     */
    payment_scenario?: PaymentScenarioEnum;
    /**
     * @min 0
     * @max 365
     */
    payment_delay?: number;
    /**
     * @min 0
     * @max 2147483647
     */
    quote_valid_for?: number | null;
    /**
     * The maximum time a supplier agrees to deliver the product within (days)
     * @min 0
     * @max 2147483647
     */
    lead_time: number;
    product_description?: string | null;
    /**
     * @format decimal
     * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
     */
    shipping_cost?: string | null;
    /**
     * * `EUR` - EUR
     * * `USD` - USD
     * * `GBP` - GBP
     * * `CAD` - CAD
     */
    currency?: Currencies;
    /**
     * * `available` - available
     * * `ordered` - ordered
     * * `expired` - expired
     * * `declined` - declined
     * * `pending_payment` - pending_payment
     * * `proceeded` - proceeded
     * * `contract_created` - Contract Created
     * * `contract_proceeded` - contract_proceeded
     * * `contract_confirmed` - contract_confirmed
     */
    status?: QuoteState;
    /**
     * Datetime when the quote becomes published. Leave empty to keep it unpublished.
     * @format date-time
     */
    published?: string | null;
    /**
     * * `fl oz` - Fluid Ounces
     * * `g` - Grams
     * * `mg` - milligrams
     * * `gals` - Gallons
     * * `kg` - Kilograms
     * * `L` - Liters
     * * `tons` - Metric Tons
     * * `oz` - Ounces
     * * `lbs` - Pounds
     * * `pcs` - Pieces
     * * `pt` - Pints
     * * `ml` - Milliliter
     * * `boxes` - Boxes
     * * `pallets` - Pallets
     * * `tsp` - Teaspoons
     * * `tbsp` - Tablespoons
     * * `units` - Units
     * * `cases` - Cases
     * * `trays` - Trays
     */
    unit_of_measurement?: UnitOfMeasurementEnum;
    inquiry_unit_of_measurement: string;
    /** @format date-time */
    created_date: string;
    /** @format date */
    expiry_date?: string | null;
    inquiry: number;
    /**
     * @format uri
     * @maxLength 2048
     */
    logo_url?: string;
    /** @format double */
    total_price: number;
    /** @format double */
    unit_price: number;
    /** @format double */
    vat_rate: number;
    is_reverse_charge?: boolean;
    vat_charged?: boolean;
    vat_remitted?: boolean;
    vat_exempt?: boolean;
    /**
     * @format decimal
     * @pattern ^-?\d{0,1}(?:\.\d{0,4})?$
     */
    fx_fee?: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,9}(?:\.\d{0,6})?$
     */
    fx_rate?: string;
    prices: PricesRetrieve;
    /**
     * @format decimal
     * @pattern ^-?\d{0,7}(?:\.\d{0,2})?$
     */
    commission_payout_vat_rate?: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,7}(?:\.\d{0,2})?$
     */
    commission_payin_vat_rate?: string;
    commission_is_reverse_charge?: boolean;
    inquiry_currency: string;
    is_new: boolean;
    /** @maxLength 32 */
    sku?: string | null;
    /**
     * * `non_recurring` - Non Recurring
     * * `recurring` - Recurring
     * * `purchase_request_quote` - Purchase Request Quote
     */
    category?: QuoteCategory;
    order_frequency: OrderFrequencyEnum;
    total_forecast_volume: string;
    is_contract_expired: boolean;
    /** @format uuid */
    inquiry_uuid: string;
    /** @format date */
    contract_end_date?: string | null;
    contract_status: string;
    total_forecast_price: string;
    /** @format double */
    total_forecast_price_for_supplier: number;
    number_of_recurring_orders: string;
    is_custom_contract?: boolean;
    custom_contract_frequency: string;
    /**
     * Duration of the contract in months.
     * @min -2147483648
     * @max 2147483647
     */
    contract_length?: number | null;
    buyer_company_name: string;
    agreement_required?: boolean;
    is_filled: boolean;
    total_forecast_payout: string;
    /** @format uuid */
    original_quote_uuid: string;
    /** @format double */
    shipping_vat_rate: number;
    expires_in: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,10}(?:\.\d{0,2})?$
     */
    total_forecast_quantity?: string | null;
    /**
     * * `total` - total
     * * `unit` - unit
     */
    selected_price_option?: SelectedPriceOptionEnum;
    update_requested?: boolean;
    ordered_volume: number;
    delivery_address: DeliveryAddressResponse;
    incoterms?: IncotermsEnum | NullEnum | null;
    /**
     * * `in_advance` - In Advance
     * * `on_dispatch` - On Dispatch
     * * `7_days_after_dispatch` - Days After Dispatch 7
     * * `14_days_after_dispatch` - Days After Dispatch 14
     * * `30_days_after_dispatch` - Days After Dispatch 30
     * * `60_days_after_dispatch` - Days After Dispatch 60
     */
    payment_terms?: PaymentTermsEnum;
}

export interface QuoteListAdmin {
    /** @format uuid */
    uuid: string;
    /** @maxLength 255 */
    product_name: string;
    supplier_name: string;
    buyer_name: string;
    request_id: string;
    /** @format date-time */
    created_date: string;
    /**
     * * `available` - available
     * * `ordered` - ordered
     * * `expired` - expired
     * * `declined` - declined
     * * `pending_payment` - pending_payment
     * * `proceeded` - proceeded
     * * `contract_created` - Contract Created
     * * `contract_proceeded` - contract_proceeded
     * * `contract_confirmed` - contract_confirmed
     */
    status?: QuoteState;
    /**
     * @format uri
     * @maxLength 2048
     */
    logo_url?: string;
    /**
     * Datetime when the quote becomes published. Leave empty to keep it unpublished.
     * @format date-time
     */
    published?: string | null;
    autoconfirm_orders?: boolean;
    /**
     * @min 0
     * @max 2147483647
     */
    minimum_lead_time?: number | null;
    /**
     * @min 0
     * @max 2147483647
     */
    order_in_multiples_of?: number | null;
    /**
     * @min 0
     * @max 2147483647
     */
    minimum_autoconfirm_order_quantity?: number | null;
    /**
     * @min 0
     * @max 2147483647
     */
    maximum_autoconfirm_order_quantity?: number | null;
    /**
     * * `available` - Available
     * * `requested` - Requested
     * * `sent` - Sent
     * * `received` - Received
     * * `accepted` - Accepted
     * * `rejected` - Rejected
     * * `declined` - Declined
     */
    samples_status?: SamplesStatusEnum;
    /**
     * @format decimal
     * @pattern ^-?\d{0,9}(?:\.\d{0,10})?$
     */
    buyer_unit_price?: string | null;
    /**
     * @format decimal
     * @pattern ^-?\d{0,9}(?:\.\d{0,10})?$
     */
    buyer_total_price?: string | null;
    /**
     * @format decimal
     * @pattern ^-?\d{0,1}(?:\.\d{0,4})?$
     */
    buyer_vat_rate?: string | null;
    is_hidden_for_buyer?: boolean;
}

export interface QuoteNegotiation {
    /** @format uuid */
    uuid: string;
    /** @format uuid */
    quote_uuid: string;
    quote: number;
    /**
     * @min 0
     * @max 2147483647
     */
    quantity: number;
    /**
     * @format decimal
     * @pattern ^-?\d{0,13}(?:\.\d{0,2})?$
     */
    unit_price: string;
    /** @format date */
    delivery_date?: string | null;
    /**
     * Duration of the contract in months.
     * @min -2147483648
     * @max 2147483647
     */
    contract_length?: number | null;
    /** @format date */
    first_order_delivery_date?: string | null;
    /**
     * * `created` - Created
     * * `accepted` - Accepted
     * * `declined` - Declined
     * * `completed` - Completed
     */
    status?: QuoteNegotiationStatus;
    /** @format date */
    declined_date?: string | null;
    /**
     * @format decimal
     * @pattern ^-?\d{0,9}(?:\.\d{0,10})?$
     */
    unit_price_with_commission_with_vat: string;
    /** @format date */
    accepted_date?: string | null;
}

/**
 * * `created` - Created
 * * `accepted` - Accepted
 * * `declined` - Declined
 * * `completed` - Completed
 */
export enum QuoteNegotiationStatus {
    Created = "created",
    Accepted = "accepted",
    Declined = "declined",
    Completed = "completed",
}

export interface QuoteOrderDetail {
    /** @format uuid */
    uuid: string;
    /** @maxLength 255 */
    product_name: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,10}(?:\.\d{0,2})?$
     */
    quantity: string;
    /** @format date */
    delivery_date: string;
    /**
     * * `in_advance` - In Advance
     * * `on_dispatch` - On Dispatch
     */
    payment_scenario?: PaymentScenarioEnum;
    /**
     * @min 0
     * @max 365
     */
    payment_delay?: number;
    /**
     * @min 0
     * @max 2147483647
     */
    quote_valid_for?: number | null;
    /**
     * The maximum time a supplier agrees to deliver the product within (days)
     * @min 0
     * @max 2147483647
     */
    lead_time: number;
    product_description?: string | null;
    /**
     * @format decimal
     * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
     */
    shipping_cost?: string | null;
    /**
     * * `EUR` - EUR
     * * `USD` - USD
     * * `GBP` - GBP
     * * `CAD` - CAD
     */
    currency?: Currencies;
    /**
     * * `available` - available
     * * `ordered` - ordered
     * * `expired` - expired
     * * `declined` - declined
     * * `pending_payment` - pending_payment
     * * `proceeded` - proceeded
     * * `contract_created` - Contract Created
     * * `contract_proceeded` - contract_proceeded
     * * `contract_confirmed` - contract_confirmed
     */
    status?: QuoteState;
    /**
     * Datetime when the quote becomes published. Leave empty to keep it unpublished.
     * @format date-time
     */
    published?: string | null;
    /**
     * * `fl oz` - Fluid Ounces
     * * `g` - Grams
     * * `mg` - milligrams
     * * `gals` - Gallons
     * * `kg` - Kilograms
     * * `L` - Liters
     * * `tons` - Metric Tons
     * * `oz` - Ounces
     * * `lbs` - Pounds
     * * `pcs` - Pieces
     * * `pt` - Pints
     * * `ml` - Milliliter
     * * `boxes` - Boxes
     * * `pallets` - Pallets
     * * `tsp` - Teaspoons
     * * `tbsp` - Tablespoons
     * * `units` - Units
     * * `cases` - Cases
     * * `trays` - Trays
     */
    unit_of_measurement?: UnitOfMeasurementEnum;
    inquiry_unit_of_measurement: string;
    /** @format date-time */
    created_date: string;
    /** @format date */
    expiry_date?: string | null;
    /** @format uuid */
    inquiry: string;
    /**
     * @format uri
     * @maxLength 2048
     */
    logo_url?: string;
    /** @format double */
    total_price: number;
    /** @format double */
    unit_price: number;
    /** @format double */
    vat_rate: number;
    is_reverse_charge?: boolean;
    vat_charged?: boolean;
    vat_remitted?: boolean;
    vat_exempt?: boolean;
    /**
     * @format decimal
     * @pattern ^-?\d{0,1}(?:\.\d{0,4})?$
     */
    fx_fee?: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,9}(?:\.\d{0,6})?$
     */
    fx_rate?: string;
    prices: PricesRetrieve;
    /**
     * @format decimal
     * @pattern ^-?\d{0,7}(?:\.\d{0,2})?$
     */
    commission_payout_vat_rate?: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,7}(?:\.\d{0,2})?$
     */
    commission_payin_vat_rate?: string;
    commission_is_reverse_charge?: boolean;
    inquiry_currency: string;
    is_new: boolean;
    /** @maxLength 32 */
    sku?: string | null;
    /**
     * * `non_recurring` - Non Recurring
     * * `recurring` - Recurring
     * * `purchase_request_quote` - Purchase Request Quote
     */
    category?: QuoteCategory;
    order_frequency: OrderFrequencyEnum;
    total_forecast_volume: string;
    is_contract_expired: boolean;
    /** @format uuid */
    inquiry_uuid: string;
    /** @format date */
    contract_end_date?: string | null;
    contract_status: string;
    total_forecast_price: string;
    /** @format double */
    total_forecast_price_for_supplier: number;
    number_of_recurring_orders: string;
    is_custom_contract?: boolean;
    custom_contract_frequency: string;
    /**
     * Duration of the contract in months.
     * @min -2147483648
     * @max 2147483647
     */
    contract_length?: number | null;
    buyer_company_name: string;
    agreement_required?: boolean;
    is_filled: boolean;
    total_forecast_payout: string;
    /** @format uuid */
    original_quote_uuid: string;
    /** @format double */
    shipping_vat_rate: number;
    expires_in: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,10}(?:\.\d{0,2})?$
     */
    total_forecast_quantity?: string | null;
    /**
     * * `total` - total
     * * `unit` - unit
     */
    selected_price_option?: SelectedPriceOptionEnum;
    update_requested?: boolean;
    ordered_volume: number;
    delivery_address: DeliveryAddressResponse;
    incoterms?: IncotermsEnum | NullEnum | null;
    /**
     * * `in_advance` - In Advance
     * * `on_dispatch` - On Dispatch
     * * `7_days_after_dispatch` - Days After Dispatch 7
     * * `14_days_after_dispatch` - Days After Dispatch 14
     * * `30_days_after_dispatch` - Days After Dispatch 30
     * * `60_days_after_dispatch` - Days After Dispatch 60
     */
    payment_terms?: PaymentTermsEnum;
    kyb_status: string;
    dispatch_address: CompanyAddress;
    /**
     * * `available` - Available
     * * `requested` - Requested
     * * `sent` - Sent
     * * `received` - Received
     * * `accepted` - Accepted
     * * `rejected` - Rejected
     * * `declined` - Declined
     */
    samples_status?: SamplesStatusEnum;
    samples_delivery_address: CompanyAddress;
    samples_feedback?: SamplesFeedbackEnum[] | null;
    samples_feedback_comment?: string;
    supplier: SectionSupplier | null;
    is_recurring: string;
    /**
     * @min 0
     * @max 2147483647
     */
    recurring_order_lead_time?: number | null;
    account_form_required?: boolean;
    payout_per_order: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,17}(?:\.\d{0,2})?$
     */
    case_size?: string | null;
    /**
     * @format decimal
     * @pattern ^-?\d{0,17}(?:\.\d{0,2})?$
     */
    minimum_order_quantity?: string | null;
    inquiry_frequency: string;
    delivery_address_id: number;
    /**
     * * `in_advance` - In Advance
     * * `on_dispatch` - On Dispatch
     * * `7_days_after_dispatch` - Days After Dispatch 7
     * * `14_days_after_dispatch` - Days After Dispatch 14
     * * `30_days_after_dispatch` - Days After Dispatch 30
     * * `60_days_after_dispatch` - Days After Dispatch 60
     */
    requested_payment_terms?: PaymentTermsEnum;
    is_opply_supplier: string;
    ingredient: IngredientsForQuote;
    /** @format date */
    samples_dispatch_date?: string | null;
    /** @format date */
    samples_sent_date?: string | null;
    /** @format date */
    samples_received_date?: string | null;
    /** @format date */
    samples_accepted_date?: string | null;
    /** @format date */
    samples_rejected_date?: string | null;
    /** @format date */
    samples_requested_date?: string | null;
    /** @format date */
    samples_declined_date?: string | null;
    samples_tracking_code?: string | null;
    /** @format date */
    samples_expected_delivery_date?: string | null;
    /** @maxLength 255 */
    samples_shipping_provider?: string | null;
    autoconfirm_orders?: boolean;
    /**
     * @min 0
     * @max 2147483647
     */
    minimum_lead_time?: number | null;
    /**
     * @min 0
     * @max 2147483647
     */
    order_in_multiples_of?: number | null;
    /**
     * @min 0
     * @max 2147483647
     */
    minimum_autoconfirm_order_quantity?: number | null;
    /**
     * @min 0
     * @max 2147483647
     */
    maximum_autoconfirm_order_quantity?: number | null;
    /**
     * @min 0
     * @max 2147483647
     */
    extension_length?: number | null;
    extension_accepted?: boolean | null;
    packaging_format?: string;
    original_quote: string;
    description_blocks?: QuoteDescriptionBlock[] | null;
    payment_terms_updated_by_supplier?: boolean;
    /** @format uuid */
    product_uuid: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,7}(?:\.\d{0,2})?$
     */
    discount?: string | null;
}

export interface QuoteRetrieve {
    /** @format uuid */
    uuid: string;
    /** @maxLength 255 */
    product_name: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,10}(?:\.\d{0,2})?$
     */
    quantity: string;
    /** @format date */
    delivery_date: string;
    /**
     * * `in_advance` - In Advance
     * * `on_dispatch` - On Dispatch
     */
    payment_scenario?: PaymentScenarioEnum;
    /**
     * @min 0
     * @max 365
     */
    payment_delay?: number;
    /**
     * @min 0
     * @max 2147483647
     */
    quote_valid_for?: number | null;
    /**
     * The maximum time a supplier agrees to deliver the product within (days)
     * @min 0
     * @max 2147483647
     */
    lead_time: number;
    product_description?: string | null;
    /**
     * @format decimal
     * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
     */
    shipping_cost?: string | null;
    /**
     * * `EUR` - EUR
     * * `USD` - USD
     * * `GBP` - GBP
     * * `CAD` - CAD
     */
    currency?: Currencies;
    /**
     * * `available` - available
     * * `ordered` - ordered
     * * `expired` - expired
     * * `declined` - declined
     * * `pending_payment` - pending_payment
     * * `proceeded` - proceeded
     * * `contract_created` - Contract Created
     * * `contract_proceeded` - contract_proceeded
     * * `contract_confirmed` - contract_confirmed
     */
    status?: QuoteState;
    /**
     * Datetime when the quote becomes published. Leave empty to keep it unpublished.
     * @format date-time
     */
    published?: string | null;
    /**
     * * `fl oz` - Fluid Ounces
     * * `g` - Grams
     * * `mg` - milligrams
     * * `gals` - Gallons
     * * `kg` - Kilograms
     * * `L` - Liters
     * * `tons` - Metric Tons
     * * `oz` - Ounces
     * * `lbs` - Pounds
     * * `pcs` - Pieces
     * * `pt` - Pints
     * * `ml` - Milliliter
     * * `boxes` - Boxes
     * * `pallets` - Pallets
     * * `tsp` - Teaspoons
     * * `tbsp` - Tablespoons
     * * `units` - Units
     * * `cases` - Cases
     * * `trays` - Trays
     */
    unit_of_measurement?: UnitOfMeasurementEnum;
    inquiry_unit_of_measurement: string;
    /** @format date-time */
    created_date: string;
    /** @format date */
    expiry_date?: string | null;
    /** @format uuid */
    inquiry: string;
    /**
     * @format uri
     * @maxLength 2048
     */
    logo_url?: string;
    /** @format double */
    total_price: number;
    /** @format double */
    unit_price: number;
    /** @format double */
    vat_rate: number;
    is_reverse_charge?: boolean;
    vat_charged?: boolean;
    vat_remitted?: boolean;
    vat_exempt?: boolean;
    /**
     * @format decimal
     * @pattern ^-?\d{0,1}(?:\.\d{0,4})?$
     */
    fx_fee?: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,9}(?:\.\d{0,6})?$
     */
    fx_rate?: string;
    prices: PricesRetrieve;
    /**
     * @format decimal
     * @pattern ^-?\d{0,7}(?:\.\d{0,2})?$
     */
    commission_payout_vat_rate?: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,7}(?:\.\d{0,2})?$
     */
    commission_payin_vat_rate?: string;
    commission_is_reverse_charge?: boolean;
    inquiry_currency: string;
    is_new: boolean;
    /** @maxLength 32 */
    sku?: string | null;
    /**
     * * `non_recurring` - Non Recurring
     * * `recurring` - Recurring
     * * `purchase_request_quote` - Purchase Request Quote
     */
    category?: QuoteCategory;
    order_frequency: OrderFrequencyEnum;
    total_forecast_volume: string;
    is_contract_expired: boolean;
    /** @format uuid */
    inquiry_uuid: string;
    /** @format date */
    contract_end_date?: string | null;
    contract_status: string;
    total_forecast_price: string;
    /** @format double */
    total_forecast_price_for_supplier: number;
    number_of_recurring_orders: string;
    is_custom_contract?: boolean;
    custom_contract_frequency: string;
    /**
     * Duration of the contract in months.
     * @min -2147483648
     * @max 2147483647
     */
    contract_length?: number | null;
    buyer_company_name: string;
    agreement_required?: boolean;
    is_filled: boolean;
    total_forecast_payout: string;
    /** @format uuid */
    original_quote_uuid: string;
    /** @format double */
    shipping_vat_rate: number;
    expires_in: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,10}(?:\.\d{0,2})?$
     */
    total_forecast_quantity?: string | null;
    /**
     * * `total` - total
     * * `unit` - unit
     */
    selected_price_option?: SelectedPriceOptionEnum;
    update_requested?: boolean;
    ordered_volume: number;
    delivery_address: DeliveryAddressResponse;
    incoterms?: IncotermsEnum | NullEnum | null;
    /**
     * * `in_advance` - In Advance
     * * `on_dispatch` - On Dispatch
     * * `7_days_after_dispatch` - Days After Dispatch 7
     * * `14_days_after_dispatch` - Days After Dispatch 14
     * * `30_days_after_dispatch` - Days After Dispatch 30
     * * `60_days_after_dispatch` - Days After Dispatch 60
     */
    payment_terms?: PaymentTermsEnum;
    kyb_status: string;
    dispatch_address?: number | null;
    /**
     * * `available` - Available
     * * `requested` - Requested
     * * `sent` - Sent
     * * `received` - Received
     * * `accepted` - Accepted
     * * `rejected` - Rejected
     * * `declined` - Declined
     */
    samples_status?: SamplesStatusEnum;
    samples_delivery_address: CompanyAddress;
    samples_feedback?: SamplesFeedbackEnum[] | null;
    samples_feedback_comment?: string;
    supplier: SectionSupplier | null;
    is_recurring: string;
    /**
     * @min 0
     * @max 2147483647
     */
    recurring_order_lead_time?: number | null;
    account_form_required?: boolean;
    payout_per_order: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,17}(?:\.\d{0,2})?$
     */
    case_size?: string | null;
    /**
     * @format decimal
     * @pattern ^-?\d{0,17}(?:\.\d{0,2})?$
     */
    minimum_order_quantity?: string | null;
    inquiry_frequency: string;
    delivery_address_id: number;
    /**
     * * `in_advance` - In Advance
     * * `on_dispatch` - On Dispatch
     * * `7_days_after_dispatch` - Days After Dispatch 7
     * * `14_days_after_dispatch` - Days After Dispatch 14
     * * `30_days_after_dispatch` - Days After Dispatch 30
     * * `60_days_after_dispatch` - Days After Dispatch 60
     */
    requested_payment_terms?: PaymentTermsEnum;
    is_opply_supplier: string;
    ingredient: IngredientsForQuote;
    /** @format date */
    samples_dispatch_date?: string | null;
    /** @format date */
    samples_sent_date?: string | null;
    /** @format date */
    samples_received_date?: string | null;
    /** @format date */
    samples_accepted_date?: string | null;
    /** @format date */
    samples_rejected_date?: string | null;
    /** @format date */
    samples_requested_date?: string | null;
    /** @format date */
    samples_declined_date?: string | null;
    samples_tracking_code?: string | null;
    /** @format date */
    samples_expected_delivery_date?: string | null;
    /** @maxLength 255 */
    samples_shipping_provider?: string | null;
    autoconfirm_orders?: boolean;
    /**
     * @min 0
     * @max 2147483647
     */
    minimum_lead_time?: number | null;
    /**
     * @min 0
     * @max 2147483647
     */
    order_in_multiples_of?: number | null;
    /**
     * @min 0
     * @max 2147483647
     */
    minimum_autoconfirm_order_quantity?: number | null;
    /**
     * @min 0
     * @max 2147483647
     */
    maximum_autoconfirm_order_quantity?: number | null;
    /**
     * @min 0
     * @max 2147483647
     */
    extension_length?: number | null;
    extension_accepted?: boolean | null;
    packaging_format?: string;
    original_quote: string;
    description_blocks?: QuoteDescriptionBlock[] | null;
    payment_terms_updated_by_supplier?: boolean;
    company: Company;
    company_address: CompanyAddress;
    order_uuid: string | null;
    inquiry_supplier_status: string;
    decline_reason: QuoteDeclineReason[];
    decline_reason_extended?: string | null;
    supplier_kyb_verification_status: string;
    beneficiary_verification_status: string;
    supplier_kriya_status: string;
    buyer_name: string;
    buyer_contact_name: string;
    buyer_company_address: string;
    supplier_contact_name: string;
    supplier_full_contact_name: string;
    show_to_other_buyers?: boolean;
}

export interface QuoteRetrieveAdmin {
    /** @format uuid */
    uuid: string;
    /** @maxLength 255 */
    product_name: string;
    supplier_name: string;
    buyer_name: string;
    request_id: string;
    /** @format date-time */
    created_date: string;
    /**
     * * `available` - available
     * * `ordered` - ordered
     * * `expired` - expired
     * * `declined` - declined
     * * `pending_payment` - pending_payment
     * * `proceeded` - proceeded
     * * `contract_created` - Contract Created
     * * `contract_proceeded` - contract_proceeded
     * * `contract_confirmed` - contract_confirmed
     */
    status?: QuoteState;
    /**
     * @format uri
     * @maxLength 2048
     */
    logo_url?: string;
    /**
     * Datetime when the quote becomes published. Leave empty to keep it unpublished.
     * @format date-time
     */
    published?: string | null;
    autoconfirm_orders?: boolean;
    /**
     * @min 0
     * @max 2147483647
     */
    minimum_lead_time?: number | null;
    /**
     * @min 0
     * @max 2147483647
     */
    order_in_multiples_of?: number | null;
    /**
     * @min 0
     * @max 2147483647
     */
    minimum_autoconfirm_order_quantity?: number | null;
    /**
     * @min 0
     * @max 2147483647
     */
    maximum_autoconfirm_order_quantity?: number | null;
    /**
     * * `available` - Available
     * * `requested` - Requested
     * * `sent` - Sent
     * * `received` - Received
     * * `accepted` - Accepted
     * * `rejected` - Rejected
     * * `declined` - Declined
     */
    samples_status?: SamplesStatusEnum;
    /**
     * @format decimal
     * @pattern ^-?\d{0,9}(?:\.\d{0,10})?$
     */
    buyer_unit_price?: string | null;
    /**
     * @format decimal
     * @pattern ^-?\d{0,9}(?:\.\d{0,10})?$
     */
    buyer_total_price?: string | null;
    /**
     * @format decimal
     * @pattern ^-?\d{0,1}(?:\.\d{0,4})?$
     */
    buyer_vat_rate?: string | null;
    is_hidden_for_buyer?: boolean;
    company: CompanyNameAndId;
    created_by: User;
    /**
     * @format decimal
     * @pattern ^-?\d{0,10}(?:\.\d{0,2})?$
     */
    quantity: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,9}(?:\.\d{0,10})?$
     */
    unit_price?: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,9}(?:\.\d{0,10})?$
     */
    total_price?: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,1}(?:\.\d{0,4})?$
     */
    vat_rate?: string | null;
    /** @format date */
    delivery_date: string;
    /**
     * * `in_advance` - In Advance
     * * `on_dispatch` - On Dispatch
     */
    payment_scenario?: PaymentScenarioEnum;
    /**
     * @min 0
     * @max 365
     */
    payment_delay?: number;
    /**
     * Minimum Shelf Life on Delivery (days)
     * @min 0
     * @max 2147483647
     */
    shelf_life?: number | null;
    /**
     * @min 0
     * @max 2147483647
     */
    quote_valid_for?: number | null;
    /**
     * The maximum time a supplier agrees to deliver the product within (days)
     * @min 0
     * @max 2147483647
     */
    lead_time: number;
    dispatch_address: CompanyAddress;
    incoterms?: IncotermsEnum | NullEnum | null;
    /**
     * * `EUR` - EUR
     * * `USD` - USD
     * * `GBP` - GBP
     * * `CAD` - CAD
     */
    currency?: Currencies;
    /**
     * * `EUR` - EUR
     * * `USD` - USD
     * * `GBP` - GBP
     * * `CAD` - CAD
     */
    buyer_currency: Currencies;
    /**
     * * `non_recurring` - Non Recurring
     * * `recurring` - Recurring
     * * `purchase_request_quote` - Purchase Request Quote
     */
    category?: QuoteCategory;
    /**
     * @format decimal
     * @pattern ^-?\d{0,9}(?:\.\d{0,6})?$
     */
    fx_rate?: string;
    product_description?: string | null;
    /**
     * * `fl oz` - Fluid Ounces
     * * `g` - Grams
     * * `mg` - milligrams
     * * `gals` - Gallons
     * * `kg` - Kilograms
     * * `L` - Liters
     * * `tons` - Metric Tons
     * * `oz` - Ounces
     * * `lbs` - Pounds
     * * `pcs` - Pieces
     * * `pt` - Pints
     * * `ml` - Milliliter
     * * `boxes` - Boxes
     * * `pallets` - Pallets
     * * `tsp` - Teaspoons
     * * `tbsp` - Tablespoons
     * * `units` - Units
     * * `cases` - Cases
     * * `trays` - Trays
     */
    unit_of_measurement?: UnitOfMeasurementEnum;
    /**
     * @format decimal
     * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
     */
    shipping_cost?: string | null;
    inquiry: InquiryAdmin;
    prices: PricesRetrieve;
    decline_reason: QuoteDeclineReason[];
    decline_reason_extended?: string | null;
    documents: QuoteDocument[];
    /** @maxLength 32 */
    sku?: string | null;
    /**
     * @format decimal
     * @pattern ^-?\d{0,17}(?:\.\d{0,2})?$
     */
    minimum_order_quantity?: string | null;
    /**
     * @format decimal
     * @pattern ^-?\d{0,17}(?:\.\d{0,2})?$
     */
    case_size?: string | null;
    order_frequency: string;
    total_forecast_volume: string;
    total_forecast_payout: string;
    total_forecast_price: string;
    total_forecast_price_no_fx: number;
    payout_per_order: string;
    /**
     * @min 0
     * @max 2147483647
     */
    recurring_order_lead_time?: number | null;
    /** @format date */
    expiry_date?: string | null;
    /**
     * Duration of the contract in months.
     * @min -2147483648
     * @max 2147483647
     */
    contract_length?: number | null;
    agreement_required?: boolean;
    is_opply_supplier: string;
    account_form_required?: boolean;
    vat_charged?: boolean;
    vat_remitted?: boolean;
    is_reverse_charge?: boolean;
    supplier_commission_per_contract: number;
    supplier_commission_per_order: number;
    buyer_price_per_order: number;
    buyer_price_per_order_no_fx: number;
    buyer_commission_per_order: number;
    buyer_commission_per_order_no_fx: number;
    buyer_commission_per_contract: number;
    is_recurring: string;
    buyer_unit_price_no_vat: number;
    buyer_unit_price_with_vat: number;
    is_custom_contract?: boolean;
    custom_contract_frequency: string;
    number_of_recurring_orders: string;
    /** @format uuid */
    recurring_inquiry_uuid: string;
    /** @format date */
    proceeded_date: string | null;
    /** @format date */
    contract_created_date: string | null;
    /** @format date */
    contract_proceeded_date: string | null;
    /** @format date */
    contract_confirmed_date: string | null;
    show_to_other_buyers?: boolean;
    /**
     * @format decimal
     * @pattern ^-?\d{0,17}(?:\.\d{0,2})?$
     */
    minimum_order_quantity_for_other_buyers?: string | null;
    /**
     * @format decimal
     * @pattern ^-?\d{0,17}(?:\.\d{0,2})?$
     */
    maximum_order_quantity_for_other_buyers?: string | null;
    /** @format date */
    samples_requested_date?: string | null;
    /** @format date */
    samples_dispatch_date?: string | null;
    /** @format date */
    samples_received_date?: string | null;
    /**
     * * `EUR` - EUR
     * * `USD` - USD
     * * `GBP` - GBP
     * * `CAD` - CAD
     */
    supplier_currency: Currencies;
    /**
     * @format decimal
     * @pattern ^-?\d{0,1}(?:\.\d{0,4})?$
     */
    shipping_vat_rate?: string | null;
    /**
     * @format decimal
     * @pattern ^-?\d{0,10}(?:\.\d{0,2})?$
     */
    total_forecast_quantity?: string | null;
}

/**
 * * `available` - available
 * * `ordered` - ordered
 * * `expired` - expired
 * * `declined` - declined
 * * `pending_payment` - pending_payment
 * * `proceeded` - proceeded
 * * `contract_created` - Contract Created
 * * `contract_proceeded` - contract_proceeded
 * * `contract_confirmed` - contract_confirmed
 */
export enum QuoteState {
    Available = "available",
    Ordered = "ordered",
    Expired = "expired",
    Declined = "declined",
    PendingPayment = "pending_payment",
    Proceeded = "proceeded",
    ContractCreated = "contract_created",
    ContractProceeded = "contract_proceeded",
    ContractConfirmed = "contract_confirmed",
}

export interface QuoteUpdateAdmin {
    /**
     * @format decimal
     * @pattern ^-?\d{0,9}(?:\.\d{0,10})?$
     */
    buyer_unit_price?: string | null;
    /**
     * @format decimal
     * @pattern ^-?\d{0,9}(?:\.\d{0,10})?$
     */
    buyer_total_price?: string | null;
    /**
     * @format decimal
     * @pattern ^-?\d{0,1}(?:\.\d{0,4})?$
     */
    buyer_vat_rate?: string | null;
}

export interface RapydCheckout {
    /** @format uuid */
    order_id: string;
    /**
     * * `EUR` - EUR
     * * `GBP` - GBP
     * * `USD` - USD
     * * `CAD` - CAD
     */
    selected_currency?: SupportedCurrencies;
}

export interface RapydCheckoutData {
    checkout_id: string;
    /** @format uri */
    redirect_url: string;
    /** @format uri */
    complete_checkout_url: string;
    prices: OrderPrices;
    virtual_bank_account: VirtualBankTransfer;
    bank_transfer_details?: BankTransfer | null;
}

export interface RapydPostCheckout {
    /** @format uuid */
    order_id: string;
    /**
     * * `EUR` - EUR
     * * `GBP` - GBP
     * * `USD` - USD
     * * `CAD` - CAD
     */
    selected_currency?: SupportedCurrencies;
    /**
     * * `card` - Card
     * * `bank_transfer` - Bank Transfer
     * * `PAY30` - Kriya 30
     * * `PAY30EOFM` - Kriya Next Month
     */
    payment_method: PaymentMethod;
    /**
     * * `in_advance` - In Advance
     * * `on_dispatch` - On Dispatch
     */
    payment_scenario: PaymentScenarioEnum;
}

export interface RapydSavePayment {
    fingerprint_token?: string;
    customer_token?: string;
    payment_id: string;
    order_id: string;
}

export interface RapydSupplierTermsCard {
    /** @format uri */
    redirect_url: string;
}

/** Recursive serializer for a taxonomy node: */
export interface RecursiveTaxonomy {
    id: string;
    name: string;
    reporting_unit_type: string;
    children: Record<string, any>[];
}

export interface RefundCreate {
    /**
     * Tax-exclusive refund amount in cents
     * @min 1
     */
    base_amount?: number | null;
    /**
     * Tax portion of refund amount in cents
     * @min 0
     */
    tax_amount?: number | null;
    /** Why the refund is being issued */
    reason: string;
    /**
     * pay_in or payout
     *
     * * `pay_in` - Pay In
     * * `payout` - Payout
     */
    refund_type: RefundTypeEnum;
    /** @default false */
    is_full_refund?: boolean;
}

/**
 * * `pay_in` - Pay In
 * * `payout` - Payout
 */
export enum RefundTypeEnum {
    PayIn = "pay_in",
    Payout = "payout",
}

export interface RegistrationValidationInput {
    registration_name?: string | null;
    registration_number?: string | null;
    registration_country_code: string;
}

export interface RegistrationValidationResponse {
    registration_name: string | null;
    registration_number: string | null;
    registration_country_code: string;
}

export interface RemoveMember {
    /** @format email */
    email: string;
}

/**
 * * `g` - Grams
 * * `kg` - Kilograms
 * * `mg` - milligrams
 * * `long tons` - Long Tons
 * * `short tons` - Short Tons
 * * `metric tons` - Metric Tons
 * * `oz` - Ounces
 * * `lbs` - Pounds
 * * `uk fl oz` - UK Fluid Ounces
 * * `us fl oz` - US Fluid Ounces
 * * `uk gals` - UK Gallons
 * * `us gals` - US Gallons
 * * `L` - Liters
 * * `ml` - Milliliter
 * * `uk pt` - UK Pints
 * * `us pt` - US Pints
 * * `uk tsp` - UK Teaspoons
 * * `uk tbsp` - UK Tablespoons
 * * `us tsp` - US Teaspoons
 * * `us tbsp` - US Tablespoons
 * * `metric tsp` - Metric Teaspoons
 * * `metric tbsp` - Metric Tablespoons
 * * `pcs` - Pieces
 * * `x1000 pcs` - 1,000 Pieces
 */
export enum ReportingUnitsEnum {
    G = "g",
    Kg = "kg",
    Mg = "mg",
    LongTons = "long tons",
    ShortTons = "short tons",
    MetricTons = "metric tons",
    Oz = "oz",
    Lbs = "lbs",
    UkFlOz = "uk fl oz",
    UsFlOz = "us fl oz",
    UkGals = "uk gals",
    UsGals = "us gals",
    L = "L",
    Ml = "ml",
    UkPt = "uk pt",
    UsPt = "us pt",
    UkTsp = "uk tsp",
    UkTbsp = "uk tbsp",
    UsTsp = "us tsp",
    UsTbsp = "us tbsp",
    MetricTsp = "metric tsp",
    MetricTbsp = "metric tbsp",
    Pcs = "pcs",
    X1000Pcs = "x1000 pcs",
}

/**
 * * `< £1M` - < £1M
 * * `£1M - £5M` - £1M - £5M
 * * `£5M - £10M` - £5M - £10M
 * * `£10M +` - £10M +
 */
export enum RevenueEnum {
    Value1M = "< £1M",
    Value1M5M = "£1M - £5M",
    Value5M10M = "£5M - £10M",
    Value10M = "£10M +",
}

/**
 * * `ingredient_quality` - Ingredient Quality
 * * `quote_price` - Quote Price
 * * `supplier_communication` - Supplier Communication
 * * `quality_not_as_expected` - Quality Not As Expected
 * * `too_expensive` - Too Expensive
 * * `not_suitable_for_recipe` - Not Suitable For Recipe
 * * `not_needed_anymore` - Not Needed Anymore
 * * `dont_provided_samples` - Dont Provide Samples
 * * `ingredient_out_of_stock` - Ingredient Out Of Stock
 * * `other` - Other
 */
export enum SamplesFeedbackEnum {
    IngredientQuality = "ingredient_quality",
    QuotePrice = "quote_price",
    SupplierCommunication = "supplier_communication",
    QualityNotAsExpected = "quality_not_as_expected",
    TooExpensive = "too_expensive",
    NotSuitableForRecipe = "not_suitable_for_recipe",
    NotNeededAnymore = "not_needed_anymore",
    DontProvidedSamples = "dont_provided_samples",
    IngredientOutOfStock = "ingredient_out_of_stock",
    Other = "other",
}

/**
 * * `available` - Available
 * * `requested` - Requested
 * * `sent` - Sent
 * * `received` - Received
 * * `accepted` - Accepted
 * * `rejected` - Rejected
 * * `declined` - Declined
 */
export enum SamplesStatusEnum {
    Available = "available",
    Requested = "requested",
    Sent = "sent",
    Received = "received",
    Accepted = "accepted",
    Rejected = "rejected",
    Declined = "declined",
}

export interface ScoringDebug {
    signals: ScoringSignal[];
    /** @format double */
    base_score: number;
    /** @format double */
    final_score: number;
    killer_applied: boolean;
    killer_reason: string | null;
    enrichment_data: Record<string, any>;
    /** @format date-time */
    fetched_at: string | null;
}

export interface ScoringSignal {
    signal: string;
    raw_value: any;
    /** @format double */
    points: number;
    /** @format double */
    max_points: number;
}

export interface SearchMessagesRequest {
    text: string;
}

export interface SearchMessagesResponse {
    /** @format uuid */
    uuid: string;
    matched_text: string;
    text?: string | null;
    /** @format uri */
    attachment?: string | null;
    sender: number;
    sender_name: string;
    /** @format date-time */
    created: string;
    /** @format date-time */
    modified: string;
    channel: ChannelForMessage;
    page_number: string;
}

export interface SectionSupplier {
    is_existing: boolean;
    company_name: string;
    city?: string | null;
    /**
     * * `AF` - AF
     * * `AX` - AX
     * * `AL` - AL
     * * `DZ` - DZ
     * * `AS` - AS
     * * `AD` - AD
     * * `AO` - AO
     * * `AI` - AI
     * * `AQ` - AQ
     * * `AG` - AG
     * * `AR` - AR
     * * `AM` - AM
     * * `AW` - AW
     * * `AU` - AU
     * * `AT` - AT
     * * `AZ` - AZ
     * * `BS` - BS
     * * `BH` - BH
     * * `BD` - BD
     * * `BB` - BB
     * * `BY` - BY
     * * `BE` - BE
     * * `BZ` - BZ
     * * `BJ` - BJ
     * * `BM` - BM
     * * `BT` - BT
     * * `BO` - BO
     * * `BQ` - BQ
     * * `BA` - BA
     * * `BW` - BW
     * * `BV` - BV
     * * `BR` - BR
     * * `IO` - IO
     * * `BN` - BN
     * * `BG` - BG
     * * `BF` - BF
     * * `BI` - BI
     * * `CV` - CV
     * * `KH` - KH
     * * `CM` - CM
     * * `CA` - CA
     * * `KY` - KY
     * * `CF` - CF
     * * `TD` - TD
     * * `CL` - CL
     * * `CN` - CN
     * * `CX` - CX
     * * `CC` - CC
     * * `CO` - CO
     * * `KM` - KM
     * * `CG` - CG
     * * `CD` - CD
     * * `CK` - CK
     * * `CR` - CR
     * * `CI` - CI
     * * `HR` - HR
     * * `CU` - CU
     * * `CW` - CW
     * * `CY` - CY
     * * `CZ` - CZ
     * * `DK` - DK
     * * `DJ` - DJ
     * * `DM` - DM
     * * `DO` - DO
     * * `EC` - EC
     * * `EG` - EG
     * * `SV` - SV
     * * `GQ` - GQ
     * * `ER` - ER
     * * `EE` - EE
     * * `SZ` - SZ
     * * `ET` - ET
     * * `FK` - FK
     * * `FO` - FO
     * * `FJ` - FJ
     * * `FI` - FI
     * * `FR` - FR
     * * `GF` - GF
     * * `PF` - PF
     * * `TF` - TF
     * * `GA` - GA
     * * `GM` - GM
     * * `GE` - GE
     * * `DE` - DE
     * * `GH` - GH
     * * `GI` - GI
     * * `GR` - GR
     * * `GL` - GL
     * * `GD` - GD
     * * `GP` - GP
     * * `GU` - GU
     * * `GT` - GT
     * * `GG` - GG
     * * `GN` - GN
     * * `GW` - GW
     * * `GY` - GY
     * * `HT` - HT
     * * `HM` - HM
     * * `VA` - VA
     * * `HN` - HN
     * * `HK` - HK
     * * `HU` - HU
     * * `IS` - IS
     * * `IN` - IN
     * * `ID` - ID
     * * `IR` - IR
     * * `IQ` - IQ
     * * `IE` - IE
     * * `IM` - IM
     * * `IL` - IL
     * * `IT` - IT
     * * `JM` - JM
     * * `JP` - JP
     * * `JE` - JE
     * * `JO` - JO
     * * `KZ` - KZ
     * * `KE` - KE
     * * `KI` - KI
     * * `KW` - KW
     * * `KG` - KG
     * * `LA` - LA
     * * `LV` - LV
     * * `LB` - LB
     * * `LS` - LS
     * * `LR` - LR
     * * `LY` - LY
     * * `LI` - LI
     * * `LT` - LT
     * * `LU` - LU
     * * `MO` - MO
     * * `MG` - MG
     * * `MW` - MW
     * * `MY` - MY
     * * `MV` - MV
     * * `ML` - ML
     * * `MT` - MT
     * * `MH` - MH
     * * `MQ` - MQ
     * * `MR` - MR
     * * `MU` - MU
     * * `YT` - YT
     * * `MX` - MX
     * * `FM` - FM
     * * `MD` - MD
     * * `MC` - MC
     * * `MN` - MN
     * * `ME` - ME
     * * `MS` - MS
     * * `MA` - MA
     * * `MZ` - MZ
     * * `MM` - MM
     * * `NA` - NA
     * * `NR` - NR
     * * `NP` - NP
     * * `NL` - NL
     * * `NC` - NC
     * * `NZ` - NZ
     * * `NI` - NI
     * * `NE` - NE
     * * `NG` - NG
     * * `NU` - NU
     * * `NF` - NF
     * * `KP` - KP
     * * `MK` - MK
     * * `XI` - XI
     * * `MP` - MP
     * * `NO` - NO
     * * `OM` - OM
     * * `PK` - PK
     * * `PW` - PW
     * * `PS` - PS
     * * `PA` - PA
     * * `PG` - PG
     * * `PY` - PY
     * * `PE` - PE
     * * `PH` - PH
     * * `PN` - PN
     * * `PL` - PL
     * * `PT` - PT
     * * `PR` - PR
     * * `QA` - QA
     * * `RE` - RE
     * * `RO` - RO
     * * `RU` - RU
     * * `RW` - RW
     * * `BL` - BL
     * * `SH` - SH
     * * `KN` - KN
     * * `LC` - LC
     * * `MF` - MF
     * * `PM` - PM
     * * `VC` - VC
     * * `WS` - WS
     * * `SM` - SM
     * * `ST` - ST
     * * `SA` - SA
     * * `SN` - SN
     * * `RS` - RS
     * * `SC` - SC
     * * `SL` - SL
     * * `SG` - SG
     * * `SX` - SX
     * * `SK` - SK
     * * `SI` - SI
     * * `SB` - SB
     * * `SO` - SO
     * * `ZA` - ZA
     * * `GS` - GS
     * * `KR` - KR
     * * `SS` - SS
     * * `ES` - ES
     * * `LK` - LK
     * * `SD` - SD
     * * `SR` - SR
     * * `SJ` - SJ
     * * `SE` - SE
     * * `CH` - CH
     * * `SY` - SY
     * * `TW` - TW
     * * `TJ` - TJ
     * * `TZ` - TZ
     * * `TH` - TH
     * * `TL` - TL
     * * `TG` - TG
     * * `TK` - TK
     * * `TO` - TO
     * * `TT` - TT
     * * `TN` - TN
     * * `TR` - TR
     * * `TM` - TM
     * * `TC` - TC
     * * `TV` - TV
     * * `UG` - UG
     * * `UA` - UA
     * * `AE` - AE
     * * `GB` - GB
     * * `UM` - UM
     * * `US` - US
     * * `UY` - UY
     * * `UZ` - UZ
     * * `VU` - VU
     * * `VE` - VE
     * * `VN` - VN
     * * `VG` - VG
     * * `VI` - VI
     * * `WF` - WF
     * * `EH` - EH
     * * `YE` - YE
     * * `ZM` - ZM
     * * `ZW` - ZW
     */
    country: SectionSupplierCountryEnum;
    /** @format uuid */
    uuid: string;
}

/**
 * * `AF` - AF
 * * `AX` - AX
 * * `AL` - AL
 * * `DZ` - DZ
 * * `AS` - AS
 * * `AD` - AD
 * * `AO` - AO
 * * `AI` - AI
 * * `AQ` - AQ
 * * `AG` - AG
 * * `AR` - AR
 * * `AM` - AM
 * * `AW` - AW
 * * `AU` - AU
 * * `AT` - AT
 * * `AZ` - AZ
 * * `BS` - BS
 * * `BH` - BH
 * * `BD` - BD
 * * `BB` - BB
 * * `BY` - BY
 * * `BE` - BE
 * * `BZ` - BZ
 * * `BJ` - BJ
 * * `BM` - BM
 * * `BT` - BT
 * * `BO` - BO
 * * `BQ` - BQ
 * * `BA` - BA
 * * `BW` - BW
 * * `BV` - BV
 * * `BR` - BR
 * * `IO` - IO
 * * `BN` - BN
 * * `BG` - BG
 * * `BF` - BF
 * * `BI` - BI
 * * `CV` - CV
 * * `KH` - KH
 * * `CM` - CM
 * * `CA` - CA
 * * `KY` - KY
 * * `CF` - CF
 * * `TD` - TD
 * * `CL` - CL
 * * `CN` - CN
 * * `CX` - CX
 * * `CC` - CC
 * * `CO` - CO
 * * `KM` - KM
 * * `CG` - CG
 * * `CD` - CD
 * * `CK` - CK
 * * `CR` - CR
 * * `CI` - CI
 * * `HR` - HR
 * * `CU` - CU
 * * `CW` - CW
 * * `CY` - CY
 * * `CZ` - CZ
 * * `DK` - DK
 * * `DJ` - DJ
 * * `DM` - DM
 * * `DO` - DO
 * * `EC` - EC
 * * `EG` - EG
 * * `SV` - SV
 * * `GQ` - GQ
 * * `ER` - ER
 * * `EE` - EE
 * * `SZ` - SZ
 * * `ET` - ET
 * * `FK` - FK
 * * `FO` - FO
 * * `FJ` - FJ
 * * `FI` - FI
 * * `FR` - FR
 * * `GF` - GF
 * * `PF` - PF
 * * `TF` - TF
 * * `GA` - GA
 * * `GM` - GM
 * * `GE` - GE
 * * `DE` - DE
 * * `GH` - GH
 * * `GI` - GI
 * * `GR` - GR
 * * `GL` - GL
 * * `GD` - GD
 * * `GP` - GP
 * * `GU` - GU
 * * `GT` - GT
 * * `GG` - GG
 * * `GN` - GN
 * * `GW` - GW
 * * `GY` - GY
 * * `HT` - HT
 * * `HM` - HM
 * * `VA` - VA
 * * `HN` - HN
 * * `HK` - HK
 * * `HU` - HU
 * * `IS` - IS
 * * `IN` - IN
 * * `ID` - ID
 * * `IR` - IR
 * * `IQ` - IQ
 * * `IE` - IE
 * * `IM` - IM
 * * `IL` - IL
 * * `IT` - IT
 * * `JM` - JM
 * * `JP` - JP
 * * `JE` - JE
 * * `JO` - JO
 * * `KZ` - KZ
 * * `KE` - KE
 * * `KI` - KI
 * * `KW` - KW
 * * `KG` - KG
 * * `LA` - LA
 * * `LV` - LV
 * * `LB` - LB
 * * `LS` - LS
 * * `LR` - LR
 * * `LY` - LY
 * * `LI` - LI
 * * `LT` - LT
 * * `LU` - LU
 * * `MO` - MO
 * * `MG` - MG
 * * `MW` - MW
 * * `MY` - MY
 * * `MV` - MV
 * * `ML` - ML
 * * `MT` - MT
 * * `MH` - MH
 * * `MQ` - MQ
 * * `MR` - MR
 * * `MU` - MU
 * * `YT` - YT
 * * `MX` - MX
 * * `FM` - FM
 * * `MD` - MD
 * * `MC` - MC
 * * `MN` - MN
 * * `ME` - ME
 * * `MS` - MS
 * * `MA` - MA
 * * `MZ` - MZ
 * * `MM` - MM
 * * `NA` - NA
 * * `NR` - NR
 * * `NP` - NP
 * * `NL` - NL
 * * `NC` - NC
 * * `NZ` - NZ
 * * `NI` - NI
 * * `NE` - NE
 * * `NG` - NG
 * * `NU` - NU
 * * `NF` - NF
 * * `KP` - KP
 * * `MK` - MK
 * * `XI` - XI
 * * `MP` - MP
 * * `NO` - NO
 * * `OM` - OM
 * * `PK` - PK
 * * `PW` - PW
 * * `PS` - PS
 * * `PA` - PA
 * * `PG` - PG
 * * `PY` - PY
 * * `PE` - PE
 * * `PH` - PH
 * * `PN` - PN
 * * `PL` - PL
 * * `PT` - PT
 * * `PR` - PR
 * * `QA` - QA
 * * `RE` - RE
 * * `RO` - RO
 * * `RU` - RU
 * * `RW` - RW
 * * `BL` - BL
 * * `SH` - SH
 * * `KN` - KN
 * * `LC` - LC
 * * `MF` - MF
 * * `PM` - PM
 * * `VC` - VC
 * * `WS` - WS
 * * `SM` - SM
 * * `ST` - ST
 * * `SA` - SA
 * * `SN` - SN
 * * `RS` - RS
 * * `SC` - SC
 * * `SL` - SL
 * * `SG` - SG
 * * `SX` - SX
 * * `SK` - SK
 * * `SI` - SI
 * * `SB` - SB
 * * `SO` - SO
 * * `ZA` - ZA
 * * `GS` - GS
 * * `KR` - KR
 * * `SS` - SS
 * * `ES` - ES
 * * `LK` - LK
 * * `SD` - SD
 * * `SR` - SR
 * * `SJ` - SJ
 * * `SE` - SE
 * * `CH` - CH
 * * `SY` - SY
 * * `TW` - TW
 * * `TJ` - TJ
 * * `TZ` - TZ
 * * `TH` - TH
 * * `TL` - TL
 * * `TG` - TG
 * * `TK` - TK
 * * `TO` - TO
 * * `TT` - TT
 * * `TN` - TN
 * * `TR` - TR
 * * `TM` - TM
 * * `TC` - TC
 * * `TV` - TV
 * * `UG` - UG
 * * `UA` - UA
 * * `AE` - AE
 * * `GB` - GB
 * * `UM` - UM
 * * `US` - US
 * * `UY` - UY
 * * `UZ` - UZ
 * * `VU` - VU
 * * `VE` - VE
 * * `VN` - VN
 * * `VG` - VG
 * * `VI` - VI
 * * `WF` - WF
 * * `EH` - EH
 * * `YE` - YE
 * * `ZM` - ZM
 * * `ZW` - ZW
 */
export enum SectionSupplierCountryEnum {
    AF = "AF",
    AX = "AX",
    AL = "AL",
    DZ = "DZ",
    AS = "AS",
    AD = "AD",
    AO = "AO",
    AI = "AI",
    AQ = "AQ",
    AG = "AG",
    AR = "AR",
    AM = "AM",
    AW = "AW",
    AU = "AU",
    AT = "AT",
    AZ = "AZ",
    BS = "BS",
    BH = "BH",
    BD = "BD",
    BB = "BB",
    BY = "BY",
    BE = "BE",
    BZ = "BZ",
    BJ = "BJ",
    BM = "BM",
    BT = "BT",
    BO = "BO",
    BQ = "BQ",
    BA = "BA",
    BW = "BW",
    BV = "BV",
    BR = "BR",
    IO = "IO",
    BN = "BN",
    BG = "BG",
    BF = "BF",
    BI = "BI",
    CV = "CV",
    KH = "KH",
    CM = "CM",
    CA = "CA",
    KY = "KY",
    CF = "CF",
    TD = "TD",
    CL = "CL",
    CN = "CN",
    CX = "CX",
    CC = "CC",
    CO = "CO",
    KM = "KM",
    CG = "CG",
    CD = "CD",
    CK = "CK",
    CR = "CR",
    CI = "CI",
    HR = "HR",
    CU = "CU",
    CW = "CW",
    CY = "CY",
    CZ = "CZ",
    DK = "DK",
    DJ = "DJ",
    DM = "DM",
    DO = "DO",
    EC = "EC",
    EG = "EG",
    SV = "SV",
    GQ = "GQ",
    ER = "ER",
    EE = "EE",
    SZ = "SZ",
    ET = "ET",
    FK = "FK",
    FO = "FO",
    FJ = "FJ",
    FI = "FI",
    FR = "FR",
    GF = "GF",
    PF = "PF",
    TF = "TF",
    GA = "GA",
    GM = "GM",
    GE = "GE",
    DE = "DE",
    GH = "GH",
    GI = "GI",
    GR = "GR",
    GL = "GL",
    GD = "GD",
    GP = "GP",
    GU = "GU",
    GT = "GT",
    GG = "GG",
    GN = "GN",
    GW = "GW",
    GY = "GY",
    HT = "HT",
    HM = "HM",
    VA = "VA",
    HN = "HN",
    HK = "HK",
    HU = "HU",
    IS = "IS",
    IN = "IN",
    ID = "ID",
    IR = "IR",
    IQ = "IQ",
    IE = "IE",
    IM = "IM",
    IL = "IL",
    IT = "IT",
    JM = "JM",
    JP = "JP",
    JE = "JE",
    JO = "JO",
    KZ = "KZ",
    KE = "KE",
    KI = "KI",
    KW = "KW",
    KG = "KG",
    LA = "LA",
    LV = "LV",
    LB = "LB",
    LS = "LS",
    LR = "LR",
    LY = "LY",
    LI = "LI",
    LT = "LT",
    LU = "LU",
    MO = "MO",
    MG = "MG",
    MW = "MW",
    MY = "MY",
    MV = "MV",
    ML = "ML",
    MT = "MT",
    MH = "MH",
    MQ = "MQ",
    MR = "MR",
    MU = "MU",
    YT = "YT",
    MX = "MX",
    FM = "FM",
    MD = "MD",
    MC = "MC",
    MN = "MN",
    ME = "ME",
    MS = "MS",
    MA = "MA",
    MZ = "MZ",
    MM = "MM",
    NA = "NA",
    NR = "NR",
    NP = "NP",
    NL = "NL",
    NC = "NC",
    NZ = "NZ",
    NI = "NI",
    NE = "NE",
    NG = "NG",
    NU = "NU",
    NF = "NF",
    KP = "KP",
    MK = "MK",
    XI = "XI",
    MP = "MP",
    NO = "NO",
    OM = "OM",
    PK = "PK",
    PW = "PW",
    PS = "PS",
    PA = "PA",
    PG = "PG",
    PY = "PY",
    PE = "PE",
    PH = "PH",
    PN = "PN",
    PL = "PL",
    PT = "PT",
    PR = "PR",
    QA = "QA",
    RE = "RE",
    RO = "RO",
    RU = "RU",
    RW = "RW",
    BL = "BL",
    SH = "SH",
    KN = "KN",
    LC = "LC",
    MF = "MF",
    PM = "PM",
    VC = "VC",
    WS = "WS",
    SM = "SM",
    ST = "ST",
    SA = "SA",
    SN = "SN",
    RS = "RS",
    SC = "SC",
    SL = "SL",
    SG = "SG",
    SX = "SX",
    SK = "SK",
    SI = "SI",
    SB = "SB",
    SO = "SO",
    ZA = "ZA",
    GS = "GS",
    KR = "KR",
    SS = "SS",
    ES = "ES",
    LK = "LK",
    SD = "SD",
    SR = "SR",
    SJ = "SJ",
    SE = "SE",
    CH = "CH",
    SY = "SY",
    TW = "TW",
    TJ = "TJ",
    TZ = "TZ",
    TH = "TH",
    TL = "TL",
    TG = "TG",
    TK = "TK",
    TO = "TO",
    TT = "TT",
    TN = "TN",
    TR = "TR",
    TM = "TM",
    TC = "TC",
    TV = "TV",
    UG = "UG",
    UA = "UA",
    AE = "AE",
    GB = "GB",
    UM = "UM",
    US = "US",
    UY = "UY",
    UZ = "UZ",
    VU = "VU",
    VE = "VE",
    VN = "VN",
    VG = "VG",
    VI = "VI",
    WF = "WF",
    EH = "EH",
    YE = "YE",
    ZM = "ZM",
    ZW = "ZW",
}

/**
 * * `total` - total
 * * `unit` - unit
 */
export enum SelectedPriceOptionEnum {
    Total = "total",
    Unit = "unit",
}

export interface ServiceFeeInvoiceCreate {
    /** @format uuid */
    buyer_uuid: string;
    /**
     * First day of the month (e.g. 2026-02-01)
     * @format date
     */
    month: string;
}

/**
 * * `not_started` - Not Started
 * * `invoice_sent` - Invoice Sent
 * * `paid` - Paid
 */
export enum ServiceFeeStatusEnum {
    NotStarted = "not_started",
    InvoiceSent = "invoice_sent",
    Paid = "paid",
}

/**
 * * `order_management_only` - Order Management Only
 * * `order_management_with_payment_support` - Order Management with Payment Support
 */
export enum ServiceFeeTypeEnum {
    OrderManagementOnly = "order_management_only",
    OrderManagementWithPaymentSupport = "order_management_with_payment_support",
}

/**
 * * `ingredient_sourcing` - Ingredient Sourcing
 * * `sampling` - Sampling
 * * `other` - Other
 */
export enum ServiceTypeEnum {
    IngredientSourcing = "ingredient_sourcing",
    Sampling = "sampling",
    Other = "other",
}

export interface SetAdmin {
    /** @format uuid */
    user_uuid: string;
    is_admin: boolean;
}

/**
 * * `pending_dispatch` - pending_dispatch
 * * `dispatched` - Dispatched
 * * `delivered` - Delivered
 */
export enum ShipmentStatusEnum {
    PendingDispatch = "pending_dispatch",
    Dispatched = "dispatched",
    Delivered = "delivered",
}

/**
 * * `buyer` - Buyer
 * * `supplier` - Supplier
 * * `unknown` - Unknown
 * * `to_be_confirmed` - To Be Confirmed
 * * `merchant_of_record` - Merchant of Record
 */
export enum ShippingResponsibilityEnum {
    Buyer = "buyer",
    Supplier = "supplier",
    Unknown = "unknown",
    ToBeConfirmed = "to_be_confirmed",
    MerchantOfRecord = "merchant_of_record",
}

export interface ShortUser {
    /** @format uuid */
    uuid: string;
    /** @maxLength 150 */
    first_name?: string;
    last_name_short: string;
}

export interface SingleMessageResponse {
    /** @maxLength 255 */
    message: string;
}

export interface SpotBuyAttachment {
    category: string;
    fileName: string;
}

/**
 * Serializer for line items in spot buy request.
 *
 * `unit` and `price` are accepted as free-form strings (kg / cases / etc.
 * for unit; a single value or a range like "10-15" for price). Both are
 * declared optional here so reads of records created before these fields
 * became required for new submissions don't break — frontend enforces
 * required-ness for new submissions.
 */
export interface SpotBuyLineItem {
    /** @maxLength 255 */
    product_name: string;
    /** @maxLength 255 */
    volume: string;
    /**
     * @maxLength 50
     * @default ""
     */
    unit?: string;
    /** @maxLength 255 */
    price?: string | null;
}

/**
 * * `pending` - Pending
 * * `completed` - Completed
 * * `cancelled` - Cancelled
 */
export enum SpotBuyRequestStatusEnum {
    Pending = "pending",
    Completed = "completed",
    Cancelled = "cancelled",
}

/** Serializer for SKUs in spot buy request */
export interface SpotBuySku {
    /** @maxLength 255 */
    sku: string;
    /** @maxLength 255 */
    quantity: string;
}

export interface SsoTemporaryToken {
    token: string;
}

export interface StaffUser {
    id: number;
    /** @format uuid */
    uuid: string;
    /** @format email */
    email: string;
    first_name: string;
    last_name: string;
    /**
     * Staff status
     * Designates whether the user can log into this admin site.
     */
    is_staff: boolean;
}

/** Statement detail with nested orders and bank details. */
export interface StatementDetail {
    /** @format uuid */
    uuid: string;
    statement_id: string;
    buyer_company_name: string;
    /** @format uuid */
    buyer_company_uuid: string;
    /**
     * * `due` - Due
     * * `overdue` - Overdue
     * * `awaiting_reconciliation` - Awaiting Reconciliation
     * * `paid` - Paid
     * * `cancelled` - Cancelled
     */
    status?: GroupedStatementStatusEnum;
    /** @format date */
    statement_month: string;
    /**
     * Subtotal in cents (before tax)
     * @format int64
     * @min 0
     * @max 9223372036854776000
     */
    subtotal: number;
    /**
     * Tax amount in cents
     * @format int64
     * @min 0
     * @max 9223372036854776000
     */
    tax: number;
    /**
     * Total in cents (subtotal + tax)
     * @format int64
     * @min 0
     * @max 9223372036854776000
     */
    total: number;
    /**
     * * `EUR` - EUR
     * * `GBP` - GBP
     * * `USD` - USD
     */
    currency: AvailableCurrenciesEnum;
    /** @format date-time */
    paid_at?: string | null;
    /**
     * Date by which payment is expected
     * @format date
     */
    due_date: string;
    /** @format date-time */
    created_at: string;
    order_count: number;
    record_type: string;
    /**
     * External payment or invoice reference from the payment provider
     * @maxLength 255
     */
    external_payment_id?: string | null;
    orders: StatementOrder[];
    bank_details: BankDetail[];
}

/** Statement list representation for service fee invoices. */
export interface StatementList {
    /** @format uuid */
    uuid: string;
    statement_id: string;
    buyer_company_name: string;
    /** @format uuid */
    buyer_company_uuid: string;
    /**
     * * `due` - Due
     * * `overdue` - Overdue
     * * `awaiting_reconciliation` - Awaiting Reconciliation
     * * `paid` - Paid
     * * `cancelled` - Cancelled
     */
    status?: GroupedStatementStatusEnum;
    /** @format date */
    statement_month: string;
    /**
     * Subtotal in cents (before tax)
     * @format int64
     * @min 0
     * @max 9223372036854776000
     */
    subtotal: number;
    /**
     * Tax amount in cents
     * @format int64
     * @min 0
     * @max 9223372036854776000
     */
    tax: number;
    /**
     * Total in cents (subtotal + tax)
     * @format int64
     * @min 0
     * @max 9223372036854776000
     */
    total: number;
    /**
     * * `EUR` - EUR
     * * `GBP` - GBP
     * * `USD` - USD
     */
    currency: AvailableCurrenciesEnum;
    /** @format date-time */
    paid_at?: string | null;
    /**
     * Date by which payment is expected
     * @format date
     */
    due_date: string;
    /** @format date-time */
    created_at: string;
    order_count: number;
    record_type: string;
}

/** Nested order representation within a statement detail. */
export interface StatementOrder {
    /** @format uuid */
    uuid: string;
    order_number: string;
    buyer_company_name: string;
    supplier_company_name: string;
    /**
     * * `EUR` - EUR
     * * `GBP` - GBP
     * * `USD` - USD
     */
    buyer_currency?: AvailableCurrenciesEnum;
    /** @format date */
    dispatched_at?: string | null;
    /**
     * @format decimal
     * @pattern ^-?\d{0,1}(?:\.\d{0,4})?$
     */
    service_fee_percentage?: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,1}(?:\.\d{0,4})?$
     */
    service_fee_tax_rate?: string;
    /**
     * * `not_started` - Not Started
     * * `invoice_sent` - Invoice Sent
     * * `paid` - Paid
     */
    service_fee_status?: ServiceFeeStatusEnum;
    service_fee_subtotal: number;
    service_fee_tax: number;
    service_fee_total: number;
}

/**
 * Serializer for supplier information.
 *
 * Only includes fields that are actively used in the public buyer onboarding form.
 * Other model fields are kept for backward compatibility but not exposed in the API.
 */
export interface Supplier {
    id: number;
    /**
     * Supplier name
     * @maxLength 255
     */
    supplier_name: string;
    /**
     * Average monthly spend with this supplier
     * @format decimal
     * @pattern ^-?\d{0,10}(?:\.\d{0,2})?$
     */
    average_monthly_spend?: string | null;
    /**
     * Invoice/Payment currency (e.g., USD, GBP, EUR)
     * @maxLength 3
     */
    invoice_currency?: string;
    /** Supplier payment terms */
    payment_terms?: string;
    /**
     * Priority to onboard this supplier
     *
     * * `high` - High
     * * `medium` - Medium
     * * `low` - Low
     */
    priority?: PriorityEnum | BlankEnum;
    /**
     * Supplier country
     * @maxLength 100
     */
    supplier_country?: string;
    /** Does the supplier arrange delivery? */
    arranges_delivery?: boolean;
    /**
     * Agreed lead time
     * @maxLength 255
     */
    lead_time?: string;
    /** Is this an organic supplier? */
    is_organic?: boolean;
    /** Any noteworthy information about your trading relationship */
    relationship_notes?: string;
    /**
     * Supplier spreadsheet
     * @format uri
     */
    supplier_spreadsheet?: string | null;
    supplier_spreadsheet_url: string;
    /** @format date-time */
    created_at: string;
    /** @format date-time */
    modified_at: string;
}

/** Serializer for adding a buyer to a supplier by creating a referral relationship. */
export interface SupplierAddBuyer {
    /**
     * UUID of the buyer (brand) company to associate with this supplier
     * @format uuid
     */
    buyer_uuid: string;
}

export interface SupplierAppOrderDetails {
    /** @format uuid */
    uuid: string;
    /** @format date-time */
    created_at: string;
    /** @format date-time */
    modified_at: string;
    ordered_by: number;
    /**
     * * `initializing` - Initializing
     * * `confirmed` - Confirmed
     * * `canceled` - Cancelled
     * * `pending_merchant_of_record_approval` - Pending Merchant of Record Approval
     * * `order_received` - Order Received
     * * `order_sent_to_supplier` - Order Sent To Supplier
     * * `order_confirming_price` - Order Confirming Price
     * * `forecasted` - Forecasted
     */
    lifecycle_state?: LifecycleStateEnum;
    /**
     * * `initializing` - Initializing
     * * `not_started` - Not Started
     * * `due` - Due
     * * `overdue` - Overdue
     * * `paid` - Paid
     * * `refunded` - Refunded
     * * `partially_refunded` - Partially Refunded
     */
    payout_state?: PayoutStateEnum;
    /**
     * * `initializing` - Initializing
     * * `not_started` - Not Started
     * * `pending_dispatch` - Pending Dispatch
     * * `in_transit` - In Transit
     * * `delivered` - Delivered
     * * `freight_ownership_pending` - Freight Ownership Pending
     * * `gathering_quotes` - Gathering Quotes
     * * `dispatch_scheduled` - Dispatch Scheduled
     * * `awaiting_collection_details` - Awaiting Collection Details
     * * `ready_for_pickup` - Ready for Pickup
     * * `picked_up` - Picked Up
     * * `preparing_freight` - Preparing Freight
     * * `freight_scheduled` - Freight Scheduled
     * * `gathering_freight_quotes` - Gathering Freight Quotes
     * * `quotes_confirmed` - Quotes Confirmed
     */
    delivery_state?: DeliveryStateEnum;
    /**
     * * `pay_before_dispatch` - Pay Before Dispatch
     * * `pay_after_dispatch` - Pay After Dispatch
     * * `pay_on_28th_second_month_after_dispatch` - Pay on 28th second month after dispatch
     * * `pay_end_of_month_of_dispatch_date` - Pay End of Month of Dispatch Date
     */
    payment_terms?: AppOrderPaymentTermsEnum;
    order_number: string;
    company_ordered_from: CompanyNameAndId;
    supplier_currency: string;
    shipping_price_in_supplier_currency: number;
    /** @format double */
    supplier_shipping_tax_rate: number;
    export_fee_price_in_supplier_currency: number | null;
    line_items: SupplierOrderLineItem[];
    /** @format date */
    dispatched_at: string | null;
    /** @format date */
    estimated_delivery_date: string | null;
    tracking_code: string | null;
    shipping_provider: string | null;
    delivery_address: DeliveryAddressResponse | null;
    payment_due_date: string;
    supplier_total_shipping_price_in_supplier_currency: number;
    supplier_total_shipping_tax_amount_in_supplier_currency: number;
    /** @format uuid */
    channel_uuid: string;
    /**
     * @min 0
     * @max 2147483647
     */
    supplier_payment_period?: number;
    supplier_payout_due_date: string;
    supplier_payout_due_date_calculated: string;
    /** @format date */
    supplier_payout_due_date_override?: string | null;
    /**
     * * `payout_before_dispatch` - Payout Before Dispatch
     * * `payout_after_dispatch` - Payout After Dispatch
     */
    supplier_payout_terms?: SupplierPayoutTermsEnum;
    /** @format date */
    delivery_date: string;
    legacy_order_uuid: string;
    legacy_order_payment_status: string;
    is_on_hold: boolean;
    total_payout_refunded_amount: number;
}

export interface SupplierAppOrderList {
    /** @format uuid */
    uuid: string;
    /** @format date-time */
    created_at: string;
    /** @format date-time */
    modified_at: string;
    ordered_by: number;
    /**
     * * `initializing` - Initializing
     * * `not_started` - Not Started
     * * `pending_dispatch` - Pending Dispatch
     * * `in_transit` - In Transit
     * * `delivered` - Delivered
     * * `freight_ownership_pending` - Freight Ownership Pending
     * * `gathering_quotes` - Gathering Quotes
     * * `dispatch_scheduled` - Dispatch Scheduled
     * * `awaiting_collection_details` - Awaiting Collection Details
     * * `ready_for_pickup` - Ready for Pickup
     * * `picked_up` - Picked Up
     * * `preparing_freight` - Preparing Freight
     * * `freight_scheduled` - Freight Scheduled
     * * `gathering_freight_quotes` - Gathering Freight Quotes
     * * `quotes_confirmed` - Quotes Confirmed
     */
    delivery_state?: DeliveryStateEnum;
    /**
     * * `initializing` - Initializing
     * * `not_started` - Not Started
     * * `due` - Due
     * * `overdue` - Overdue
     * * `paid` - Paid
     * * `refunded` - Refunded
     * * `partially_refunded` - Partially Refunded
     */
    payout_state?: PayoutStateEnum;
    /**
     * * `pay_before_dispatch` - Pay Before Dispatch
     * * `pay_after_dispatch` - Pay After Dispatch
     * * `pay_on_28th_second_month_after_dispatch` - Pay on 28th second month after dispatch
     * * `pay_end_of_month_of_dispatch_date` - Pay End of Month of Dispatch Date
     */
    payment_terms?: AppOrderPaymentTermsEnum;
    order_number: string;
    company_ordered_from: CompanyNameAndId;
    supplier_currency: string;
    shipping_price_in_supplier_currency: number;
    export_fee_price_in_supplier_currency: number | null;
    line_items: SupplierOrderLineItem[];
    total_order_price_for_supplier: number;
    legacy_delivery_status: LegacyDeliveryStatusEnum;
    legacy_total_order_price: number;
    legacy_ingredients: {
        product_name: string;
    }[];
    legacy_order_uuid: string;
    legacy_payout_status: LegacyPayoutStatusEnum;
    is_on_hold: boolean;
}

/**
 * Serializer for buyer information associated with a supplier through referrals.
 * Includes payment terms if a BuyerSupplierPaymentTerms record exists for this pair.
 */
export interface SupplierBuyer {
    /** @format uuid */
    uuid: string;
    name: string;
    company_type: CompanyTypeEnum;
    /** @format date-time */
    created: string;
    payment_terms: string;
    days_until_payment_due: string;
}

export interface SupplierCompany {
    id: number;
    /** @format uuid */
    uuid: string;
    /** @format uri */
    website: string;
    /** @maxLength 255 */
    name: string;
    /** @format uri */
    logo?: string | null;
    /** @maxLength 100 */
    industry?: string | null;
    kyb_status: string;
    /** @maxLength 50 */
    phone_number?: string | null;
    country: string;
    state: string;
    /**
     * * `brand` - Brand
     * * `supplier` - Supplier
     * * `merchant_of_record` - Merchant of Record
     */
    company_type?: CompanyTypeEnum;
    /** @default ["e","h","o","r","t"] */
    product_type?: ProductTypeEnum[];
    /** @default ["e","h","o","r","t"] */
    activity_type?: ActivityTypeEnum[];
    /** @maxLength 255 */
    registration_number?: string | null;
    /** @maxLength 255 */
    registration_name?: string | null;
    mongo_id: string | null;
    referral_code: string;
    phone_country_code?: PhoneCountryCodeEnum | BlankEnum | NullEnum | null;
    company_addresses?: CompanyAddress[];
    currency: string;
    /**
     * rapyd payout method
     * @maxLength 45
     */
    payout_method_type?: string | null;
    bank_account_country?: Country | BlankEnum | NullEnum | null;
    /**
     * DUNS number for creditworthiness checks and payouts
     * @maxLength 50
     */
    duns?: string | null;
}

export interface SupplierContact {
    /** @format uuid */
    uuid: string;
    /** @maxLength 150 */
    first_name: string;
    /** @maxLength 150 */
    last_name?: string;
    /**
     * @format email
     * @maxLength 254
     */
    email: string;
    /** @maxLength 50 */
    phone_number?: string;
    /**
     * * `orders` - Orders
     * * `logistics` - Logistics and Supply Chain
     * * `finance` - Finance
     * * `other` - Other
     */
    category: SupplierContactCategoryEnum;
    /** @format date-time */
    created: string;
    /** @format date-time */
    modified: string;
    notes?: string;
}

/**
 * * `orders` - Orders
 * * `logistics` - Logistics and Supply Chain
 * * `finance` - Finance
 * * `other` - Other
 */
export enum SupplierContactCategoryEnum {
    Orders = "orders",
    Logistics = "logistics",
    Finance = "finance",
    Other = "other",
}

export interface SupplierCreate {
    company_name: string;
    /** @format uri */
    website: string;
    first_name: string;
    last_name: string;
    /** @format email */
    email: string;
    /** @maxLength 10 */
    referred_by?: string;
    phone_country_code?: PhoneCountryCodeEnum | BlankEnum | NullEnum | null;
    registration_number?: string | null;
    phone_number?: string | null;
    company_address: CompanyAddress;
    /** @default true */
    send_welcome_email?: boolean;
    /** @default false */
    send_contract_ready_email?: boolean;
    company_type: ActivityTypeEnum[];
}

export interface SupplierDashboardCount {
    /** @min 0 */
    active_contracts: number;
    /** @min 0 */
    orders_to_date: number;
    /**
     * @format decimal
     * @pattern ^-?\d{0,13}(?:\.\d{0,2})?$
     */
    orders_to_date_value: string;
    /** @min 0 */
    active_quotes: number;
    currency: string;
}

export interface SupplierDocument {
    /** @format uuid */
    uuid: string;
    company: number;
    /** @format uuid */
    supplier_uuid: string;
    supplier_name: string;
    type: DocumentType;
    /** @format uuid */
    type_uuid?: string;
    /** @format uuid */
    renewing_uuid?: string | null;
    site: SupplierSite;
    /** @format uuid */
    site_uuid?: string | null;
    /** Address/site name - auto-creates SupplierSite if not exists (SC-2293) */
    site_name?: string;
    /**
     * Buyer company UUID (optional)
     * @format uuid
     */
    buyer_uuid?: string | null;
    /** Return the buyer company name if assigned. */
    buyer_name: string | null;
    /** @format uri */
    url: string;
    /** @format date */
    start_date?: string | null;
    /** @format date */
    end_date?: string | null;
    /** @maxLength 2048 */
    notes?: string | null;
    status: DocumentLifecycleStatusEnum;
    /** Return whether the document is archived. */
    is_archived: boolean;
    /** @format uuid */
    superseded_by_uuid: string | null;
}

export interface SupplierInquiryList {
    id: number;
    /** @format uuid */
    uuid: string;
    /**
     * * `awaiting_quotes` - Awaiting Quotes
     * * `quotes_available` - Quotes Available
     * * `ordered` - Ordered
     * * `expired` - Expired
     * * `proceeded` - Proceeded
     * * `contract_confirmed` - Contract Confirmed
     * * `supplier_decline_to_quote` - Supplier Decline To Quote
     * * `cancelled` - Cancelled
     */
    state?: InquiryState;
    /** @maxLength 255 */
    name: string;
    /**
     * * `EUR` - EUR
     * * `USD` - USD
     * * `GBP` - GBP
     * * `CAD` - CAD
     */
    currency?: Currencies;
    /**
     * @format decimal
     * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
     */
    quantity: string;
    /**
     * * `fl oz` - Fluid Ounces
     * * `g` - Grams
     * * `mg` - milligrams
     * * `gals` - Gallons
     * * `kg` - Kilograms
     * * `L` - Liters
     * * `tons` - Metric Tons
     * * `oz` - Ounces
     * * `lbs` - Pounds
     * * `pcs` - Pieces
     * * `pt` - Pints
     * * `ml` - Milliliter
     * * `boxes` - Boxes
     * * `pallets` - Pallets
     * * `tsp` - Teaspoons
     * * `tbsp` - Tablespoons
     * * `units` - Units
     * * `cases` - Cases
     * * `trays` - Trays
     */
    unit_of_measurement?: UnitOfMeasurementEnum;
    /** @format date */
    due_date: string;
    delivery_address: DeliveryAddressForSupplier;
    /**
     * Datetime when the inquiry becomes published. Leave empty to keep it unpublished.
     * @format date-time
     */
    published?: string | null;
    /**
     * @format uri
     * @maxLength 2048
     */
    logo_url?: string;
    is_new: boolean;
    supplier_state: SupplierStateEnum;
    declined: string;
    /** @format date */
    first_order_delivery_date?: string | null;
    /** @default false */
    is_recurring?: boolean;
    is_delivery_date_flexible?: boolean;
    total_forecast_quantity: string;
    /**
     * * `non_recurring` - Non Recurring
     * * `recurring` - Recurring
     * * `purchase_request` - Purchase Request
     * * `ingredient` - Ingredient
     * * `ingredient_copy` - Ingredient Copy
     */
    category?: InquiryCategory;
    /** @format uuid */
    original_quote_uuid: string;
}

export interface SupplierInquiryResponse {
    id: number;
    /** @format uuid */
    uuid: string;
    /**
     * * `awaiting_quotes` - Awaiting Quotes
     * * `quotes_available` - Quotes Available
     * * `ordered` - Ordered
     * * `expired` - Expired
     * * `proceeded` - Proceeded
     * * `contract_confirmed` - Contract Confirmed
     * * `supplier_decline_to_quote` - Supplier Decline To Quote
     * * `cancelled` - Cancelled
     */
    state?: InquiryState;
    /**
     * * `non_recurring` - Non Recurring
     * * `recurring` - Recurring
     * * `purchase_request` - Purchase Request
     * * `ingredient` - Ingredient
     * * `ingredient_copy` - Ingredient Copy
     */
    category?: InquiryCategory;
    /** @maxLength 255 */
    name: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
     */
    current_unit_price: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
     */
    target_unit_price: string;
    /**
     * * `EUR` - EUR
     * * `USD` - USD
     * * `GBP` - GBP
     * * `CAD` - CAD
     */
    currency?: Currencies;
    description: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
     */
    quantity: string;
    /**
     * * `fl oz` - Fluid Ounces
     * * `g` - Grams
     * * `mg` - milligrams
     * * `gals` - Gallons
     * * `kg` - Kilograms
     * * `L` - Liters
     * * `tons` - Metric Tons
     * * `oz` - Ounces
     * * `lbs` - Pounds
     * * `pcs` - Pieces
     * * `pt` - Pints
     * * `ml` - Milliliter
     * * `boxes` - Boxes
     * * `pallets` - Pallets
     * * `tsp` - Teaspoons
     * * `tbsp` - Tablespoons
     * * `units` - Units
     * * `cases` - Cases
     * * `trays` - Trays
     */
    unit_of_measurement?: UnitOfMeasurementEnum;
    allergen_requirements?: (AllergenRequirementsEnum | BlankEnum)[];
    allergen_declaration?: boolean;
    dietary_certificate?: boolean;
    diet_requirements?: (DietRequirementsEnum | BlankEnum)[];
    forecast?: ForecastEnum | BlankEnum | NullEnum | null;
    /** @format date */
    due_date: string;
    delivery_address: DeliveryAddressForSupplier;
    /** @maxItems 250 */
    supplier_countries: (Country | BlankEnum)[];
    current_supplier?: string;
    /**
     * Datetime when the inquiry becomes published. Leave empty to keep it unpublished.
     * @format date-time
     */
    published?: string | null;
    /**
     * @format uri
     * @maxLength 2048
     */
    logo_url?: string;
    is_new: boolean;
    /** @format uuid */
    article?: string | null;
    existing_suppliers: string[] | null;
    supply_priorities?: SupplyPriorities[];
    /** @format date */
    first_order_delivery_date?: string | null;
    /**
     * @format decimal
     * @pattern ^-?\d{0,7}(?:\.\d{0,2})?$
     */
    opply_brand_commission?: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,7}(?:\.\d{0,2})?$
     */
    opply_supplier_commission?: string;
    /** @default false */
    is_recurring?: boolean;
    frequency?: FrequencyEnum | BlankEnum | NullEnum | null;
    /** @min 0 */
    desired_contract_length?: number | null;
    is_delivery_date_flexible?: boolean;
    /** @format uuid */
    parent_uuid?: string | null;
    ingredient?: number | null;
    reason_for_request?: string | null;
    desired_packaging_format?: string;
    desired_packaging_format_is_flexible?: boolean;
    ai_generated?: boolean;
    documents_to_copy?: string[] | null;
    orders_uuid: string[];
    /** @format uuid */
    existing_supplier_uuid: string;
    total_forecast_quantity: string;
    /** @format uuid */
    original_quote_uuid: string;
    declined: string;
    decline_reason: string;
    company_address: Address;
    progress: string;
    possible_suppliers: string;
    suppliers_found: string;
    number_of_quotes: string;
    company: Company;
    existing_supplier_name: string;
    supplier_matching: string;
    total_forecast_spend: string;
    /** @default "" */
    published_quote_uuid?: string;
    supplier_state: SupplierStateEnum;
    buyer_contact_name: string;
    buyer_full_name: string;
    commission_payout_vat_rate: string;
}

export interface SupplierItemCreate {
    /** @maxLength 255 */
    item_name: string;
    /** @maxLength 255 */
    sku?: string | null;
    item_description?: string | null;
    /**
     * @format uri
     * @maxLength 2048
     */
    logo_url?: string;
    /** @format uuid */
    supplier_company_uuid: string;
    /** @format uuid */
    category_uuid?: string | null;
    /**
     * What kind of material this row represents (ingredient, packaging, ...).
     *
     * * `ingredient` - Ingredient
     * * `packaging` - Packaging
     */
    kind?: CatalogItemKindEnum;
    /**
     * Natural unit the material is measured in.
     *
     * * `fl oz` - Fluid Ounces
     * * `g` - Grams
     * * `mg` - milligrams
     * * `gals` - Gallons
     * * `kg` - Kilograms
     * * `L` - Liters
     * * `tons` - Metric Tons
     * * `oz` - Ounces
     * * `lbs` - Pounds
     * * `pcs` - Pieces
     * * `pt` - Pints
     * * `ml` - Milliliter
     * * `boxes` - Boxes
     * * `pallets` - Pallets
     * * `tsp` - Teaspoons
     * * `tbsp` - Tablespoons
     * * `units` - Units
     * * `cases` - Cases
     * * `trays` - Trays
     */
    unit_of_measurement?: UnitOfMeasurementEnum;
    contained_allergens?: ContainedAllergensEnum[];
    /** A signed allergen declaration is available on file for this material. */
    has_allergen_declaration?: boolean;
    diet_compliance?: DietComplianceEnum[];
    /** A dietary certificate is available on file for this material. */
    has_dietary_certificate?: boolean;
}

export interface SupplierItemDetail {
    /** @format uuid */
    uuid: string;
    /** @maxLength 255 */
    item_name: string;
    /** @maxLength 255 */
    sku?: string | null;
    item_description?: string | null;
    /**
     * @format uri
     * @maxLength 2048
     */
    logo_url?: string;
    /** @format uuid */
    supplier_company_uuid: string;
    supplier_company_name: string;
    /** @format uuid */
    category_uuid?: string | null;
    /**
     * What kind of material this row represents (ingredient, packaging, ...).
     *
     * * `ingredient` - Ingredient
     * * `packaging` - Packaging
     */
    kind?: CatalogItemKindEnum;
    /**
     * Natural unit the material is measured in.
     *
     * * `fl oz` - Fluid Ounces
     * * `g` - Grams
     * * `mg` - milligrams
     * * `gals` - Gallons
     * * `kg` - Kilograms
     * * `L` - Liters
     * * `tons` - Metric Tons
     * * `oz` - Ounces
     * * `lbs` - Pounds
     * * `pcs` - Pieces
     * * `pt` - Pints
     * * `ml` - Milliliter
     * * `boxes` - Boxes
     * * `pallets` - Pallets
     * * `tsp` - Teaspoons
     * * `tbsp` - Tablespoons
     * * `units` - Units
     * * `cases` - Cases
     * * `trays` - Trays
     */
    unit_of_measurement?: UnitOfMeasurementEnum;
    contained_allergens?: ContainedAllergensEnum[];
    /** A signed allergen declaration is available on file for this material. */
    has_allergen_declaration?: boolean;
    diet_compliance?: DietComplianceEnum[];
    /** A dietary certificate is available on file for this material. */
    has_dietary_certificate?: boolean;
    is_active?: boolean;
    documents: SupplierItemDocument[];
    /** @format date-time */
    created_at: string;
    /** @format date-time */
    modified_at: string;
}

export interface SupplierItemDocument {
    /** @format uuid */
    uuid: string;
    /** @format uri */
    document: string;
    file_name: string;
    category: CatalogItemDocumentCategoryEnum;
    /**
     * Start date of document validity
     * @format date
     */
    start_date: string | null;
    /**
     * End/expiry date of document validity
     * @format date
     */
    end_date: string | null;
    is_active: boolean;
    status: string;
    is_archived: boolean;
    /** @format date-time */
    created_at: string;
}

export interface SupplierItemDocumentUpload {
    file_name: string;
    /**
     * * `spec_sheet` - Spec Sheet
     * * `certificate_of_analysis` - Certificate of Analysis
     * * `british_retail_consortium` - British Retail Consortium
     * * `international_organisation_for_standardisation` - International Organisation for Standardisation
     * * `foundation_food_safety_system_certification` - Foundation Food Safety System Certification
     * * `international_featured_standards` - International Featured Standards
     * * `safe_quality_food` - Safe Quality Food
     */
    category: CatalogItemDocumentCategoryEnum;
    /** @format date */
    start_date?: string | null;
    /** @format date */
    end_date?: string | null;
}

export interface SupplierItemList {
    /** @format uuid */
    uuid: string;
    item_name: string;
    sku: string | null;
    item_description: string | null;
    /** @format uri */
    logo_url: string;
    /** @format uuid */
    supplier_company_uuid: string;
    supplier_company_name: string;
    /** @format uuid */
    merchant_of_record_company_uuid: string;
    /** @format uuid */
    category_uuid: string | null;
    /**
     * What kind of material this row represents (ingredient, packaging, ...).
     *
     * * `ingredient` - Ingredient
     * * `packaging` - Packaging
     */
    kind: CatalogItemKindEnum;
    /**
     * Natural unit the material is measured in.
     *
     * * `fl oz` - Fluid Ounces
     * * `g` - Grams
     * * `mg` - milligrams
     * * `gals` - Gallons
     * * `kg` - Kilograms
     * * `L` - Liters
     * * `tons` - Metric Tons
     * * `oz` - Ounces
     * * `lbs` - Pounds
     * * `pcs` - Pieces
     * * `pt` - Pints
     * * `ml` - Milliliter
     * * `boxes` - Boxes
     * * `pallets` - Pallets
     * * `tsp` - Teaspoons
     * * `tbsp` - Tablespoons
     * * `units` - Units
     * * `cases` - Cases
     * * `trays` - Trays
     */
    unit_of_measurement: UnitOfMeasurementEnum;
    /**
     * Allergens present in this material.
     *
     * * `celery` - Celery
     * * `cereals_containing_gluten` - Cereals Containing Gluten
     * * `crustaceans` - Crustaceans
     * * `eggs` - Eggs
     * * `fish` - Fish
     * * `lupin` - Lupin
     * * `milk` - Milk
     * * `molluscs` - Molluscs
     * * `mustard` - Mustard
     * * `nuts` - Nuts
     * * `peanuts` - Peanuts
     * * `sesame_seeds` - Sesame Seeds
     * * `soya` - Soya
     * * `sulphur_dioxide` - Sulphur Dioxide
     */
    contained_allergens: ContainedAllergensEnum | NullEnum | null;
    /** A signed allergen declaration is available on file for this material. */
    has_allergen_declaration: boolean;
    /**
     * Dietary regimes this material complies with.
     *
     * * `kosher` - Kosher
     * * `halal` - Halal
     * * `organic` - Organic
     * * `vegan` - Vegan
     * * `vegetarian` - Vegetarian
     */
    diet_compliance: DietComplianceEnum | NullEnum | null;
    /** A dietary certificate is available on file for this material. */
    has_dietary_certificate: boolean;
    is_active: boolean;
    document_count: number;
    /** @format date-time */
    created_at: string;
}

export interface SupplierOnboarding {
    /** @maxLength 255 */
    first_name: string;
    /** @maxLength 255 */
    last_name: string;
    /**
     * @format email
     * @maxLength 255
     */
    email: string;
    /** @maxLength 255 */
    password: string;
    /** @maxLength 255 */
    company_name: string;
    /** @maxLength 100 */
    state?: string;
    /** @format uri */
    website: string;
    company_address: CompanyAddress;
    referred_by?: string;
    phone_country_code?: PhoneCountryCodeEnum | BlankEnum | NullEnum | null;
    registration_number?: string | null;
    phone_number?: string | null;
    /** @maxLength 50 */
    duns?: string | null;
    /** @default ["e","h","o","r","t"] */
    activity_type?: ActivityTypeEnum[];
}

export interface SupplierOrderLineItem {
    /** @format uuid */
    uuid: string;
    /** @format date-time */
    created_at: string;
    /** @format date-time */
    modified_at: string;
    /** @maxLength 255 */
    product_name: string;
    /**
     * @format uri
     * @maxLength 2048
     */
    logo_url?: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,10}(?:\.\d{0,2})?$
     */
    quantity: string;
    /**
     * * `fl oz` - Fluid Ounces
     * * `g` - Grams
     * * `mg` - milligrams
     * * `gals` - Gallons
     * * `kg` - Kilograms
     * * `L` - Liters
     * * `tons` - Metric Tons
     * * `oz` - Ounces
     * * `lbs` - Pounds
     * * `pcs` - Pieces
     * * `pt` - Pints
     * * `ml` - Milliliter
     * * `boxes` - Boxes
     * * `pallets` - Pallets
     * * `tsp` - Teaspoons
     * * `tbsp` - Tablespoons
     * * `units` - Units
     * * `cases` - Cases
     * * `trays` - Trays
     */
    unit_of_measurement?: UnitOfMeasurementEnum;
    /**
     * @format decimal
     * @pattern ^-?\d{0,1}(?:\.\d{0,4})?$
     */
    buyer_tax_rate?: string | null;
    /**
     * @format int64
     * @min 0
     * @max 9223372036854776000
     */
    delivery_surcharge_price_in_supplier_currency?: number | null;
    /** @format float */
    supplier_tax_rate: number;
    supplier_unit_price_in_supplier_currency: number;
    supplier_total_price_in_supplier_currency: number;
    supplier_total_tax_amount_in_supplier_currency: number;
    /** @maxLength 255 */
    sku?: string | null;
    /** @maxLength 255 */
    packaging_info?: string | null;
    product_description?: string | null;
}

export interface SupplierPayoutDetails {
    /** @format uuid */
    uuid: string;
    /**
     * * `US` - Us
     * * `GB` - Gb
     * * `CA` - Ca
     * * `AT` - At
     * * `BE` - Be
     * * `CY` - Cy
     * * `DE` - De
     * * `EE` - Ee
     * * `ES` - Es
     * * `FI` - Fi
     * * `FR` - Fr
     * * `GR` - Gr
     * * `IE` - Ie
     * * `IT` - It
     * * `LT` - Lt
     * * `LU` - Lu
     * * `LV` - Lv
     * * `MT` - Mt
     * * `NL` - Nl
     * * `PT` - Pt
     * * `SI` - Si
     * * `SK` - Sk
     * * `BG` - Bg
     * * `CZ` - Cz
     * * `DK` - Dk
     * * `HR` - Hr
     * * `HU` - Hu
     * * `PL` - Pl
     * * `RO` - Ro
     * * `SE` - Se
     * * `EU` - Eu
     */
    bank_country: BankingCountryTypeEnum;
    /** @maxLength 255 */
    bank_name: string;
    /** @maxLength 255 */
    account_holder_name: string;
    /** @maxLength 64 */
    account_number: string;
    /** @maxLength 16 */
    sort_code?: string;
    /** @maxLength 32 */
    routing_number?: string;
    account_type?: AccountTypeEnum | BlankEnum;
    /** @maxLength 64 */
    iban?: string;
    /** @maxLength 32 */
    bic?: string;
    /** @maxLength 100 */
    account_holder_building?: string;
    /** @maxLength 255 */
    account_holder_street_1: string;
    /** @maxLength 255 */
    account_holder_street_2?: string;
    /** @maxLength 100 */
    account_holder_town: string;
    /** @maxLength 100 */
    account_holder_region?: string;
    /** @maxLength 100 */
    account_holder_postcode: string;
    /**
     * * `AF` - Afghanistan
     * * `AX` - Åland Islands
     * * `AL` - Albania
     * * `DZ` - Algeria
     * * `AS` - American Samoa
     * * `AD` - Andorra
     * * `AO` - Angola
     * * `AI` - Anguilla
     * * `AQ` - Antarctica
     * * `AG` - Antigua and Barbuda
     * * `AR` - Argentina
     * * `AM` - Armenia
     * * `AW` - Aruba
     * * `AU` - Australia
     * * `AT` - Austria
     * * `AZ` - Azerbaijan
     * * `BS` - Bahamas
     * * `BH` - Bahrain
     * * `BD` - Bangladesh
     * * `BB` - Barbados
     * * `BY` - Belarus
     * * `BE` - Belgium
     * * `BZ` - Belize
     * * `BJ` - Benin
     * * `BM` - Bermuda
     * * `BT` - Bhutan
     * * `BO` - Bolivia
     * * `BQ` - Bonaire, Sint Eustatius and Saba
     * * `BA` - Bosnia and Herzegovina
     * * `BW` - Botswana
     * * `BV` - Bouvet Island
     * * `BR` - Brazil
     * * `IO` - British Indian Ocean Territory
     * * `BN` - Brunei
     * * `BG` - Bulgaria
     * * `BF` - Burkina Faso
     * * `BI` - Burundi
     * * `CV` - Cabo Verde
     * * `KH` - Cambodia
     * * `CM` - Cameroon
     * * `CA` - Canada
     * * `KY` - Cayman Islands
     * * `CF` - Central African Republic
     * * `TD` - Chad
     * * `CL` - Chile
     * * `CN` - China
     * * `CX` - Christmas Island
     * * `CC` - Cocos (Keeling) Islands
     * * `CO` - Colombia
     * * `KM` - Comoros
     * * `CG` - Congo
     * * `CD` - Congo (the Democratic Republic of the)
     * * `CK` - Cook Islands
     * * `CR` - Costa Rica
     * * `CI` - Côte d'Ivoire
     * * `HR` - Croatia
     * * `CU` - Cuba
     * * `CW` - Curaçao
     * * `CY` - Cyprus
     * * `CZ` - Czechia
     * * `DK` - Denmark
     * * `DJ` - Djibouti
     * * `DM` - Dominica
     * * `DO` - Dominican Republic
     * * `EC` - Ecuador
     * * `EG` - Egypt
     * * `SV` - El Salvador
     * * `GQ` - Equatorial Guinea
     * * `ER` - Eritrea
     * * `EE` - Estonia
     * * `SZ` - Eswatini
     * * `ET` - Ethiopia
     * * `FK` - Falkland Islands (Malvinas)
     * * `FO` - Faroe Islands
     * * `FJ` - Fiji
     * * `FI` - Finland
     * * `FR` - France
     * * `GF` - French Guiana
     * * `PF` - French Polynesia
     * * `TF` - French Southern Territories
     * * `GA` - Gabon
     * * `GM` - Gambia
     * * `GE` - Georgia
     * * `DE` - Germany
     * * `GH` - Ghana
     * * `GI` - Gibraltar
     * * `GR` - Greece
     * * `GL` - Greenland
     * * `GD` - Grenada
     * * `GP` - Guadeloupe
     * * `GU` - Guam
     * * `GT` - Guatemala
     * * `GG` - Guernsey
     * * `GN` - Guinea
     * * `GW` - Guinea-Bissau
     * * `GY` - Guyana
     * * `HT` - Haiti
     * * `HM` - Heard Island and McDonald Islands
     * * `VA` - Holy See
     * * `HN` - Honduras
     * * `HK` - Hong Kong
     * * `HU` - Hungary
     * * `IS` - Iceland
     * * `IN` - India
     * * `ID` - Indonesia
     * * `IR` - Iran
     * * `IQ` - Iraq
     * * `IE` - Ireland
     * * `IM` - Isle of Man
     * * `IL` - Israel
     * * `IT` - Italy
     * * `JM` - Jamaica
     * * `JP` - Japan
     * * `JE` - Jersey
     * * `JO` - Jordan
     * * `KZ` - Kazakhstan
     * * `KE` - Kenya
     * * `KI` - Kiribati
     * * `KW` - Kuwait
     * * `KG` - Kyrgyzstan
     * * `LA` - Laos
     * * `LV` - Latvia
     * * `LB` - Lebanon
     * * `LS` - Lesotho
     * * `LR` - Liberia
     * * `LY` - Libya
     * * `LI` - Liechtenstein
     * * `LT` - Lithuania
     * * `LU` - Luxembourg
     * * `MO` - Macao
     * * `MG` - Madagascar
     * * `MW` - Malawi
     * * `MY` - Malaysia
     * * `MV` - Maldives
     * * `ML` - Mali
     * * `MT` - Malta
     * * `MH` - Marshall Islands
     * * `MQ` - Martinique
     * * `MR` - Mauritania
     * * `MU` - Mauritius
     * * `YT` - Mayotte
     * * `MX` - Mexico
     * * `FM` - Micronesia
     * * `MD` - Moldova
     * * `MC` - Monaco
     * * `MN` - Mongolia
     * * `ME` - Montenegro
     * * `MS` - Montserrat
     * * `MA` - Morocco
     * * `MZ` - Mozambique
     * * `MM` - Myanmar
     * * `NA` - Namibia
     * * `NR` - Nauru
     * * `NP` - Nepal
     * * `NL` - Netherlands
     * * `NC` - New Caledonia
     * * `NZ` - New Zealand
     * * `NI` - Nicaragua
     * * `NE` - Niger
     * * `NG` - Nigeria
     * * `NU` - Niue
     * * `NF` - Norfolk Island
     * * `KP` - North Korea
     * * `MK` - North Macedonia
     * * `XI` - Northern Ireland
     * * `MP` - Northern Mariana Islands
     * * `NO` - Norway
     * * `OM` - Oman
     * * `PK` - Pakistan
     * * `PW` - Palau
     * * `PS` - Palestine, State of
     * * `PA` - Panama
     * * `PG` - Papua New Guinea
     * * `PY` - Paraguay
     * * `PE` - Peru
     * * `PH` - Philippines
     * * `PN` - Pitcairn
     * * `PL` - Poland
     * * `PT` - Portugal
     * * `PR` - Puerto Rico
     * * `QA` - Qatar
     * * `RE` - Réunion
     * * `RO` - Romania
     * * `RU` - Russia
     * * `RW` - Rwanda
     * * `BL` - Saint Barthélemy
     * * `SH` - Saint Helena, Ascension and Tristan da Cunha
     * * `KN` - Saint Kitts and Nevis
     * * `LC` - Saint Lucia
     * * `MF` - Saint Martin (French part)
     * * `PM` - Saint Pierre and Miquelon
     * * `VC` - Saint Vincent and the Grenadines
     * * `WS` - Samoa
     * * `SM` - San Marino
     * * `ST` - Sao Tome and Principe
     * * `SA` - Saudi Arabia
     * * `SN` - Senegal
     * * `RS` - Serbia
     * * `SC` - Seychelles
     * * `SL` - Sierra Leone
     * * `SG` - Singapore
     * * `SX` - Sint Maarten (Dutch part)
     * * `SK` - Slovakia
     * * `SI` - Slovenia
     * * `SB` - Solomon Islands
     * * `SO` - Somalia
     * * `ZA` - South Africa
     * * `GS` - South Georgia and the South Sandwich Islands
     * * `KR` - South Korea
     * * `SS` - South Sudan
     * * `ES` - Spain
     * * `LK` - Sri Lanka
     * * `SD` - Sudan
     * * `SR` - Suriname
     * * `SJ` - Svalbard and Jan Mayen
     * * `SE` - Sweden
     * * `CH` - Switzerland
     * * `SY` - Syria
     * * `TW` - Taiwan
     * * `TJ` - Tajikistan
     * * `TZ` - Tanzania
     * * `TH` - Thailand
     * * `TL` - Timor-Leste
     * * `TG` - Togo
     * * `TK` - Tokelau
     * * `TO` - Tonga
     * * `TT` - Trinidad and Tobago
     * * `TN` - Tunisia
     * * `TR` - Türkiye
     * * `TM` - Turkmenistan
     * * `TC` - Turks and Caicos Islands
     * * `TV` - Tuvalu
     * * `UG` - Uganda
     * * `UA` - Ukraine
     * * `AE` - United Arab Emirates
     * * `GB` - United Kingdom
     * * `UM` - United States Minor Outlying Islands
     * * `US` - United States of America
     * * `UY` - Uruguay
     * * `UZ` - Uzbekistan
     * * `VU` - Vanuatu
     * * `VE` - Venezuela
     * * `VN` - Vietnam
     * * `VG` - Virgin Islands (British)
     * * `VI` - Virgin Islands (U.S.)
     * * `WF` - Wallis and Futuna
     * * `EH` - Western Sahara
     * * `YE` - Yemen
     * * `ZM` - Zambia
     * * `ZW` - Zimbabwe
     */
    account_holder_country: Country;
    /** @format date-time */
    created: string;
    /** @format date-time */
    modified: string;
    note?: string;
}

/**
 * * `payout_before_dispatch` - Payout Before Dispatch
 * * `payout_after_dispatch` - Payout After Dispatch
 */
export enum SupplierPayoutTermsEnum {
    PayoutBeforeDispatch = "payout_before_dispatch",
    PayoutAfterDispatch = "payout_after_dispatch",
}

export interface SupplierQuestionnaire {
    /** @default ["e","h","o","r","t"] */
    product_category?: ProductCategoryEnum[];
    annual_turnover?: AnnualTurnoverEnum | BlankEnum | NullEnum | null;
    num_of_employees?: NumOfEmployeesEnum | BlankEnum | NullEnum | null;
    num_of_skus?: NumOfSkusEnum | BlankEnum | NullEnum | null;
    mov?: MovEnum | BlankEnum | NullEnum | null;
}

export interface SupplierQuoteUpdate {
    company: Company;
    /** @maxLength 255 */
    product_name: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,10}(?:\.\d{0,2})?$
     */
    quantity: string;
    /** @format date */
    delivery_date: string;
    /**
     * * `in_advance` - In Advance
     * * `on_dispatch` - On Dispatch
     */
    payment_scenario?: PaymentScenarioEnum;
    /**
     * @min 0
     * @max 365
     */
    payment_delay?: number;
    /**
     * @min 0
     * @default 0
     */
    shelf_life?: number | null;
    /**
     * @min 0
     * @max 2147483647
     */
    quote_valid_for?: number | null;
    /**
     * The maximum time a supplier agrees to deliver the product within (days)
     * @min 0
     * @max 2147483647
     */
    lead_time: number;
    product_description?: string | null;
    /**
     * @format decimal
     * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
     */
    shipping_cost?: string | null;
    /**
     * * `EUR` - EUR
     * * `USD` - USD
     * * `GBP` - GBP
     * * `CAD` - CAD
     */
    currency: Currencies;
    /**
     * Datetime when the quote becomes published. Leave empty to keep it unpublished.
     * @format date-time
     */
    published?: string | null;
    /**
     * * `fl oz` - Fluid Ounces
     * * `g` - Grams
     * * `mg` - milligrams
     * * `gals` - Gallons
     * * `kg` - Kilograms
     * * `L` - Liters
     * * `tons` - Metric Tons
     * * `oz` - Ounces
     * * `lbs` - Pounds
     * * `pcs` - Pieces
     * * `pt` - Pints
     * * `ml` - Milliliter
     * * `boxes` - Boxes
     * * `pallets` - Pallets
     * * `tsp` - Teaspoons
     * * `tbsp` - Tablespoons
     * * `units` - Units
     * * `cases` - Cases
     * * `trays` - Trays
     */
    unit_of_measurement?: UnitOfMeasurementEnum;
    /** @format date-time */
    created_date: string;
    /**
     * @format uri
     * @maxLength 2048
     */
    logo_url?: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,9}(?:\.\d{0,10})?$
     */
    total_price: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,9}(?:\.\d{0,10})?$
     */
    unit_price?: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,1}(?:\.\d{0,4})?$
     */
    vat_rate: string | null;
    is_reverse_charge?: boolean;
    /**
     * @format decimal
     * @pattern ^-?\d{0,7}(?:\.\d{0,2})?$
     */
    commission_payout_vat_rate?: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,7}(?:\.\d{0,2})?$
     */
    commission_payin_vat_rate?: string;
    commission_is_reverse_charge?: boolean;
    /** @maxLength 32 */
    sku?: string | null;
    /** @default "delivery_duty_paid" */
    incoterms?: IncotermsEnum | NullEnum | null;
    dispatch_address?: number | null;
    /**
     * * `available` - Available
     * * `requested` - Requested
     * * `sent` - Sent
     * * `received` - Received
     * * `accepted` - Accepted
     * * `rejected` - Rejected
     * * `declined` - Declined
     */
    samples_status?: SamplesStatusEnum;
    samples_delivery_address?: number | null;
    /**
     * @min 0
     * @max 2147483647
     */
    recurring_order_lead_time?: number | null;
    /**
     * Duration of the contract in months.
     * @min -2147483648
     * @max 2147483647
     */
    contract_length?: number | null;
    /**
     * @format decimal
     * @pattern ^-?\d{0,17}(?:\.\d{0,2})?$
     */
    case_size?: string | null;
    /**
     * @format decimal
     * @pattern ^-?\d{0,17}(?:\.\d{0,2})?$
     */
    minimum_order_quantity?: string | null;
    agreement_required?: boolean;
    account_form_required?: boolean;
    /**
     * * `non_recurring` - Non Recurring
     * * `recurring` - Recurring
     * * `purchase_request_quote` - Purchase Request Quote
     */
    category?: QuoteCategory;
    /** @format date */
    samples_declined_date?: string | null;
    samples_feedback?: SamplesFeedbackEnum[] | null;
    samples_feedback_comment?: string;
    /**
     * * `in_advance` - In Advance
     * * `on_dispatch` - On Dispatch
     * * `7_days_after_dispatch` - Days After Dispatch 7
     * * `14_days_after_dispatch` - Days After Dispatch 14
     * * `30_days_after_dispatch` - Days After Dispatch 30
     * * `60_days_after_dispatch` - Days After Dispatch 60
     */
    payment_terms?: PaymentTermsEnum;
    is_custom_contract?: boolean;
    /** @format date */
    samples_dispatch_date?: string | null;
    /** @format date */
    samples_sent_date?: string | null;
    samples_tracking_code?: string | null;
    /** @format date */
    samples_expected_delivery_date?: string | null;
    /** @maxLength 255 */
    samples_shipping_provider?: string | null;
    autoconfirm_orders?: boolean;
    /**
     * @min 0
     * @max 2147483647
     */
    minimum_lead_time?: number | null;
    /**
     * @min 0
     * @max 2147483647
     */
    order_in_multiples_of?: number | null;
    /**
     * @min 0
     * @max 2147483647
     */
    minimum_autoconfirm_order_quantity?: number | null;
    /**
     * @min 0
     * @max 2147483647
     */
    maximum_autoconfirm_order_quantity?: number | null;
    packaging_format?: string;
    show_to_other_buyers?: boolean;
    description_blocks?: QuoteDescriptionBlockCreate[] | null;
    /**
     * @format decimal
     * @pattern ^-?\d{0,1}(?:\.\d{0,4})?$
     */
    shipping_vat_rate?: string | null;
    /**
     * @format decimal
     * @pattern ^-?\d{0,10}(?:\.\d{0,2})?$
     */
    total_forecast_quantity?: string | null;
    /**
     * * `total` - total
     * * `unit` - unit
     */
    selected_price_option?: SelectedPriceOptionEnum;
    update_requested?: boolean;
}

/** Serializer for removing a buyer from a supplier. */
export interface SupplierRemoveBuyer {
    /**
     * UUID of the buyer to remove from this supplier
     * @format uuid
     */
    buyer_uuid: string;
}

/**
 * Serializer for buyer supplier requests.
 * Accepts the same fields as the buyer onboarding SupplierSerializer.
 * Creates an OnboardingSupplier and stores request data for Zendesk ticket.
 */
export interface SupplierRequest {
    /**
     * Supplier name
     * @maxLength 255
     */
    supplier_name?: string;
    /**
     * Average monthly spend
     * @format decimal
     * @pattern ^-?\d{0,10}(?:\.\d{0,2})?$
     */
    average_monthly_spend?: string | null;
    /**
     * Invoice/Payment currency (e.g., USD, GBP, EUR)
     *
     * * `EUR` - EUR
     * * `GBP` - GBP
     * * `USD` - USD
     */
    invoice_currency?: AvailableCurrenciesEnum | BlankEnum;
    /** Supplier payment terms */
    payment_terms?: string;
    /**
     * Priority to onboard this supplier
     *
     * * `high` - High
     * * `medium` - Medium
     * * `low` - Low
     */
    priority?: PriorityEnum | BlankEnum;
    /**
     * Supplier country
     * @maxLength 100
     */
    supplier_country?: string;
    /**
     * Does the supplier arrange delivery?
     * @default false
     */
    arranges_delivery?: boolean;
    /**
     * Agreed lead time
     * @maxLength 255
     */
    lead_time?: string;
    /**
     * Is this an organic supplier?
     * @default false
     */
    is_organic?: boolean;
    /** Any noteworthy information about your trading relationship */
    relationship_notes?: string;
    /**
     * DUNS number for US suppliers
     * @maxLength 50
     */
    duns?: string | null;
    /**
     * Supplier spreadsheet file
     * @format uri
     */
    supplier_spreadsheet?: string | null;
}

/**
 * * `pending_review` - Pending review
 * * `matched` - Matched to existing supplier
 * * `onboarding` - Onboarding new supplier
 */
export enum SupplierReviewStatusEnum {
    PendingReview = "pending_review",
    Matched = "matched",
    Onboarding = "onboarding",
}

export interface SupplierSite {
    /** @format uuid */
    uuid: string;
    /** @maxLength 255 */
    name: string;
    company: number;
}

/**
 * * `awaiting_quote` - awaiting_quote
 * * `quote_provided` - quote_provided
 * * `ordered` - ordered
 * * `expired` - expired
 * * `declined` - declined
 */
export enum SupplierStateEnum {
    AwaitingQuote = "awaiting_quote",
    QuoteProvided = "quote_provided",
    Ordered = "ordered",
    Expired = "expired",
    Declined = "declined",
}

/**
 * * `producer` - Producer
 * * `manufacturer` - Manufacturer
 * * `broker` - Broker
 * * `other` - Other
 * * `not_applicable` - N/A
 */
export enum SupplierTypeEnum {
    Producer = "producer",
    Manufacturer = "manufacturer",
    Broker = "broker",
    Other = "other",
    NotApplicable = "not_applicable",
}

export interface SupplyPriorities {
    priority_name?: PriorityNameEnum | BlankEnum | NullEnum | null;
    /**
     * Level of priority for the user. 1-higher, 3-lower
     * @min 1
     * @max 3
     */
    priority_value?: number | null;
}

/**
 * * `EUR` - EUR
 * * `GBP` - GBP
 * * `USD` - USD
 * * `CAD` - CAD
 */
export enum SupportedCurrencies {
    EUR = "EUR",
    GBP = "GBP",
    USD = "USD",
    CAD = "CAD",
}

export interface Target {
    type: string;
    /** @format uuid */
    uuid: string;
    name: string;
}

export interface TargetDeleteAdmin {
    company_uuids: string[];
}

/**
 * * `order_received` - Order Received
 * * `order_sent_to_supplier` - Order Sent To Supplier
 * * `order_confirming_price` - Order Confirming Price
 */
export enum TargetStatusEnum {
    OrderReceived = "order_received",
    OrderSentToSupplier = "order_sent_to_supplier",
    OrderConfirmingPrice = "order_confirming_price",
}

export interface Task {
    /** @format uuid */
    uuid: string;
    /** @maxLength 512 */
    title: string;
    description?: string;
    /** @format date */
    due_date?: string | null;
    /**
     * * `open` - Open
     * * `in_progress` - In Progress
     * * `done` - Done
     */
    status?: TaskStatusEnum;
    /** @format date-time */
    completed_at: string | null;
    /**
     * * `low` - Low
     * * `medium` - Medium
     * * `high` - High
     * * `urgent` - Urgent
     */
    priority?: TaskPriorityEnum;
    is_private?: boolean;
    assignee: UserMinimal;
    /** @format uuid */
    assignee_uuid?: string | null;
    created_by: UserMinimal;
    watchers: UserMinimal[];
    watcher_uuids?: string[];
    target: Target;
    target_type?: string | null;
    /** @format uuid */
    target_uuid?: string | null;
    parent_task: Record<string, any>;
    /** @format uuid */
    parent_task_uuid?: string | null;
    subtasks: Record<string, any>[];
    /** List of task attachments */
    attachments: Record<string, any>[];
    /** @format date-time */
    created: string;
    /** @format date-time */
    modified: string;
}

export interface TaskAttachment {
    /** @format uuid */
    uuid: string;
    /** @maxLength 512 */
    filename: string;
    /** @maxLength 1024 */
    gcs_key?: string;
    /**
     * General attachment, or an agent-authored plan rendered specially in the UI.
     *
     * * `general` - General
     * * `plan` - Plan
     */
    kind?: TaskAttachmentKindEnum;
    /** Inline content for small text-shaped attachments (notably ``kind=plan`` agent plans). The FE renders this directly without round-tripping through GCS. Binary / large attachments leave this blank and rely on ``gcs_key`` for the download URL. */
    body?: string;
    uploaded_by: UserMinimal;
    /** @format date-time */
    created_at: string;
    download_url: string | null;
    file_ref: TaskAttachmentFileRef | null;
}

/**
 * Stable handle the agent feeds to ``get_file`` MCP tool.
 *
 * Same uuid as ``TaskAttachment.uuid``; the dedicated nested type just
 * keeps the generated FE schema strongly-typed (otherwise drf-spectacular
 * falls back to ``additionalProperties: {}`` on the parent serializer).
 */
export interface TaskAttachmentFileRef {
    /** @format uuid */
    uuid: string;
}

/**
 * * `general` - General
 * * `plan` - Plan
 */
export enum TaskAttachmentKindEnum {
    General = "general",
    Plan = "plan",
}

export interface TaskCreated {
    /** @format uuid */
    task_id: string;
}

/**
 * * `low` - Low
 * * `medium` - Medium
 * * `high` - High
 * * `urgent` - Urgent
 */
export enum TaskPriorityEnum {
    Low = "low",
    Medium = "medium",
    High = "high",
    Urgent = "urgent",
}

export interface TaskResult {
    /**
     * Celery ID for the Task that was run
     * @maxLength 255
     */
    task_id: string;
    /**
     * Task State
     * Current state of the task being run
     *
     * * `FAILURE` - FAILURE
     * * `PENDING` - PENDING
     * * `RECEIVED` - RECEIVED
     * * `RETRY` - RETRY
     * * `REVOKED` - REVOKED
     * * `STARTED` - STARTED
     * * `SUCCESS` - SUCCESS
     */
    status?: TaskResultStatusEnum;
    result: Record<string, any>;
}

/**
 * * `FAILURE` - FAILURE
 * * `PENDING` - PENDING
 * * `RECEIVED` - RECEIVED
 * * `RETRY` - RETRY
 * * `REVOKED` - REVOKED
 * * `STARTED` - STARTED
 * * `SUCCESS` - SUCCESS
 */
export enum TaskResultStatusEnum {
    FAILURE = "FAILURE",
    PENDING = "PENDING",
    RECEIVED = "RECEIVED",
    RETRY = "RETRY",
    REVOKED = "REVOKED",
    STARTED = "STARTED",
    SUCCESS = "SUCCESS",
}

/**
 * * `to_do` - To Do
 * * `done` - Done
 */
export enum TaskStateEnum {
    ToDo = "to_do",
    Done = "done",
}

/**
 * * `open` - Open
 * * `in_progress` - In Progress
 * * `done` - Done
 */
export enum TaskStatusEnum {
    Open = "open",
    InProgress = "in_progress",
    Done = "done",
}

/**
 * * `Kriya KYB Reminder` - Kriya Kyb Reminder
 * * `New Quote` - New Quote
 * * `New Quote Reminder` - New Quote Reminder
 * * `New Request` - New Request
 * * `New Request Reminder` - New Request Reminder
 * * `New Samples Request` - New Samples Request
 * * `Samples Request Reminder` - Samples Request Reminder
 * * `Samples Dispatched` - Samples Dispatched
 * * `Samples Received Reminder` - Samples Received Reminder
 * * `Samples Approved` - Samples Approved
 * * `Samples Not Approved` - Samples Not Approved
 * * `Buyer Started Negotiation` - Buyer Started Negotiation
 * * `Supplier Negotiation Response` - Supplier Negotiation Response
 * * `Quote updated` - Quote Updated
 * * `New Order` - New Order
 * * `Order Dispatched` - Order Dispatched
 * * `Payment Due` - Payment Due
 * * `Quote Proceeded` - Quote Proceeded
 * * `Create Contract Reminder` - Create Contract Reminder
 * * `Proceed with Contract` - Proceed With Contract
 * * `Reminder: Proceed with Contract` - Reminder Proceed With Contract
 * * `Confirm Contract` - Confirm Contract
 * * `Contract Created` - Contract Created
 * * `New Purchase Request` - New Purchase Request
 * * `New Purchase Request Reminder` - New Purchase Request Reminder
 * * `Response to Purchase Request` - Response To Purchase Request
 * * `Purchase Request Cancelled` - Purchase Request Cancelled
 * * `Quote Expiring` - Quote Expiring
 * * `Request Expiring` - Request Expiring
 * * `New Message` - New Message
 * * `New User` - New User
 * * `Contract Renewal Declined` - Contract Renewal Declined
 * * `Supplier Accepts Contract Renewal` - Contract Renewal Accepted
 * * `Sign New Contract Purchase Agreement` - Contract Renewal Accepted With Agreement
 * * `Contract Renewal Requested` - Contract Renewal Requested
 * * `Contract Renewal Terms accepted` - Contract Renewal Terms Accepted
 * * `Supplier Negotiates Contract Renewal` - Supplier Negotiates Contract Renewal
 * * `Re-order` - Reorder
 * * `Request for Re-order Declined` - Reorder Declined
 * * `Supplier change payment terms` - Supplier Updated Payment Terms
 */
export enum TitleEnum {
    KriyaKYBReminder = "Kriya KYB Reminder",
    NewQuote = "New Quote",
    NewQuoteReminder = "New Quote Reminder",
    NewRequest = "New Request",
    NewRequestReminder = "New Request Reminder",
    NewSamplesRequest = "New Samples Request",
    SamplesRequestReminder = "Samples Request Reminder",
    SamplesDispatched = "Samples Dispatched",
    SamplesReceivedReminder = "Samples Received Reminder",
    SamplesApproved = "Samples Approved",
    SamplesNotApproved = "Samples Not Approved",
    BuyerStartedNegotiation = "Buyer Started Negotiation",
    SupplierNegotiationResponse = "Supplier Negotiation Response",
    QuoteUpdated = "Quote updated",
    NewOrder = "New Order",
    OrderDispatched = "Order Dispatched",
    PaymentDue = "Payment Due",
    QuoteProceeded = "Quote Proceeded",
    CreateContractReminder = "Create Contract Reminder",
    ProceedWithContract = "Proceed with Contract",
    ReminderProceedWithContract = "Reminder: Proceed with Contract",
    ConfirmContract = "Confirm Contract",
    ContractCreated = "Contract Created",
    NewPurchaseRequest = "New Purchase Request",
    NewPurchaseRequestReminder = "New Purchase Request Reminder",
    ResponseToPurchaseRequest = "Response to Purchase Request",
    PurchaseRequestCancelled = "Purchase Request Cancelled",
    QuoteExpiring = "Quote Expiring",
    RequestExpiring = "Request Expiring",
    NewMessage = "New Message",
    NewUser = "New User",
    ContractRenewalDeclined = "Contract Renewal Declined",
    SupplierAcceptsContractRenewal = "Supplier Accepts Contract Renewal",
    SignNewContractPurchaseAgreement = "Sign New Contract Purchase Agreement",
    ContractRenewalRequested = "Contract Renewal Requested",
    ContractRenewalTermsAccepted = "Contract Renewal Terms accepted",
    SupplierNegotiatesContractRenewal = "Supplier Negotiates Contract Renewal",
    ReOrder = "Re-order",
    RequestForReOrderDeclined = "Request for Re-order Declined",
    SupplierChangePaymentTerms = "Supplier change payment terms",
}

export interface Token {
    access_token: string;
}

export interface TradedItemCreate {
    item_name: string;
    /** @maxLength 255 */
    sku?: string | null;
    item_description?: string | null;
    /** @format uuid */
    supplier_company_uuid: string;
    /** @format uuid */
    buyer_company_uuid?: string | null;
    /** @format uuid */
    category_uuid?: string | null;
}

export interface TradedItemDetail {
    /** @format uuid */
    uuid: string;
    item_name: string;
    /** @maxLength 255 */
    sku?: string | null;
    item_description?: string | null;
    /** @format uuid */
    supplier_company_uuid: string;
    supplier_company_name: string;
    /** @format uuid */
    buyer_company_uuid?: string | null;
    buyer_company_name: string | null;
    /** @format uuid */
    category_uuid?: string | null;
    is_active?: boolean;
    documents: TradedItemDocument[];
    /** @format date-time */
    created_at: string;
    /** @format date-time */
    modified_at: string;
}

export interface TradedItemDocument {
    /** @format uuid */
    uuid: string;
    /** @format uri */
    document: string;
    file_name: string;
    category: CatalogItemDocumentCategoryEnum;
    /**
     * Start date of document validity
     * @format date
     */
    start_date: string | null;
    /**
     * End/expiry date of document validity
     * @format date
     */
    end_date: string | null;
    is_active: boolean;
    status: CatalogDocumentStatusEnum;
    is_archived: boolean;
    /** @format date-time */
    created_at: string;
}

export interface TradedItemDocumentUpload {
    file_name: string;
    /**
     * * `spec_sheet` - Spec Sheet
     * * `certificate_of_analysis` - Certificate of Analysis
     * * `british_retail_consortium` - British Retail Consortium
     * * `international_organisation_for_standardisation` - International Organisation for Standardisation
     * * `foundation_food_safety_system_certification` - Foundation Food Safety System Certification
     * * `international_featured_standards` - International Featured Standards
     * * `safe_quality_food` - Safe Quality Food
     */
    category: CatalogItemDocumentCategoryEnum;
    /** @format date */
    start_date?: string | null;
    /** @format date */
    end_date?: string | null;
}

export interface TradedItemList {
    /** @format uuid */
    uuid: string;
    item_name: string;
    sku: string | null;
    item_description: string | null;
    /** @format uuid */
    supplier_company_uuid: string;
    supplier_company_name: string;
    /** @format uuid */
    buyer_company_uuid: string | null;
    buyer_company_name: string | null;
    /** @format uuid */
    category_uuid: string | null;
    is_active: boolean;
    document_count: number;
    /** @format date-time */
    created_at: string;
}

/** Serializer for Trends model - isolated feature */
export interface Trends {
    /** @format uuid */
    uuid: string;
    /**
     * Creator agent type
     *
     * * `payment_agent` - Payment Agent
     * * `debt_agent` - Debt Agent
     * * `onboarding_agent` - Onboarding Agent
     * * `demand_forecaster` - Demand Forecaster
     * * `supplier_optimizer` - Supplier Optimizer
     */
    creator: CreatorEnum;
    /** Messages/Description */
    content: string;
    /**
     * Alert type classification
     *
     * * `critical` - Critical
     * * `baseline` - Baseline
     * * `stress_scenario` - Stress Scenario
     * * `optimistic_scenario` - Optimistic Scenario
     */
    type: TrendsAlertTypeEnum;
    /**
     * Title text
     * @maxLength 255
     */
    title: string;
    /** @format date-time */
    created_at: string;
    /** @format date-time */
    modified_at: string;
}

/**
 * * `critical` - Critical
 * * `baseline` - Baseline
 * * `stress_scenario` - Stress Scenario
 * * `optimistic_scenario` - Optimistic Scenario
 */
export enum TrendsAlertTypeEnum {
    Critical = "critical",
    Baseline = "baseline",
    StressScenario = "stress_scenario",
    OptimisticScenario = "optimistic_scenario",
}

export interface TwoBuyerConfig {
    /** @maxLength 255 */
    representative_first_name?: string;
    /** @maxLength 255 */
    representative_last_name?: string;
    /**
     * @format email
     * @maxLength 254
     */
    representative_email?: string;
    /** @maxLength 50 */
    representative_phone_number?: string;
    /** List of email addresses to receive Two invoices */
    invoice_emails?: any;
}

export interface TwoBuyerConfigUpdate {
    /** @maxLength 255 */
    representative_first_name?: string;
    /** @maxLength 255 */
    representative_last_name?: string;
    /** @format email */
    representative_email?: string;
    /** @maxLength 50 */
    representative_phone_number?: string;
    invoice_emails?: string[];
}

/** Credit limit data for Two organic (non-recourse) credit. */
export interface TwoOrganicCreditLimit {
    /**
     * Credit limit availability status
     *
     * * `available` - Available
     * * `not_connected` - Not Connected
     * * `not_configured` - Not Configured
     * * `api_error` - API Error
     */
    status: CreditLimitStatusEnum;
    /** Two's total approved organic credit line (cents) */
    total_limit: number | null;
    /** Current outstanding organic exposure reported by Two (cents) */
    exposure: number | null;
    /** Two's organic available limit before our allocations (cents) */
    available_limit: number | null;
    /** Available limit minus allocated organic credit (cents) */
    effective_available: number | null;
    /** Maximum amount per single order (cents) */
    per_order_limit: number | null;
    /** Two's credit decision (e.g. APPROVED, DECLINED) */
    decision: string | null;
    /** Reason for decline, if applicable */
    decline_reason: string | null;
}

/** Two organic limit with per-order limit. */
export interface TwoOrganicLimitCheck {
    /** Available credit after allocations (cents) */
    effective_available: number;
    /** Whether the limit covers the requested amount (null if no amount) */
    is_sufficient: boolean | null;
    /**
     * Reason the limit is insufficient
     *
     * * `exceeds_effective_available` - Exceeds Effective Available
     * * `exceeds_per_order_limit` - Exceeds Per Order Limit
     */
    insufficient_reason: InsufficientCreditReasonEnum | NullEnum | null;
    /** Maximum amount per single order (cents) */
    per_order_limit: number;
}

/** Credit limit data for Two recourse credit. */
export interface TwoRecourseCreditLimit {
    /**
     * Credit limit availability status
     *
     * * `available` - Available
     * * `not_connected` - Not Connected
     * * `not_configured` - Not Configured
     * * `api_error` - API Error
     */
    status: CreditLimitStatusEnum;
    /** Merchant-defined recourse limit for this buyer (cents) */
    total_limit: number | null;
    /** Current recourse exposure reported by Two (cents) */
    exposure: number | null;
    /** Two's recourse available limit (cents) */
    available_limit: number | null;
    /** Available recourse limit minus allocated recourse credit (cents) */
    effective_available: number | null;
}

/** Response serializer for Two registration check. */
export interface TwoRegistrationCheckResponse {
    /** True if the company is registered on Two */
    is_registered: boolean;
    /** Company name as registered on Two */
    buyer_company_name?: string | null;
    /** Credit decision from Two (e.g., 'APPROVED', 'DECLINED') */
    decision?: string | null;
    /** List of reasons if credit was declined */
    decline_reason?: string[] | null;
    /** Credit information if registered and approved */
    credit_info?: MerchantOfRecordTwoCreditInformation | null;
}

export interface URL {
    /** @format uri */
    url: string;
}

/**
 * * `fl oz` - Fluid Ounces
 * * `g` - Grams
 * * `mg` - milligrams
 * * `gals` - Gallons
 * * `kg` - Kilograms
 * * `L` - Liters
 * * `tons` - Metric Tons
 * * `oz` - Ounces
 * * `lbs` - Pounds
 * * `pcs` - Pieces
 * * `pt` - Pints
 * * `ml` - Milliliter
 * * `boxes` - Boxes
 * * `pallets` - Pallets
 * * `tsp` - Teaspoons
 * * `tbsp` - Tablespoons
 * * `units` - Units
 * * `cases` - Cases
 * * `trays` - Trays
 */
export enum UnitOfMeasurementEnum {
    FlOz = "fl oz",
    G = "g",
    Mg = "mg",
    Gals = "gals",
    Kg = "kg",
    L = "L",
    Tons = "tons",
    Oz = "oz",
    Lbs = "lbs",
    Pcs = "pcs",
    Pt = "pt",
    Ml = "ml",
    Boxes = "boxes",
    Pallets = "pallets",
    Tsp = "tsp",
    Tbsp = "tbsp",
    Units = "units",
    Cases = "cases",
    Trays = "trays",
}

/** Serializer for unmarking an order as forecasted, with optional credit risk owner. */
export interface UnmarkForecasted {
    /**
     * Credit risk owner to set on the order when confirming. Omit to leave unchanged, pass null to clear.
     *
     * * `two` - Two
     * * `allianz` - Allianz
     * * `opply` - Opply
     */
    credit_risk_owner?: CreditRiskOwnerEnum | NullEnum | null;
}

export interface UnreadCount {
    unread_count: number;
}

export interface UpdatePassword {
    current_password: string;
    /** @maxLength 128 */
    password: string;
}

export interface UpdatePurchaseRequest {
    /**
     * @format decimal
     * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
     */
    quantity: string;
    /** @format date */
    due_date: string;
    delivery_address?: number | null;
    /** @format uuid */
    purchase_quote_uuid: string;
}

export interface UpdatedBy {
    /** @format uuid */
    uuid: string;
    name: string;
}

export interface UploadedProductsCatalogue {
    id: number;
    /** @format uuid */
    uuid: string;
    /**
     * * `pending` - Pending
     * * `being_processed` - Is being processed
     * * `processed` - Processed
     * * `failed` - Failed
     */
    status?: UploadedProductsCatalogueStatus;
    /** @format uri */
    catalogue?: string | null;
}

/**
 * * `pending` - Pending
 * * `being_processed` - Is being processed
 * * `processed` - Processed
 * * `failed` - Failed
 */
export enum UploadedProductsCatalogueStatus {
    Pending = "pending",
    BeingProcessed = "being_processed",
    Processed = "processed",
    Failed = "failed",
}

export interface UploadedProductsCatalogueStorage {
    /** @maxLength 976 */
    file_path: string;
}

/**
 * * `general_notifications` - General Notifications
 * * `actions` - Actions
 */
export enum UsedForEnum {
    GeneralNotifications = "general_notifications",
    Actions = "actions",
}

export interface User {
    id: number;
    /** @format uuid */
    uuid: string;
    /** @format email */
    email: string;
    /** @maxLength 150 */
    first_name?: string;
    /** @maxLength 150 */
    last_name?: string;
    /** @maxLength 255 */
    job_title?: string | null;
    /** @format double */
    tc_version?: number;
}

export interface UserAction {
    /** @format date-time */
    created: string;
    /**
     * * `login` - login
     * * `Quote viewed` - Quote viewed
     * * `Quote viewed on request details` - Quote viewed on request details
     * * `Inquiry viewed` - Inquiry viewed
     * * `Order viewed` - Order viewed
     */
    action?: UserActionActionEnum;
    extra_data?: string | null;
}

/**
 * * `login` - login
 * * `Quote viewed` - Quote viewed
 * * `Quote viewed on request details` - Quote viewed on request details
 * * `Inquiry viewed` - Inquiry viewed
 * * `Order viewed` - Order viewed
 */
export enum UserActionActionEnum {
    Login = "login",
    QuoteViewed = "Quote viewed",
    QuoteViewedOnRequestDetails = "Quote viewed on request details",
    InquiryViewed = "Inquiry viewed",
    OrderViewed = "Order viewed",
}

export interface UserAuthToken {
    token: string;
}

export interface UserDetails {
    /** @format uuid */
    uuid: string;
    /**
     * @format email
     * @maxLength 254
     */
    email: string;
    /** @maxLength 150 */
    first_name?: string;
    company_name: string;
}

export interface UserInviteAcceptRequest {
    /** @format uuid */
    invite_uuid: string;
    password: string;
}

export interface UserInviteCreate {
    /** @maxLength 30 */
    first_name: string;
    /** @maxLength 30 */
    last_name: string;
    /**
     * @format email
     * @maxLength 254
     */
    email: string;
    /** @default false */
    is_admin?: boolean;
}

export interface UserJWTTokenResponse {
    token: string;
}

export interface UserList {
    /** @format uuid */
    uuid: string;
    /** @maxLength 150 */
    first_name?: string;
    /** @maxLength 150 */
    last_name?: string;
    /**
     * @format email
     * @maxLength 254
     */
    email: string;
    company_name: string | null;
    last_login: UserAction;
}

export interface UserMinimal {
    /** @format uuid */
    uuid: string;
    name: string;
    /** @format email */
    email: string;
}

export interface UserRetrieve {
    /** @format uuid */
    uuid: string;
    /** @maxLength 150 */
    first_name?: string;
    /** @maxLength 150 */
    last_name?: string;
    /**
     * @format email
     * @maxLength 254
     */
    email: string;
    company_name: string | null;
    last_login: UserAction;
    /** @maxLength 255 */
    job_title?: string | null;
    company_type: string | null;
}

export interface UserTokenRequest {
    /** @format uuid */
    user_uuid: string;
}

export interface UserTokenResponse {
    token: string;
}

export interface UserUpdate {
    /** @maxLength 150 */
    first_name?: string;
    /** @maxLength 150 */
    last_name?: string;
    /** @maxLength 255 */
    job_title?: string | null;
    /**
     * @format email
     * @maxLength 254
     */
    email: string;
}

export interface Userflow {
    id: number;
    /** @format uuid */
    uuid: string;
    /** @format email */
    email: string;
    /** @maxLength 150 */
    first_name?: string;
    /** @maxLength 150 */
    last_name?: string;
    /** @maxLength 255 */
    job_title?: string | null;
    /** @format double */
    tc_version?: number;
    userflow_signature: string;
    signed_up_at: string;
    role: CompanyRoleEnum;
}

export interface VatInvoiceResponse {
    /** @format uri */
    pdf_url: string;
    /** @format uri */
    pdf_url_merged: string;
}

export interface VatInvoiceSupplierResponse {
    /** @format uri */
    pdf_url: string;
}

export interface VirtualBankTransfer {
    bank_account: string;
    merchant_reference_id: string;
    reference_number: string;
}

/**
 * * `place_an_order` - Place an order
 * * `payments` - Payments
 * * `explore` - Explore
 */
export enum WelcomeModalActionEnum {
    PlaceAnOrder = "place_an_order",
    Payments = "payments",
    Explore = "explore",
}

export interface WelcomeModalDismissal {
    /**
     * Which CTA the user chose when dismissing the welcome modal.
     *
     * * `place_an_order` - Place an order
     * * `payments` - Payments
     * * `explore` - Explore
     */
    action: WelcomeModalActionEnum;
    /** @format date-time */
    dismissed_at: string;
}

/** Inbound payload for `POST /users/welcome-modal/me/`. */
export interface WelcomeModalDismissalRequest {
    /**
     * * `place_an_order` - Place an order
     * * `payments` - Payments
     * * `explore` - Explore
     */
    action: WelcomeModalActionEnum;
}

/** Response shape for `GET /users/welcome-modal/me/`. */
export interface WelcomeModalState {
    dismissed: boolean;
    action: WelcomeModalActionEnum | NullEnum | null;
    /** @format date-time */
    dismissed_at: string | null;
}

/** Serializer for Zendesk ticket data from the search API */
export interface ZendeskTicket {
    id: number;
    /** @format date-time */
    created_at: string;
    subject: string | null;
    status: string | null;
}

export interface AgentRef {
    /** @format uuid */
    uuid: string;
    /** @pattern ^[-a-zA-Z0-9_]+$ */
    slug: string;
    name: string;
    description: string;
    is_taskable: boolean;
}

export interface InstallationRef {
    /** @format uuid */
    uuid: string;
    /**
     * * `active` - Active
     * * `paused` - Paused
     * * `revoked` - Revoked
     */
    status: AgentInstallationStatusEnum;
    installed_by: InstalledBy | null;
    /** @format date-time */
    installed_at: string;
}

export interface InstalledBy {
    /** @format uuid */
    uuid: string;
    name: string;
}

/** Inline write shape for line items inside a proposal payload. */
export interface LineItemWrite {
    /** @format uuid */
    source_invoice_uuid?: string | null;
    /** @maxLength 255 */
    name: string;
    /**
     * @maxLength 2000
     * @default ""
     */
    description?: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,11}(?:\.\d{0,3})?$
     */
    quantity?: string | null;
    /**
     * @maxLength 32
     * @default ""
     */
    unit?: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,10}(?:\.\d{0,4})?$
     */
    unit_price?: string | null;
    /**
     * @maxLength 8
     * @default ""
     */
    currency?: string;
    /** @default "OTHER" */
    classification?: LineItemClassificationEnum;
    /** @default "medium" */
    confidence?: ExtractionConfidenceEnum;
}

export interface ShadowUserRef {
    /** @format uuid */
    uuid: string;
    name: string;
}

/** Inline write shape for an extracted supplier (+ its line items). */
export interface SupplierWrite {
    /** @format uuid */
    source_invoice_uuid?: string | null;
    /** @maxLength 255 */
    supplier_name: string;
    /**
     * @maxLength 64
     * @default ""
     */
    vat_number?: string;
    /** @default "" */
    address?: string;
    /**
     * @maxLength 255
     * @default ""
     */
    contact_name?: string;
    /**
     * @format email
     * @default ""
     */
    contact_email?: string;
    /**
     * @maxLength 64
     * @default ""
     */
    contact_phone?: string;
    /**
     * @maxLength 64
     * @default ""
     */
    payment_terms?: string;
    /**
     * @maxLength 8
     * @default ""
     */
    invoice_currency?: string;
    /**
     * @format decimal
     * @pattern ^-?\d{0,12}(?:\.\d{0,2})?$
     */
    average_monthly_spend?: string | null;
    /** @min 0 */
    lead_time_days?: number | null;
    /**
     * @maxLength 100
     * @default ""
     */
    supplier_country?: string;
    /** @default "medium" */
    confidence?: ExtractionConfidenceEnum;
    /**
     * @maxLength 300
     * @default ""
     */
    evidence?: string;
    gaps?: Record<string, any>[];
    /** @min 1 */
    matched_existing_supplier_id?: number | null;
    line_items?: LineItemWrite[];
}

export interface TaskRef {
    /** @format uuid */
    uuid: string;
    title: string;
}
